webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(464),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(483),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: "https://myinxait.inxaitcorp.com/v1/api/",
  timeout: 18000,
  crossDomain: true,
  headers: {
    'Authorization': 'Bearer ' + localStorage.token,
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
}));

/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(458),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(295)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(400),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(302)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(429),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e2547fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LIST_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ALL_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SHOW_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REGISTER_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return REMOVE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return LIST_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return LIST_ACCOUNTCOUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ALL_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SHOW_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return REGISTER_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return UPDATE_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return REMOVE_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return LIST_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ALL_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SHOW_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return REGISTER_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UPDATE_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return REMOVE_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return LIST_TEAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ALL_TEAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SHOW_TEAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return REGISTER_TEAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return UPDATE_TEAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return REMOVE_TEAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return LIST_CAMPAIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return ALL_CAMPAIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SHOW_CAMPAIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return REGISTER_CAMPAIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return UPDATE_CAMPAIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return REMOVE_CAMPAIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return LIST_SOCIALREASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return ALL_SOCIALREASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return REGISTER_SOCIALREASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return UPDATE_SOCIALREASON; });
/* unused harmony export REGISTER_TRMCHANGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return LIST_SUPPLIER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return ALL_SUPPLIER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SHOW_SUPPLIER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return REGISTER_SUPPLIER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return UPDATE_SUPPLIER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return ALL_SUPPLIERACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return REGISTER_SUPPLIERACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return UPDATE_SUPPLIERACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return ALL_SUPPLIERSOCIALREASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return REGISTER_SUPPLIERSOCIALREASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return UPDATE_SUPPLIERSOCIALREASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return LIST_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return ALL_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return SHOW_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return REGISTER_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return UPDATE_CLIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return ALL_CLIENTACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return REGISTER_CLIENTACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return UPDATE_CLIENTACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return LIST_BUDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return LIST_BUDGETSTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return ALL_BUDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return SHOW_BUDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return REGISTER_BUDGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return UPDATE_BUDGET; });
/* unused harmony export REMOVE_BUDGET */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return LIST_BUDGETELEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return ALL_BUDGETELEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return SHOW_BUDGETELEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return REGISTER_BUDGETELEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return UPDATE_BUDGETELEMENT; });
/* unused harmony export REMOVE_BUDGETELEMENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return LIST_TASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return LIST_TASKSTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return ALL_TASKVERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SHOW_TASKVERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return ALL_TASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return SHOW_TASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return REGISTER_TASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return REGISTER_TASKVERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return UPDATE_TASK; });
/* unused harmony export REMOVE_TASK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return REMOVE_POINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return LIST_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return LIST_EMAILSTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return ALL_EMAILVERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return SHOW_EMAILVERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return ALL_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return SHOW_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return REGISTER_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return REGISTER_EMAILVERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return UPDATE_EMAIL; });
/* unused harmony export REMOVE_EMAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return SHOW_EMAILCHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return LIST_EMAILCHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return REGISTER_EMAILCHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return ALL_EMAILCHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return ALL_EMAILCLASSIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return SHOW_EMAILCLASSIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return REGISTER_EMAILCLASSIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return LIST_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return ALL_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return SHOW_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return REGISTER_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return UPDATE_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return REMOVE_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return LIST_HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return ALL_HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return SHOW_HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return REGISTER_HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return UPDATE_HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return REMOVE_HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return LIST_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return ALL_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return SHOW_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return REGISTER_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return UPDATE_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return REMOVE_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return LIST_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return UPDATE_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return ALL_ACCOUNTUSER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return REGISTER_ACCOUNTUSER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return UPDATE_ACCOUNTUSER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return LIST_LIBRARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return ALL_LIBRARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return SHOW_LIBRARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return REGISTER_LIBRARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return UPDATE_LIBRARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return REMOVE_LIBRARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return LIST_ACTIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return ALL_ACTIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return SHOW_ACTIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return REGISTER_ACTIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return UPDATE_ACTIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return REMOVE_ACTIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGIN; });
/* unused harmony export REGISTER_AUTH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SESSION_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SESSION_TEAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOGOUT; });
/* unused harmony export SIGNUP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return ALL_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return SET_lOADING; });
var LIST_USER = 'user/LIST_USER';
var ALL_USER = 'user/ALL_USER';
var SHOW_USER = 'user/SHOW_USER';
var REGISTER_USER = 'user/REGISTER_USER';
var UPDATE_USER = 'user/UPDATE_USER';
var REMOVE_USER = 'user/REMOVE_USER';

var LIST_ACCOUNT = 'account/LIST_ACCOUNT';
var LIST_ACCOUNTCOUNTRY = 'accountcountry/LIST_ACCOUNTCOUNTRY';
var ALL_ACCOUNT = 'account/ALL_ACCOUNT';
var SHOW_ACCOUNT = 'account/SHOW_ACCOUNT';
var REGISTER_ACCOUNT = 'account/REGISTER_ACCOUNT';
var UPDATE_ACCOUNT = 'account/UPDATE_ACCOUNT';
var REMOVE_ACCOUNT = 'account/REMOVE_ACCOUNT';

var LIST_PROJECT = 'project/LIST_PROJECT';
var ALL_PROJECT = 'project/ALL_PROJECT';
var SHOW_PROJECT = 'project/SHOW_PROJECT';
var REGISTER_PROJECT = 'project/REGISTER_PROJECT';
var UPDATE_PROJECT = 'project/UPDATE_PROJECT';
var REMOVE_PROJECT = 'project/REMOVE_PROJECT';

var LIST_TEAM = 'team/LIST_TEAM';
var ALL_TEAM = 'team/ALL_TEAM';
var SHOW_TEAM = 'team/SHOW_TEAM';
var REGISTER_TEAM = 'team/REGISTER_TEAM';
var UPDATE_TEAM = 'team/UPDATE_TEAM';
var REMOVE_TEAM = 'team/REMOVE_TEAM';

var LIST_CAMPAIGN = 'campaign/LIST_CAMPAIGN';
var ALL_CAMPAIGN = 'campaign/ALL_CAMPAIGN';
var SHOW_CAMPAIGN = 'campaign/SHOW_CAMPAIGN';
var REGISTER_CAMPAIGN = 'campaign/REGISTER_CAMPAIGN';
var UPDATE_CAMPAIGN = 'campaign/UPDATE_CAMPAIGN';
var REMOVE_CAMPAIGN = 'campaign/REMOVE_CAMPAIGN';

var LIST_SOCIALREASON = 'socialreason/LIST_SOCIALREASON';
var ALL_SOCIALREASON = 'socialreason/ALL_SOCIALREASON';
var REGISTER_SOCIALREASON = 'socialreason/REGISTER_SOCIALREASON';
var UPDATE_SOCIALREASON = 'socialreason/UPDATE_SOCIALREASON';

var REGISTER_TRMCHANGE = 'trmchange/REGISTER_TRMCHANGE';

var LIST_SUPPLIER = 'supplier/LIST_SUPPLIER';
var ALL_SUPPLIER = 'supplier/ALL_SUPPLIER';
var SHOW_SUPPLIER = 'supplier/SHOW_SUPPLIER';
var REGISTER_SUPPLIER = 'supplier/REGISTER_SUPPLIER';
var UPDATE_SUPPLIER = 'supplier/UPDATE_SUPPLIER';

var ALL_SUPPLIERACCOUNT = 'supplieraccount/ALL_SUPPLIERACCOUNT';
var REGISTER_SUPPLIERACCOUNT = 'supplieraccount/REGISTER_SUPPLIERACCOUNT';
var UPDATE_SUPPLIERACCOUNT = 'supplieraccount/UPDATE_SUPPLIERACCOUNT';

var ALL_SUPPLIERSOCIALREASON = 'suppliersocialreason/ALL_SUPPLIERSOCIALREASON';
var REGISTER_SUPPLIERSOCIALREASON = 'suppliersocialreason/REGISTER_SUPPLIERSOCIALREASON';
var UPDATE_SUPPLIERSOCIALREASON = 'suppliersocialreason/UPDATE_SUPPLIERSOCIALREASON';

var LIST_CLIENT = 'client/LIST_CLIENT';
var ALL_CLIENT = 'client/ALL_CLIENT';
var SHOW_CLIENT = 'client/SHOW_CLIENT';
var REGISTER_CLIENT = 'client/REGISTER_CLIENT';
var UPDATE_CLIENT = 'client/UPDATE_CLIENT';

var ALL_CLIENTACCOUNT = 'clientaccount/ALL_CLIENTACCOUNT';
var REGISTER_CLIENTACCOUNT = 'clientaccount/REGISTER_CLIENTACCOUNT';
var UPDATE_CLIENTACCOUNT = 'clientaccount/UPDATE_CLIENTACCOUNT';

var LIST_BUDGET = 'budget/LIST_BUDGET';
var LIST_BUDGETSTATE = 'budgetstate/LIST_BUDGETSTATE';
var ALL_BUDGET = 'budget/ALL_BUDGET';
var SHOW_BUDGET = 'budget/SHOW_BUDGET';
var REGISTER_BUDGET = 'budget/REGISTER_BUDGET';
var UPDATE_BUDGET = 'budget/UPDATE_BUDGET';
var REMOVE_BUDGET = 'budget/REMOVE_BUDGET';

var LIST_BUDGETELEMENT = 'budgetelement/LIST_BUDGETELEMENT';
var ALL_BUDGETELEMENT = 'budgetelement/ALL_BUDGETELEMENT';
var SHOW_BUDGETELEMENT = 'budgetelement/SHOW_BUDGETELEMENT';
var REGISTER_BUDGETELEMENT = 'budgetelement/REGISTER_BUDGETELEMENT';
var UPDATE_BUDGETELEMENT = 'budgetelement/UPDATE_BUDGETELEMENT';
var REMOVE_BUDGETELEMENT = 'budgetelement/REMOVE_BUDGETELEMENT';

var LIST_TASK = 'task/LIST_TASK';
var LIST_TASKSTATE = 'taskstate/LIST_TASKSTATE';
var ALL_TASKVERSION = 'taskversion/ALL_TASKVERSION';
var SHOW_TASKVERSION = 'taskversion/SHOW_TASKVERSION';
var ALL_TASK = 'task/ALL_TASK';
var SHOW_TASK = 'task/SHOW_TASK';
var REGISTER_TASK = 'task/REGISTER_TASK';
var REGISTER_TASKVERSION = 'taskversion/REGISTER_TASKVERSION';
var UPDATE_TASK = 'task/UPDATE_TASK';
var REMOVE_TASK = 'task/REMOVE_TASK';

var REMOVE_POINT = 'point/REMOVE_POINT';

var LIST_EMAIL = 'email/LIST_EMAIL';
var LIST_EMAILSTATE = 'emailstate/LIST_EMAILSTATE';
var ALL_EMAILVERSION = 'emailversion/ALL_EMAILVERSION';
var SHOW_EMAILVERSION = 'emailversion/SHOW_EMAILVERSION';
var ALL_EMAIL = 'email/ALL_EMAIL';
var SHOW_EMAIL = 'email/SHOW_EMAIL';
var REGISTER_EMAIL = 'email/REGISTER_EMAIL';
var REGISTER_EMAILVERSION = 'emailversion/REGISTER_EMAILVERSION';
var UPDATE_EMAIL = 'email/UPDATE_EMAIL';
var REMOVE_EMAIL = 'email/REMOVE_EMAIL';
var SHOW_EMAILCHECK = 'emailcheck/SHOW_EMAILCHECK';
var LIST_EMAILCHECK = 'emailcheck/LIST_EMAILCHECK';
var REGISTER_EMAILCHECK = 'emailcheck/REGISTER_EMAILCHECK';
var ALL_EMAILCHECK = 'emailcheck/ALL_EMAILCHECK';
var ALL_EMAILCLASSIFICATION = 'emailclassification/ALL_EMAILCLASSIFICATION';
var SHOW_EMAILCLASSIFICATION = 'emailclassification/SHOW_EMAILCLASSIFICATION';
var REGISTER_EMAILCLASSIFICATION = 'emailclassification/REGISTER_EMAILCLASSIFICATION';

var LIST_PROFILE = 'profile/LIST_PROFILE';
var ALL_PROFILE = 'profile/ALL_PROFILE';
var SHOW_PROFILE = 'profile/SHOW_PROFILE';
var REGISTER_PROFILE = 'profile/REGISTER_PROFILE';
var UPDATE_PROFILE = 'profile/UPDATE_PROFILE';
var REMOVE_PROFILE = 'profile/REMOVE_PROFILE';

var LIST_HOUR = 'hour/LIST_HOUR';
var ALL_HOUR = 'hour/ALL_HOUR';
var SHOW_HOUR = 'hour/SHOW_HOUR';
var REGISTER_HOUR = 'hour/REGISTER_HOUR';
var UPDATE_HOUR = 'hour/UPDATE_HOUR';
var REMOVE_HOUR = 'hour/REMOVE_HOUR';

var LIST_CALENDAR = 'calendar/LIST_CALENDAR';
var ALL_CALENDAR = 'calendar/ALL_CALENDAR';
var SHOW_CALENDAR = 'calendar/SHOW_CALENDAR';
var REGISTER_CALENDAR = 'calendar/REGISTER_CALENDAR';
var UPDATE_CALENDAR = 'calendar/UPDATE_CALENDAR';
var REMOVE_CALENDAR = 'calendar/REMOVE_CALENDAR';

var LIST_NOTIFICATION = 'notification/LIST_NOTIFICATION';
var UPDATE_NOTIFICATION = 'notification/UPDATE_NOTIFICATION';

var ALL_ACCOUNTUSER = 'accountuser/ALL_ACCOUNTUSER';
var REGISTER_ACCOUNTUSER = 'accountuser/REGISTER_ACCOUNTUSER';
var UPDATE_ACCOUNTUSER = 'accountuser/UPDATE_ACCOUNTUSER';

var LIST_LIBRARY = 'library/LIST_LIBRARY';
var ALL_LIBRARY = 'library/ALL_LIBRARY';
var SHOW_LIBRARY = 'library/SHOW_LIBRARY';
var REGISTER_LIBRARY = 'library/REGISTER_LIBRARY';
var UPDATE_LIBRARY = 'library/UPDATE_LIBRARY';
var REMOVE_LIBRARY = 'library/REMOVE_LIBRARY';

var LIST_ACTIVITY = 'activity/LIST_ACTIVITY';
var ALL_ACTIVITY = 'activity/ALL_ACTIVITY';
var SHOW_ACTIVITY = 'activity/SHOW_ACTIVITY';
var REGISTER_ACTIVITY = 'activity/REGISTER_ACTIVITY';
var UPDATE_ACTIVITY = 'activity/UPDATE_ACTIVITY';
var REMOVE_ACTIVITY = 'activity/REMOVE_ACTIVITY';

var SESSION = 'user/SESSION';
var LOGIN = 'user/LOGIN';
var REGISTER_AUTH = 'auth/REGISTER_AUTH';
var SESSION_ACCOUNT = 'SESSION_ACCOUNT';
var SESSION_TEAM = 'SESSION_TEAM,';
var LOGOUT = 'user/LOGOUT';
var SIGNUP = 'user/SIGNUP';

var ALL_NOTIFICATION = 'notification/ALL_NOTIFICATION';

var SET_lOADING = 'SET_lOADING';

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleDateClass; });
var handleDateClass = function handleDateClass(type, model, today) {
  var date = model.date;

  if (model.state_id == 7 && type == 'task') {
    return 'bg-theme-7';
  }

  if (model.state_id == 4 && type == 'task') {
    return 'bg-theme-1';
  }

  if (model.state_id == 6 && type == 'email') {
    return 'bg-theme-1';
  }

  if (date > today) {
    return 'bg-theme-9';
  }

  if (date == today) {
    return 'bg-theme-12';
  }

  return 'bg-theme-6';
};

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return todayFormat; });
var todayFormat = function todayFormat() {
  var newDate = new Date();
  var dd = ('0' + newDate.getDate()).slice(-2);
  var mm = ('0' + (newDate.getMonth() + 1)).slice(-2);
  var yyyy = newDate.getFullYear();

  return yyyy + '-' + mm + '-' + dd;
};

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(444),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(445),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(425),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(460),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(466),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(299)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(416),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_Login__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__admin__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__admintraffic__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__adminbusiness__ = __webpack_require__(225);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_home_Login___default.a
  }, __WEBPACK_IMPORTED_MODULE_3__admin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__admintraffic__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__adminbusiness__["a" /* default */]]
}));

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__entity_index__ = __webpack_require__(232);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);
var debug = "production" !== 'production';

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  modules: {
    entity: __WEBPACK_IMPORTED_MODULE_2__entity_index__["a" /* default */]
  },
  strict: debug,
  state: {
    // Busca si ya hay un valor guardado en localStorage, si no, por defecto false
    isDarkMode: localStorage.getItem('theme') === 'dark'
  },
  mutations: {
    TOGGLE_DARK_MODE: function TOGGLE_DARK_MODE(state) {
      state.isDarkMode = !state.isDarkMode;

      // Persistir la elección del usuario
      if (state.isDarkMode) {
        localStorage.setItem('theme', 'dark');
        document.documentElement.classList.add('dark-mode');
      } else {
        localStorage.setItem('theme', 'light');
        document.documentElement.classList.remove('dark-mode');
      }
    },

    // Mutación que se ejecuta al cargar la aplicación inicialmente
    INIT_THEME: function INIT_THEME(state) {
      if (state.isDarkMode) {
        document.documentElement.classList.add('dark-mode');
      } else {
        document.documentElement.classList.remove('dark-mode');
      }
    }
    // ... tus otras mutaciones

  },
  actions: {
    toggleTheme: function toggleTheme(_ref) {
      var commit = _ref.commit;

      commit('TOGGLE_DARK_MODE');
    }
  }
});

/***/ }),
/* 106 */,
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(300)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(421),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports) {

module.exports = {"_args":[["axios@0.21.4","/var/www/frontend"]],"_from":"axios@0.21.4","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"axios@0.21.4","name":"axios","escapedName":"axios","rawSpec":"0.21.4","saveSpec":null,"fetchSpec":"0.21.4"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/axios/-/axios-0.21.4.tgz","_spec":"0.21.4","_where":"/var/www/frontend","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);



//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MyInxaitApp',
  components: {},
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.commit('INIT_THEME');
              _context.prev = 1;

              if (!localStorage.token) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return _this.session().then(function (user) {
                _this.SET_lOADING(true);
              }).catch(function (message) {
                _this.SET_lOADING(false);
                _this.$router.replace(_this.$route.query.redirect || '/');
              });

            case 5:
              _context.next = 9;
              break;

            case 7:
              _this.SET_lOADING(false);
              _this.$router.replace('/');

            case 9:
              _context.next = 13;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](1);

            case 13:
              _context.prev = 13;

              _this.SET_lOADING(false);
              return _context.finish(13);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 11, 13, 16]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['getList', 'session']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['SET_lOADING']))
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Top__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Top___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Top__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_SideBar__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_SideBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_SideBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_profile_ModalPasswordUpdated__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_profile_ModalPasswordUpdated___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_profile_ModalPasswordUpdated__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      openmenu: true
    };
  },

  methods: {
    menuMobile: function menuMobile() {
      var menu = this.openmenu;
      console.log('clic');
      this.openmenu = !menu;
    }
  },
  created: function created() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({ user: 'getUser', isLoading: 'getIsLoading' })),
  components: {
    appTop: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Top___default.a,
    appIcon: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon___default.a,
    appSideBar: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_SideBar___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a,
    ModalPasswordUpdated: __WEBPACK_IMPORTED_MODULE_6__components_admin_profile_ModalPasswordUpdated___default.a
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Top__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Top___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Top__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_SideBar__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_SideBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_SideBar__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      openmenu: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (localStorage.token) {
      this.session().then(function (user) {
        _this.loading = false;
      }).catch(function (message) {
        _this.loading = false;
        _this.$router.replace(_this.$route.query.redirect || '/');
      });
    } else {
      this.loading = false;
      this.$router.replace('/');
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['session']), {
    menuMobile: function menuMobile() {
      var menu = this.openmenu;
      console.log('clic');
      this.openmenu = !menu;
    },
    subIsActive: function subIsActive(input) {
      var _this2 = this;

      var paths = Array.isArray(input) ? input : [input];
      return paths.some(function (path) {
        return _this2.$route.path.indexOf(path) === 0;
      });
    }
  }),
  components: {
    appTop: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Top___default.a,
    appSideBar: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_SideBar___default.a,
    appIcon: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default.a
  }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Top__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Top___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Top__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_SideBar__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_SideBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_SideBar__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminTraffic',
  data: function data() {
    return {
      openmenu: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (localStorage.token) {
      this.session().then(function (user) {
        _this.loading = false;
      }).catch(function (message) {
        _this.loading = false;
        _this.$router.replace(_this.$route.query.redirect || '/');
      });
    } else {
      this.loading = false;
      this.$router.replace('/');
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['session']), {
    menuMobile: function menuMobile() {
      var menu = this.openmenu;
      console.log('clic');
      this.openmenu = !menu;
    },
    subIsActive: function subIsActive(input) {
      var _this2 = this;

      var paths = Array.isArray(input) ? input : [input];
      return paths.some(function (path) {
        return _this2.$route.path.indexOf(path) === 0;
      });
    }
  }),
  components: {
    appTop: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Top___default.a,
    appSideBar: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_SideBar___default.a,
    appIcon: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default.a
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssignAccountUser',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      view: {
        entity: 'user',
        id: this.$route.params.id
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    accounts: 'getAccounts',
    account: 'getAccount',
    current: 'getCurrentUser'
  }), {
    filteredAccounts: function filteredAccounts() {
      var _this = this;

      return this.accounts.filter(function (account) {
        if (!_this.current.accounts.some(function (item) {
          return item.id == account.id;
        })) {
          return account;
        }
      });
    }
  }),
  beforeMount: function beforeMount() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this2.getList('account'), _this2.lookCurrentUser()]);

            case 2:

              _this2.loading = true;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    addAccount: function addAccount(account) {
      var _this3 = this;

      var form = {
        entity: 'accountuser',
        id: this.current.id,
        account_id: account.id
      };

      this.store(form).then(function () {
        _this3.lookCurrentUser();
      });
    },
    removeAccount: function removeAccount(account) {
      var _this4 = this;

      var form = {
        entity: 'accountuser',
        id: this.current.id,
        account_id: account.id
      };

      this.update(form).then(function () {
        _this4.lookCurrentUser();
      });
    },
    lookCurrentUser: function lookCurrentUser() {
      var _this5 = this;

      this.show(this.view).then(function (response) {
        _this5.loading = true;
      });
    },
    updateValue: function updateValue(attribute, e) {
      this.user_current[attribute] = e.target.value;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['show', 'getAll', 'getList', 'store', 'update', 'remove'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListAccount',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      account: this.defineAccount(),
      account_current: {},
      accounts_active: 0,
      groups: null,
      filter: {
        name: '',
        group: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    accounts: 'getAccounts',
    countries: 'getAccountCountries',
    socialreasons: 'getSocialReasons'
  }), {
    socialreasonsfiltered: function socialreasonsfiltered() {
      var _this = this;

      return this.socialreasons.filter(function (socialreason) {
        if (socialreason.country_id == _this.account.country_id || socialreason.country_id == _this.account_current.country_id) {
          return socialreason;
        }
      });
    },
    countAccountsActive: function countAccountsActive() {
      var count = 0;
      this.accounts.filter(function (item) {
        if (item.status == 1) {
          count++;
        }
      });

      this.accounts_active = count;
      return count;
    },

    filteredAccounts: function filteredAccounts() {
      var _this2 = this;

      return this.accounts.filter(function (item) {
        var name = _this2.filter.name ? item.name.toLowerCase().includes(_this2.filter.name.toLowerCase()) : true;
        var account_group_id = _this2.filter.group ? item.account_group_id === _this2.filter.group : true;

        return name && account_group_id;
      });
    }
  }),
  beforeMount: function beforeMount() {
    var _this3 = this;

    //SEND ENTITY AND MUTATION
    this.getAll('account').then(function () {
      _this3.loading = true;
    }), this.getList('socialreason').then(function () {
      _this3.loading = true;
    }), this.getList('accountcountry').then(function () {
      _this3.loading = true;
    });
    this.getGroups();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    getGroups: function getGroups() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, list;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.loading = false;
                _context.prev = 1;
                _context.next = 4;
                return _this4.get('/account-group');

              case 4:
                _ref = _context.sent;
                list = _ref.list;

                _this4.groups = list;
                _this4.loading = true;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);
                _this4.loading = true;

              case 14:
                _context.prev = 14;

                _this4.loading = true;
                return _context.finish(14);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[1, 10, 14, 17]]);
      }))();
    },
    defineAccount: function defineAccount() {
      return {
        name: '',
        prefix: '',
        country_id: '',
        status: '',
        entity: 'account',
        social_reason_id: null,
        account_group_id: null
      };
    },
    createAccount: function createAccount() {
      var _this5 = this;

      var vm = this;
      window.$('#create').button('loading');
      vm.account.status = 1;
      vm.store(vm.account).then(function (item) {
        window.$('#account').modal('hide');
        _this5.defineAccount();
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/accounts');
      }).catch(function (error) {
        window.$('#create').button('reset');
        _this5.defineAccount();
      });
    },

    removeAccount: function removeAccount(value) {
      var vm = this;
      vm.form = {
        id: value.id,
        entity: 'account'
      };
      vm.loading = false;
      vm.remove(vm.form).then(function (item) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/accounts');
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    editAccount: function editAccount(value) {
      this.boxedit = true;
      this.account_current = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
    },
    closeEditAccount: function closeEditAccount() {
      this.boxedit = false;
      this.account_current = {};
    },
    updateAccount: function updateAccount(value) {
      var vm = this;
      vm.account_current.entity = 'account';
      vm.loading = false;
      vm.update(vm.account_current).then(function (item) {
        vm.loading = true;
        vm.boxedit = false;
        vm.account = { name: '', entity: 'account' };
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/accounts');
      }).catch(function (message) {
        vm.loading = true;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['get', 'getAll', 'getList', 'remove', 'store', 'update'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ActivityQuestions',
  props: {
    activity: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  beforeMount: function beforeMount() {
    this.activityQuestions = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.activity.questions));

    if (this.$route.name == 'show-activity') {
      this.isShow = true;
    }
  },
  data: function data() {
    return {
      checked: false,
      currentActivityQuestion: this.defineActivityQuestion(),
      currentQuestionAnswer: this.defineQuestionAnswer(),
      activityQuestions: [],
      showCurrentQuestion: 0,
      isShow: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    defineActivityQuestion: function defineActivityQuestion() {
      return {
        title: null,
        time_in_seconds: 30,
        answers: []
      };
    },
    defineQuestionAnswer: function defineQuestionAnswer() {
      return {
        text_answer: null,
        correct: false
      };
    },
    addQuestionToActivity: function addQuestionToActivity() {
      this.activityQuestions.push(this.currentActivityQuestion);

      this.currentActivityQuestion = this.defineActivityQuestion();
    },
    addAnswerToQuestion: function addAnswerToQuestion(index) {
      var isCorrect = this.activityQuestions[index].answers.length == 0 ? true : false;

      this.activityQuestions[index].answers.push({
        text_answer: this.currentQuestionAnswer.text_answer,
        correct: isCorrect
      });

      this.currentQuestionAnswer.text_answer = "";
    },
    checkWhichAnswerChanged: function checkWhichAnswerChanged(questionIndex, position) {
      var answers = this.activityQuestions[questionIndex].answers;

      answers.forEach(function (element, index) {
        element.correct = index == position ? true : false;
      });
    },
    updateOrCreateQuestions: function updateOrCreateQuestions() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _validateQuestions, notValid, message, data, form;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _validateQuestions = _this.validateQuestions(), notValid = _validateQuestions.notValid, message = _validateQuestions.message;

                if (!notValid) {
                  _context.next = 4;
                  break;
                }

                window.$toast.error(message);
                return _context.abrupt('return');

              case 4:
                data = {
                  entity: 'activity',
                  questions: _this.activityQuestions,
                  id: _this.activity.slug
                };
                form = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.activity, data);
                _context.prev = 6;
                _context.next = 9;
                return _this.update(form);

              case 9:
                window.$toast.success('Preguntas y respuestas actualizadas');
                _this.$router.push('/admin/activities');
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](6);

                window.$toast.error(_context.t0.message);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[6, 13]]);
      }))();
    },
    validateQuestions: function validateQuestions() {

      var response = {
        notValid: false,
        message: ''
      };

      if (this.activityQuestions.length == 0) {
        response.notValid = true;
        response.message = 'Debe agregar al menos una pregunta';
        return response;
      }

      this.activityQuestions.forEach(function (question) {

        if (question.title == null || question.title == "") {
          response.notValid = true;
          response.message = 'Todas las preguntas deben tener un titulo';
          return response;
        }

        if (question.answers.length == 0) {
          response.notValid = true;
          response.message = 'Todas las preguntas deben tener al menos una respuesta';
          return response;
        }

        question.answers.forEach(function (answer) {
          if (answer.text_answer == null || answer.text_answer == "") {
            response.notValid = true;
            response.message = 'Todas las respuestas deben tener un texto';
            return response;
          }
        });
      });

      return response;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['getAll', 'getList', 'store', 'update']))
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ActivityQuestions_vue__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ActivityQuestions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ActivityQuestions_vue__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateActivity',
  data: function data() {
    return {
      loading: true,
      view: {
        entity: 'activity',
        id: this.$route.params.slug
      },
      checked: false,
      existSlug: false,

      activity: this.defineActivity(),
      activityQuestions: [],
      activityTypes: ['Trivia', 'Parejas', 'Ordenar Letras', 'Extra'],
      activityTypeContents: ['Url', 'Texto'],
      loadImage: false,
      isShow: false,
      type: null,
      percentage_70: false,
      percentage_80: false,
      type_content: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    //activity: 'getActivity',
  })),
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.$route.name == 'show-activity') {
                _this.isShow = true;
              }
              _context.prev = 1;

              _this.existSlug = _this.$route.params.slug ? true : false;

              if (!_this.existSlug) {
                _context.next = 7;
                break;
              }

              _this.checked = true;
              _context.next = 7;
              return _this.lookCurrentActivity();

            case 7:
              _context.prev = 7;

              _this.loading = false;
              return _context.finish(7);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1,, 7, 10]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    defineActivity: function defineActivity() {
      return {
        name: null,
        description: null,
        image: null,
        points_high_correct: null,
        points_medium_correct: null,
        points_under_correct: null,
        status: 1,
        type: null,
        start_date: null,
        end_date: null,
        entity: 'activity',
        study_information: null
      };
    },
    lookCurrentActivity: function lookCurrentActivity() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.show(_this2.view);

              case 3:
                _this2.activity = _context2.sent;
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](0);

                _this2.$router.push('/admin/activities');

              case 9:
                _context2.prev = 9;

                _this2.loading = false;
                return _context2.finish(9);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 6, 9, 12]]);
      }))();
    },
    createActivity: function createActivity() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var formData;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = true;

                _context3.prev = 1;
                formData = new FormData();


                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(_this3.activity).forEach(function (_ref) {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                      key = _ref2[0],
                      value = _ref2[1];

                  formData.append(key, value);
                });

                _context3.next = 6;
                return _this3.store(formData).then(function (data) {
                  console.log('then');
                  var model = data.model;

                  console.log(model);
                  _this3.$router.replace('/admin/activities/' + model.slug + '/questions');
                }).catch(function (error) {
                  var data = error.response.data;
                  if (data.errors) {
                    var errors = data.errors;

                    for (var item in errors) {
                      for (var i = 0; i < errors[item].length; i++) {
                        window.$toast.error(errors[item][i]);
                      }
                    }
                  }
                });

              case 6:
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](1);

                console.log('FAILURE!!');
                console.log({ error: _context3.t0 });

              case 12:
                _context3.prev = 12;

                _this3.loading = false;
                return _context3.finish(12);

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 8, 12, 15]]);
      }))();
    },
    onFileChange: function onFileChange(e) {
      this.loadImage = true;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.activity.image = e.target.files[0];
    },
    onStudyActivityFileChange: function onStudyActivityFileChange(e) {
      this.loadImage = true;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      console.log(files);
      this.activity.study_information = e.target.files[0];
    },
    changeType: function changeType(e) {
      var value = e.target.value;
      this.activity.type = value;
      if (value != "Extra") {
        this.percentage_70 = true;
        this.percentage_80 = true;
        this.type_content = false;
      } else {
        this.percentage_70 = false;
        this.percentage_80 = false;
        this.type_content = true;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['show', 'getAll', 'getList', 'update', 'store'])),
  components: {
    ActivityQuestionsComponent: __WEBPACK_IMPORTED_MODULE_7__ActivityQuestions_vue___default.a,
    AppLoading: __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_axios__ = __webpack_require__(16);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DownloadParticipations',
  props: {
    text: {
      type: String,
      default: 'Descargar Participaciones'
    },
    activity: {}
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    downloadList: function downloadList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__services_axios__["a" /* default */].get('activity/participations-excel/' + this.activity.id).then(function (response) {
        var data = response.data;
        var path = data.path;


        _this.$refs.download.href = path;
        _this.$refs.download.click();
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['get']))
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_activity_ModalEditActivity__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_activity_ModalEditActivity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_activity_ModalEditActivity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_report_ModalMessage__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_report_ModalMessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_report_ModalMessage__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListActivity',
  data: function data() {
    return {
      loading: false,
      current_activity: {},
      show_activity_model: false,
      modalMessage: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    activities: 'getActivities'
  })),
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _context.prev = 1;
              _context.next = 4;
              return _this.getAll('activity');

            case 4:
              _context.prev = 4;

              _this.loading = false;
              return _context.finish(4);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1,, 4, 7]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['getAll']), {
    editActivity: function editActivity(activity) {
      this.current_activity = activity;
      this.show_activity_model = true;
    },
    closeEditActivity: function closeEditActivity() {
      this.current_activity = {};
      this.show_activity_model = false;
    },
    toggleModalMessage: function toggleModalMessage(status) {
      this.modalMessage = status;
    }
  }),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a,
    ModalEditActivity: __WEBPACK_IMPORTED_MODULE_6__components_admin_activity_ModalEditActivity___default.a,
    ModalMessage: __WEBPACK_IMPORTED_MODULE_7__components_admin_report_ModalMessage___default.a
  }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_assets_Modal_Modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_assets_Modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_assets_Modal_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_activity_DownloadParticipations__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_activity_DownloadParticipations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_admin_activity_DownloadParticipations__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListActivityParticipations',
  data: function data() {
    return {
      loading: false,
      activity: {},
      showParticipationDeleteModal: false,
      deleteParticipationSlug: null,
      showParticipationQualificationModal: false,
      participationQualificationSlug: null,
      answer: null
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getAcitivtyParticipations();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get']), {
    getAcitivtyParticipations: function getAcitivtyParticipations() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, model;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.get('/activity/' + _this2.$route.params.slug + '/participations');

              case 4:
                _ref = _context2.sent;
                model = _ref.model;

                _this2.activity = model;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](1);

                _this2.$router.push('/admin/activities');

              case 12:
                _context2.prev = 12;

                _this2.loading = false;
                return _context2.finish(12);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 9, 12, 15]]);
      }))();
    },
    deleteActivityUser: function deleteActivityUser(activityUSerSlug) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref2, message;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].delete('/activity/' + _this3.$route.params.slug + '/participations/' + activityUSerSlug);

              case 3:
                _ref2 = _context3.sent;
                message = _ref2.data.message;
                _context3.next = 7;
                return _this3.getAcitivtyParticipations();

              case 7:

                window.$toast.info(message);
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 10]]);
      }))();
    },
    showDeleteModal: function showDeleteModal(slug) {
      this.deleteParticipationSlug = slug;
      this.showParticipationDeleteModal = true;
    },
    closeDeleteModal: function closeDeleteModal() {
      this.deleteParticipationSlug = null;
      this.showParticipationDeleteModal = false;
    },
    showQualificationModal: function showQualificationModal(slug, answer) {
      this.participationQualificationSlug = slug;
      this.showParticipationQualificationModal = true;
      this.answer = answer;
    },
    closeQualificationModal: function closeQualificationModal() {
      this.participationQualificationSlug = null;
      this.showParticipationQualificationModal = false;
      this.answer = null;
    },
    submitDeleteModal: function submitDeleteModal() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return _this4.deleteActivityUser(_this4.deleteParticipationSlug);

              case 3:
                _this4.closeDeleteModal();
                _context4.next = 9;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4['catch'](0);

                console.log(_context4.t0);

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 6]]);
      }))();
    },
    submitQualificationModal: function submitQualificationModal(qualification) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _ref3, message;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].post('/qualification-extra/' + _this5.participationQualificationSlug, {
                  qualification: qualification
                });

              case 3:
                _ref3 = _context5.sent;
                message = _ref3.message;

                window.$toast.info(message);
                _this5.closeQualificationModal();
                location.reload();
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](0);

                console.log(_context5.t0);

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 10]]);
      }))();
    }
  }),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_LoadingWhite___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_6__components_assets_Modal_Modal___default.a,
    DownloadParticipations: __WEBPACK_IMPORTED_MODULE_8__components_admin_activity_DownloadParticipations___default.a
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ListUserAnswers',
  data: function data() {
    return {
      loading: false,
      activity: {}
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, model;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _context.prev = 1;
              _context.next = 4;
              return _this.get('/activity/' + _this.$route.params.slug + '/answers');

            case 4:
              _ref = _context.sent;
              model = _ref.model;

              console.log(model);
              _this.activity = model;
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](1);

              _this.$router.push('/admin/activities');

            case 13:
              _context.prev = 13;

              _this.loading = false;
              return _context.finish(13);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 10, 13, 16]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_assets_Modal_Modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_assets_Modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_assets_Modal_Modal__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['categories', 'teams', 'current_activity'],
  data: function data() {
    return {
      library: {},
      activity: {},
      activityTypes: ['Trivia', 'Parejas', 'Ordenar Letras', 'Extra'],
      activityTypeContents: ['Url', 'Texto'],
      loadImage: false
    };
  },
  created: function created() {
    this.activity = JSON.parse(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(this.current_activity));
    console.log(this.activity);
    //const { name: image } = JSON.parse(this.activity.image)
    //console.log(JSON.parse(this.activity.image), 'this.activity.image')
    this.activity['entity'] = 'activity';
    //this.activity['image'] = image
    this.activity.id = this.current_activity.slug;
  },

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    updateActivity: function updateActivity() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formData, _ref3, model;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;

                _context.prev = 1;
                formData = new FormData();


                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(_this.activity).forEach(function (_ref) {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                      key = _ref2[0],
                      value = _ref2[1];

                  console.log(key, value);
                  if (value !== null) {
                    formData.append(key, value);
                  }
                });

                console.log(formData);

                _context.next = 7;
                return _this.store(formData).then(function () {
                  _this.$emit('close');

                  _this.activity = _this.defineActivity();
                }).catch(function (error) {
                  var data = error.response.data;
                  if (data.errors) {
                    var errors = data.errors;
                    console.log(errors);
                    for (var item in errors) {
                      for (var i = 0; i < errors[item].length; i++) {
                        window.$toast.error(errors[item][i]);
                      }
                    }
                  }
                });

              case 7:
                _ref3 = _context.sent;
                model = _ref3.model;
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](1);

                console.log('FAILURE!!');
                console.log({ error: _context.t0 });

              case 15:
                _context.prev = 15;

                _this.loading = false;
                return _context.finish(15);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 11, 15, 18]]);
      }))();
    },
    emitClose: function emitClose() {
      this.$emit('close');
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapActions */])(['store']), {
    onFileChange: function onFileChange(e) {
      this.loadImage = true;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      console.log(e.target.files[0]);
      this.activity.image_path = e.target.files[0];
    },
    onStudyActivityFileChange: function onStudyActivityFileChange(e) {
      this.loadImage = true;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      console.log(files);
      this.activity.study_information_path = e.target.files[0];
    }
  }),
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_7__components_assets_Modal_Modal___default.a
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_social_reasons_TrmChangeModal__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_social_reasons_TrmChangeModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_social_reasons_TrmChangeModal__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateBudget',
  data: function data() {
    return {
      loading: false,
      view: {
        entity: 'budget',
        id: this.$route.params.id
      },
      budgetCurrentItem: this.defineBudgetItem(),
      budgetitems: [],
      budget: this.defineBudget(),
      subtotal: 0,
      total: 0,
      checked: false,
      boxtrmchange: false,
      selectedSocialReason: {},
      country_select_id: null,
      accounts_client: null,
      social_country_id: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    countries: 'getAccountCountries',
    socialreasons: 'getSocialReasons',
    accounts: 'getAccounts',
    campaigns: 'getCampaigns',
    states: 'getBudgetStates',
    user: 'getUser',
    projects: 'getProjects',
    elements: 'getBudgetElements',
    clients: 'getClients',
    ejecutives: 'getUsers',
    suppliers: 'getSuppliers'
  }), {
    filteredAccounts: function filteredAccounts() {
      var _this = this;

      return this.accounts.filter(function (account) {
        var social_reason = _this.budget.social_reason_id ? account.social_reason_id == _this.budget.social_reason_id : true;
        var country = _this.country_select_id ? item.country_id == _this.country_select_id : true;

        return social_reason && country;
      });
    },
    filteredProjects: function filteredProjects() {
      var _this2 = this;

      return this.projects.filter(function (project) {
        if (project.account_id == _this2.budget.account_id || project.account_id == _this2.budget.account_id) {
          return project;
        }
      });
    },
    filteredClients: function filteredClients() {
      var _this3 = this;

      return this.clients.filter(function (item) {
        if (item.country_id == _this3.social_country_id) {
          return item;
        }
      });
    },
    filteredCampaigns: function filteredCampaigns() {
      var _this4 = this;

      return this.campaigns.filter(function (campaign) {
        if (campaign.project_id == _this4.budget.project_id || campaign.project_id == _this4.budget.project_id) {
          return campaign;
        }
      });
    },
    filteredBudgetElements: function filteredBudgetElements() {
      var _this5 = this;

      return this.elements.filter(function (element) {
        if (element.account_id == _this5.budget.account_id || element.account_id == _this5.budget.account_id) {
          return element;
        }
      });
    },
    filteredEjecutives: function filteredEjecutives() {
      return this.ejecutives.filter(function (ejecutive) {
        if ([5].includes(ejecutive.roles[0].id)) {
          return ejecutive;
        }
      });
    },
    filteredSocialReasonsWithoutTrm: function filteredSocialReasonsWithoutTrm() {
      var _this6 = this;

      var current_month = new Date().getMonth() + 1;
      var current_year = new Date().getFullYear();

      return this.socialreasons.filter(function (socialreason) {
        if (!_this6.searchMonth(socialreason.trm_change, current_month, current_year)) {
          return socialreason;
        }
      });
    },
    taxSubtotal: function taxSubtotal() {
      var _this7 = this;

      return this.budgetitems.reduce(function (acc, item) {
        return acc + _this7.percentCalculator(item.iva, item.quantity * item.unit_value);
      }, 0);
    },
    commissionSubtotal: function commissionSubtotal() {
      var _this8 = this;

      return this.budgetitems.reduce(function (acc, item) {
        return acc + _this8.percentCalculator(item.commission, item.quantity * item.unit_value);
      }, 0);
    }
  }),
  beforeMount: function beforeMount() {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this9.getList('accountcountry');

            case 3:
              _context.next = 5;
              return _this9.getList('socialreason');

            case 5:
              _context.next = 7;
              return _this9.getList('account');

            case 7:
              _context.next = 9;
              return _this9.getList('project');

            case 9:
              _context.next = 11;
              return _this9.getList('campaign');

            case 11:
              _context.next = 13;
              return _this9.getList('budgetstate');

            case 13:
              _context.next = 15;
              return _this9.getList('budgetelement');

            case 15:
              _context.next = 17;
              return _this9.getList('client');

            case 17:
              _context.next = 19;
              return _this9.getList('user');

            case 19:
              _context.next = 21;
              return _this9.getAll('supplier');

            case 21:

              _this9.loading = true;
              _context.next = 26;
              break;

            case 24:
              _context.prev = 24;
              _context.t0 = _context['catch'](0);

            case 26:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this9, [[0, 24]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    defineBudget: function defineBudget() {
      return {
        client_id: null,
        ejecutive_id: null,

        name: '',
        number: '',
        date: '',
        entity: 'budget',
        path: '',
        created_by: null,

        reference: null,
        type: null,

        country_id: null,
        social_reason_id: null,
        account_id: null,
        project_id: null,
        campaign_id: null,

        money_code: null,
        iva: 0,
        commission: 0,
        usd_convertion: null,
        trm_change_id: null,

        usd_subtotal: 0,
        usd_total: 0
      };
    },
    updateSocialReasonConvertion: function updateSocialReasonConvertion(response) {
      var trm_change_id = response.trm_change_id,
          money_code = response.money_code,
          usd_convertion = response.usd_convertion;


      if (!usd_convertion) {
        this.boxtrmchange = true;
      }

      this.budget.money_code = money_code;
      this.budget.usd_convertion = usd_convertion;
      this.budget.trm_change_id = trm_change_id;
    },

    defineBudgetItem: function defineBudgetItem() {
      return {
        id: null,
        quantity: 1
      };
    },
    checkBudget: function checkBudget() {
      if (!this.budgetitems.length) {
        window.$toast.info('No hay elementos seleccionados');
        return;
      }

      if (!this.budget.usd_convertion) {
        window.$toast.info('Actualice las conversiones en la seccion de paises');
        return;
      }

      this.checked = true;
    },
    selectSocialReason: function selectSocialReason() {
      var _this10 = this;

      var response = this.socialreasons.find(function (socialreason) {
        return socialreason.id == _this10.budget.social_reason_id;
      });
      if (response) {
        this.social_country_id = response.country_id;
        this.updateSocialReasonConvertion(response);
        this.selectedSocialReason = response;
      } else {
        return {};
      }
    },
    createBudget: function createBudget() {
      var _this11 = this;

      if (!this.budgetitems.length) {
        window.$toast.info('No hay elementos seleccionados');
        return;
      }

      var vm = this;
      vm.budget.created_by = this.user.id;
      vm.budget.items = this.budgetitems;

      vm.budget.subtotal = this.subtotal;
      vm.budget.subtotal_internal = this.subtotal_internal;
      vm.budget.total = this.total;
      vm.budget.total_internal = this.total_internal;
      vm.budget.iva = this.taxSubtotal;
      vm.budget.commission = this.commissionSubtotal;
      vm.budget.usd_tax = this.taxSubtotal / vm.budget.usd_convertion;
      vm.budget.usd_commission = this.commissionSubtotal / vm.budget.usd_convertion;
      //console.log(vm.budget)
      vm.loading = false;
      vm.store(vm.budget).then(function (item) {
        vm.$router.replace(vm.$route.query.redirect || '/admin/business/budgets');
      }).catch(function (error) {
        console.log('FAILURE!!');
        vm.loading = true;
      }).finally(function () {
        vm.loading = true;
        _this11.defineBudget();
      });
    },
    createVersion: function createVersion() {
      var vm = this;
      vm.loading = false;
      window.$('#create').button('loading');
      vm.version.email_id = this.email.id;
      vm.store(vm.version).then(function (item) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/business/budgets');
      }).catch(function (message) {
        window.$('#create').button('reset');
        vm.loading = true;
      });
    },
    updateVersion: function updateVersion(item) {
      var vm = this;
      vm.loading = false;
      window.$('#editversion').button('loading');
      vm.version_current.id = item.id;
      vm.store(vm.version_current).then(function (item) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/business/budgets');
      }).catch(function (message) {
        window.$('#editversion').button('reset');
        vm.loading = true;
      });
    },
    addItem: function addItem() {
      var _this12 = this;

      var item = this.elements.find(function (element) {
        return element.id == _this12.budgetCurrentItem.id;
      });

      var object = {
        name: item ? item.name : 'Titulo',
        description: null,
        quantity: parseInt(this.budgetCurrentItem.quantity),
        unit_value: item ? item.value : 0,
        unit_value_internal: item ? item.value : 0,
        iva: 0,
        commission: 0,
        total: null,
        supplier_id: null
      };
      this.budgetitems.push(object);

      this.budgetCurrentItem = this.defineBudgetItem();
    },
    formatPrice: function formatPrice(value) {
      var val = (value / 1).toFixed(5); // 5 decimales

      var _val$split = val.split('.'),
          _val$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_val$split, 2),
          integer = _val$split2[0],
          decimal = _val$split2[1]; // separar partes

      // aplicar separador de miles SOLO al entero


      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

      return integer + ',' + decimal; // unir con coma decimal
    },
    percentCalculator: function percentCalculator(percent, value) {
      var totalIncludePercent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (percent) {
        var ivaDecimal = totalIncludePercent ? (100 + percent) / 100 : percent / 100;
        return ivaDecimal * value;
      }

      if (totalIncludePercent) {
        return value;
      }

      return 0;
    },
    resetBudgetItems: function resetBudgetItems(element) {
      if (element == 'social_reason_id') {
        this.budgetitems = [];
        this.budget.account_id = null;
        this.budget.project_id = null;
      }

      if (element == 'account_id') {
        this.budgetitems = [];
        this.budget.project_id = null;
      }
    },
    accountsClient: function accountsClient() {
      var _this13 = this;

      var client = this.clients.find(function (_ref) {
        var id = _ref.id;
        return id === _this13.budget.client_id;
      });
      this.accounts_client = client.accounts;
    },
    searchMonth: function searchMonth(trms, month, year) {
      var response = false;

      trms.forEach(function (trm) {
        if (trm.month == month && trm.year == year) {
          response = true;
        }
      });

      return response;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['show', 'getAll', 'getList', 'update', 'store'])),
  watch: {
    budgetitems: {
      deep: true,

      handler: function handler(value) {
        var _this14 = this;

        this.subtotal = 0;
        this.subtotal_internal = 0;
        this.total = 0;
        this.total_internal = 0;
        this.budgetitems.forEach(function (item) {
          _this14.subtotal += item.quantity * item.unit_value;
          _this14.subtotal_internal += item.quantity * item.unit_value_internal;
          _this14.total += item.quantity * item.unit_value + _this14.percentCalculator(item.iva, item.quantity * item.unit_value, false) + _this14.percentCalculator(item.commission, item.quantity * item.unit_value, false);
          _this14.total_internal += item.quantity * item.unit_value_internal + _this14.percentCalculator(item.iva, item.quantity * item.unit_value_internal, false) + _this14.percentCalculator(item.commission, item.quantity * item.unit_value_internal, false);
        });

        this.budget.usd_subtotal = this.subtotal / this.budget.usd_convertion;
        this.budget.usd_total = this.total / this.budget.usd_convertion;
      }
    }
  },
  components: {
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a,
    TrmChangeModal: __WEBPACK_IMPORTED_MODULE_6__components_admin_social_reasons_TrmChangeModal___default.a
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListBudget',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      supplier: this.defineSupplier(),
      supplier_current: {},
      filter: this.clearFilter(),
      pagination: {
        currentPage: 1,
        lastPage: 1,
        total: 0,
        perPage: 15
      },
      months: [{ id: '01', name: 'ENERO' }, { id: '02', name: 'FEBRERO' }, { id: '03', name: 'MARZO' }, { id: '04', name: 'ABRIL' }, { id: '05', name: 'MAYO' }, { id: '06', name: 'JUNIO' }, { id: '07', name: 'JULIO' }, { id: '08', name: 'AGOSTO' }, { id: '09', name: 'SEPTIEMBRE' }, { id: '10', name: 'OCTUBRE' }, { id: '11', name: 'NOVIEMBRE' }, { id: '12', name: 'DICIEMBRE' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    user: 'getUser',
    suppliers: 'getSuppliers',
    countries: 'getAccountCountries',
    accounts: 'getAccounts',
    budgets: 'getBudgets',
    clients: 'getClients'
  }), {
    filteredBudgets: function filteredBudgets() {
      var _this = this;

      return this.budgets.filter(function (item) {
        var slug = _this.filter.slug ? item.slug.toLowerCase().includes(_this.filter.slug.toLowerCase()) : true;
        var account = _this.filter.account ? _this.filter.account == item.account_id : true;
        var client = _this.filter.client ? _this.filter.client == item.client_id : true;
        var month = _this.filter.month ? _this.filter.month == item.created_at.substr(5, 2) : true;

        return slug && account && client && month;
      });
    },
    paginationPages: function paginationPages() {
      var pages = [];
      var current = this.pagination.currentPage;
      var last = this.pagination.lastPage;
      var start = Math.max(1, current - 2);
      var end = Math.min(last, current + 2);
      for (var i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  }),
  beforeMount: function beforeMount() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this2.getAll('supplier');

            case 3:
              _context.next = 5;
              return _this2.getList('accountcountry');

            case 5:
              _context.next = 7;
              return _this2.getList('account');

            case 7:
              _context.next = 9;
              return _this2.fetchBudgets();

            case 9:
              _context.next = 11;
              return _this2.getList('client');

            case 11:

              _this2.loading = true;
              _context.next = 16;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context['catch'](0);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 14]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    defineSupplier: function defineSupplier() {
      return {
        social_reason: null,
        contact: null,
        nit: null,
        address: null,
        telphone: null,
        cellphone: null,
        email: null,
        link: null,
        entity: 'supplier'
      };
    },
    formatPrice: function formatPrice(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    clearFilter: function clearFilter() {
      return {
        account: null,
        client: null,
        month: null,
        slug: ''
      };
    },
    fetchBudgets: function fetchBudgets() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = 'page=' + _this3.pagination.currentPage + '&per_page=' + _this3.pagination.perPage;
                _context2.next = 3;
                return _this3.getList(['budget', params]);

              case 3:
                response = _context2.sent;

                if (response.pagination) {
                  _this3.pagination.currentPage = response.pagination.current_page;
                  _this3.pagination.lastPage = response.pagination.last_page;
                  _this3.pagination.total = response.pagination.total;
                  _this3.pagination.perPage = response.pagination.per_page;
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    changePage: function changePage(page) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(page < 1 || page > _this4.pagination.lastPage)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                _this4.pagination.currentPage = page;
                _context3.next = 5;
                return _this4.fetchBudgets();

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['getAll', 'getList', 'store', 'update'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_partials_LoadingWhite__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListTask',
  data: function data() {
    var _ref;

    return _ref = {
      loading: false,
      boxedit: false,
      view: {
        entity: 'budget',
        id: this.$route.params.id
      },
      budgetCurrentItem: {}
    }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'budgetCurrentItem', this.defineBudgetItem()), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'budgetitems', []), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'version', this.defineBudget()), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'subtotal', 0), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'subtotal_internal', 0), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'total', 0), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'checked', false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'createNewVersion', false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'selectedSocialReason', null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, 'current', {}), _ref;
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    countries: 'getAccountCountries',
    socialreasons: 'getSocialReasons',
    suppliers: 'getSuppliers',
    accounts: 'getAccounts',
    budgets: 'getBudgets',
    budget: 'getBudget',
    campaigns: 'getCampaigns',
    user: 'getUser',
    projects: 'getProjects',
    elements: 'getBudgetElements',
    clients: 'getClients',
    ejecutives: 'getUsers'
  }), {
    filteredAccounts: function filteredAccounts() {
      var _this = this;

      return this.accounts.filter(function (account) {
        if (account.social_reason_id == _this.current.social_reason_id || account.social_reason_id == _this.current.social_reason_id) {
          return account;
        }
      });
    },
    filteredProjects: function filteredProjects() {
      var _this2 = this;

      return this.projects.filter(function (project) {
        if (project.account_id == _this2.current.account_id || project.account_id == _this2.current.account_id) {
          return project;
        }
      });
    },
    filteredCampaigns: function filteredCampaigns() {
      var _this3 = this;

      return this.campaigns.filter(function (campaign) {
        if (campaign.project_id == _this3.current.project_id || campaign.project_id == _this3.current.project_id) {
          return campaign;
        }
      });
    },
    filteredBudgetElements: function filteredBudgetElements() {
      var _this4 = this;

      return this.elements.filter(function (element) {
        if (element.account_id == _this4.current.account_id || element.account_id == _this4.current.account_id) {
          return element;
        }
      });
    },
    filteredEjecutives: function filteredEjecutives() {
      return this.ejecutives.filter(function (ejecutive) {
        if ([4, 5].includes(ejecutive.team_id)) {
          return ejecutive;
        }
      });
    },
    taxSubtotal: function taxSubtotal() {
      var _this5 = this;

      return this.budgetitems.reduce(function (acc, item) {
        return acc + _this5.percentCalculator(item.iva, item.quantity * item.unit_value);
      }, 0);
    },
    commissionSubtotal: function commissionSubtotal() {
      var _this6 = this;

      return this.budgetitems.reduce(function (acc, item) {
        return acc + _this6.percentCalculator(item.commission, item.quantity * item.unit_value);
      }, 0);
    }
  }),
  beforeMount: function beforeMount() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this7.getAll('socialreason');

            case 3:
              _context.next = 5;
              return _this7.getList('project');

            case 5:
              _context.next = 7;
              return _this7.getList('campaign');

            case 7:
              _context.next = 9;
              return _this7.getList('budgetstate');

            case 9:
              _context.next = 11;
              return _this7.getList('budgetelement');

            case 11:
              _context.next = 13;
              return _this7.getAll('supplier');

            case 13:
              _context.next = 15;
              return _this7.getList('accountcountry');

            case 15:
              _context.next = 17;
              return _this7.getList('account');

            case 17:
              _context.next = 19;
              return _this7.getList('budget');

            case 19:
              _context.next = 21;
              return _this7.getList('client');

            case 21:
              _context.next = 23;
              return _this7.getList('user');

            case 23:
              _context.next = 25;
              return _this7.lookCurrentBudget();

            case 25:
              _this7.loading = true;
              _context.next = 28;
              return JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this7.budget));

            case 28:
              _this7.current = _context.sent;
              _context.next = 31;
              return _this7.selectSocialReason();

            case 31:

              _this7.budgetitems = _this7.current.versions[0].items;
              _this7.current.usd_subtotal = _this7.current.versions[0].usd_subtotal;
              _this7.current.usd_total = _this7.current.versions[0].usd_total;
              _context.next = 38;
              break;

            case 36:
              _context.prev = 36;
              _context.t0 = _context['catch'](0);

            case 38:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this7, [[0, 36]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    updateSocialReasonConvertion: function updateSocialReasonConvertion(response) {
      var money_code = response.money_code,
          usd_convertion = response.usd_convertion,
          updated_conversion = response.updated_conversion;


      this.current.money_code = money_code;
      this.current.usd_convertion = usd_convertion;
      this.current.updated_conversion = updated_conversion;
    },
    formatPrice: function formatPrice(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    percentCalculator: function percentCalculator(percent, value) {
      var totalIncludePercent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (percent) {
        var ivaDecimal = totalIncludePercent ? (100 + percent) / 100 : percent / 100;
        return ivaDecimal * value;
      }

      if (totalIncludePercent) {
        return value;
      }

      return 0;
    },
    lookCurrentBudget: function lookCurrentBudget() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this8.show(_this8.view);

              case 3:

                _this8.loading = true;
                _context2.next = 8;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](0);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8, [[0, 6]]);
      }))();
    },

    defineBudget: function defineBudget() {
      return {
        name: '',
        number: '',
        date: '',
        entity: 'budget',
        path: '',
        created_by: null,

        reference: null,
        type: null,

        country_id: null,
        social_reason_id: null,
        account_id: null,
        project_id: null,
        campaign_id: null,

        money_code: null,
        iva: 0,
        usd_convertion: null,
        updated_conversion: null,

        usd_subtotal: 0,
        usd_total: 0
      };
    },
    defineBudgetItem: function defineBudgetItem() {
      return {
        id: null,
        quantity: 1
      };
    },
    checkBudget: function checkBudget() {
      if (!this.budgetitems.length) {
        window.$toast.info('No hay elementos seleccionados');
        return;
      }

      if (!this.current.usd_convertion) {
        window.$toast.info('Actualice las conversiones en la seccion de paises');
        return;
      }

      this.checked = true;
    },
    createVersion: function createVersion() {
      if (!this.budgetitems.length) {
        window.$toast.info('No hay elementos seleccionados');
        return;
      }

      var vm = this;
      vm.current.created_by = this.user.id;
      vm.current.items = this.budgetitems;

      vm.current.subtotal = this.subtotal;
      vm.current.subtotal_internal = this.subtotal_internal;
      vm.current.total = this.total;
      vm.current.total_internal = this.total_internal;
      vm.current.iva = this.taxSubtotal;
      vm.current.commission = this.commissionSubtotal;
      vm.current.usd_tax = this.taxSubtotal / vm.current.usd_convertion;
      vm.current.usd_commission = this.commissionSubtotal / vm.current.usd_convertion;
      vm.current.entity = 'budget';
      vm.update(vm.current).then(function (item) {
        vm.$router.replace(vm.$route.query.redirect || '/admin/business/budgets');
      }).catch(function (error) {
        console.log('FAILURE!!');
      }).finally(function () {
        vm.loading = true;
        //this.defineBudget()
      });
    },
    addItem: function addItem() {
      var _this9 = this;

      var item = this.elements.find(function (element) {
        return element.id == _this9.budgetCurrentItem.id;
      });

      var object = {
        name: item ? item.name : 'Titulo',
        description: null,
        quantity: parseInt(this.budgetCurrentItem.quantity),
        unit_value: item ? item.value : 0,
        unit_value_internal: item ? item.value : 0,
        iva: 0,
        commission: 0,
        total: null,
        supplier_id: null
      };
      this.budgetitems.push(object);

      this.budgetCurrentItem = this.defineBudgetItem();
    },
    selectSocialReason: function selectSocialReason() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                response = _this10.socialreasons.find(function (socialreason) {
                  return socialreason.id == _this10.current.social_reason_id;
                });

                if (!response) {
                  _context3.next = 6;
                  break;
                }

                _this10.updateSocialReasonConvertion(response);
                _this10.selectedSocialReason = response;
                _context3.next = 7;
                break;

              case 6:
                return _context3.abrupt('return', {});

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this10);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['show', 'getAll', 'getList', 'store', 'update'])),
  watch: {
    budgetitems: {
      deep: true,

      handler: function handler(value) {
        var _this11 = this;

        this.subtotal = 0;
        this.total = 0;
        this.total_internal = 0;
        this.budgetitems.forEach(function (item) {
          _this11.subtotal += item.quantity * item.unit_value;
          _this11.subtotal_internal += item.quantity * item.unit_value_internal;
          _this11.total += item.quantity * item.unit_value + _this11.percentCalculator(item.iva, item.quantity * item.unit_value, false) + _this11.percentCalculator(item.commission, item.quantity * item.unit_value, false);
          _this11.total_internal += item.quantity * item.unit_value_internal + _this11.percentCalculator(item.iva, item.quantity * item.unit_value_internal, false) + _this11.percentCalculator(item.commission, item.quantity * item.unit_value_internal, false);
        });

        this.version.usd_subtotal = this.version.usd_convertion * this.subtotal;
        this.version.usd_total = this.version.usd_convertion * this.total;
      }
    }
  },
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_portal_vue__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_portal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_portal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_kalendar_vue__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_luxon__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_luxon__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_portal_vue___default.a);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminCalendarUser',
  data: function data() {
    return {
      loading: false,
      id: this.$route.params.id,
      calendar_settings: {
        view_type: 'week',
        style: 'material_design',
        cell_height: 10,
        scrollToNow: true,
        military_time: false,
        read_only: false,
        day_starts_at: 7,
        day_ends_at: 22,
        overlap: true,
        hide_dates: [],
        hide_days: [5, 6],
        past_event_creation: true
      },
      new_appointment: this.clearPopupCreate(),
      popup_information: {},
      renderComponent: true,
      user_calendar: null,
      calendars: [],
      buttonIsLoading: false,
      loadCalendar: false,
      event_current: null,
      filter: {
        date: null
      },
      editIndex: null,
      current_calendar: {
        title: '',
        id: '',
        entity: 'calendar',
        from: ''
      },
      message: null,
      start_ia: false,
      icon_ia: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
    user: 'getUser'
  }), {
    filteredCalendars: function filteredCalendars() {
      var _this = this;

      return this.calendars.filter(function (item) {
        var date = _this.filter.date ? _this.filter.date == item.from.substr(0, 10) : true;
        return date;
      });
    }
  }),
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_9_vue__["default"].filter('formatToHours', function (value, how) {
      var dt = __WEBPACK_IMPORTED_MODULE_12_luxon__["DateTime"].fromISO(value);
      return dt.toLocaleString(__WEBPACK_IMPORTED_MODULE_12_luxon__["DateTime"].TIME_24_SIMPLE);
    });
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this2.getUser();

            case 3:
              _context.next = 5;
              return _this2.getCalendars();

            case 5:
              _context.next = 9;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

            case 9:
              _context.prev = 9;

              _this2.loading = true;
              return _context.finish(9);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 7, 9, 12]]);
    }))();
  },

  watch: {
    calendar_settings: {
      handler: function handler(newValue) {
        this.kalendarKey = new Date().valueOf();
      },

      deep: true
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({
    clearPopupCreate: function clearPopupCreate() {
      return {
        title: null,
        description: null
      };
    },
    getCalendars: function getCalendars() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, list, formattedList;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loading = false;
                _context2.prev = 1;
                _context2.next = 4;
                return _this3.getListCalendarsMongo('/calendar/list?user_id=' + _this3.user_calendar.id);

              case 4:
                _ref = _context2.sent;
                list = _ref.list;
                formattedList = list.map(function (item) {
                  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, item, {
                    data: {
                      title: item.title,
                      description: item.description,
                      user_id: item.user_id,
                      id: item.id
                    }
                  });
                });
                //console.log(formattedList)

                _this3.calendars = formattedList;
                //console.log(list.length)
                _this3.loading = true;
                _this3.loadCalendar = true;
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](1);

                console.log(_context2.t0);
                _this3.loading = true;

              case 16:
                _context2.prev = 16;

                _this3.loading = true;
                return _context2.finish(16);

              case 19:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 12, 16, 19]]);
      }))();
    },
    addEvent: function addEvent(popup_data, form_data) {
      var _payload;

      this.buttonIsLoading = true;
      var vm = this;
      vm.loading = false;
      var payload = (_payload = {
        title: vm.new_appointment.description,
        description: vm.new_appointment.description
      }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_payload, 'description', '-'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_payload, 'from', popup_data.start_time), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_payload, 'to', popup_data.end_time), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_payload, 'user_id', this.user_calendar.id), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_payload, 'entity', 'calendar'), _payload);
      vm.store(payload).then(function (item) {
        location.reload();
      }).catch(function (error) {
        var errors = error.response && error.response.data ? error.response.data.errors : [];

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(errors).forEach(function (_ref2) {
          var _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
              field = _ref3[0],
              messages = _ref3[1];

          console.log('Campo: ' + field);
          if (Array.isArray(messages)) {
            messages.forEach(function (msg) {
              return window.$toast.error(msg);
            });
          } else {
            window.$toast.error(messages);
          }
        });
        vm.loading = true;
      }).finally(function () {
        vm.loading = true;
      });
    },
    editItem: function editItem(index, item) {
      console.log(item);
      this.editIndex = index;
      this.current_calendar.title = item.title;
      this.current_calendar.id = item.id;
      this.current_calendar.from = item.from;
    },
    updateItem: function updateItem() {
      var vm = this;
      vm.loading = false;
      console.log(vm.current_calendar);

      vm.put(vm.current_calendar).then(function (item) {
        location.reload();
      }).catch(function (message) {
        vm.loading = true;
      }).finally(function () {
        vm.loading = true;
      });
    },
    removeEvent: function removeEvent(id) {
      var vm = this;
      vm.loading = false;
      vm.form = {
        id: id,
        entity: 'calendar'
      };
      console.log(vm.form);
      vm.remove(vm.form).then(function (item) {
        location.reload();
      }).catch(function (message) {
        vm.loading = true;
      }).finally(function () {
        vm.loading = true;
      });
    },
    removeEventKalendar: function removeEventKalendar(kalendarEvent) {
      this.removeEvent(kalendarEvent.kalendar_id);
    },
    removeEventList: function removeEventList(calendar) {
      //console.log(calendar)
      this.removeEvent(calendar.id);
    },
    handleEventClick: function handleEventClick(event) {
      this.event_current = event;
    },
    closePopups: function closePopups() {
      this.$kalendar.closePopups();
    },
    getUser: function getUser() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref4, model;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.loading = false;
                _context3.prev = 1;
                _context3.next = 4;
                return _this4.get('/user-slug/' + _this4.$route.params.id);

              case 4:
                _ref4 = _context3.sent;
                model = _ref4.model;

                _this4.user_calendar = model;
                _this4.loading = true;
                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](1);

                console.log(_context3.t0);
                _this4.loading = true;

              case 14:
                _context3.prev = 14;

                _this4.loading = true;
                return _context3.finish(14);

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[1, 10, 14, 17]]);
      }))();
    },
    IAreport: function IAreport() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var body, _ref5, response;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.start_ia = true;
                _this5.message = 'Analizando los eventos...';
                _context4.prev = 2;
                body = {
                  entity: 'calendar-ai',
                  user_id: _this5.user_calendar.id
                };
                _context4.next = 6;
                return _this5.post(body);

              case 6:
                _ref5 = _context4.sent;
                response = _ref5.response;

                _this5.message = response;
                _this5.icon_ia = false;
                _this5.loading = true;
                _context4.next = 17;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4['catch'](2);

                console.log(_context4.t0);
                _this5.loading = true;

              case 17:
                _context4.prev = 17;

                _this5.loading = true;
                return _context4.finish(17);

              case 20:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[2, 13, 17, 20]]);
      }))();
    },
    simpleMarkdownToHTML: function simpleMarkdownToHTML(text) {
      var hasTable = false;
      return text
      // Tablas
      .replace(/(\|.*\|\n*)+/gm, function (match) {
        hasTable = true;
        var rows = match.split('\n').filter(function (row) {
          return row.trim();
        }).map(function (row) {
          var cells = row.split('|').filter(function (cell) {
            return cell.trim();
          }).map(function (cell) {
            return cell.trim();
          });

          // Ignorar la fila separadora
          if (cells.some(function (cell) {
            return cell.includes('---');
          })) {
            return '';
          }

          var cellsHtml = cells.map(function (cell) {
            return '<td class="border p-2 text-sm whitespace-normal w-1/3">' + cell + '</td>';
          }).join('');

          return '<tr class="border-b hover:bg-gray-50">' + cellsHtml + '</tr>';
        }).filter(function (row) {
          return row;
        });

        return '\n                <table class="w-full">\n                  ' + rows.join('') + '\n                </table>';
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapActions */])(['get', 'getListCalendarsMongo', 'put', 'post', 'getList', 'store', 'remove'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_8__components_admin_partials_LoadingWhite___default.a,
    appKalendar: __WEBPACK_IMPORTED_MODULE_11_kalendar_vue__["a" /* Kalendar */]
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_DateClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_TodayFormat__ = __webpack_require__(51);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Week',
  data: function data() {
    return {
      loading: false,
      firstday: null,
      lastday: null,
      account_session: null,
      team_session: null,
      projects: null,
      today: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
    user: 'getUser',
    tasks: 'getTasks',
    hours: 'getHours'
  }), {
    filteredTasks: function filteredTasks() {
      var _this = this;

      return this.tasks.filter(function (item) {
        if (item.date >= _this.firstday.toISOString().slice(0, 10) && item.date <= _this.lastday.toISOString().slice(0, 10)) {
          return item;
        }
      });
    },
    filteredHours: function filteredHours() {
      return this.hours.filter(function (item) {
        if (item.team_id == localStorage.session_team) {
          return item;
        }
      });
    },
    sumHoursByProject: function sumHoursByProject() {
      var _this2 = this;

      var arr = [];
      this.tasks.filter(function (item) {
        if (item.date >= _this2.firstday.toISOString().slice(0, 10) && item.date <= _this2.lastday.toISOString().slice(0, 10)) {
          var row = {
            project_id: item.project_id,
            total: item.hours
          };
          arr.push(row);
        }
      });

      var res = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(arr.reduce(function (m, _ref) {
        var project_id = _ref.project_id,
            total = _ref.total;
        return m.set(project_id, (m.get(project_id) || 0) + total);
      }, new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a()), function (_ref2) {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
            project_id = _ref3[0],
            total = _ref3[1];

        return { project_id: project_id, total: total };
      });

      return res;
    },
    sumHoursByAccount: function sumHoursByAccount() {
      var _this3 = this;

      var arr = [];
      this.tasks.filter(function (item) {
        if (item.team_id == localStorage.session_team && item.date >= _this3.firstday.toISOString().slice(0, 10) && item.date <= _this3.lastday.toISOString().slice(0, 10)) {
          var row = {
            account_id: item.campaign_attribute.project_account_id,
            total: item.hours
          };
          arr.push(row);
        }
      });

      var res = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_array_from___default()(arr.reduce(function (m, _ref4) {
        var account_id = _ref4.account_id,
            total = _ref4.total;
        return m.set(account_id, (m.get(account_id) || 0) + total);
      }, new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a()), function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            account_id = _ref6[0],
            total = _ref6[1];

        return { account_id: account_id, total: total };
      });

      return res;
    }
  }),
  beforeMount: function beforeMount() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var query, query_projects;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this4.account_session = null;
              _this4.team_session = localStorage.session_team;

              _this4.week();

              //SEND ENTITY AND MUTATION
              query = 'account_session=' + _this4.user.accountsIds + '&team_session=' + _this4.team_session + '&states=all';
              query_projects = 'account_session=' + _this4.user.accountsIds + '&hours=true';
              _context.prev = 5;
              _context.next = 8;
              return _this4.getListTasksMongo(['task', query]);

            case 8:
              _context.next = 10;
              return _this4.getList(['project', query_projects]).then(function (item) {
                _this4.projects = item.list;
              }).catch(function (message) {
                _this4.$router.replace(_this4.$route.query.redirect || '/');
              });

            case 10:
              _this4.getAll('hour');

              _this4.loading = true;
              _context.next = 16;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context['catch'](5);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this4, [[5, 14]]);
    }))();
  },
  mounted: function mounted() {
    var newDate = new Date();
    var dd = newDate.getDate();
    var mm = newDate.getMonth() + 1;
    var yyyy = newDate.getFullYear();

    this.today = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__services_TodayFormat__["a" /* todayFormat */])();
  },

  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapActions */])(['getListTasksMongo', 'getList', 'getAll']), {
    week: function week() {
      var curr = new Date();

      if (this.team_session == 1) {
        this.firstday = new Date(curr.getFullYear(), curr.getMonth(), 1);
        this.lastday = new Date(curr.getFullYear(), curr.getMonth() + 1, 0);
      } else {
        this.firstday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 1));
        this.lastday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 5));
      }
    },
    viewAccounts: function viewAccounts(val) {
      var query = '';

      if (val == 'all') {
        query = 'account_session=' + this.user.accountsIds + '&team_session=' + this.team_session + '&states=all';
        this.account_session = null;
      } else {
        this.account_session = localStorage.session_account;
        query = 'account_session=' + localStorage.session_account + '&team_session=' + this.team_session + '&states=all';
      }

      try {
        this.getListTasksMongo(['task', query]);

        this.loading = true;
      } catch (error) {}
    },
    viewAccountTask: function viewAccountTask(task) {
      localStorage.session_account = task.campaign_attribute.project_account_id;
      this.$router.push({ path: '/admin/tasks?task=' + task.id + 'account=' + task.campaign_attribute.project_account_id });
    },
    changeWeek: function changeWeek(val) {
      var curr = new Date(this.firstday);

      if (this.team_session == 1) {
        if (val == 'minus') {
          this.firstday = new Date(curr.getFullYear(), curr.getMonth() - 1);
          var new_date = new Date(this.firstday);
          this.lastday = new Date(new_date.getFullYear(), new_date.getMonth() + 1, 0);
        } else {
          this.firstday = new Date(curr.getFullYear(), curr.getMonth() + 1);
          var new_date = new Date(this.firstday);
          this.lastday = new Date(new_date.getFullYear(), new_date.getMonth() + 1, 0);
        }
      } else {
        if (val == 'minus') {
          this.firstday = new Date(curr.setDate(curr.getDate() - curr.getDay() - 6));
          this.lastday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 5));
        } else {
          this.firstday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 8));
          this.lastday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 5));
        }
      }
    },
    dateClass: function dateClass(task) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__services_DateClass__["a" /* handleDateClass */])('task', task, this.today);
    }
  }),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_Icon___default.a,
    handleDateClass: __WEBPACK_IMPORTED_MODULE_8__services_DateClass__["a" /* handleDateClass */],
    todayFormat: __WEBPACK_IMPORTED_MODULE_9__services_TodayFormat__["a" /* todayFormat */]
  }

});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListCampaign',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      campaign: {
        name: '',
        project_id: '',
        status: '',
        entity: 'campaign'
      },
      campaign_current: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    campaigns: 'getCampaigns',
    projects: 'getProjects'
  }), {
    filteredProjects: function filteredProjects() {
      return this.projects.filter(function (item) {
        if (item.account_id == localStorage.session_account) {
          return item;
        }
      });
    }
  }),
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var query;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              query = 'account_session=' + localStorage.session_account;
              _context.prev = 1;
              _context.next = 4;
              return _this.getList(['campaign', query]);

            case 4:
              _this.getList(['project', query]);

              _this.loading = true;
              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](1);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 8]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    createCampaign: function createCampaign() {
      var vm = this;
      window.$('#create').button('loading');
      vm.store(vm.campaign).then(function (item) {
        window.$('#campaign').modal('hide');
        vm.campaign = { name: '', entity: 'campaign' };
        vm.$router.replace(vm.$route.query.redirect || '/admin/campaigns');
      }).catch(function (error) {
        window.$('#create').button('reset');
        vm.campaign = { name: '', entity: 'campaign' };
      });
    },

    removeCampaign: function removeCampaign(value) {
      var vm = this;
      vm.form = {
        id: value.id,
        entity: 'campaign'
      };
      vm.loading = false;
      vm.remove(vm.form).then(function (item) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/campaigns');
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    editCampaign: function editCampaign(value) {
      this.boxedit = true;
      this.campaign = value;
    },
    closeEditCampaign: function closeEditCampaign() {
      this.boxedit = false;
      this.campaign_current = {};
    },
    updateCampaign: function updateCampaign(value) {
      var _this2 = this;

      var vm = this;
      vm.form = {
        id: vm.campaign.id,
        entity: 'campaign',
        name: vm.campaign_current.name,
        project_id: vm.campaign_current.project_id,
        status: vm.campaign_current.status
      };
      vm.loading = false;
      vm.update(vm.form).then(function (item) {
        vm.loading = true;
        vm.boxedit = false;
        vm.campaign = { name: '', entity: 'campaign' };
        vm.$router.replace(_this2.$route.query.redirect || '/admin/campaigns');
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    updateValue: function updateValue(attribute, e) {
      this.campaign_current[attribute] = e.target.value;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['getAll', 'getList', 'remove', 'store', 'update'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListCampaign',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      account_id: null,
      campaign: {
        name: '',
        project_id: null,
        status: '',
        entity: 'campaign'
      },
      campaign_current: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    filteredProjects: function filteredProjects() {
      var projects = this.projects,
          account_id = this.account_id;

      if (account_id == null) {
        return projects;
      }

      return projects.filter(function (item) {
        if (item.account_id == account_id) {
          return item;
        }
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    campaigns: 'getCampaigns',
    projects: 'getProjects',
    accounts: 'getAccounts'
  })),
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.getList('project');

            case 3:
              _context.next = 5;
              return _this.getList('campaign');

            case 5:
              _context.next = 7;
              return _this.getList('account');

            case 7:

              _this.loading = true;
              _context.next = 12;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](0);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 10]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    createCampaign: function createCampaign() {
      var vm = this;
      window.$('#create').button('loading');
      vm.store(vm.campaign).then(function (item) {
        window.$('#campaign').modal('hide');
        vm.campaign = { name: '', entity: 'campaign' };
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/campaigns');
      }).catch(function (error) {
        window.$('#create').button('reset');
        vm.campaign = { name: '', entity: 'campaign' };
      });
    },

    removeCampaign: function removeCampaign(value) {
      var vm = this;
      vm.form = {
        id: value.id,
        entity: 'campaign'
      };
      vm.loading = false;
      vm.remove(vm.form).then(function (item) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/campaigns');
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    editCampaign: function editCampaign(value) {
      this.boxedit = true;
      this.campaign = value;
    },
    closeEditCampaign: function closeEditCampaign() {
      this.boxedit = false;
      this.campaign_current = {};
    },
    updateCampaign: function updateCampaign(value) {
      var _this2 = this;

      var vm = this;
      vm.form = {
        id: vm.campaign.id,
        entity: 'campaign',
        name: vm.campaign_current.name,
        project_id: vm.campaign_current.project_id,
        status: vm.campaign_current.status
      };
      vm.loading = false;
      vm.update(vm.form).then(function (item) {
        vm.loading = true;
        vm.boxedit = false;
        vm.campaign = { name: '', entity: 'campaign' };
        vm.$router.replace(_this2.$route.query.redirect || '/admin/traffic/campaigns');
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    updateValue: function updateValue(attribute, e) {
      this.campaign_current[attribute] = e.target.value;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['getAll', 'getList', 'remove', 'store', 'update'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListTask',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      client: this.defineClient(),
      client_current: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    clients: 'getClients',
    countries: 'getAccountCountries'
  })),
  mounted: function mounted() {
    var _this = this;

    $('#create-modal').on('hidden.bs.modal', function () {
      _this.defineClient();
    });
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this2.getList('client');

            case 3:
              _context.next = 5;
              return _this2.getList('accountcountry');

            case 5:

              _this2.loading = true;
              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](0);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 8]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    defineClient: function defineClient() {
      return {
        social_reason: null,
        nit: null,
        address: null,
        telphone: null,
        contact_purchasing: null,
        cellphone_purchasing: null,
        email_purchasing: null,
        contact_treasury: null,
        cellphone_treasury: null,
        email_treasury: null,
        link: null,
        entity: 'client'
      };
    },
    createElement: function createElement() {
      var _this3 = this;

      var vm = this;
      window.$('#create').button('loading');
      vm.store(vm.client).then(function (item) {
        window.$('#create-modal').modal('hide');
        vm.$router.replace(vm.$route.query.redirect || '/admin/business/clients');
      }).catch(function (error) {
        console.log('FAILURE!!');
      }).finally(function () {
        window.$('#create').button('reset');
        vm.loading = true;
        _this3.client = _this3.defineClient();
      });
    },
    editElement: function editElement(value) {
      this.boxedit = true;
      this.client_current = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
    },
    closeEditElement: function closeEditElement() {
      this.boxedit = false;
      this.client_current = {};
    },
    updateEditElement: function updateEditElement(value) {
      var _this4 = this;

      var vm = this;
      vm.client_current.entity = 'client';
      vm.loading = false;
      vm.update(vm.client_current).then(function (item) {
        vm.loading = true;
        vm.boxedit = false;
        vm.client = _this4.defineClient();
        vm.$router.replace(vm.$route.query.redirect || '/admin/business/clients');
      }).catch(function (message) {
        vm.loading = true;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['getAll', 'getList', 'store', 'update'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssignAccountUser',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      view: {
        entity: 'client',
        id: this.$route.params.id
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    current: 'getClient',
    accounts: 'getAccounts'
  }), {
    filteredAccounts: function filteredAccounts() {
      var _this = this;

      return this.accounts.filter(function (account) {
        if (!_this.current.accounts.some(function (item) {
          return item.id == account.id;
        })) {
          return account;
        }
      });
    }
  }),
  beforeMount: function beforeMount() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this2.getList('account');

            case 3:
              _context.next = 5;
              return _this2.getList('socialreason');

            case 5:
              _context.next = 7;
              return _this2.lookCurrentElement();

            case 7:
              _this2.loading = true;
              _context.next = 12;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](0);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 10]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    addElement: function addElement(element, entity) {
      var _this3 = this;

      var form = {
        entity: entity,
        id: this.current.id,
        element_id: element.id
      };

      this.store(form).then(function () {
        _this3.lookCurrentElement();
      });
    },
    removeElement: function removeElement(element, entity) {
      var _this4 = this;

      var form = {
        entity: entity,
        id: this.current.id,
        element_id: element.id
      };

      this.update(form).then(function () {
        _this4.lookCurrentElement();
      });
    },
    lookCurrentElement: function lookCurrentElement() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this5.show(_this5.view);

              case 3:
                _this5.loading = true;
                _context2.next = 8;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](0);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[0, 6]]);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['show', 'getAll', 'getList', 'store', 'update'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashboardAdmin',
  data: function data() {
    return {
      loading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    users: 'getUsers',
    accounts: 'getAccounts',
    campaigns: 'getCampaigns',
    tasks: 'getTasks'
  })),
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _this.getList('campaign');
              _this.getList('account');
              _context.next = 5;
              return _this.getListTasksMongo('task');

            case 5:
              _this.loading = true;
              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](0);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['getListTasksMongo'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a
  }

});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Copy__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Copy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Copy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_email_EmailDownloadListButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_email_EmailDownloadListButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_email_EmailDownloadListButton__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashboardUser',
  data: function data() {
    return {
      loading: false,
      password: '',
      tip: null,
      emailsdownload: ['juan.garcia@inxaitcorp.com', 'juan.ruiz@inxaitcorp.com']
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.get('library/filter?category=Tips').then(function (data) {
                var model = data.model;


                if (model) {
                  _this.tip = model;
                }
              });

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context['catch'](0);

              window.$toast.error(_context.t0);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 5]]);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    usersession: 'getUser'
  })),
  beforeMount: function beforeMount() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.loading = true;

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    generatePassword: function generatePassword() {
      var all = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789*+=)(/&%$#!|[]';
      var mayus = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      var minus = 'abcdefghijklmnopqrstuvwxyz';
      var numbers = '0123456789';
      var symbols = '*+=)(/&%$#!|[]';
      this.password = '';
      var new_pass = '';
      for (var i = 0; i < 2; i++) {
        var generate_mayus = mayus[Math.floor(Math.random() * mayus.length)];
        var generate_minus = minus[Math.floor(Math.random() * minus.length)];
        var generate_numbers = numbers[Math.floor(Math.random() * numbers.length)];
        var generate_symbols = symbols[Math.floor(Math.random() * symbols.length)];
        new_pass += generate_mayus;
        new_pass += generate_minus;
        new_pass += generate_numbers;
        new_pass += generate_symbols;
      }
      for (var _i = 0; _i < 8; _i++) {
        var generate_all = all[Math.floor(Math.random() * all.length)];
        new_pass += generate_all;
      }
      this.password = new_pass;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get'])),
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default.a,
    Copy: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Copy___default.a,
    EmailDownloadListButton: __WEBPACK_IMPORTED_MODULE_7__components_admin_email_EmailDownloadListButton___default.a
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ListDevelopments',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      development: this.defineDevelopment(),
      developments: null,
      status: null,
      development_current: {},
      filter: {
        status: 'En cotización'
      }
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.getItems();
    this.getList('account').then(function () {
      _this.loading = true;
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    user: 'getUser',
    accounts: 'getAccounts'
  }), {
    filteredDevelopments: function filteredDevelopments() {
      var _this2 = this;

      return this.developments.filter(function (item) {
        var status = _this2.filter.status ? item.status === _this2.filter.status : true;

        return status;
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    getItems: function getItems() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, list, status_get;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.loading = false;
                _context.prev = 1;
                _context.next = 4;
                return _this3.get('/development');

              case 4:
                _ref = _context.sent;
                list = _ref.list;
                status_get = _ref.status_get;

                _this3.developments = list;
                _this3.status = status_get;
                //console.log(this.user)
                _this3.loading = true;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);
                _this3.loading = true;

              case 16:
                _context.prev = 16;

                _this3.loading = true;
                return _context.finish(16);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[1, 12, 16, 19]]);
      }))();
    },
    defineDevelopment: function defineDevelopment() {
      return {
        title: '',
        account_id: '',
        hours: '',
        date: '',
        status: '',
        observations: '',
        entity: 'development'
      };
    },
    createDevelopment: function createDevelopment() {
      var vm = this;
      vm.loading = false;
      window.$('#create').button('loading');
      vm.post(vm.development).then(function (item) {
        window.$('#development').modal('hide');
        vm.defineDevelopment();
        vm.loading = true;
        window.$('#create').button('reset');
        window.location.reload();
      }).catch(function (error) {
        window.$('#create').button('reset');
        vm.defineDevelopment();
        vm.loading = true;
      });
    },

    editDevelopment: function editDevelopment(value) {
      this.boxedit = true;
      this.development = value;
    },
    closeEditDevelopment: function closeEditDevelopment() {
      this.boxedit = false;
      this.development_current = {};
    },
    updateValue: function updateValue(attribute, e) {
      this.development_current[attribute] = e.target.value;
    },
    updateDevelopment: function updateDevelopment() {
      var _this4 = this;

      var vm = this;
      vm.loading = false;

      vm.development_current.id = vm.development.id;
      vm.development_current.entity = 'development';
      //console.log(vm.development_current)
      vm.put(vm.development_current).then(function (item) {
        _this4.closeEditDevelopment();
        vm.defineDevelopment();
        vm.loading = true;
        window.location.reload();
      }).catch(function (error) {
        vm.defineDevelopment();
        vm.loading = true;
      });
    },

    removeDevelopment: function removeDevelopment(value) {
      var vm = this;
      vm.form = {
        id: value.id,
        entity: 'development'
      };
      vm.deleteItem(vm.form).then(function (item) {
        vm.loading = true;
        window.location.reload();
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    setFilter: function setFilter(value) {
      //console.log(value)
      this.filter.status = value;
      //this.getItems()
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get', 'post', 'put', 'deleteItem', 'getList'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_TitleCustom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_TitleCustom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_TitleCustom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_assets_MultiSelect_MultiSelect__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_assets_MultiSelect_MultiSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_assets_MultiSelect_MultiSelect__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['nums', 'user', 'email', 'options', 'email_validated'],
  components: {
    MultiSelect: __WEBPACK_IMPORTED_MODULE_6__components_assets_MultiSelect_MultiSelect___default.a,
    AppTitleCustom: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_TitleCustom___default.a
  },
  created: function created() {
    document.body.style.overflow = 'hidden';
  },
  beforeDestroy: function beforeDestroy() {
    document.body.style.overflow = null;
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([_this.getList('campaign'), _this.getList('project')]);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      emailButtonLoading: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['getList', 'store']), {
    addTag: function addTag(tag) {
      this.$emit('addTag', tag);
    },
    createElement: function createElement() {
      var _this2 = this;

      this.emailButtonLoading = true;
      var vm = this;
      window.$('#create').button('loading');
      vm.email.created_by = this.user.id;
      vm.urgent = vm.urgent == 0 ? false : true;
      vm.store(vm.email).then(function (item) {
        _this2.$emit('emailCreated');
        window.location.reload();
      }).catch(function (error) {
        console.log('FAILURE!!');
      }).finally(function () {
        _this2.emailButtonLoading = false;
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    filteredCampaigns: function filteredCampaigns() {
      var _this3 = this;

      return this.campaigns.filter(function (campaign) {
        return campaign.project_id == _this3.email.project_id;
      });
    },
    filteredProjects: function filteredProjects() {
      return this.projects.filter(function (campaign) {
        return campaign.account_id == localStorage.session_account;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    projects: 'getProjects',
    campaigns: 'getCampaigns'
  }))
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditEmail',
  data: function data() {
    return {
      loading: false,
      nums: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      view: {
        entity: 'email',
        id: this.$route.params.id
      },
      version: {
        entity: 'emailversion',
        observations: '',
        path: ''
      },
      aux_email: {
        entity: 'email',
        campaign_id: null,
        project_id: null
      },
      version_current: {
        entity: 'emailversion'
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    email: 'getEmail',
    campaigns: 'getCampaigns',
    teams: 'getTeams',
    states: 'getEmailStates',
    users: 'getUsers',
    projects: 'getProjects'
  }), {
    filteredCampaigns: function filteredCampaigns() {
      var _this = this;

      var campaigns = this.campaigns.filter(function (v) {
        return v.project_id == _this.aux_email.project_id;
      });

      var found = campaigns.some(function (el) {
        return el.id == _this.aux_email['campaign_id'];
      });
      if (this.email && !found) {
        this.aux_email['campaign_id'] = '';
      }
      return campaigns;
    },
    filteredUsers: function filteredUsers() {
      return this.users.filter(function (v) {
        return v.team_id == 1;
      });
    }
  }),
  beforeMount: function beforeMount() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this2.show(_this2.view);

            case 3:
              _this2.getList('project');
              _this2.getList('campaign');
              _this2.getList('emailstate');

              _this2.aux_email['campaign_id'] = _this2.email.campaign_id;
              _this2.aux_email['project_id'] = _this2.email.project_id;

              _this2.loading = true;
              _context.next = 13;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](0);

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 11]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    updateEmail: function updateEmail() {
      var vm = this;
      vm.loading = false;
      window.$('#edit').button('loading');
      vm.aux_email.id = this.email.id;
      vm.update(vm.aux_email).then(function (item) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/emails');
      }).catch(function (message) {
        window.$('#edit').button('reset');
        vm.loading = true;
      });
    },
    createVersion: function createVersion() {
      var vm = this;
      vm.loading = false;
      window.$('#create').button('loading');
      vm.version.email_id = this.email.id;
      vm.store(vm.version).then(function (item) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/emails');
      }).catch(function (message) {
        window.$('#create').button('reset');
        vm.loading = true;
      });
    },
    updateVersion: function updateVersion(item) {
      var vm = this;
      vm.loading = false;
      window.$('#editversion').button('loading');
      vm.version_current.id = item.id;
      vm.store(vm.version_current).then(function (item) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/emails');
      }).catch(function (message) {
        window.$('#editversion').button('reset');
        vm.loading = true;
      });
    },
    updateValue: function updateValue(attribute, e) {
      this.aux_email[attribute] = e.target.value;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['show', 'getAll', 'getList', 'update', 'store'])),
  components: {
    appLoading: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_TitleCustom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_TitleCustom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_partials_TitleCustom__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminEmailCheck',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      filter: {
        state: null,
        slug: ''
      },
      account_session: null,
      team_session: null,
      isUserEmployee: false,
      view: {
        entity: 'emailcheck',
        id: null
      },
      check_current: {
        entity: 'emailcheck',
        id: null
      }
    };
  },
  mounted: function mounted() {
    this.account_session = localStorage.session_account;
    this.team_session = localStorage.session_team;
    this.isUserEmployee = this.user.role != 4;
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    user: 'getUser',
    checks: 'getEmailChecks',
    emailCheck: 'getEmailCheck'
  }), {
    filteredCheckList: function filteredCheckList() {
      var _this = this;

      var emailChek = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.emailCheck.email_check));

      return emailChek.sort(function (a, b) {
        return a.type.team_id == _this.user.team_id ? -1 : 1;
      });
    },

    filteredEmails: function filteredEmails() {
      var _this2 = this;

      return this.checks.filter(function (item) {
        if (item.campaign.project.account_id == _this2.account_session) {
          if (_this2.filter.slug != "") {
            return item.slug.match(_this2.filter.slug);
          }
          if (_this2.filter.slug == "") {
            return item;
          }
        }
      });
    }
  }),
  beforeMount: function beforeMount() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this3.$route.params.id) {
                _this3.checkElement(_this3.$route.params.id);
              }

              _context.prev = 1;
              _context.next = 4;
              return _this3.getList('emailcheck');

            case 4:

              _this3.loading = true;
              _context.next = 9;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](1);

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3, [[1, 7]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    checkElement: function checkElement(value) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.view.id = value;
                _context2.next = 3;
                return _this4.show(_this4.view);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    changeCheckStatus: function changeCheckStatus(check, validation) {
      var vm = this;
      vm.check_current.id = check.id;
      vm.check_current.validation = validation;
      vm.store(vm.check_current).finally(function (element) {
        vm.checkElement(check.email_id);
      });
    },
    viewAccounts: function viewAccounts(val) {
      if (val == 'all') {
        this.account_session = null;
      } else {
        this.account_session = localStorage.session_account;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['show', 'getList', 'store', 'update'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default.a,
    appTitleCustom: __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_TitleCustom___default.a
  }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmailClassificationModal',
  props: ['email'],
  data: function data() {
    return {
      buttonisLoading: false,
      isLoading: false,
      form: {
        entity: 'emailclassification',
        current: 0,
        email_id: null
      },
      classifications: [],
      types: [{ name: 'Dinamico', value: 'dinamico' }, { name: 'Estático', value: 'estatico' }],
      emailClassification: {},
      errors: []
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var view, response, classifications, index, baseIndex, emailClassification, element;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              document.body.className = 'overflow-hidden';
              _this.isLoading = true;
              _context.prev = 2;
              view = {
                entity: 'emailclassification',
                id: _this.email.id
              };
              _context.next = 6;
              return _this.show(view);

            case 6:
              response = _context.sent;

              _this.emailClassification = response;

              classifications = _this.emailClassification.classifications;


              for (index = 1; index <= _this.emailClassification.number; index++) {
                baseIndex = index - 1;

                if (classifications[baseIndex] == undefined || classifications.length == 0) {
                  emailClassification = _this.deffineEmailClassification(index);

                  _this.classifications.push(emailClassification);
                } else {
                  element = {
                    position: index,
                    name: classifications[baseIndex].name,
                    type: classifications[baseIndex].type,
                    quantity: classifications[baseIndex].quantity,
                    checked: index == 1 ? true : false,
                    email_id: classifications[baseIndex].email_id,
                    hours: classifications[baseIndex].hours,
                    slug: classifications[baseIndex].slug
                  };

                  _this.classifications.push(element);
                }
              }
              _this.form.email_id = _this.emailClassification.id;
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](2);

              console.log(_context.t0);

            case 16:
              _context.prev = 16;

              _this.isLoading = false;
              return _context.finish(16);

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 13, 16, 19]]);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    document.body.classList.remove('overflow-hidden');
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    deffineEmailClassification: function deffineEmailClassification(position) {
      return {
        position: position,
        name: null,
        type: null,
        quantity: 1,
        checked: position == 1 ? true : false,
        email_id: this.emailClassification.id,
        hours: 0,
        slug: null
      };
    },
    proccessEmailType: function proccessEmailType(operation) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var oldCurrent;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.isLastElement && operation == 'sum')) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 3;
                return _this2.createEmailClassification();

              case 3:
                return _context2.abrupt('return');

              case 4:
                oldCurrent = operation == 'sum' ? _this2.form.current + 1 : _this2.form.current - 1;

                if (!(oldCurrent < 0 || _this2.isLastElement && operation == 'sum')) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt('return');

              case 7:

                if (operation == 'sum') {
                  _this2.classifications[oldCurrent].checked = true;
                } else {
                  _this2.classifications[_this2.form.current].checked = false;
                }

                _this2.form.current = oldCurrent;

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    createEmailClassification: function createEmailClassification() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var vm;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                vm = _this3;

                vm.buttonisLoading = true;
                vm.form.classifications = vm.classifications;
                _context3.next = 5;
                return vm.store(vm.form).then(function (item) {
                  vm.$emit('closeModal');
                }).catch(function (message) {
                  //
                }).finally(function () {
                  vm.buttonisLoading = false;
                });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['getList', 'store', 'update', 'show'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isLastElement: function isLastElement() {
      return this.classifications.length <= this.form.current + 1;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    user: 'getUser'
  })),
  components: {
    appLoading: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    text: {
      type: String,
      default: 'Descargar Lista'
    },
    classname: ''
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    downloadList: function downloadList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__services_axios__["a" /* default */].get('email/excel').then(function (response) {
        var data = response.data;
        var path = data.path;


        _this.$refs.download_emails.href = path;
        _this.$refs.download_emails.click();
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['get'])),
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon___default.a
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_TitleCustom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_TitleCustom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_TitleCustom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_assets_MultiSelect_MultiSelect__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_assets_MultiSelect_MultiSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_assets_MultiSelect_MultiSelect__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['nums', 'users', 'states', 'usersession', 'email_current'],
  data: function data() {
    return {
      version: this.defineVersion(),
      version_current: this.defineResponseVersion(),
      createVersionVariable: false,
      options: [],
      buttonIsLoading: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    defineVersion: function defineVersion() {
      return {
        entity: 'emailversion',
        path: ''
      };
    },
    defineResponseVersion: function defineResponseVersion() {
      return {
        entity: 'emailversion',
        response_observations: '',
        response_path: ''
      };
    },

    updateElement: function updateElement(value) {
      var _this = this;

      var vm = this;
      vm.email_current.entity = 'email';
      this.buttonIsLoading = true;
      console.log(vm.email_current);

      vm.update(vm.email_current).then(function (item) {
        _this.$emit('emailEdited');
      }).finally(function () {
        _this.$emit('emailEdited');
        _this.buttonIsLoading = false;
      });
    },
    createVersion: function createVersion() {
      var _this2 = this;

      var vm = this;
      vm.version.email_id = this.email_current.id;
      console.log(vm.version);
      this.buttonIsLoading = true;
      vm.store(vm.version).then(function (item) {
        vm.version = _this2.defineVersion();
        window.location.reload();
      }).finally(function () {
        _this2.buttonIsLoading = false;
      });
    },
    updateVersion: function updateVersion(item) {
      var _this3 = this;

      var vm = this;
      this.buttonIsLoading = true;
      window.$('#editversion').button('loading');
      vm.version_current.id = item.id;
      vm.store(vm.version_current).then(function (item) {
        vm.version = _this3.defineVersion();
        window.location.reload();
      }).catch(function (message) {
        window.$('#editversion').button('reset');
      }).finally(function () {
        _this3.buttonIsLoading = false;
      });
    },
    addTag: function addTag(newTag) {
      this.options.push(newTag);
      this.version.path.push(newTag);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['get', 'store', 'update'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    versions: 'getEmailVersion'
  }), {
    filteredUsers: function filteredUsers() {
      var _this4 = this;

      return this.users.filter(function (item) {
        var accounts_ids = item.accountsIds;
        var search = accounts_ids.indexOf(_this4.email_current.campaign_attribute.project_account_id);

        if (_this4.usersession.role == 4) {
          return search !== -1;
        } else {
          return search !== -1 && item.team_id == localStorage.session_team;
        }
      });
    }
  }),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default.a,
    appTitleCustom: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_TitleCustom___default.a,
    MultiSelect: __WEBPACK_IMPORTED_MODULE_4__components_assets_MultiSelect_MultiSelect___default.a
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_email_EmailClassificationModal__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_email_EmailClassificationModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_email_EmailClassificationModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_email_EmailDownloadListButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_email_EmailDownloadListButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_admin_email_EmailDownloadListButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_partials_TitleCustom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_partials_TitleCustom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_admin_partials_TitleCustom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin_email_EmailEditModal__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin_email_EmailEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_admin_email_EmailEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_admin_email_ViewEmailModal__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_admin_email_ViewEmailModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_admin_email_ViewEmailModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_email_CreateEmailModal__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_email_CreateEmailModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_admin_email_CreateEmailModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_DateClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_TodayFormat__ = __webpack_require__(51);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminEmailTeam',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      email: this.defineEmail(),
      email_current: {
        project_id: null,
        campaign_id: null
      },
      filter: this.clearFilter(),
      account_session: null,
      version: this.defineVersion(),
      version_current: this.defineVersion(),
      nums: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      isUserEmployee: false,
      emailClassification: null,
      email_view: null,
      createEmailModal: false,
      completed_emails: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.routeQuery();

            case 2:
              _this.getList('emailstate');
              _this.getList('user');

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    this.today = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__services_TodayFormat__["a" /* todayFormat */])();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    defineEmail: function defineEmail() {
      return {
        name: '',
        number: '',
        date: '',
        campaign_id: '',
        entity: 'email',
        path: '',
        project_id: '',
        created_by: '',
        today: null,
        urgent: 0
      };
    },
    clearFilter: function clearFilter() {
      return {
        state: null,
        slug: '',
        date: null,
        name: null,
        created_by: null
      };
    },
    defineVersion: function defineVersion() {
      return {
        entity: 'emailversion'
      };
    },
    setCreateEmailModal: function setCreateEmailModal(boolean) {
      this.createEmailModal = boolean;
    },
    routeQuery: function routeQuery() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var routeQuery, accountSession, query, _ref, list, emailId, email;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                routeQuery = _this2.$route.query;
                accountSession = routeQuery.account ? routeQuery.account : localStorage.session_account;

                _this2.SESSION_ACCOUNT(accountSession);

                if (_this2.$route.path === '/admin/pendings-emails') {
                  _this2.account_session = null;
                } else {
                  _this2.account_session = accountSession;
                }
                _this2.auth_session_account = accountSession;
                _this2.isUserEmployee = _this2.user.team_id == 1;

                query = _this2.defineQuery();
                _context2.prev = 7;
                _context2.next = 10;
                return _this2.getListEmailsMongo(['email', query]);

              case 10:
                _ref = _context2.sent;
                list = _ref.list;

                _this2.loading = true;

                emailId = parseInt(_this2.$route.query.email);


                if (emailId) {
                  email = list.find(function (x) {
                    return x.id === emailId;
                  });


                  if (email) {
                    _this2.editElement(email);
                  }
                }
                _context2.next = 20;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2['catch'](7);

                console.log(_context2.t0);

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[7, 17]]);
      }))();
    },
    defineQuery: function defineQuery() {
      var completed_emails = this.completed_emails ? 'completed' : 'default';

      var query = 'account_session=' + this.account_session + '&states=' + completed_emails;

      if (this.$route.path === '/admin/pendings-emails' && this.account_session == null && this.user.accounts.length) {
        query = 'account_session=' + this.user.accountsIds + '&states=pending';
      }
      //console.log(query)
      return query;
    },
    editElement: function editElement(value) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var view;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                view = {
                  entity: 'emailversion',
                  id: value.id
                };
                _context3.next = 3;
                return _this3.show(view);

              case 3:
                value.versions = _context3.sent;


                window.scrollTo(0, 0);

                _this3.email_current = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
                _this3.boxedit = true;

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    viewEmail: function viewEmail(email) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var view;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                view = {
                  entity: 'emailversion',
                  id: email.id
                };
                _context4.next = 3;
                return _this4.show(view);

              case 3:
                email.versions = _context4.sent;


                _this4.email_view = email;

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    closeEditEmail: function closeEditEmail() {
      //console.log("close edit email")
      this.boxedit = false;
      this.email_current = {};
      //this.$router.push('/admin/emails')
      this.$router.replace('/admin/emails');
    },
    viewAccountEmail: function viewAccountEmail(e) {
      localStorage.session_account = e.campaign_attribute.project_account_id;
      this.$router.push('/admin/emails?email=' + e.id + '&account=' + e.campaign_attribute.project_account_id);
      //window.location.reload()
    },
    viewAccounts: function viewAccounts(val) {
      var query = '';

      if (val == 'all') {
        query = 'account_session=' + this.user.accountsIds;
        this.account_session = null;
      } else {
        this.account_session = localStorage.session_account;
        query = 'account_session=' + this.account_session;
      }

      try {
        this.getList(['email', query]);
      } catch (error) {}
    },
    showEmailClassification: function showEmailClassification(email) {
      this.emailClassification = email;
    },
    emailCreated: function emailCreated() {
      this.email = this.defineEmail();
      this.createEmailModal = false;
    },
    emailEdited: function emailEdited() {
      this.loading = false;
      this.email = this.defineEmail();
      this.boxedit = false;
      this.$router.replace('/admin/emails');
      window.location.reload();
    },
    dateClass: function dateClass(email) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__services_DateClass__["a" /* handleDateClass */])('email', email, this.today);
    },
    closeEmailClassificationModal: function closeEmailClassificationModal() {
      this.emailClassification = null;
      this.getEmailsReload();
    },
    getEmailsReload: function getEmailsReload() {
      var _this5 = this;

      this.loading = false;
      setTimeout(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.routeQuery();

              case 2:
                _this5.loading = true;

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      })), 500);
    },
    viewEmailFinish: function viewEmailFinish() {
      this.completed_emails = !this.completed_emails;

      var query = '';
      query = this.defineQuery();

      try {
        this.getListEmailsMongo(['email', query]);

        this.loading = true;
      } catch (error) {}
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapMutations */])(['SESSION_ACCOUNT']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['getList', 'getListEmailsMongo', 'store', 'update', 'show'])),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    emails: 'getEmails',
    campaigns: 'getCampaigns',
    user: 'getUser',
    users: 'getUsers',
    usersession: 'getUser',
    states: 'getEmailStates',
    projects: 'getProjects'
  }), {
    filteredEmails: function filteredEmails() {
      var _this6 = this;

      return this.emails.filter(function (item) {
        var pending = _this6.$route.path === '/admin/pendings-emails' ? item.state_id <= 4 : true;
        var slug = _this6.filter.slug ? item.slug.toLowerCase().includes(_this6.filter.slug.toLowerCase()) : true;
        var name = _this6.filter.name ? item.name.toLowerCase().includes(_this6.filter.name.toLowerCase()) : true;
        var date = _this6.filter.date ? _this6.filter.date == item.date : true;
        var state = _this6.filter.state ? _this6.filter.state == item.state_id : true;
        var created_by = _this6.filter.created_by ? _this6.filter.created_by == item.created_by : true;

        return pending && slug && name && date && state && created_by;
      });
    },
    filteredUsers: function filteredUsers() {
      return this.users.filter(function (user) {
        return user.team_id == 1;
      });
    },
    filteredUsersAccount: function filteredUsersAccount() {
      var _this7 = this;

      return this.users.filter(function (item) {
        var accounts_ids = item.accountsIds;
        var search = accounts_ids.indexOf(parseInt(_this7.account_session));

        return search !== -1;
      });
    },
    filteredStates: function filteredStates() {
      return this.states.filter(function (state) {
        return localStorage.session_team == 1 ? state : state.id == 6;
      });
    }
  }),
  watch: {
    '$route.query': {
      handler: function handler(newVal) {
        if (newVal.email) {
          var email = this.emails.find(function (x) {
            return x.id === Number(newVal.email);
          });
          if (email) {
            this.editElement(email);
          }
        }
      },

      deep: true
    }
  },
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default.a,
    appTitleCustom: __WEBPACK_IMPORTED_MODULE_9__components_admin_partials_TitleCustom___default.a,
    EmailClassificationModal: __WEBPACK_IMPORTED_MODULE_7__components_admin_email_EmailClassificationModal___default.a,
    EmailDownloadListButton: __WEBPACK_IMPORTED_MODULE_8__components_admin_email_EmailDownloadListButton___default.a,
    ViewEmailModal: __WEBPACK_IMPORTED_MODULE_11__components_admin_email_ViewEmailModal___default.a,
    EmailEditModal: __WEBPACK_IMPORTED_MODULE_10__components_admin_email_EmailEditModal___default.a,
    CreateEmailModal: __WEBPACK_IMPORTED_MODULE_12__components_admin_email_CreateEmailModal___default.a,
    handleDateClass: __WEBPACK_IMPORTED_MODULE_13__services_DateClass__["a" /* handleDateClass */],
    todayFormat: __WEBPACK_IMPORTED_MODULE_14__services_TodayFormat__["a" /* todayFormat */]
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminEmailWithoutFinish',
  data: function data() {
    return {
      loading: false,
      emails: []
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.getEmails();

            case 3:
              _context.next = 7;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context['catch'](0);

            case 7:
              _context.prev = 7;

              _this.loading = true;
              return _context.finish(7);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 5, 7, 10]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get']), {
    getEmails: function getEmails() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, list;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.get('/emails-without-finish');

              case 2:
                _ref = _context2.sent;
                list = _ref.list;

                _this2.emails = list;

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    finishEmails: function finishEmails(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = 'finish-emails-user/' + id;
                _context3.next = 3;
                return _this3.get(url);

              case 3:
                setTimeout(function () {
                  location.reload();
                }, "1000");

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }),
  components: {
    appLoading: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_email_EmailDownloadListButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_email_EmailDownloadListButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_email_EmailDownloadListButton__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListEmail',
  data: function data() {
    return {
      loading: false,
      email: this.defineEmail(),
      nums: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    user: 'getUser',
    emails: 'getEmails',
    campaigns: 'getCampaigns',
    projects: 'getProjects',
    users: 'getUsers'
  }), {
    filteredCampaigns: function filteredCampaigns() {
      var _this = this;

      this.email.campaign_id = "";
      return this.campaigns.filter(function (v) {
        return v.project_id == _this.email.project_id;
      });
    },
    filteredTasks: function filteredTasks() {
      return this.emails.slice(0, 500);
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    $('#email').on('hidden.bs.modal', function () {
      _this2.defineEmail();
    });
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this3.getListEmailsMongo('email');

            case 3:
              _this3.getList('campaign');
              _this3.getList('project');
              _this3.getList('user');
              _this3.loading = true;
              _context.next = 11;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);

            case 11:
              _context.prev = 11;

              _this3.loading = true;
              return _context.finish(11);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3, [[0, 9, 11, 14]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    defineEmail: function defineEmail() {
      return {
        name: '',
        number: '',
        date: '',
        campaign_id: '',
        entity: 'email',
        path: '',
        project_id: '',
        created_by: ''
      };
    },
    createEmail: function createEmail() {
      var _this4 = this;

      var vm = this;
      window.$('#create').button('loading');
      vm.email.created_by = this.user.id;
      vm.store(vm.email).then(function (item) {
        window.$('#email').modal('hide');
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/emails');
      }).catch(function (error) {
        console.log('FAILURE!!');
      }).finally(function () {
        window.$('#create').button('reset');
        vm.loading = true;
        _this4.defineEmail();
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['getAll', 'getListEmailsMongo', 'store'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a,
    EmailDownloadListButton: __WEBPACK_IMPORTED_MODULE_6__components_admin_email_EmailDownloadListButton___default.a
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_TitleCustom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_TitleCustom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_TitleCustom__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewEmailModal',
  props: ['email', 'versions'],
  data: function data() {
    return {
      errors: []
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              document.body.className = 'overflow-hidden';

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    document.body.classList.remove('overflow-hidden');
  },

  components: {
    appLoading: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite___default.a,
    appTitleCustom: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_TitleCustom___default.a
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListHour',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      hour: {
        name: '',
        status: '',
        entity: 'hour'
      },
      hour_current: {},
      filter: {
        name: '',
        account: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    hours: 'getHours',
    accounts: 'getAccounts',
    teams: 'getTeams'
  }), {
    filteredAccounts: function filteredAccounts() {
      var _this = this;

      return this.accounts.filter(function (item) {
        var name = _this.filter.name ? item.name.toLowerCase().includes(_this.filter.name.toLowerCase()) : true;
        var account_id = _this.filter.account ? item.id === _this.filter.account : true;
        return name && account_id;
      });
    }
  }),
  beforeMount: function beforeMount() {
    var _this2 = this;

    //SEND ENTITY AND MUTATION
    this.getAll('hour').then(function () {
      _this2.loading = true;
    }), this.getList('account').then(function () {
      _this2.loading = true;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    createHour: function createHour() {
      var vm = this;
      window.$('#create').button('loading');
      vm.store(vm.hour).then(function (item) {
        window.$('#hour').modal('hide');
        vm.hour = { name: '', entity: 'hour' };
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/hours');
        window.$('#create').button('reset');
      }).catch(function (error) {
        window.$('#create').button('reset');
        vm.hour = { name: '', entity: 'hour' };
      });
    },

    removeHour: function removeHour(value) {
      var vm = this;
      vm.form = {
        id: value.id,
        entity: 'hour'
      };
      vm.loading = false;
      vm.remove(vm.form).then(function (item) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/hours');
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    editHour: function editHour(value) {
      this.boxedit = true;
      this.hour = value;
    },
    closeEditHour: function closeEditHour() {
      this.boxedit = false;
      this.hour_current = {};
    },
    updateHour: function updateHour(value) {
      var vm = this;
      vm.form = {
        id: vm.hour.id,
        entity: 'hour',
        hours: vm.hour_current.hours
      };
      vm.loading = false;
      vm.update(vm.form).then(function (item) {
        vm.loading = true;
        vm.boxedit = false;
        vm.hour = { name: '', entity: 'hour' };
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/hours');
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    updateValue: function updateValue(attribute, e) {
      this.hour_current[attribute] = e.target.value;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['getAll', 'getList', 'remove', 'store', 'update'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListLibrary',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      library_current: {},
      categories: [],
      filter: {
        slug: null,
        category: null,
        team: null
      }
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, categories;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.getList('account');

            case 3:
              _context.next = 5;
              return _this.getList('library');

            case 5:
              _ref = _context.sent;
              categories = _ref.categories;

              _this.categories = categories;

              _this.loading = true;
              _context.next = 13;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](0);

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 11]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    setCategory: function setCategory(name) {
      this.filter.category = name;
    },
    setTeam: function setTeam(id) {
      this.filter.team = id;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['getList', 'getAll'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    libraries: 'getLibraries',
    accounts: 'getAccounts',
    user: 'getUser',
    teams: 'getTeams'
  }), {
    filteredLibraries: function filteredLibraries() {
      var _this2 = this;

      var items = this.libraries.filter(function (library) {
        var category = _this2.filter.category ? library.category == _this2.filter.category : true;
        var team = _this2.filter.team ? library.team_createdby_id == _this2.filter.team : true;
        var slug = _this2.filter.slug ? library.name.toLowerCase().includes(_this2.filter.slug.toLowerCase()) : true;

        return category && team && slug;
      });

      return items;
    },
    filteredCategories: function filteredCategories() {
      return this.categories.filter(function (category) {
        return category.name !== "Anuncios";
      });
    }
  }),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_library_ModalCreateLibrary__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_library_ModalCreateLibrary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_library_ModalCreateLibrary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_library_ModalEditLibrary__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_library_ModalEditLibrary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_library_ModalEditLibrary__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListLibrary',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      library_current: {},
      create_modal: false,
      edit_modal: false,
      categories: [],
      filter: {
        slug: null,
        category: null,
        team: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    libraries: 'getLibraries',
    accounts: 'getAccounts',
    teams: 'getTeams'
  }), {
    filteredLibraries: function filteredLibraries() {
      var _this = this;

      var items = this.libraries.filter(function (library) {
        var category = _this.filter.category ? library.category == _this.filter.category : true;
        var team = _this.filter.team ? library.team_createdby_id == _this.filter.team : true;
        var slug = _this.filter.slug ? library.name.toLowerCase().includes(_this.filter.slug.toLowerCase()) : true;

        return category && team && slug;
      });

      return items;
    }
  }),
  beforeMount: function beforeMount() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, categories;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this2.getList('account');

            case 3:
              _context.next = 5;
              return _this2.getAll('library');

            case 5:
              _ref = _context.sent;
              categories = _ref.categories;

              _this2.categories = categories;

              _this2.loading = true;
              _context.next = 13;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](0);

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 11]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    setCategory: function setCategory(name) {
      this.filter.category = name;
      console.log(this.filter);
    },
    setTeam: function setTeam(name) {
      this.filter.team = name;
      console.log(this.filter);
    },
    libraryCreated: function libraryCreated() {
      this.create_modal = false;
      this.getAll('library');
    },
    libraryEdited: function libraryEdited() {
      this.library_current = {};
      this.edit_modal = false;
      this.getAll('library');
    },
    editModal: function editModal(library) {
      this.library_current = library;
      this.edit_modal = true;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['getList', 'getAll'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a,
    ModalCreateLibrary: __WEBPACK_IMPORTED_MODULE_6__components_admin_library_ModalCreateLibrary___default.a,
    ModalEditLibrary: __WEBPACK_IMPORTED_MODULE_7__components_admin_library_ModalEditLibrary___default.a
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_assets_Modal_Modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_assets_Modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_assets_Modal_Modal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['categories', 'teams'],
  data: function data() {
    return {
      library: this.defineLibrary()
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    defineLibrary: function defineLibrary() {
      return {
        name: '',
        description: '',
        active: 1,
        url: '',
        category: null,
        team_id: null,
        team_createdby_id: null,
        entity: 'library'
      };
    },
    createLibrary: function createLibrary() {
      var _this = this;

      var vm = this;
      window.$('#create').button('loading');
      vm.store(vm.library).then(function (item) {
        _this.$emit('created');
      }).finally(function () {
        window.$('#create').button('reset');
        _this.library = _this.defineLibrary();
      });
    },
    emitClose: function emitClose() {
      this.$emit('close');
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['store'])),
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_assets_Modal_Modal___default.a
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_assets_Modal_Modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_assets_Modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_assets_Modal_Modal__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['library_current', 'categories', 'teams'],
  data: function data() {
    return {
      library: {}
    };
  },
  created: function created() {
    this.library = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.library_current));
    this.library['entity'] = 'library';
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    updateLibrary: function updateLibrary() {
      var _this = this;

      var vm = this;
      window.$('#edit').button('loading');
      vm.update(vm.library).then(function (item) {
        _this.$emit('edited');
      }).finally(function () {
        window.$('#edit').button('reset');
      });
    },
    emitClose: function emitClose() {
      this.$emit('close');
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapActions */])(['update'])),
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_assets_Modal_Modal___default.a
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ListNotes',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      note: this.defineNote(),
      notes: null,
      note_current: {}
    };
  },
  beforeMount: function beforeMount() {
    this.getNotes();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    getNotes: function getNotes() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, list;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = false;
                _context.prev = 1;
                _context.next = 4;
                return _this.get('/note');

              case 4:
                _ref = _context.sent;
                list = _ref.list;

                _this.notes = list;
                _this.loading = true;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);
                _this.loading = true;

              case 14:
                _context.prev = 14;

                _this.loading = true;
                return _context.finish(14);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 10, 14, 17]]);
      }))();
    },
    defineNote: function defineNote() {
      return {
        title: '',
        description: '',
        entity: 'note'
      };
    },
    createNote: function createNote() {
      var vm = this;
      vm.loading = false;
      window.$('#create').button('loading');
      vm.post(vm.note).then(function (item) {
        window.$('#note').modal('hide');
        vm.defineNote();
        vm.loading = true;
        window.$('#create').button('reset');
        window.location.reload();
      }).catch(function (error) {
        window.$('#create').button('reset');
        vm.defineNote();
        vm.loading = true;
      });
    },

    editNote: function editNote(value) {
      this.boxedit = true;
      this.note = value;
    },
    closeEditNote: function closeEditNote() {
      this.boxedit = false;
      this.note_current = {};
    },
    updateValue: function updateValue(attribute, e) {
      this.note_current[attribute] = e.target.value;
    },
    updateNote: function updateNote() {
      var vm = this;
      vm.loading = false;
      window.$('#create').button('loading');
      vm.note_current.id = vm.note.id;
      vm.note_current.entity = 'note';
      console.log(vm.note_current);
      vm.put(vm.note_current).then(function (item) {
        window.$('#note').modal('hide');
        vm.defineNote();
        vm.loading = true;
        window.$('#create').button('reset');
        window.location.reload();
      }).catch(function (error) {
        window.$('#create').button('reset');
        vm.defineNote();
        vm.loading = true;
      });
    },

    removeNote: function removeNote(value) {
      var vm = this;
      vm.form = {
        id: value.id,
        entity: 'note'
      };
      vm.deleteItem(vm.form).then(function (item) {
        vm.loading = true;
        window.location.reload();
      }).catch(function (message) {
        vm.loading = true;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get', 'post', 'put', 'deleteItem'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);



//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Alerts',
  props: ['category'],
  data: function data() {
    return {};
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.get('library/filter?category=' + _this.category).then(function (data) {
                var model = data.model;


                if (model) {
                  var name, config;

                  name = model.name;
                  config = {
                    closeButton: true,
                    timeOut: 0,
                    extendedTimeOut: 0,
                    progressBar: true,
                    positionClass: 'toast-bottom-left',
                    preventDuplicates: true
                  };
                  window.$toast.warning(model.description, name, config);
                }
              });

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context['catch'](0);

              window.$toast.error(_context.t0);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 5]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get']))
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__);


//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Copy',
  props: ['text', 'classes'],
  data: function data() {
    return {};
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    CopyClipboard: function CopyClipboard(text) {
      //console.log(text);
      var textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);

      window.$toast.success('Contraseña copiada correctamente');
    }
  },
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default.a
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Icon',
  props: ['name', 'classname']
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SideBar',
  props: ['classname'],
  data: function data() {
    return {
      menu: [{
        role: [1],
        to: '/admin/dashboard',
        icon: 'home',
        title: 'Dashboard'
      }, {
        role: [1],
        to: '/admin/traffic/tasks',
        icon: 'hard-drive',
        title: 'Trafico'
      }, {
        role: [1, 2, 3, 4, 5],
        to: '/admin/business/budgets',
        icon: 'archive',
        title: 'Administración',
        team: [5, 9]
      }, {
        role: [1],
        to: '/admin/users',
        icon: 'users',
        title: 'Usuarios'
      }, {
        role: [1],
        to: '/admin/libraries',
        icon: 'libraries',
        title: 'Biblioteca'
      }, {
        role: [1],
        to: '/admin/activities',
        icon: 'activities',
        title: 'Actividades'
      }, {
        role: [2, 3, 4, 5],
        to: '/admin/home',
        icon: 'home',
        title: 'Dashboard'
      }, {
        role: [2],
        to: '/admin/business/budgets',
        icon: 'archive',
        title: 'Administración'
      }, {
        role: [2, 3, 4, 5],
        to: '/admin/tasks',
        icon: 'file-plus',
        title: 'Tareas'
      }, {
        role: [2, 3, 4, 5],
        to: '/admin/pendings-tasks',
        icon: 'file',
        title: 'Tareas Pendientes'
      }, {
        role: [3, 4, 5],
        to: '/admin/hours-tasks',
        icon: 'clock',
        title: 'Horas'
      }, {
        role: [3, 4, 5],
        to: '/admin/week',
        icon: 'clock',
        title: 'Trafico'
      }, {
        role: [3, 4, 5],
        to: '/admin/emails',
        icon: 'code',
        title: 'Cortes'
      }, {
        role: [3, 4, 5],
        to: '/admin/pendings-emails',
        icon: 'code',
        title: 'Cortes Pendientes',
        team: [1]
      }, {
        role: [3, 4, 5],
        to: '/admin/campaigns',
        icon: 'mail',
        title: 'Campañas'
      }, {
        role: [3, 5],
        to: '/admin/team',
        icon: 'users',
        title: 'Equipo'
      }, {
        role: [3, 4, 5],
        to: '/admin/planning',
        icon: 'clock',
        title: 'Planeación',
        t_session: ['2', '3']
      }, {
        role: [1, 2, 3, 4, 5],
        to: '/admin/platforms',
        icon: 'layers',
        title: 'Plataformas'
      }, {
        role: [2, 3, 4, 5],
        to: '/admin/library',
        icon: 'libraries',
        title: 'Libreria'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    user: 'getUser',
    session_team_current: 'getSessionTeam'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    subIsActive: function subIsActive(input) {
      var _this = this;

      var paths = Array.isArray(input) ? input : [input];
      return paths.some(function (path) {
        return _this.$route.path.indexOf(path) == 0;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])(['SESSION_ACCOUNT', 'SESSION_TEAM'])),

  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default.a
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TitleCustom',
  data: function data() {
    return {};
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.getList('account');

            case 3:

              _this.loading = true;
              _context.next = 8;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context['catch'](0);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 6]]);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    accounts: 'getAccounts',
    teams: 'getTeams',
    session_account: 'getSessionAccount',
    session_team: 'getSessionTeam'
  }), {
    filteredAccounts: function filteredAccounts() {
      var _this2 = this;

      return this.accounts.filter(function (item) {
        var account = _this2.session_account ? _this2.session_account : localStorage.session_account;
        if (item.id == account) {
          return item;
        }
      });
    },
    filteredTeams: function filteredTeams() {
      var _this3 = this;

      return this.teams.filter(function (item) {
        var team = _this3.session_team ? _this3.session_team : localStorage.session_team;
        if (item.id == team) {
          return item;
        }
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['getList']))
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Alerts__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Alerts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Alerts__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Top',
  data: function data() {
    return {
      loading: false,
      task_notification: {
        entity: 'notification',
        view: 1
      },
      birthday: false,
      btn_calendar: false,
      btn_noti: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var query;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                //console.log('------------start-top--------------')
                query = 'user_id=true';

                _this.getList(['notification', query]);
                _this.getList('team');
                //console.log('------------end-top--------------')
                _this.loading = true;
              } catch (error) {}
              _this.searchBirthday();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    user: 'getUser',
    notifications: 'getNotifications',
    teams: 'getTeams',
    session_account_current: 'getSessionAccount',
    session_team_current: 'getSessionTeam'
  }), {
    filteredNotifications: function filteredNotifications() {
      var _this2 = this;

      return this.notifications.filter(function (item) {
        if (item.user_id == _this2.user.id) {
          return item;
        }
      });
    },
    filteredNotificationsNotViews: function filteredNotificationsNotViews() {
      var _this3 = this;

      return this.notifications.filter(function (item) {
        if (item.user_id == _this3.user.id && item.view == 0) {
          return item;
        }
      });
    },
    filteredTeams: function filteredTeams() {
      return this.teams.filter(function (item) {
        return [1, 2, 3, 5].includes(item.id);
      });
    },
    isDark: {
      get: function get() {
        return this.$store.state.isDarkMode;
      },
      set: function set(value) {
        // El set se realiza a través de la acción
      }
    }
  }),
  created: function created() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    doLogout: function doLogout() {
      var _this4 = this;

      this.logout(this.user).then(function (log) {
        _this4.$router.replace(_this4.$route.query.redirect || '/');
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapMutations */])(['SESSION_ACCOUNT', 'SESSION_TEAM']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get', 'getAll', 'getList', 'logout', 'update']), {
    subIsActive: function subIsActive(input) {
      var _this5 = this;

      var paths = Array.isArray(input) ? input : [input];
      return paths.some(function (path) {
        return _this5.$route.path.indexOf(path) == 0;
      });
    },
    changeAccount: function changeAccount(e) {
      localStorage.session_account = e.target.value;
      this.SESSION_ACCOUNT(e.target.value);
      this.reloadWithoutParameters();
    },
    changeTeam: function changeTeam(e) {
      localStorage.session_team = e.target.value;
      this.SESSION_TEAM(e.target.value);
      this.reloadWithoutParameters();
    },
    updateNotification: function updateNotification(value) {
      var vm = this;
      vm.loading = false;
      vm.task_notification.id = value.id;
      vm.update(vm.task_notification).then(function (item) {
        vm.loading = true;
        if (value.url) {
          window.location.href = value.url;
        }
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    readAllNotifications: function readAllNotifications() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this6.loading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return _this6.get('notification/read-all').then(function (data) {
                  setTimeout(function () {
                    window.location.reload();
                  }, 1000);
                });

              case 4:
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](1);

                window.$toast.error(_context2.t0);

              case 9:
                _context2.prev = 9;

                _this6.loading = false;
                return _context2.finish(9);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[1, 6, 9, 12]]);
      }))();
    },
    reload: function reload() {
      window.location.reload();
    },
    reloadWithoutParameters: function reloadWithoutParameters() {
      window.location = window.location.href.split('?')[0];
    },
    searchBirthday: function searchBirthday() {
      var user = this.user;
      if (user) {
        var birthday = user.birthday;
        var today = new Date();
        var mm = today.getMonth() + 1; // Months start at 0!
        var dd = today.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        var today_date = mm + '-' + dd;
        if (birthday) {
          var birthday_date = birthday.substr(5, 5);

          if (birthday_date == today_date) {
            this.birthday = true;
          }
        }
      }
    },
    changeTheme: function changeTheme() {
      // Llamamos a la acción de vuex
      this.$store.dispatch('toggleTheme');
    }
  }),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appAlerts: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Alerts___default.a
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['team_session', 'accounts', 'users', 'planning_id'],
  data: function data() {
    return {
      planning: this.definePlanning(),
      planningButtonLoading: false
    };
  },
  created: function created() {
    document.body.style.overflow = 'hidden';
  },
  beforeDestroy: function beforeDestroy() {
    document.body.style.overflow = null;
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([_this.getList('campaign'), _this.getList('project')]);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['get', 'getList', 'post']), {
    createPlanning: function createPlanning() {
      var _this2 = this;

      this.planningButtonLoading = true;
      this.planning.team_id = this.team_session;
      this.planning.planning_id = this.planning_id;
      console.log(this.planning);
      this.post(this.planning).then(function (item) {
        _this2.$emit('closeModal');
        _this2.$emit('planningCreated');
      }).catch(function (error) {
        console.log('FAILURE!!');
      }).finally(function () {
        _this2.planningButtonLoading = false;
      });
    },
    definePlanning: function definePlanning() {
      return {
        entity: 'planning',
        task: '',
        hours: '',
        date: '',
        account_id: '',
        team_id: '',
        user_id: '',
        planning_id: null
      };
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({}), {
    filteredUsers: function filteredUsers() {
      var _this3 = this;

      return this.users.filter(function (item) {
        return _this3.team_session ? item.team_id == _this3.team_session : true;
      });
    }
  })
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_assets_MultiSelect_MultiSelect__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_assets_MultiSelect_MultiSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_assets_MultiSelect_MultiSelect__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CreateTaskModal',
  props: ['task_current'],
  data: function data() {
    return {
      form: {
        entity: 'task',
        path: []
      },
      current_planning: {
        entity: 'planning'
      },
      options: [],
      createButtonLoading: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.getList('project');

            case 3:
              _context.next = 5;
              return _this.getList('campaign');

            case 5:
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              console.log('FAILURE!!', _context.t0);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    filteredCampaigns: function filteredCampaigns() {
      var _this2 = this;

      return this.campaigns.filter(function (campaign) {
        return campaign.project_id == _this2.form.project_id;
      });
    },
    filteredProjects: function filteredProjects() {
      var _this3 = this;

      return this.projects.filter(function (project) {
        var account = project.account_id == _this3.task_current.account.id;
        return account;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    projects: 'getProjects',
    campaigns: 'getCampaigns'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['getList', 'store', 'put']), {
    createTask: function createTask() {
      var _this4 = this;

      this.createButtonLoading = true;
      this.form.user_id = this.task_current.user.id;
      this.form.name = this.task_current.task;
      this.form.date = this.task_current.date;
      this.form.account_id = this.task_current.account.id;
      this.form.hours = this.task_current.hours;
      this.form.team_id = this.task_current.team_id;
      //console.log(this.form);
      this.store([this.form]).then(function (item) {
        _this4.current_planning.id = _this4.task_current.id;
        _this4.current_planning.task_created = 'date';
        _this4.put(_this4.current_planning).then(function (item) {
          _this4.$emit('closeModal');
          _this4.$emit('secondPlanningCreated');
        });
      }).catch(function (error) {
        console.log('FAILURE!!', error);
      }).finally(function () {
        _this4.createButtonLoading = false;
      });
    },
    addTag: function addTag(newTag) {
      this.options.push(newTag);
      this.form.path.push(newTag);
    }
  }),
  components: {
    MultiSelect: __WEBPACK_IMPORTED_MODULE_4__components_assets_MultiSelect_MultiSelect___default.a
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['dates', 'hours', 'hours_by_dates'],
  data: function data() {
    return {
      today: new Intl.DateTimeFormat('sv-SE', {
        timeZone: 'America/Bogota'
      }).format(new Date()),
      hours_by_today: 0,
      show_div: true
    };
  },

  computed: {
    sumHoursWeek: function sumHoursWeek() {
      var sum = 0;
      this.hours.filter(function (item) {
        if (item.hours) {
          sum = sum + item.hours;
        }
      });
      this.hours_by_today = sum / 5;

      return sum;
    },
    sumHoursUsedWeek: function sumHoursUsedWeek() {
      var sum = 0;
      this.hours.filter(function (item) {
        if (item.hours_used) {
          sum = sum + item.hours_used;
        }
      });
      return sum;
    }
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['dates', 'users', 'users_dates'],
  data: function data() {
    return {
      today: new Intl.DateTimeFormat('sv-SE', {
        timeZone: 'America/Bogota'
      }).format(new Date()),
      hours_by_today: 8.5,
      show_div: false
    };
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateTaskModal_vue__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateTaskModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CreateTaskModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ListPlanning',
  props: ['accounts', 'users', 'items', 'user', 'team_session'],
  data: function data() {
    return {
      show_div: false,
      editIndex: null,
      current_planning: {
        account_id: '',
        user_id: '',
        task: '',
        hours: '',
        date: '',
        entity: 'planning',
        id: ''
      },
      filter_date: true,
      filter: {
        account_id: '-',
        user_id: '-'
      },
      createTaskModalOption: false,
      task_current: null
    };
  },

  computed: {
    filteredUsers: function filteredUsers() {
      var _this = this;

      return this.users.filter(function (item) {
        return _this.team_session ? item.team_id == _this.team_session : true;
      });
    },
    filteredItems: function filteredItems() {
      var _this2 = this;

      return this.items.filter(function (item) {
        var account = _this2.filter.account_id === '-' ? true : item.account_id == _this2.filter.account_id;
        var user = _this2.filter.user_id === '-' ? true : item.user_id == _this2.filter.user_id;
        var date = _this2.filter.date ? item.date == _this2.filter.date : true;

        return account && user && date;
      });
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    editItem: function editItem(index, item) {
      this.editIndex = index;
      this.current_planning.task = item.task;
      this.current_planning.hours = item.hours;
      this.current_planning.date = item.date;
      this.current_planning.id = item.id;
      this.current_planning.account_id = item.account_id;
      this.current_planning.user_id = item.user_id;
    },
    updateItem: function updateItem() {
      var _this3 = this;

      //console.log(this.current_planning)
      this.put(this.current_planning).then(function (item) {
        _this3.$emit('planningCreated');
        _this3.show_div = true;
        _this3.editIndex = null;
      }).catch(function (message) {}).finally(function () {});
    },
    removeItem: function removeItem(item) {
      var _this4 = this;

      this.form = {
        id: item.id,
        entity: 'planning'
        //console.log(this.form)
      };this.remove(this.form).then(function (item) {
        _this4.$emit('planningCreated');
      }).catch(function (message) {}).finally(function () {});
    },
    newVersion: function newVersion(item) {
      this.$emit('setPlanningId', item.id);
    },
    closeFilterDate: function closeFilterDate() {
      this.filter.date = '';
      this.filter_date = true;
    },
    openCreateTask: function openCreateTask(item) {
      //console.log(item)
      this.task_current = item;
      this.setCreateTaskModal(true);
    },
    setCreateTaskModal: function setCreateTaskModal(boolean) {
      this.createTaskModalOption = boolean;
    },
    secondPlanningCreated: function secondPlanningCreated() {
      console.log('planningCreated');
      this.$emit('planningCreated');
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['put', 'remove'])),
  components: {
    CreateTaskModal: __WEBPACK_IMPORTED_MODULE_2__CreateTaskModal_vue___default.a,
    appIcon: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon___default.a
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_planning_CreatePlanningModal__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_planning_CreatePlanningModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_planning_CreatePlanningModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_planning_HoursPlanning__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_planning_HoursPlanning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_planning_HoursPlanning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HoursUsersPlanning_vue__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HoursUsersPlanning_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__HoursUsersPlanning_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ListPlanning_vue__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ListPlanning_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ListPlanning_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin_planning_PlanningDownloadListButton__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin_planning_PlanningDownloadListButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_admin_planning_PlanningDownloadListButton__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminPlanning',
  data: function data() {
    return {
      loading: false,
      items: [],
      accounts: [],
      users_team: [],
      users_dates: {},
      start_date: null,
      end_date: null,
      createPlanningModal: false,
      team_session: null,
      groups: [],
      filter: {
        group: null
      },
      dates: [],
      hours: [],
      hours_by_date: [],
      firstday: null,
      users: [],
      planning_id: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    user: 'getUser'
  })),
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.team_session = localStorage.session_team;
              _this.session_account = localStorage.session_account;
              _this.getItems();
              _this.getGroups();
              //this.startDay()
              _this.getUsers();

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    getItems: function getItems() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, accounts, list, start_date, end_date, filter_group, dates, hours, hours_by_dates, users, users_dates;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = false;
                _context2.prev = 1;

                console.log('firsday', _this2.firstday);
                _context2.next = 5;
                return _this2.get('/planning?team_id=' + _this2.team_session + '&account_id=' + _this2.session_account + '&group=' + _this2.filter.group + '&startdate=' + _this2.firstday);

              case 5:
                _ref = _context2.sent;
                accounts = _ref.accounts;
                list = _ref.list;
                start_date = _ref.start_date;
                end_date = _ref.end_date;
                filter_group = _ref.filter_group;
                dates = _ref.dates;
                hours = _ref.hours;
                hours_by_dates = _ref.hours_by_dates;
                users = _ref.users;
                users_dates = _ref.users_dates;

                _this2.accounts = accounts;
                _this2.items = list;
                _this2.dates = dates;
                _this2.hours = hours;
                _this2.hours_by_dates = hours_by_dates;
                _this2.start_date = start_date;
                _this2.end_date = end_date;
                _this2.users_team = users;
                _this2.users_dates = users_dates;
                if (filter_group) {
                  _this2.filter.group = filter_group;
                }
                //console.log(list.length)
                _this2.loading = true;
                _context2.next = 33;
                break;

              case 29:
                _context2.prev = 29;
                _context2.t0 = _context2['catch'](1);

                console.log(_context2.t0);
                _this2.loading = true;

              case 33:
                _context2.prev = 33;

                _this2.loading = true;
                return _context2.finish(33);

              case 36:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 29, 33, 36]]);
      }))();
    },
    getGroups: function getGroups() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref2, list;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = false;
                _context3.prev = 1;
                _context3.next = 4;
                return _this3.get('/account-group');

              case 4:
                _ref2 = _context3.sent;
                list = _ref2.list;

                _this3.groups = list;
                _this3.loading = true;
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](1);

                _this3.loading = true;

              case 13:
                _context3.prev = 13;

                _this3.loading = true;
                return _context3.finish(13);

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 10, 13, 16]]);
      }))();
    },
    getUsers: function getUsers() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _ref3, list;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.loading = false;
                _context4.prev = 1;
                _context4.next = 4;
                return _this4.get('/user');

              case 4:
                _ref3 = _context4.sent;
                list = _ref3.list;

                _this4.users = list;
                _this4.loading = true;
                _context4.next = 13;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](1);

                _this4.loading = true;

              case 13:
                _context4.prev = 13;

                _this4.loading = true;
                return _context4.finish(13);

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 10, 13, 16]]);
      }))();
    },
    changeGroup: function changeGroup(event) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.loading = false;
                _this5.filter.group = event.target.value;
                _context5.prev = 2;
                _context5.next = 5;
                return _this5.getItems();

              case 5:
                _context5.next = 9;
                break;

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5['catch'](2);

              case 9:
                _context5.prev = 9;

                _this5.loading = true;
                return _context5.finish(9);

              case 12:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[2, 7, 9, 12]]);
      }))();
    },
    startDay: function startDay() {
      var curr = new Date();
      this.firstday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 1)).toISOString().slice(0, 10);
      console.log('startDay', this.firstday);
    },
    changeWeek: function changeWeek(val) {
      if (!this.firstday) {
        this.startDay();
      }
      var curr = new Date(this.firstday);
      if (val == 'minus') {
        this.firstday = new Date(curr.setDate(curr.getDate() - curr.getDay() - 7)).toISOString().slice(0, 10);
      } else {
        this.firstday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 7)).toISOString().slice(0, 10);
      }
      this.getItems();
    },
    setCreatePlanningModal: function setCreatePlanningModal(boolean) {
      this.createPlanningModal = boolean;
    },
    planningCreated: function planningCreated() {
      console.log('planningCreated');
      this.loading = false;
      this.getItems();
      this.loading = true;
    },
    setPlanningId: function setPlanningId(planning_id) {
      this.planning_id = planning_id;
      this.setCreatePlanningModal(true);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a,
    CreatePlanningModal: __WEBPACK_IMPORTED_MODULE_6__components_admin_planning_CreatePlanningModal___default.a,
    HoursPlanning: __WEBPACK_IMPORTED_MODULE_7__components_admin_planning_HoursPlanning___default.a,
    HoursUsersPlanning: __WEBPACK_IMPORTED_MODULE_8__HoursUsersPlanning_vue___default.a,
    ListPlanning: __WEBPACK_IMPORTED_MODULE_9__ListPlanning_vue___default.a,
    PlanningDownloadListButton: __WEBPACK_IMPORTED_MODULE_10__components_admin_planning_PlanningDownloadListButton___default.a
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    text: {
      type: String,
      default: 'Descargar Lista'
    },
    classname: ''
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    downloadList: function downloadList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__services_axios__["a" /* default */].get('planning/excel').then(function (response) {
        var data = response.data;
        var path = data.path;


        _this.$refs.download_planning.href = path;
        _this.$refs.download_planning.click();
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['get'])),
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon___default.a
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_points_ModalLoadPoints__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_points_ModalLoadPoints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_points_ModalLoadPoints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_assets_Modal_Modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_assets_Modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_assets_Modal_Modal__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListPoints',
  data: function data() {
    return {
      loading: false,
      points: [],
      modalLoadPoints: false,
      showPointsDeleteModal: false,
      deletePointsSlug: null
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                _this.loading = true;
                _this.getPointsFromAxios();
              } finally {
                _this.loading = false;
              }

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getPointsFromAxios: function getPointsFromAxios() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, points;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_5__services_axios__["a" /* default */].get('/point');

              case 3:
                _ref = _context2.sent;
                points = _ref.data.data;


                _this2.points = points;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8]]);
      }))();
    },
    deletePoints: function deletePoints() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var form;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                form = {
                  id: _this3.deletePointsSlug,
                  entity: 'point'
                };
                _context3.next = 4;
                return _this3.remove(form, 'user');

              case 4:

                window.location.reload();
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 7]]);
      }))();
    },
    showDeleteModal: function showDeleteModal(slug) {
      this.deletePointsSlug = slug;
      this.showPointsDeleteModal = true;
    },
    closeDeleteModal: function closeDeleteModal() {
      this.deletePointsSlug = null;
      this.showPointsDeleteModal = false;
    },
    toggleModalPoints: function toggleModalPoints(status) {
      this.modalLoadPoints = status;
    },
    uploadedPointsFile: function uploadedPointsFile() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.toggleModalPoints(false);
                _context4.next = 3;
                return _this4.getPointsFromAxios();

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['remove'])),
  components: {
    appLoading: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default.a,
    ModalLoadPoints: __WEBPACK_IMPORTED_MODULE_6__components_admin_points_ModalLoadPoints___default.a,
    Icon: __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_Icon___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_8__components_assets_Modal_Modal___default.a
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_assets_Modal_Modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_assets_Modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_assets_Modal_Modal__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      activity: {},
      loadImage: false,
      pointsUploader: {
        file: null,
        fileName: ''
      },
      errors: []
    };
  },
  created: function created() {},

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    createActivity: function createActivity() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.errors = [];
                _this.loading = true;

                _context.prev = 2;
                formData = new FormData();


                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(_this.pointsUploader).forEach(function (_ref) {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                      key = _ref2[0],
                      value = _ref2[1];

                  console.log(key, value);
                  formData.append(key, value);
                });

                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_6__services_axios__["a" /* default */].post('/point', formData);

              case 7:

                window.$toast.info('Puntos cargados correctamente');

                _this.$emit('upload');
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](2);

                console.log({ error: _context.t0 });
                _this.errors = _context.t0.response.data.errors;
                console.log(_this.errors);

              case 16:
                _context.prev = 16;

                _this.loading = false;
                return _context.finish(16);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 11, 16, 19]]);
      }))();
    },
    emitClose: function emitClose() {
      this.$emit('close');
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['store']), {
    onFileChange: function onFileChange(e) {
      this.loadImage = true;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.pointsUploader.file = e.target.files[0];
      this.pointsUploader.fileName = e.target.files[0].name;
    }
  }),
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_7__components_assets_Modal_Modal___default.a
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListProfile',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      profile: {
        name: '',
        status: '',
        team_id: '',
        entity: 'profile'
      },
      profile_current: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    profiles: 'getProfiles',
    teams: 'getTeams'
  })),
  beforeMount: function beforeMount() {
    var _this = this;

    //SEND ENTITY AND MUTATION
    this.getAll('profile').then(function () {
      _this.loading = true;
    }), this.getAll('team').then(function () {
      _this.loading = true;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    createProfile: function createProfile() {
      var vm = this;
      window.$('#create').button('loading');
      vm.store(vm.profile).then(function (item) {
        window.$('#profile').modal('hide');
        vm.profile = { name: '', entity: 'profile', team_id: '' };
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/profiles');
      }).catch(function (error) {
        window.$('#create').button('reset');
        vm.profile = { name: '', entity: 'profile', team_id: '' };
      });
    },

    removeProfile: function removeProfile(value) {
      var vm = this;
      vm.form = {
        id: value.id,
        entity: 'profile'
      };
      vm.loading = false;
      vm.remove(vm.form).then(function (item) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/profiles');
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    editProfile: function editProfile(value) {
      this.boxedit = true;
      this.profile = value;
    },
    closeEditProfile: function closeEditProfile() {
      this.boxedit = false;
      this.profile_current = {};
    },
    updateProfile: function updateProfile(value) {
      var vm = this;
      vm.form = {
        id: vm.profile.id,
        entity: 'profile',
        team_id: vm.profile_current.team_id,
        name: vm.profile_current.name,
        status: vm.profile_current.status
      };
      vm.loading = false;
      vm.update(vm.form).then(function (item) {
        vm.loading = true;
        vm.boxedit = false;
        vm.profile = { name: '', entity: 'profile' };
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/profiles');
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    updateValue: function updateValue(attribute, e) {
      this.profile_current[attribute] = e.target.value;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['getAll', 'remove', 'store', 'update'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ModalPasswordUpdated',
  data: function data() {
    return {
      loading: false,
      form: {
        password: null,
        password_confirmation: null,
        entity: 'user',
        update_password: true
      },
      errors: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    updatePassword: function updatePassword() {
      var vm = this;
      vm.loading = false;
      this.form.id = this.user.id;
      vm.update(vm.form).then(function (item) {
        vm.loading = true;
        vm.form = { entity: 'user' };
        window.location.reload();
      }).catch(function (message) {
        vm.loading = true;
        vm.errors = message.response.data.errors.password;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['update'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({ user: 'getUser' }))
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditProject',
  data: function data() {
    return {
      loading: false,
      view: {
        entity: 'project',
        id: this.$route.params.id
      },
      aux_project: { entity: 'project' }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    project: 'getProject',
    users: 'getUsers',
    accounts: 'getAccounts'
  })),
  beforeMount: function beforeMount() {
    var _this = this;

    this.show(this.view).then(function () {
      _this.loading = true;
    });
    this.getList('user').then(function () {
      _this.loading = true;
    }), this.getList('account').then(function () {
      _this.loading = true;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    putProject: function putProject() {
      var vm = this;
      vm.loading = false;
      window.$('#edit').button('loading');
      vm.aux_project.id = vm.project.id;
      vm.update(vm.aux_project).then(function (project) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/projects');
      }).catch(function (message) {
        window.$('#edit').button('reset');
        vm.loading = true;
      });
    },
    updateValue: function updateValue(attribute, e) {
      this.aux_project[attribute] = e.target.value;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['show', 'getAll', 'getList', 'update'])),
  components: {
    appLoading: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListProject',
  data: function data() {
    return {
      loading: false,
      project: {
        user_id: '',
        name: '',
        account_id: '',
        entity: 'project',
        hours: 0
      },
      filter: {
        name: '',
        account: '',
        status: '',
        hours: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    projects: 'getProjects',
    users: 'getUsers',
    accounts: 'getAccounts'
  }), {
    filteredProjects: function filteredProjects() {
      var _this = this;

      return this.projects.filter(function (item) {
        var name = _this.filter.name ? item.name.match(_this.filter.name) : true;
        var account_id = _this.filter.account ? item.account_id === _this.filter.account : true;
        var status = _this.filter.status ? item.status === parseInt(_this.filter.status) : true;
        var hours_filter = parseInt(_this.filter.hours);
        console.log(hours_filter);
        var validate_hours = hours_filter > 1 ? item.hours > hours_filter : item.hours === hours_filter;
        var hours = _this.filter.hours ? validate_hours : true;

        return name && account_id && status && hours;
      });
    }
  }),
  beforeMount: function beforeMount() {
    var _this2 = this;

    //SEND ENTITY AND MUTATION
    this.getAll('project').then(function () {
      _this2.loading = true;
    }), this.getList('user').then(function () {
      _this2.loading = true;
    }), this.getList('account').then(function () {
      _this2.loading = true;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    createProject: function createProject() {
      var vm = this;
      vm.loading = false;
      window.$('#create').button('loading');
      vm.store(vm.project).then(function (item) {
        window.$('#project').modal('hide');
        vm.project = {
          user_id: '',
          name: '',
          account_id: '',
          entity: 'project'
        };
        vm.loading = true;
        window.$('#create').button('reset');
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/projects');
      }).catch(function (error) {
        window.$('#create').button('reset');
        vm.project = {
          user_id: '',
          name: '',
          account_id: '',
          entity: 'project'
        };
        vm.loading = true;
      });
    },

    removeProject: function removeProject(value) {
      var vm = this;
      vm.form = {
        id: value.id,
        entity: 'project'
      };
      vm.remove(vm.form).then(function (item) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/projects');
      }).catch(function (message) {
        vm.loading = true;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['getAll', 'getList', 'remove', 'store'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_assets_Modal_Modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_assets_Modal_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_assets_Modal_Modal__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: "",
      message: ""
    };
  },
  created: function created() {},

  methods: {
    sendMessage: function sendMessage() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, _ref, total;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.errors = [];
                _this.loading = true;

                _context.prev = 2;
                data = { 'title': _this.title, 'message': _this.message };

                console.log(data);
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_2__services_axios__["a" /* default */].post('/message', data);

              case 7:
                _ref = _context.sent;
                total = _ref.data.total;


                window.$toast.info(total + ' mensaje(s) enviado(s) correctamente');
                window.location.reload();
                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](2);

                console.log({ error: _context.t0 });
                _this.errors = _context.t0.response.data.errors;
                console.log(_this.errors);

              case 18:
                _context.prev = 18;

                _this.loading = false;
                return _context.finish(18);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 13, 18, 21]]);
      }))();
    },
    emitClose: function emitClose() {
      this.$emit('close');
    }
  },
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_assets_Modal_Modal___default.a
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_TasksAccounts_vue__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_TasksAccounts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__partials_TasksAccounts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_TasksMonthsAccount_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partials_TasksMonthsAccount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__partials_TasksMonthsAccount_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ReportTasks',
  data: function data() {
    return {
      loading: false,
      all: false,
      team_session: null,
      account_session: null
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.account_session = localStorage.session_account;
              _this.team_session = localStorage.session_team;

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    changeReport: function changeReport(value) {
      this.all = value;
    }
  },
  components: {
    TasksMonthsAccount: __WEBPACK_IMPORTED_MODULE_4__partials_TasksMonthsAccount_vue___default.a,
    TasksAccounts: __WEBPACK_IMPORTED_MODULE_3__partials_TasksAccounts_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_apexcharts__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TasksAccounts',
  data: function data() {
    return {
      loading: false,
      start_date: null,
      end_date: null,
      team_session: null,
      account_session: null,
      series: [],
      options: {
        chart: {
          type: 'bar'
        },
        plotOptions: {
          bar: {
            vertical: true
          }
        },
        colors: ['#00E396'],
        dataLabels: {
          style: {
            fontSize: '8px'
          },
          formatter: function formatter(val, opt) {
            var goals = opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex].goals;

            if (goals && goals.length) {
              return val + ' / ' + goals[0].value;
            }
            return val;
          }
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          customLegendItems: ['Usadas', 'Total'],
          markers: {
            fillColors: ['#00E396', '#775DD0']
          }
        }
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.get('task/report?team_session=' + localStorage.session_team).then(function (data) {
                //console.log(data)
                var list = data.list,
                    start_date = data.start_date,
                    end_date = data.end_date;

                _this.start_date = start_date;
                _this.end_date = end_date;
                var array_data = [];

                list.map(function (item) {
                  var data_goals = {
                    name: 'Total',
                    value: item.hours,
                    strokeWidth: 10,
                    strokeFontSize: 10
                  };
                  if (parseInt(item.hours_used) > item.hours) {
                    data_goals.strokeHeight = 5;
                    data_goals.strokeLineCap = 'round';
                    data_goals.strokeColor = '#d32929';
                  } else {
                    data_goals.strokeHeight = 10;
                    data_goals.strokeColor = '#775DD0';
                  }

                  var row = {
                    x: item.name,
                    y: item.hours_used,
                    goals: [data_goals]
                  };
                  array_data.push(row);
                });
                _this.loading = true;

                _this.addSerie(array_data);
              });

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context['catch'](0);

              window.$toast.error(_context.t0);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 5]]);
    }))();
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.account_session = localStorage.session_account;
              _this2.team_session = localStorage.session_team;

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addSerie: function addSerie(array_data) {
      var series = [{
        name: 'Usadas',
        data: array_data
      }];
      this.series = series;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get'])),
  components: {
    VueApexCharts: __WEBPACK_IMPORTED_MODULE_4_vue_apexcharts___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_apexcharts__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TasksMonthsAccount',
  data: function data() {
    return {
      loading: false,
      start_date: null,
      end_date: null,
      team_session: null,
      account_session: null,
      series: [],
      options: {
        chart: {
          type: 'bar'
        },
        plotOptions: {
          bar: {
            vertical: true
          }
        },
        colors: ['#00E396'],
        dataLabels: {
          style: {
            fontSize: '18px'
          },
          formatter: function formatter(val, opt) {
            var goals = opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex].goals;

            if (goals && goals.length) {
              return val + ' / ' + goals[0].value;
            }
            return val;
          }
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          customLegendItems: ['Usadas', 'Total'],
          markers: {
            fillColors: ['#00E396', '#775DD0']
          }
        }
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.get('task/report-month?team_session=' + localStorage.session_team + '&account_session=' + localStorage.session_account).then(function (data) {
                //console.log(data)
                var list = data.list,
                    start_date = data.start_date,
                    end_date = data.end_date;

                _this.start_date = start_date;
                _this.end_date = end_date;
                var array_data = [];

                list.map(function (item) {
                  var data_goals = {
                    name: 'Total',
                    value: item.hours,
                    strokeWidth: 10,
                    strokeFontSize: 10
                  };
                  if (parseInt(item.hours_used) > item.hours) {
                    data_goals.strokeHeight = 5;
                    data_goals.strokeLineCap = 'round';
                    data_goals.strokeColor = '#d32929';
                  } else {
                    data_goals.strokeHeight = 10;
                    data_goals.strokeColor = '#775DD0';
                  }

                  var row = {
                    x: item.name_dates,
                    y: item.hours_used,
                    goals: [data_goals]
                  };
                  array_data.push(row);
                  console.log(array_data);
                });
                _this.loading = true;

                _this.addSerie(array_data);
              });

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context['catch'](0);

              window.$toast.error(_context.t0);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 5]]);
    }))();
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.account_session = localStorage.session_account;
              _this2.team_session = localStorage.session_team;

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    addSerie: function addSerie(array_data) {
      var series = [{
        name: 'Usadas',
        data: array_data
      }];
      this.series = series;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get'])),
  components: {
    VueApexCharts: __WEBPACK_IMPORTED_MODULE_4_vue_apexcharts___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_social_reasons_TrmChangeModal__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_social_reasons_TrmChangeModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_social_reasons_TrmChangeModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_social_reasons_TrmChangeHistoryModal__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_social_reasons_TrmChangeHistoryModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_admin_social_reasons_TrmChangeHistoryModal__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListTask',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      boxtrmchange: false,
      boxtrmchangehistory: false,
      socialreason: this.defineSocialReason(),
      socialreason_current: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    user: 'getUser',
    socialreasons: 'getSocialReasons',
    countries: 'getAccountCountries'
  })),
  mounted: function mounted() {
    var _this = this;

    $('#socialreason').on('hidden.bs.modal', function () {
      _this.defineSocialReason();
    });
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this2.getAll('socialreason');

            case 3:
              _context.next = 5;
              return _this2.getList('accountcountry');

            case 5:

              _this2.loading = true;
              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](0);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 8]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    defineSocialReason: function defineSocialReason() {
      return {
        name: null,
        money: null,
        money_code: null,
        country_id: null,
        entity: 'socialreason',
        money_prefix: null,
        money_format: '1,000.00',
        tax_prefix: 'IVA'
      };
    },
    createSocialReason: function createSocialReason() {
      var _this3 = this;

      var vm = this;
      window.$('#create').button('loading');
      vm.store(vm.socialreason).then(function (item) {
        window.$('#socialreason').modal('hide');
        vm.$router.replace(vm.$route.query.redirect || '/admin/business/social-reasons');
      }).catch(function (error) {
        console.log('FAILURE!!');
      }).finally(function () {
        window.$('#create').button('reset');
        vm.loading = true;
        _this3.socialreason = _this3.defineSocialReason();
      });
    },
    editSocialReason: function editSocialReason(value) {
      this.boxedit = true;
      this.socialreason_current = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
    },
    trmChange: function trmChange(value) {
      this.boxtrmchange = true;
      this.socialreason_current = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
    },
    closeTrmChangeModal: function closeTrmChangeModal() {
      this.boxtrmchange = false;
      this.socialreason_current = {};
    },
    trmChangeHistory: function trmChangeHistory(value) {
      this.boxtrmchangehistory = true;
      this.socialreason_current = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
    },
    closeTrmChangeHistoryModal: function closeTrmChangeHistoryModal() {
      this.boxtrmchangehistory = false;
      this.socialreason_current = {};
    },
    closeEditSocialReason: function closeEditSocialReason() {
      this.boxedit = false;
      this.socialreason_current = {};
    },
    updateEditSocialReason: function updateEditSocialReason(value) {
      var _this4 = this;

      var vm = this;
      vm.socialreason_current.entity = 'socialreason';
      vm.loading = false;
      vm.update(vm.socialreason_current).then(function (item) {
        vm.loading = true;
        vm.boxedit = false;
        vm.socialreason = _this4.defineSocialReason();
        vm.$router.replace(vm.$route.query.redirect || '/admin/business/social-reasons');
      }).catch(function (message) {
        vm.loading = true;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['getAll', 'getList', 'store', 'update'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default.a,
    TrmChangeModal: __WEBPACK_IMPORTED_MODULE_7__components_admin_social_reasons_TrmChangeModal___default.a,
    TrmChangeHistoryModal: __WEBPACK_IMPORTED_MODULE_8__components_admin_social_reasons_TrmChangeHistoryModal___default.a
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TrmChangeModal',
  props: ['socialreason', 'message'],
  data: function data() {
    return {
      errors: [],
      change: {
        social_reason_id: null,
        change: null,
        entity: 'trmchange'
      }
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              document.body.className = 'overflow-hidden';

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    document.body.classList.remove('overflow-hidden');
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    updateTrmChange: function updateTrmChange() {
      var vm = this;
      vm.change.social_reason_id = this.socialreason.id;
      vm.loading = false;
      vm.store(vm.change).then(function (item) {
        vm.boxedit = false;
        window.location.reload();
      }).catch(function (message) {
        console.log(message);
      }).finally(function () {
        vm.loading = true;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['store'])),
  components: {
    appLoading: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TrmChangeModal',
  props: ['socialreason', 'message'],
  data: function data() {
    return {
      errors: [],
      change: {
        social_reason_id: null,
        change: null,
        month: null,
        year: null,
        entity: 'trmchange'
      },
      confirmation: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              document.body.className = 'overflow-hidden';

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    document.body.classList.remove('overflow-hidden');
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    updateTrmChange: function updateTrmChange() {
      var vm = this;
      vm.change.social_reason_id = this.socialreason.id;
      vm.loading = false;
      vm.store(vm.change).then(function (item) {
        vm.boxedit = false;
        window.location.reload();
      }).catch(function (message) {
        console.log(message);
      }).finally(function () {
        vm.loading = true;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['store'])),
  components: {
    appLoading: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListTask',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      supplier: this.defineSupplier(),
      supplier_current: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    user: 'getUser',
    suppliers: 'getSuppliers',
    countries: 'getAccountCountries',
    accounts: 'getAccounts'
  })),
  mounted: function mounted() {
    var _this = this;

    $('#supplier').on('hidden.bs.modal', function () {
      _this.defineSupplier();
    });
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this2.getAll('supplier');

            case 3:
              _context.next = 5;
              return _this2.getList('accountcountry');

            case 5:
              _context.next = 7;
              return _this2.getList('account');

            case 7:

              _this2.loading = true;
              _context.next = 12;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](0);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 10]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    defineSupplier: function defineSupplier() {
      return {
        social_reason: null,
        contact: null,
        nit: null,
        country: null,
        city: null,
        address: null,
        telphone: null,
        cellphone: null,
        email: null,
        contact_name: null,
        contact_cellphone: null,
        contact_email: null,
        link: null,
        entity: 'supplier'
      };
    },
    createSupplier: function createSupplier() {
      var _this3 = this;

      var vm = this;
      window.$('#create').button('loading');
      vm.store(vm.supplier).then(function (item) {
        window.$('#supplier').modal('hide');
        vm.$router.replace(vm.$route.query.redirect || '/admin/business/suppliers');
      }).catch(function (error) {
        console.log('FAILURE!!');
      }).finally(function () {
        window.$('#create').button('reset');
        vm.loading = true;
        _this3.supplier = _this3.defineSupplier();
      });
    },
    editSupplier: function editSupplier(value) {
      this.boxedit = true;
      this.supplier_current = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
    },
    closeEditSupplier: function closeEditSupplier() {
      this.boxedit = false;
      this.supplier_current = {};
    },
    updateEditSupplier: function updateEditSupplier(value) {
      var _this4 = this;

      var vm = this;
      vm.supplier_current.entity = 'supplier';
      vm.loading = false;
      vm.update(vm.supplier_current).then(function (item) {
        vm.loading = true;
        vm.boxedit = false;
        vm.supplier = _this4.defineSupplier();
        vm.$router.replace(vm.$route.query.redirect || '/admin/business/suppliers');
      }).catch(function (message) {
        vm.loading = true;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['getAll', 'getList', 'store', 'update'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AssignAccountUser',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      view: {
        entity: 'supplier',
        id: this.$route.params.id
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    current: 'getSupplier',
    accounts: 'getAccounts',
    socialreasons: 'getSocialReasons'
  }), {
    filteredAccounts: function filteredAccounts() {
      var _this = this;

      return this.accounts.filter(function (account) {
        if (!_this.current.accounts.some(function (item) {
          return item.id == account.id;
        })) {
          return account;
        }
      });
    },
    filteredSocialReasons: function filteredSocialReasons() {
      var _this2 = this;

      return this.socialreasons.filter(function (socialreason) {
        if (!_this2.current.socialreasons.some(function (item) {
          return item.id == socialreason.id;
        })) {
          return socialreason;
        }
      });
    }
  }),
  beforeMount: function beforeMount() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this3.getList('account');

            case 3:
              _context.next = 5;
              return _this3.getList('socialreason');

            case 5:
              _context.next = 7;
              return _this3.lookCurrentSupplier();

            case 7:
              _this3.loading = true;
              _context.next = 12;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](0);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3, [[0, 10]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    addElement: function addElement(element, entity) {
      var _this4 = this;

      var form = {
        entity: entity,
        id: this.current.id,
        element_id: element.id
      };

      this.store(form).then(function () {
        _this4.lookCurrentSupplier();
      });
    },
    removeElement: function removeElement(element, entity) {
      var _this5 = this;

      var form = {
        entity: entity,
        id: this.current.id,
        element_id: element.id
      };

      this.update(form).then(function () {
        _this5.lookCurrentSupplier();
      });
    },
    lookCurrentSupplier: function lookCurrentSupplier() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this6.show(_this6.view);

              case 3:
                _this6.loading = true;
                _context2.next = 8;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](0);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[0, 6]]);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['show', 'getAll', 'getList', 'store', 'update'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_TitleCustom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_TitleCustom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_TitleCustom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_assets_MultiSelect_MultiSelect__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_assets_MultiSelect_MultiSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_assets_MultiSelect_MultiSelect__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['task', 'options', 'team_session', 'defineQuery'],
  data: function data() {
    return {
      task_loading: 11,
      task_validated: false,
      taskButtonLoading: false
    };
  },

  components: {
    MultiSelect: __WEBPACK_IMPORTED_MODULE_6__components_assets_MultiSelect_MultiSelect___default.a,
    AppTitleCustom: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_TitleCustom___default.a
  },
  created: function created() {
    document.body.style.overflow = 'hidden';
  },
  beforeDestroy: function beforeDestroy() {
    document.body.style.overflow = null;
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([_this.getList('campaign'), _this.getList('project')]);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['getList', 'store']), {
    addTag: function addTag(tag) {
      this.$emit('addTag', tag);
    },
    createTask: function createTask() {
      if (this.task_validated) {
        this.processValidatedTask();
      } else {
        this.processNoValidatedTask();
      }
    },
    processValidatedTask: function processValidatedTask() {
      var _this2 = this;

      this.taskButtonLoading = true;
      this.task.team_id = this.team_session;
      var query = this.defineQuery();
      console.log(this.task);
      this.store([this.task, query]).then(function (item) {
        _this2.$emit('taskCreated');
        window.location.reload();
      }).catch(function (error) {
        console.log('FAILURE!!');
      }).finally(function () {
        _this2.taskButtonLoading = false;
      });
    },
    processNoValidatedTask: function processNoValidatedTask() {
      var _this3 = this;

      this.task_validated = !this.task_validated;
      this.taskButtonLoading = true;
      setTimeout(function () {
        _this3.taskButtonLoading = false;
      }, 10000);
      var interval = setInterval(function (interval) {
        _this3.addSeconds(interval);
      }, 1000);

      this.task_loading = 11;
    },
    addSeconds: function addSeconds(interval) {
      if (this.task_loading > 0) {
        this.task_loading = this.task_loading - 1;
      } else {
        clearInterval(interval);
      }
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    filteredCampaigns: function filteredCampaigns() {
      var _this4 = this;

      return this.campaigns.filter(function (campaign) {
        return campaign.project_id == _this4.task.project_id;
      });
    },
    filteredProjects: function filteredProjects() {
      var _this5 = this;

      return this.projects.filter(function (project) {
        var account = project.account_id == localStorage.session_account;
        if (_this5.team_session == 1) {
          return project.hours > 0 && account;
        } else {
          return account;
        }
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    projects: 'getProjects',
    campaigns: 'getCampaigns'
  }))
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_assets_MultiSelect_MultiSelect__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_assets_MultiSelect_MultiSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_assets_MultiSelect_MultiSelect__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['task'],
  data: function data() {
    return {
      task_duplicate: {},
      task_loading: 11,
      task_validated: false,
      options: [],
      isLoading: false
    };
  },
  created: function created() {
    document.body.style.overflow = 'hidden';
  },
  beforeDestroy: function beforeDestroy() {
    document.body.style.overflow = null;
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var query;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.isLoading = true;
              query = 'account_session=' + localStorage.session_account;
              _context.prev = 2;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([_this.getList(['project', query]), _this.getList(['campaign', query])]);

            case 5:
              _context.next = 7;
              return _this.duplicateTask();

            case 7:
              _this.isLoading = false;
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](2);

              _this.isLoading = false;

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 10]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['getList']), {
    duplicateTask: function duplicateTask() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.task_duplicate = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.task));
                //console.log(this.task_duplicate)
                _this2.task_duplicate.path = _this2.task_duplicate.path.split(',');
                _this2.showDuplicateModal = true;

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    clearDuplicateTask: function clearDuplicateTask() {
      this.task_duplicate = {};
      this.showDuplicateModal = false;
      this.$emit('clearDuplicateTask');
    },
    addTag: function addTag(newTag) {
      this.options.push(newTag);
    },
    createDuplicateTask: function createDuplicateTask() {
      var _this3 = this;

      var vm = this;

      if (this.task_validated) {
        window.$('#create_duplicate').button('loading');

        vm.task_duplicate.response_observations = null;
        vm.task_duplicate.response_path = null;
        vm.task_duplicate.state_id = 1;
        vm.task_duplicate.entity = 'task';

        vm.store(vm.task_duplicate).then(function (item) {
          _this3.clearDuplicateTask();
          window.location.reload();
        }).catch(function (error) {
          console.log('FAILURE!!');
        }).finally(function () {
          window.$('#create_duplicate').button('reset');
          vm.loading = true;
        });
      } else {
        var _addSeconds = function _addSeconds() {
          if (vm.task_loading > 0) {
            vm.task_loading = vm.task_loading - 1;
          } else {
            clearInterval(interval);
          }
        };

        vm.task_validated = !vm.task_validated;
        window.$('#create_duplicate').button('loading');
        setTimeout(function () {
          window.$('#create_duplicate').button('reset');
        }, 10000);
        var interval = setInterval(function () {
          _addSeconds();
        }, 1000);

        this.task_loading = 11;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['store'])),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    projects: 'getProjects',
    campaigns: 'getCampaigns',
    teams: 'getTeams'
  })),
  components: {
    MultiSelect: __WEBPACK_IMPORTED_MODULE_7__components_assets_MultiSelect_MultiSelect___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_TitleCustom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_TitleCustom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_TitleCustom__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EditTaskAdmin',
  data: function data() {
    return {
      loading: false,
      view: {
        entity: 'task',
        id: this.$route.params.id
      },
      version: {
        entity: 'taskversion',
        observations: '',
        path: '',
        date: ''
      },
      aux_task: {
        entity: 'task',
        campaign_id: null,
        project_id: null
      },
      version_current: {
        entity: 'taskversion'
      },
      buttonIsLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    task: 'getTask',
    campaigns: 'getCampaigns',
    teams: 'getTeams',
    states: 'getTaskStates',
    users: 'getUsers',
    projects: 'getProjects'
  }), {
    filteredCampaigns: function filteredCampaigns() {
      var _this = this;

      var campaigns = this.campaigns.filter(function (v) {
        return v.project_id == _this.aux_task.project_id;
      });

      var found = campaigns.some(function (el) {
        return el.id == _this.aux_task['campaign_id'];
      });
      if (this.task && !found) {
        this.aux_task['campaign_id'] = '';
      }
      return campaigns;
    },
    filteredUsers: function filteredUsers() {
      var _this2 = this;

      return this.users.filter(function (item) {
        var accounts_ids = item.accountsIds;
        var search = accounts_ids.indexOf(_this2.task.campaign_attribute.project_account_id);

        return search !== -1;
      });
    }
  }),
  beforeMount: function beforeMount() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this3.loading = true;
              _context.prev = 1;
              _context.next = 4;
              return _this3.show(_this3.view);

            case 4:
              _this3.getList('campaign');
              _this3.getList('team');
              _this3.getList('taskstate');
              _this3.getList('user');
              _this3.getList('project');
              _this3.aux_task['campaign_id'] = _this3.task.campaign_id;
              _this3.aux_task['project_id'] = _this3.task.project_id;
              _this3.loading = false;
              _context.next = 16;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context['catch'](1);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3, [[1, 14]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    updateTask: function updateTask() {
      var _this4 = this;

      var vm = this;
      this.loadingButton = true;
      window.$('#edit').button('loading');
      vm.aux_task.id = this.task.id;
      vm.update(vm.aux_task).then(function (item) {
        vm.$router.replace('/admin/traffic/tasks');
      }).catch(function (message) {
        window.$('#edit').button('reset');
      }).finally(function () {
        _this4.loadingButton = false;
      });
    },
    createVersion: function createVersion() {
      var vm = this;
      vm.loading = false;
      window.$('#create').button('loading');
      vm.version.task_id = this.task.id;
      vm.store(vm.version).then(function (item) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/tasks');
      }).catch(function (message) {
        window.$('#create').button('reset');
        vm.loading = true;
      });
    },
    updateVersion: function updateVersion(item) {
      var vm = this;
      vm.loading = false;
      window.$('#editversion').button('loading');
      vm.version_current.id = item.id;
      vm.store(vm.version_current).then(function (item) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/tasks');
      }).catch(function (message) {
        window.$('#editversion').button('reset');
        vm.loading = true;
      });
    },
    updateValue: function updateValue(attribute, e) {
      this.aux_task[attribute] = e.target.value;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['show', 'getAll', 'getList', 'update', 'store'])),
  components: {
    appLoading: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default.a,
    appTitleCustom: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_TitleCustom___default.a
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['team_session', 'account_session'],
  data: function data() {
    return {
      percentage: 0,
      start_date: null,
      end_date: null,
      hours_account: 0,
      hours_used: 0,
      projects: []
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getInfo();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get']), {
    getInfo: function getInfo() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, percentage, start_date, end_date, hours_account, hours_used, projects_hours;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.get('/hours-account/' + _this2.account_session + '/' + _this2.team_session);

              case 4:
                _ref = _context2.sent;
                percentage = _ref.percentage;
                start_date = _ref.start_date;
                end_date = _ref.end_date;
                hours_account = _ref.hours_account;
                hours_used = _ref.hours_used;
                projects_hours = _ref.projects_hours;

                if (_this2.team_session != "1") {
                  _this2.percentage = percentage;
                  _this2.start_date = start_date;
                  _this2.end_date = end_date;
                  _this2.hours_account = hours_account;
                  _this2.hours_used = hours_used;
                } else {
                  _this2.projects = projects_hours;
                }
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](1);

                console.log(_context2.t0);

              case 17:
                _context2.prev = 17;

                _this2.loading = false;
                return _context2.finish(17);

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 14, 17, 20]]);
      }))();
    }
  })
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_assets_MultiSelect_MultiSelect__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_assets_MultiSelect_MultiSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_assets_MultiSelect_MultiSelect__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListTask',
  data: function data() {
    return {
      loading: false,
      task: this.defineTask(),
      filter: this.clearFilter(),
      task_validated: false,
      task_loading: 11,
      today: null,
      options: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    user: 'getUser',
    tasks: 'getTasks',
    users: 'getUsers',
    campaigns: 'getCampaigns',
    teams: 'getTeams',
    projects: 'getProjects',
    accounts: 'getAccounts',
    states: 'getTaskStates'
  }), {
    filteredCampaigns: function filteredCampaigns() {
      var _this = this;

      this.task.campaign_id = '';
      return this.campaigns.filter(function (v) {
        return v.project_id == _this.task.project_id;
      });
    },
    filteredTasks: function filteredTasks() {
      var _this2 = this;

      var tasksFiltered = this.tasks.filter(function (item) {
        var slug = _this2.filter.slug ? item.slug.toLowerCase().includes(_this2.filter.slug.toLowerCase()) : true;
        var account = _this2.filter.account ? item.campaign_attribute.project_account_id === _this2.filter.account : true;
        var state = _this2.filter.state ? item.state_id === _this2.filter.state : true;

        return slug && account && state;
      });

      return tasksFiltered.slice(0, 500);
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    $('#task').on('hidden.bs.modal', function () {
      _this3.defineTask();
    });

    var newDate = new Date();
    var dd = ('0' + newDate.getDate()).slice(-2);
    var mm = ('0' + (newDate.getMonth() + 1)).slice(-2);
    var yyyy = newDate.getFullYear();

    this.today = yyyy + '-' + mm + '-' + dd;
  },
  beforeMount: function beforeMount() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this4.getListTasksMongo('task');

            case 3:
              _this4.getList('user');
              _this4.getList('campaign');
              _this4.getList('project');
              _this4.getList('account');
              _this4.getList('taskstate');
              _context.next = 12;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](0);

            case 12:
              _context.prev = 12;

              _this4.loading = true;
              return _context.finish(12);

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this4, [[0, 10, 12, 15]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    defineTask: function defineTask() {
      return {
        name: '',
        description: '',
        date: '',
        campaign_id: '',
        team_id: '',
        entity: 'task',
        path: [],
        project_id: ''
      };
    },
    clearFilter: function clearFilter() {
      return {
        slug: null,
        account: null,
        state: null
      };
    },
    createTask: function createTask() {
      var _this5 = this;

      var vm = this;
      window.$('#create').button('loading');
      vm.store(vm.task).then(function (item) {
        window.$('#task').modal('hide');
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/tasks');
      }).catch(function (error) {
        console.log('FAILURE!!');
      }).finally(function () {
        window.$('#create').button('reset');
        vm.loading = true;
        _this5.defineTask();
      });
    },
    dateClass: function dateClass(task) {
      var date = task.date;
      var styleClass = null;

      if (task.state_id == 4) {
        styleClass = 'bg-theme-1';
      } else {
        if (date > this.today) {
          styleClass = 'bg-theme-9';
        } else {
          if (date == this.today) {
            styleClass = 'bg-theme-12';
          } else {
            styleClass = 'bg-theme-6';
          }
        }
      }
      return styleClass;
    },
    addTag: function addTag(newTag) {
      this.options.push(newTag);
      this.task.path.push(newTag);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['getListTasksMongo', 'getList', 'getAll', 'store'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_LoadingWhite___default.a,
    MultiSelect: __WEBPACK_IMPORTED_MODULE_6__components_assets_MultiSelect_MultiSelect___default.a
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_partials_TitleCustom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_partials_TitleCustom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_admin_partials_TitleCustom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_task_TaskEditModal__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_task_TaskEditModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_admin_task_TaskEditModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin_task_ViewTaskModal__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin_task_ViewTaskModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_admin_task_ViewTaskModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_assets_MultiSelect_MultiSelect__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_assets_MultiSelect_MultiSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_assets_MultiSelect_MultiSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_task_CreateTaskModal__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_task_CreateTaskModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_admin_task_CreateTaskModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_admin_task_DuplicateTaskComponent__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_admin_task_DuplicateTaskComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_admin_task_DuplicateTaskComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_admin_task_HoursTasksComponent__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_admin_task_HoursTasksComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_admin_task_HoursTasksComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_DateClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_TodayFormat__ = __webpack_require__(51);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminTaskComponent',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      task: this.defineTask(),
      task_current: null,
      task_duplicate: {},
      filter: this.clearFilter(),
      account_session: null,
      auth_session_account: null,
      team_session: null,
      showDuplicateModal: false,
      task_view: null,
      tasks_by_finish: 0,
      today: null,
      options: [],
      createTaskModal: false,
      completed_tasks: false,
      clic_taskspendingauth: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var routeQuery, accountSession, query, _ref, list, taskId, task;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              routeQuery = _this.$route.query;
              accountSession = routeQuery.account ? routeQuery.account : localStorage.session_account;

              _this.SESSION_ACCOUNT(accountSession);

              if (_this.$route.path === '/admin/pendings-tasks') {
                _this.account_session = null;
              } else {
                _this.account_session = accountSession;
                localStorage.session_account = accountSession;
              }

              _this.auth_session_account = accountSession;
              _this.team_session = localStorage.session_team;

              _context.prev = 6;
              query = _this.defineQuery();
              _context.next = 10;
              return _this.getListTasksMongo(['task', query]);

            case 10:
              _ref = _context.sent;
              list = _ref.list;
              taskId = parseInt(_this.$route.query.task);


              if (taskId) {
                task = list.find(function (x) {
                  return x.id === taskId;
                });


                if (task) {
                  _this.editTask(task);
                }
              }
              _context.next = 18;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context['catch'](6);

            case 18:
              _context.prev = 18;

              _this.loading = true;
              return _context.finish(18);

            case 21:
              _context.next = 23;
              return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([_this.getList('taskstate'), _this.getList('user')]);

            case 23:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[6, 16, 18, 21]]);
    }))();
  },
  mounted: function mounted() {
    this.today = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__services_TodayFormat__["a" /* todayFormat */])();
  },


  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    defineTask: function defineTask() {
      return {
        name: '',
        date: '',
        campaign_id: '',
        team_id: '',
        entity: 'task',
        path: [],
        project_id: ''
      };
    },
    setCreateTaskModal: function setCreateTaskModal(boolean) {
      this.createTaskModal = boolean;
    },
    taskCreated: function taskCreated() {
      this.task = this.defineTask();
      this.createTaskModal = false;
    },
    taskEdited: function taskEdited() {
      this.loading = false;
      this.task = this.defineTask();
      this.boxedit = false;
      window.location = window.location.href.split('?')[0];
    },
    clearFilter: function clearFilter() {
      return {
        state: null,
        slug: '',
        date: null,
        name: null,
        created_by: null,
        support: true,
        assigned_to_me: false,
        start_date: null,
        end_date: null
      };
    },
    defineQuery: function defineQuery() {
      var completed_tasks = this.completed_tasks ? 'completed' : 'default';

      var query = 'account_session=' + this.account_session + '&team_session=' + this.team_session + '&states=' + completed_tasks;

      var accountsLength = this.usersession.accounts ? this.usersession.accounts.length : null;

      if (this.$route.path === '/admin/pendings-tasks' && this.account_session == null && accountsLength) {
        query = 'account_session=' + this.usersession.accountsIds + '&team_session=' + this.team_session + '&states=pending';
      }

      return query;
    },
    editTask: function editTask(value) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var task, data, task_show;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.boxedit = false;
                window.scrollTo(0, 0);

                _this2.boxedit = true;
                task = void 0;

                if (!value.task_id) {
                  _context2.next = 12;
                  break;
                }

                data = {
                  entity: 'task',
                  id: value.task_id
                };
                _context2.next = 8;
                return _this2.show(data);

              case 8:
                task_show = _context2.sent;

                task = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, task_show);
                _context2.next = 13;
                break;

              case 12:
                task = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));

              case 13:
                if (task.response_path) {
                  task.response_path = task.response_path.split(',');
                }
                _this2.task_current = task;

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    viewTask: function viewTask(task) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var view;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                view = {
                  entity: 'taskversion',
                  id: task.id
                };
                _context3.next = 3;
                return _this3.show(view);

              case 3:
                task.versions = _context3.sent;


                _this3.task_view = task;

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    closeEditTask: function closeEditTask() {
      this.boxedit = false;
      this.task_current = null;
    },
    createDuplicateModal: function createDuplicateModal(task) {
      this.showDuplicateModal = true;
      task.user_id = null;
      this.task_duplicate = task;
    },
    viewAccountTask: function viewAccountTask(e) {
      var project_account_id = e.campaign_attribute.project_account_id;

      localStorage.session_account = project_account_id;
      this.$router.push('/admin/tasks?task=' + e.id + '&account=' + project_account_id);
    },
    viewAccounts: function viewAccounts(val) {
      var query = '';
      var pending = '';

      if (this.$route.path === '/admin/pendings-tasks') {
        pending = 'pending';
      }

      if (val == 'all') {
        query = 'account_session=' + this.usersession.accountsIds + '&team_session=' + this.team_session + '&states=' + pending;
        this.account_session = null;
      } else {
        this.account_session = localStorage.session_account;
        query = 'account_session=' + this.account_session + '&team_session=' + this.team_session + '&states=' + pending;
      }

      try {
        this.getListTasksMongo(['task', query]);

        this.loading = true;
      } catch (error) {}
    },
    viewTaskFinish: function viewTaskFinish() {
      this.completed_tasks = !this.completed_tasks;

      var query = '';
      query = this.defineQuery();

      try {
        this.getListTasksMongo(['task', query]);

        this.loading = true;
      } catch (error) {}
    },
    addTag: function addTag(newTag) {
      this.options.push(newTag);
      this.task.path.push(newTag);
    },
    dateClass: function dateClass(task) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__services_DateClass__["a" /* handleDateClass */])('task', task, this.today);
    },
    taskPendingAuth: function taskPendingAuth() {
      var current = this.clic_taskspendingauth;
      if (!current) {
        this.filter.state = 7;
        this.filter.created_by = this.usersession.id;
      } else {
        this.filter = this.clearFilter();
      }
      this.clic_taskspendingauth = !current;
    },
    removeSupport: function removeSupport() {
      this.filter.support = !this.filter.support;
    },
    assignedToMe: function assignedToMe() {
      this.filter.assigned_to_me = !this.filter.assigned_to_me;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapMutations */])(['SESSION_ACCOUNT']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['show', 'getAll', 'getList', 'getListTasksMongo'])),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    tasks: 'getTasks',
    users: 'getUsers',
    usersession: 'getUser',
    states: 'getTaskStates'
  }), {
    filteredTasks: function filteredTasks() {
      var _this4 = this;

      var count = 0;
      var tasksFiltered = this.tasks.filter(function (item) {
        if (_this4.$route.path === '/admin/pendings-tasks') {
          if (item.state_id <= 3 || item.state_id == 6) {
            var support = _this4.filter.support ? true : item.campaign_attribute.project_account_id != 44;

            var assigned_to_me = _this4.filter.assigned_to_me ? item.user_id == _this4.usersession.id : true;
            return item && support && assigned_to_me;
          }
        } else {
          var slug = _this4.filter.slug ? item.slug.toLowerCase().includes(_this4.filter.slug.toLowerCase()) : true;
          var name = _this4.filter.name ? item.name.toLowerCase().includes(_this4.filter.name.toLowerCase()) : true;
          var date = _this4.filter.date ? _this4.filter.date == item.date : true;
          var state = _this4.filter.state ? _this4.filter.state == item.state_id : true;

          var created_by = _this4.filter.created_by ? _this4.filter.created_by == item.created_by : true;
          var start_date = _this4.filter.start_date ? _this4.filter.start_date + ' 00:00:01' <= item.created_at : true;
          var end_date = _this4.filter.end_date ? _this4.filter.end_date + ' 23:00:00' >= item.created_at : true;

          // validate tasks by finish
          if (item.state_id == 7 && item.created_by == _this4.usersession.id) {
            count++;
          }

          return slug && name && date && state && created_by && start_date && end_date;
        }
      });

      this.tasks_by_finish = count;

      return tasksFiltered;
    },
    filteredUsers: function filteredUsers() {
      var _this5 = this;

      return this.users.filter(function (item) {
        var accounts_ids = item.accountsIds;
        var search = accounts_ids.indexOf(parseInt(_this5.account_session));

        return search !== -1;
      });
    }
  }),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_7__components_admin_partials_LoadingWhite___default.a,
    appTitleCustom: __WEBPACK_IMPORTED_MODULE_8__components_admin_partials_TitleCustom___default.a,
    DuplicateTaskComponent: __WEBPACK_IMPORTED_MODULE_13__components_admin_task_DuplicateTaskComponent___default.a,
    ViewTaskModal: __WEBPACK_IMPORTED_MODULE_10__components_admin_task_ViewTaskModal___default.a,
    TaskEditModal: __WEBPACK_IMPORTED_MODULE_9__components_admin_task_TaskEditModal___default.a,
    HoursTasksComponent: __WEBPACK_IMPORTED_MODULE_14__components_admin_task_HoursTasksComponent___default.a,
    MultiSelect: __WEBPACK_IMPORTED_MODULE_11__components_assets_MultiSelect_MultiSelect___default.a,
    CreateTaskModal: __WEBPACK_IMPORTED_MODULE_12__components_admin_task_CreateTaskModal___default.a,
    handleDateClass: __WEBPACK_IMPORTED_MODULE_15__services_DateClass__["a" /* handleDateClass */],
    todayFormat: __WEBPACK_IMPORTED_MODULE_16__services_TodayFormat__["a" /* todayFormat */]
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_entity_mutation_types__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_TitleCustom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_TitleCustom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_TitleCustom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_assets_MultiSelect_MultiSelect__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_assets_MultiSelect_MultiSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_assets_MultiSelect_MultiSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_task_TaskEditVersions__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_task_TaskEditVersions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_task_TaskEditVersions__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['users', 'states', 'usersession', 'task_current', 'team_session', 'defineQuery'],
  data: function data() {
    return {
      version: this.defineVersion(),
      version_current: this.defineResponseVersion(),
      createVersionVariable: false,
      options: [],
      responsePathOptions: [],
      responseVersionPathOptions: [],
      buttonIsLoading: false,
      edit_response_path: false,
      response_path: []
    };
  },
  mounted: function mounted() {
    this.edit_response_path = this.task_current.response_path == null ? true : false;
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__vuex_entity_mutation_types__["a" /* SHOW_TASKVERSION */], []);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    updateTask: function updateTask() {
      var _this = this;

      var vm = this;
      vm.task_current.entity = 'task';
      vm.task_current.response_path = this.edit_response_path ? vm.response_path : vm.task_current.response_path;
      this.buttonIsLoading = true;
      var query = this.defineQuery();
      vm.update([vm.task_current, query]).then(function (item) {
        _this.$emit('taskEdited');
      }).catch(function (message) {
        console.log(message);
      }).finally(function () {
        _this.buttonIsLoading = false;
      });
    },
    defineVersion: function defineVersion() {
      return {
        entity: 'taskversion',
        path: []
      };
    },
    defineResponseVersion: function defineResponseVersion() {
      return {
        entity: 'taskversion',
        response_path: [],
        response_observations: ''
      };
    },
    createVersion: function createVersion() {
      var _this2 = this;

      var vm = this;
      vm.version.task_id = this.task_current.id;
      this.buttonIsLoading = true;
      console.log(vm.version);
      vm.store(vm.version).then(function (item) {
        vm.boxedit = false;
        vm.version = _this2.defineVersion();
        window.location.reload();
      }).catch(function (message) {
        console.log(message);
      }).finally(function () {
        _this2.buttonIsLoading = false;
      });
    },
    updateVersion: function updateVersion(item) {
      var _this3 = this;

      var vm = this;
      this.buttonIsLoading = true;
      window.$('#editversion').button('loading');
      vm.version_current.id = item.id;
      vm.store(vm.version_current).then(function (item) {
        vm.version = _this3.defineVersion();
        window.location.reload();
      }).catch(function (message) {
        window.$('#editversion').button('reset');
        _this3.buttonIsLoading = false;
      });
    },
    addTag: function addTag(newTag) {
      this.options.push(newTag);
      this.version.path.push(newTag);
    },
    editResponsePath: function editResponsePath() {
      this.edit_response_path = true;
    },
    addResponseTag: function addResponseTag(newTag) {
      this.responsePathOptions.push(newTag);
      if (this.response_path == null) {
        this.response_path = [];
      }
      this.response_path.push(newTag);
    },
    addResponseVersionTag: function addResponseVersionTag(newTag) {
      this.responseVersionPathOptions.push(newTag);
      if (this.version_current.response_path == null) {
        this.version_current.response_path = [];
      }
      this.version_current.response_path.push(newTag);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['get', 'store', 'update'])),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    //versions: 'getTaskVersion',
  }), {
    filteredUsers: function filteredUsers() {
      var _this4 = this;

      return this.users.filter(function (item) {
        var accounts_ids = item.accountsIds;
        var search = accounts_ids.indexOf(_this4.task_current.campaign_attribute.project_account_id);

        if (_this4.usersession.role == 4) {
          return search !== -1;
        } else {
          return search !== -1 && item.team_id == localStorage.session_team;
        }
      });
    },
    filteredStates: function filteredStates() {
      var _this5 = this;

      return this.states.filter(function (v) {
        if (_this5.usersession.team_id != _this5.task_current.team_id) {
          return v.id == 4;
        } else {
          return v.id != 4;
        }
      });
    }
  }),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_Icon___default.a,
    appTitleCustom: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_TitleCustom___default.a,
    MultiSelect: __WEBPACK_IMPORTED_MODULE_5__components_assets_MultiSelect_MultiSelect___default.a,
    TaskEditVersions: __WEBPACK_IMPORTED_MODULE_6__components_admin_task_TaskEditVersions___default.a
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_assets_MultiSelect_MultiSelect__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_assets_MultiSelect_MultiSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_assets_MultiSelect_MultiSelect__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['users', 'states', 'usersession', 'task_current', 'team_session'],

  data: function data() {
    return {
      current_version: {
        version: {},
        entity: 'taskversion'
      },
      versions: {},
      open: null,
      options: [],
      buttonIsLoading: false,
      responsePathOptions: [],
      responseVersionPathOptions: [],
      edit_response_path: false,
      response_path: []
    };
  },
  mounted: function mounted() {
    this.getListChildrenTasks();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    getListChildrenTasks: function getListChildrenTasks() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!_this.task_current || !_this.task_current.id)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return _this.get('task/children/' + _this.task_current.id).then(function (data) {
                  _this.versions = data.model;
                });

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](2);

                window.$toast.error(_context.t0);

              case 10:
                _context.prev = 10;
                return _context.finish(10);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 7, 10, 12]]);
      }))();
    },
    updateTaskVersion: function updateTaskVersion(item) {
      var _this2 = this;

      var vm = this;
      this.buttonIsLoading = true;
      window.$('#editversion').button('loading');
      vm.current_version.version = item;
      vm.current_version.version.response_path = this.response_path.length > 0 ? vm.response_path : vm.current_version.version.response_path;
      console.log(vm.current_version);
      vm.store(vm.current_version).then(function (item) {
        window.$('#editversion').button('reset');
        _this2.buttonIsLoading = false;
        window.location = window.location.href.split('?')[0];
      }).catch(function (message) {
        window.$('#editversion').button('reset');
        _this2.buttonIsLoading = false;
      });
    },
    addTag: function addTag(newTag) {
      this.options.push(newTag);
      this.version.path.push(newTag);
    },
    addResponseTag: function addResponseTag(newTag, version) {
      this.responsePathOptions.push(newTag);
      if (this.response_path == null) {
        this.response_path = [];
      }
      this.response_path.push(newTag);
    },
    editResponsePath: function editResponsePath() {
      this.edit_response_path = true;
    },
    changeStatus: function changeStatus(event) {
      var value = event.target.value;

      if (value == 7) {
        this.edit_response_path = true;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get', 'store'])),
  computed: {
    filteredUsers: function filteredUsers() {
      var _this3 = this;

      return this.users.filter(function (item) {
        var accounts_ids = item.accountsIds;
        var search = accounts_ids.indexOf(_this3.task_current.campaign_attribute.project_account_id);

        if (_this3.usersession.role == 4) {
          return search !== -1;
        } else {
          return search !== -1 && item.team_id == localStorage.session_team;
        }
      });
    },
    filteredStates: function filteredStates() {
      var _this4 = this;

      return this.states.filter(function (v) {
        if (_this4.usersession.team_id != _this4.task_current.team_id) {
          return v.id == 4;
        } else {
          return v.id != 4;
        }
      });
    },
    filteredVersions: function filteredVersions() {
      return this.versions.map(function (v) {
        if (v.response_path && !Array.isArray(v.response_path)) {
          v.response_path = v.response_path.split(',');
        }
        return v;
      });
    }
  },
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_Icon___default.a,
    MultiSelect: __WEBPACK_IMPORTED_MODULE_5__components_assets_MultiSelect_MultiSelect___default.a
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'AdminTaskHoursMonth',
    data: function data() {
        return {
            loading: false,
            tasks: [],
            groups: [],
            team_session: null,
            account_session: null,
            start_date: null,
            end_date: null,
            order_select: 'percentage',
            orders: [{ 'id': 'percentage', 'name': 'Porcentaje' }, { 'id': 'hours', 'name': 'Horas' }, { 'id': 'hours_used', 'name': 'Horas Usadas' }],
            filter: {
                group: null
            },
            total_hours: 0,
            total_hours_used: 0
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
        user: 'getUser'
    })),
    beforeMount: function beforeMount() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.account_session = localStorage.session_account;
                            _this.team_session = localStorage.session_team;
                            _context.prev = 2;
                            _context.next = 5;
                            return _this.getTasks();

                        case 5:
                            _context.next = 9;
                            break;

                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context['catch'](2);

                        case 9:
                            _context.prev = 9;

                            _this.loading = true;
                            return _context.finish(9);

                        case 12:
                            _this.getGroups();

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[2, 7, 9, 12]]);
        }))();
    },

    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get']), {
        getGroups: function getGroups() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _ref, list;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.loading = false;
                                _context2.prev = 1;
                                _context2.next = 4;
                                return _this2.get('/account-group');

                            case 4:
                                _ref = _context2.sent;
                                list = _ref.list;

                                _this2.groups = list;
                                _this2.loading = true;
                                _context2.next = 13;
                                break;

                            case 10:
                                _context2.prev = 10;
                                _context2.t0 = _context2['catch'](1);

                                _this2.loading = true;

                            case 13:
                                _context2.prev = 13;

                                _this2.loading = true;
                                return _context2.finish(13);

                            case 16:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[1, 10, 13, 16]]);
            }))();
        },
        getTasks: function getTasks() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var _ref2, list, start_date, end_date, filter_group;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return _this3.get('/tasks-hours-month?team_session=' + _this3.team_session + '&order=' + _this3.order_select + '&account_id=' + _this3.account_session + '&group=' + _this3.filter.group);

                            case 2:
                                _ref2 = _context3.sent;
                                list = _ref2.list;
                                start_date = _ref2.start_date;
                                end_date = _ref2.end_date;
                                filter_group = _ref2.filter_group;

                                _this3.tasks = list;
                                _this3.start_date = start_date;
                                _this3.end_date = end_date;
                                if (filter_group) {
                                    _this3.filter.group = filter_group;
                                }
                                _this3.sumHoursTotal();

                            case 12:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        sumHoursTotal: function sumHoursTotal() {
            var total_hours = 0;
            var total_hours_used = 0;

            this.tasks.forEach(function (element) {
                total_hours += element.hours;
                total_hours_used += parseFloat(element.hours_used.replace(",", "."));
            });

            this.total_hours = total_hours;
            this.total_hours_used = total_hours_used;
        },
        changeOrder: function changeOrder(event) {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this4.loading = false;
                                _this4.order_select = event.target.value;
                                _context4.prev = 2;
                                _context4.next = 5;
                                return _this4.getTasks();

                            case 5:
                                _context4.next = 9;
                                break;

                            case 7:
                                _context4.prev = 7;
                                _context4.t0 = _context4['catch'](2);

                            case 9:
                                _context4.prev = 9;

                                _this4.loading = true;
                                return _context4.finish(9);

                            case 12:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4, [[2, 7, 9, 12]]);
            }))();
        },
        changeGroup: function changeGroup(event) {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _this5.loading = false;
                                _this5.filter.group = event.target.value;
                                _context5.prev = 2;
                                _context5.next = 5;
                                return _this5.getTasks();

                            case 5:
                                _context5.next = 9;
                                break;

                            case 7:
                                _context5.prev = 7;
                                _context5.t0 = _context5['catch'](2);

                            case 9:
                                _context5.prev = 9;

                                _this5.loading = true;
                                return _context5.finish(9);

                            case 12:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5, [[2, 7, 9, 12]]);
            }))();
        }
    }),
    components: {
        appLoading: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default.a,
        appIcon: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default.a
    }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminTaskWithoutFinish',
  data: function data() {
    return {
      loading: false,
      tasks: []
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.getTasks();

            case 3:
              _context.next = 7;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context['catch'](0);

            case 7:
              _context.prev = 7;

              _this.loading = true;
              return _context.finish(7);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 5, 7, 10]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get']), {
    getTasks: function getTasks() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, list;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.get('/tasks-without-finish');

              case 2:
                _ref = _context2.sent;
                list = _ref.list;

                _this2.tasks = list;

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    finishTasks: function finishTasks(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = 'finish-tasks-user/' + id;
                _context3.next = 3;
                return _this3.get(url);

              case 3:
                setTimeout(function () {
                  location.reload();
                }, "1000");

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }),
  components: {
    appLoading: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vuex_entity_mutation_types__ = __webpack_require__(43);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ViewTaskModal',
  props: ['task'],
  data: function data() {
    return {
      versions: {},
      errors: []
    };
  },
  mounted: function mounted() {
    this.getListChildrenTaks();
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              document.body.className = 'overflow-hidden';

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    document.body.classList.remove('overflow-hidden');

    this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__vuex_entity_mutation_types__["a" /* SHOW_TASKVERSION */], []);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    getListChildrenTaks: function getListChildrenTaks() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!_this2.task || !_this2.task.id)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.prev = 2;
                _context2.next = 5;
                return _this2.get('task/children-finished/' + _this2.task.id).then(function (data) {
                  _this2.versions = data.model;
                });

              case 5:
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](2);

                window.$toast.error(_context2.t0);

              case 10:
                _context2.prev = 10;
                return _context2.finish(10);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 7, 10, 12]]);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['get'])),
  components: {
    appLoading: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default.a
  },
  computed: {}
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListTeam',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      team: {
        name: '',
        status: '',
        entity: 'team'
      },
      team_current: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    teams: 'getTeams'
  })),
  beforeMount: function beforeMount() {
    var _this = this;

    //SEND ENTITY AND MUTATION
    this.getAll('team').then(function () {
      _this.loading = true;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    createTeam: function createTeam() {
      var vm = this;
      window.$('#create').button('loading');
      vm.store(vm.team).then(function (item) {
        window.$('#team').modal('hide');
        vm.team = { name: '', entity: 'team' };
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/teams');
      }).catch(function (error) {
        window.$('#create').button('reset');
        vm.team = { name: '', entity: 'team' };
      });
    },

    removeTeam: function removeTeam(value) {
      var vm = this;
      vm.form = {
        id: value.id,
        entity: 'team'
      };
      vm.loading = false;
      vm.remove(vm.form).then(function (item) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/teams');
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    editTeam: function editTeam(value) {
      this.boxedit = true;
      this.team = value;
    },
    closeEditTeam: function closeEditTeam() {
      this.boxedit = false;
      this.team_current = {};
    },
    updateTeam: function updateTeam(value) {
      var vm = this;
      vm.form = {
        id: vm.team.id,
        entity: 'team',
        name: vm.team_current.name,
        status: vm.team_current.status
      };
      vm.loading = false;
      vm.update(vm.form).then(function (item) {
        vm.loading = true;
        vm.boxedit = false;
        vm.team = { name: '', entity: 'team' };
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/teams');
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    updateValue: function updateValue(attribute, e) {
      this.team_current[attribute] = e.target.value;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['getAll', 'remove', 'store', 'update'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminTeam',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      user: {
        name: '',
        email: '',
        password: '',
        team_id: '',
        profile_id: '',
        role: '',
        entity: 'user'
      },
      user_current: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    auth: 'getUser',
    users: 'getUsers',
    profiles: 'getProfiles',
    usersession: 'getUser'
  }), {
    filteredUsers: function filteredUsers() {
      var _this = this;

      var emails = ['diana.florez@inxaitcorp.com', 'juan.garcia@inxaitcorp.com', 'aprendiz.th@inxaitcorp.com', 'lady.ortega@inxaitcorp.com'];
      //console.log(this.auth)
      if (emails.includes(this.auth.email)) {
        return this.users.filter(function (item) {
          if (item.deleted_at === null) {
            return item;
          }
        });
      } else {
        return this.users.filter(function (item) {
          if (item.team_id === _this.usersession.team_id) {
            return item;
          }
        });
      }
    },
    filteredProfiles: function filteredProfiles() {
      var _this2 = this;

      return this.profiles.filter(function (item) {
        if (item.team_id === _this2.usersession.team_id) {
          return item;
        }
      });
    }
  }),
  beforeMount: function beforeMount() {
    var _this3 = this;

    //SEND ENTITY AND MUTATION
    this.getAll('user').then(function () {
      _this3.loading = true;
    });
    this.getList('profile').then(function () {
      _this3.loading = true;
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    createUser: function createUser() {
      var _this4 = this;

      var vm = this;
      window.$('#create').button('loading');
      vm.user.team_id = vm.usersession.team_id;
      vm.store(vm.user).then(function (item) {
        window.$('#user').modal('hide');
        vm.user = {
          name: '',
          email: '',
          password: '',
          team_id: '',
          profile_id: '',
          role: '',
          entity: 'user'
        };
        vm.$router.replace(vm.$route.query.redirect || '/admin/team');
      }).catch(function (error) {
        window.$('#create').button('reset');
        _this4.user = {
          name: '',
          email: '',
          password: '',
          team_id: '',
          profile_id: '',
          role: '',
          entity: 'user'
        };
      });
    },

    removeUser: function removeUser(value) {
      var vm = this;
      vm.form = {
        id: value.id,
        entity: 'user'
      };
      vm.remove(vm.form, 'user').then(function (user) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/team');
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    editUser: function editUser(value) {
      this.boxedit = true;
      this.user = value;
    },
    closeEditUser: function closeEditUser() {
      this.boxedit = false;
      this.profile_current = {};
    },
    updateUser: function updateUser(value) {
      var vm = this;
      vm.form = {
        id: vm.user.id,
        entity: 'user',
        name: vm.user_current.name,
        email: vm.user_current.email,
        password_edit: vm.user_current.password,
        active: vm.user_current.active,
        profile_id: vm.user_current.profile_id,
        role: vm.user_current.role
      };
      window.$('#update').button('loading');
      vm.loading = false;
      vm.update(vm.form).then(function (item) {
        vm.loading = true;
        vm.boxedit = false;
        vm.user = { name: '', entity: 'user' };
        window.$('#update').button('reset');
        vm.$router.replace(vm.$route.query.redirect || '/admin/team');
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    updateValue: function updateValue(attribute, e) {
      this.user_current[attribute] = e.target.value;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['getAll', 'getList', 'store', 'update', 'remove'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_3__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountsAuth',
  data: function data() {
    return {
      filter: {
        country: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    user: 'getUser',
    countries: 'getAccountCountries'
  }), {
    filteredAccounts: function filteredAccounts() {
      var _this = this;

      return this.user.accounts.filter(function (item) {
        if (_this.filter.country === '') {
          return item;
        }
        if (parseInt(_this.filter.country) === item.country_id) {
          return item;
        }
      });
    }
  }),
  beforeMount: function beforeMount() {
    var _this2 = this;

    this.loading = true;
    this.getList('accountcountry').then(function () {
      _this2.loading = true;
    });
  },

  components: {
    appLoading: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_LoadingWhite___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['getList']))
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminProfile',
  data: function data() {
    return {
      loadImage: false,
      loading: false,
      view: {
        entity: 'user'
      },
      file: null,
      aux_user: { entity: 'user' }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    user: 'getUser'
  })),
  beforeMount: function beforeMount() {
    this.loading = true;
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    changeAvatar: function changeAvatar() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var vm, formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vm = _this;

                vm.loading = true;

                formData = new FormData();

                formData.append('id', vm.user.id);
                formData.append('entity', 'user');
                formData.append('image', _this.file);

                _context.next = 8;
                return vm.store(formData).then(function (user) {
                  vm.loadImage = false;
                  window.location.reload();
                }).catch(function (message) {
                  console.log('error', message);
                  vm.loadImage = false;
                });

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onFileChange: function onFileChange(e) {
      console.log('onfile');
      this.loadImage = true;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      var file = files[0];
      this.file = e.target.files[0];
      this.changeAvatar();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['show', 'store'])),
  components: {
    appLoading: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default.a
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'AdminProfile',
    props: ['user'],
    data: function data() {
        return {
            loadImage: false,
            loading: false,
            file: null
        };
    },

    computed: {},
    beforeMount: function beforeMount() {
        this.loading = true;
    },

    methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        changeAvatar: function changeAvatar() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var vm, formData;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                vm = _this;

                                vm.loading = true;

                                formData = new FormData();

                                formData.append('id', vm.user.id);
                                formData.append('entity', 'user');
                                formData.append('image', _this.file);

                                _context.next = 8;
                                return vm.store(formData).then(function (user) {
                                    vm.loadImage = false;
                                    window.location.reload();
                                }).catch(function (message) {
                                    console.log('error', message);
                                    vm.loadImage = false;
                                });

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        onFileChange: function onFileChange(e) {
            console.log('onfile');
            this.loadImage = true;
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            var file = files[0];
            this.file = e.target.files[0];
            this.changeAvatar();
        }
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['show', 'store'])),
    components: {
        appLoading: __WEBPACK_IMPORTED_MODULE_4__components_admin_partials_LoadingWhite___default.a
    }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_user_EditPhoto__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_user_EditPhoto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_user_EditPhoto__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminListUser',
  data: function data() {
    return {
      loading: false,
      boxedit: false,
      user: {
        name: '',
        nickname: '',
        email: '',
        password: '',
        team_id: '',
        profile_id: '',
        role: '',
        entity: 'user',
        id_company: '',
        birthday: '',
        prize: '',
        admission_date: '',
        img_png: ''
      },
      filter: this.clearFilter(),
      user_current: {},
      users_incomplete: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    users: 'getUsers',
    teams: 'getTeams',
    profiles: 'getProfiles'
  }), {
    filteredUsers: function filteredUsers() {
      var _this = this;

      return this.users.filter(function (item) {
        if (_this.filter.team === null && _this.filter.name === '') {
          return item;
        }
        if (_this.filter.name !== '') {
          return item.name.toLowerCase().includes(_this.filter.name.toLowerCase());
        }
        if (parseInt(_this.filter.team) === item.team_id) {
          return item;
        }
      });
    },
    filteredProfiles: function filteredProfiles() {
      var _this2 = this;

      return this.profiles.filter(function (item) {
        if (_this2.user.team_id === item.team_id) {
          return item;
        }
      });
    }
  }),
  beforeMount: function beforeMount() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              //SEND ENTITY AND MUTATION
              _this3.getAll('user').then(function () {
                _this3.loading = true;
              });
              _this3.getList('team').then(function () {
                _this3.loading = true;
              });
              _this3.getList('profile').then(function () {
                _this3.loading = true;
              });
              _context.prev = 3;
              _context.next = 6;
              return _this3.getUsersIncomplete();

            case 6:
              _context.next = 10;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](3);

            case 10:
              _context.prev = 10;

              _this3.loading = true;
              return _context.finish(10);

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3, [[3, 8, 10, 13]]);
    }))();
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    clearFilter: function clearFilter() {
      return {
        team: null,
        name: ''
      };
    },
    createUser: function createUser() {
      var vm = this;
      window.$('#create').button('loading');
      vm.store(vm.user).then(function (item) {
        window.$('#user').modal('hide');
        vm.user = {
          name: '',
          email: '',
          password: '',
          team_id: '',
          profile_id: '',
          role: '',
          entity: 'user'
        };
        vm.$router.replace(vm.$route.query.redirect || '/admin/users');
      }).catch(function (error) {
        window.$('#create').button('reset');
        vm.user = {
          name: '',
          email: '',
          password: '',
          team_id: '',
          profile_id: '',
          role: '',
          entity: 'user'
        };
      });
    },

    removeUser: function removeUser(value) {
      var vm = this;
      vm.form = {
        id: value.id,
        entity: 'user'
      };
      vm.remove(vm.form, 'user').then(function (user) {
        vm.loading = true;
        vm.$router.replace(vm.$route.query.redirect || '/admin/users');
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    editUser: function editUser(value) {
      var _this4 = this;

      this.boxedit = true;
      this.user = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, value);
      this.$nextTick(function () {
        _this4.$refs.boxedit.scrollIntoView({ behavior: 'smooth' });
      });
    },
    closeEditUser: function closeEditUser() {
      this.boxedit = false;
      this.user_current = {};
    },
    updateUser: function updateUser(value) {
      var vm = this;
      vm.form = {
        id: vm.user.id,
        entity: 'user',
        name: vm.user_current.name,
        nickname: vm.user_current.nickname,
        email: vm.user_current.email,
        password_edit: vm.user_current.password,
        active: vm.user_current.active,
        team_id: vm.user_current.team_id,
        profile_id: vm.user_current.profile_id,
        id_company: vm.user_current.id_company,
        birthday: vm.user_current.birthday,
        prize: vm.user_current.prize,
        admission_date: vm.user_current.admission_date,
        role: vm.user_current.role,
        img_png: vm.user_current.img_png
      };
      vm.loading = false;
      vm.update(vm.form).then(function (item) {
        vm.loading = true;
        vm.boxedit = false;
        vm.user = { name: '', entity: 'user' };
        vm.$router.replace(vm.$route.query.redirect || '/admin/users');
      }).catch(function (message) {
        vm.loading = true;
      });
    },
    updateValue: function updateValue(attribute, e) {
      this.user_current[attribute] = e.target.value;
    },
    downloadList: function downloadList() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].get('user/excel').then(function (response) {
        var data = response.data;
        var path = data.path;


        _this5.$refs.download_users.href = path;
        _this5.$refs.download_users.click();
      });
    },
    getUsersIncomplete: function getUsersIncomplete() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref, list;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this6.get('/users-incomplete');

              case 2:
                _ref = _context2.sent;
                list = _ref.list;

                //console.log(list)
                _this6.users_incomplete = list;

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['get', 'getAll', 'getList', 'store', 'update', 'remove'])),
  components: {
    appIcon: __WEBPACK_IMPORTED_MODULE_5__components_admin_partials_Icon___default.a,
    appLoading: __WEBPACK_IMPORTED_MODULE_6__components_admin_partials_LoadingWhite___default.a,
    EditPhoto: __WEBPACK_IMPORTED_MODULE_7__components_admin_user_EditPhoto___default.a
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// wall: "back" | "left" | "right"; action: método de login de la plataforma
var DOORS = [{ name: 'Shortener', description: 'Acortador de urls', wall: 'left', icon: 'link', action: 'shortener' }, { name: 'Catalogo Digital', description: 'Piezas HTML, Plataformas', wall: 'back', icon: 'book', action: 'catalog' }, { name: 'Mailjet Report', description: 'Estadisticas Envios Mailjet', wall: 'back', icon: 'mail', action: 'mailjet' }, { name: 'Academy', description: 'Cursos de Capacitación', wall: 'back', icon: 'cap', action: 'academy' }, { name: 'Flows', description: 'Envio de campañas', wall: 'right', icon: 'flow', action: 'flows' }];

var ICONS = {
  link: '<path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7"/><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7"/>',
  book: '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5z"/><path d="M4 19.5A2.5 2.5 0 0 0 6.5 22H20v-5"/><path d="M9 7h7M9 11h5"/>',
  mail: '<rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 6-10 7L2 6"/>',
  cap: '<path d="M22 10 12 5 2 10l10 5 10-5z"/><path d="M6 12v5c3 2.5 9 2.5 12 0v-5"/>',
  flow: '<rect x="3" y="3" width="6" height="6" rx="1"/><rect x="15" y="15" width="6" height="6" rx="1"/><path d="M6 9v4a2 2 0 0 0 2 2h7"/><path d="m13 12 3 3-3 3"/>'
};

var ROOM = { W: 900, H: 440, D: 700 };

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Platforms',
  data: function data() {
    return {
      loading: true,
      doors: DOORS,
      walls: [{ id: 'left', width: ROOM.D }, { id: 'back', width: ROOM.W }, { id: 'right', width: ROOM.D }],
      hovered: null,
      opened: null,
      overlay: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    user: 'getUser'
  }), {
    busy: function busy() {
      return !!this.opened;
    }
  }),
  watch: {
    // Los métodos de login ponen loading en true al terminar la petición
    loading: function loading(value) {
      if (value && this.overlay) this.finish();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.cam = { x: 0, y: 0, tx: 0, ty: 0 };
    this.scale = 1;
    this.fit();
    window.addEventListener('resize', this.fit);
    var loop = function loop() {
      var c = _this.cam;
      c.x += (c.tx - c.x) * 0.06;
      c.y += (c.ty - c.y) * 0.06;
      _this.applyCamera();
      _this.raf = requestAnimationFrame(loop);
    };
    loop();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.fit);
    cancelAnimationFrame(this.raf);
    clearTimeout(this.timer);
  },

  methods: {
    doorsOn: function doorsOn(id) {
      return this.doors.filter(function (d) {
        return d.wall === id;
      });
    },
    slotLeft: function slotLeft(wall, k) {
      var slot = wall.width / this.doorsOn(wall.id).length;
      return slot * k + slot / 2 - 85;
    },
    state: function state(d) {
      if (this.opened === d.name) return 'open';
      if (this.hovered === d.name) return 'hover';
      return 'closed';
    },
    isActive: function isActive(d) {
      return this.state(d) !== 'closed';
    },
    leafStyle: function leafStyle(d) {
      var angle = { closed: 0, hover: -42, open: -108 }[this.state(d)];
      return {
        transform: 'rotateY(' + angle + 'deg)',
        boxShadow: this.isActive(d) ? '-12px 0 30px #00fe7f66, inset 0 0 30px #0006' : 'inset 0 0 30px #0006'
      };
    },
    iconStyle: function iconStyle(d) {
      return this.isActive(d) ? { transform: 'scale(1.5)', boxShadow: '0 0 20px #00fe7f, 0 0 50px #00fe7f' } : { transform: 'scale(1)' };
    },
    peekStyle: function peekStyle(d) {
      var st = this.state(d);
      if (st === 'open') return { opacity: 1, transform: 'scale(2.2)' };
      if (st === 'hover') return { opacity: 1, transform: 'scale(1.6) translateY(0)' };
      return { opacity: 0, transform: 'scale(.3) translateY(30px)' };
    },
    glowOpacity: function glowOpacity(d) {
      return { open: 1, hover: 0.85, closed: 0 }[this.state(d)];
    },
    icon: function icon(k, size) {
      return '<svg viewBox="0 0 24 24" width="' + size + '" height="' + size + '" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + ICONS[k] + '</svg>';
    },
    enter: function enter(door) {
      var _this2 = this;

      if (this.busy) return;
      this.opened = door.name;
      this.timer = setTimeout(function () {
        _this2.overlay = door;
        _this2[door.action]();
        // Academy abre de forma síncrona y no cambia loading
        _this2.$nextTick(function () {
          if (_this2.loading) _this2.finish();
        });
      }, 800);
    },
    finish: function finish() {
      clearTimeout(this.timer);
      this.timer = setTimeout(this.close, 900);
    },
    close: function close() {
      this.overlay = null;
      this.opened = null;
    },
    onMove: function onMove(e) {
      var r = this.$refs.stage.getBoundingClientRect();
      this.cam.tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      this.cam.ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
    },
    onLeave: function onLeave() {
      this.cam.tx = 0;
      this.cam.ty = 0;
    },
    fit: function fit() {
      var stage = this.$refs.stage;
      if (!stage) return;
      this.scale = Math.min(1, stage.clientWidth / 1000, stage.clientHeight / 620);
    },
    applyCamera: function applyCamera() {
      var s = this.scale,
          c = this.cam;
      this.$refs.world.style.transform = 'translateZ(' + 250 * s + 'px) scale3d(' + s + ',' + s + ',' + s + ') rotateY(' + c.x * 14 + 'deg) rotateX(' + -c.y * 6 + 'deg) translateZ(350px)';
    },
    shortener: function shortener() {
      var _this3 = this;

      this.loading = false;

      var data = {
        email: this.user.email,
        name: this.user.name,
        code: 'Usbr1tM@g4Kr8SYGOtpiS2RmAf115CXAnc^c^Vkv'
      };
      var url = 'https://inxaitc.co/admin/api/validate';
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, data).then(function (response) {
        if (response.data.status == 200) {
          var path = 'https://inxaitc.co/admin/login-api?uuid=' + response.data.uuid;
          window.open(path, "_blank");
        } else {
          window.$toast.warning('Error en conexión');
        }
        _this3.loading = true;
      }).catch(function (error) {
        console.log(error);
        _this3.loading = true;
      });
    },
    mailjet: function mailjet() {
      var _this4 = this;

      this.loading = false;

      var data = {
        email: this.user.email,
        name: this.user.name,
        code: '^6P2GqXANB3LAL0&s7EY@d&at2VAfuTLOl%GFTwu'
      };
      var url = 'https://sendingmails.inxaitcorp.com/api/validate';
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, data).then(function (response) {
        if (response.data.status == 200) {
          var path = 'https://sendingmails.inxaitcorp.com/login-api?uuid=' + response.data.uuid;
          window.open(path, "_blank");
        } else {
          window.$toast.warning('Error en conexión');
        }
        _this4.loading = true;
      }).catch(function (error) {
        console.log(error);
        _this4.loading = true;
      });
    },
    catalog: function catalog() {
      var _this5 = this;

      this.loading = false;

      var data = {
        email: this.user.email,
        name: this.user.name,
        code: 'C5cbzUbS1*QbOYd2pfF&x%uA42m6*WW1aeJ0E@6q'
      };
      var url = 'https://catalogodigital.inxaitcorp.com/api/validate';
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, data).then(function (response) {
        if (response.data.status == 200) {
          var path = 'https://catalogodigital.inxaitcorp.com/login-api?uuid=' + response.data.uuid;
          window.open(path, "_blank");
        } else {
          window.$toast.warning('Error en conexión');
        }
        _this5.loading = true;
      }).catch(function (error) {
        console.log(error);
        _this5.loading = true;
      });
    },
    academy: function academy() {
      this.loading = false;

      var data = {
        email: this.user.email,
        name: encodeURIComponent(this.user.name),
        avatar: this.user.avatar,
        token: 'XZ9cBaJSjyR0ZO7hWEZp879pHQqFOiqy'
      };

      var path = 'https://academy.inxaitcorp.com/users/login-external/?token=' + data.token + '&email=' + data.email + '&name=' + data.name + '&avatar=' + data.avatar;
      //console.log(path)
      window.open(path, "_blank");
      this.loading = true;
    },
    flows: function flows() {
      var _this6 = this;

      this.loading = false;

      var data = {
        email: this.user.email,
        name: this.user.name,
        code: 'wwPWpc0oQG2q629223NUy1maf9JSAp'
      };
      var url = 'https://flows.inxaitc.co/api/validate-user';
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, data).then(function (response) {
        if (response.data.status == 200) {
          var path = 'https://flows.inxaitc.co/login-api?uuid=' + response.data.uuid;
          window.open(path, "_blank");
        } else {
          window.$toast.warning('Error en conexión');
        }
        _this6.loading = true;
      }).catch(function (error) {
        console.log(error);
        _this6.loading = true;
      });
    }
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Modal',
  props: {
    title: {
      type: String,
      default: 'Modal'
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  methods: {
    emitClose: function emitClose() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MultiSelect_multiselectMixin__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MultiSelect_pointerMixin__ = __webpack_require__(222);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vue-multiselect',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__MultiSelect_multiselectMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__MultiSelect_pointerMixin__["a" /* default */]],
  props: {
    /**
     * name attribute to match optional label element
     * @default ''
     * @type {String}
     */
    name: {
      type: String,
      default: ''
    },
    /**
     * String to show when pointing to an option
     * @default 'Press enter to select'
     * @type {String}
     */
    selectLabel: {
      type: String,
      default: 'Presione enter para seleccionar'
    },
    /**
     * String to show when pointing to an option
     * @default 'Press enter to select'
     * @type {String}
     */
    selectGroupLabel: {
      type: String,
      default: 'Press enter to select group'
    },
    /**
     * String to show next to selected option
     * @default 'Selected'
     * @type {String}
     */
    selectedLabel: {
      type: String,
      default: 'Selected'
    },
    /**
     * String to show when pointing to an already selected option
     * @default 'Press enter to remove'
     * @type {String}
     */
    deselectLabel: {
      type: String,
      default: 'Presione enter para eliminar de la lista'
    },
    /**
     * String to show when pointing to an already selected option
     * @default 'Press enter to remove'
     * @type {String}
     */
    deselectGroupLabel: {
      type: String,
      default: 'Press enter to deselect group'
    },
    /**
     * Decide whether to show pointer labels
     * @default true
     * @type {Boolean}
     */
    showLabels: {
      type: Boolean,
      default: true
    },
    /**
     * Limit the display of selected options. The rest will be hidden within the limitText string.
     * @default 99999
     * @type {Integer}
     */
    limit: {
      type: Number,
      default: 99999
    },
    /**
     * Sets maxHeight style value of the dropdown
     * @default 300
     * @type {Integer}
     */
    maxHeight: {
      type: Number,
      default: 300
    },
    /**
     * Function that process the message shown when selected
     * elements pass the defined limit.
     * @default 'and * more'
     * @param {Int} count Number of elements more than limit
     * @type {Function}
     */
    limitText: {
      type: Function,
      default: function _default(count) {
        return 'and ' + count + ' more';
      }
    },
    /**
     * Set true to trigger the loading spinner.
     * @default False
     * @type {Boolean}
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * Disables the multiselect if true.
     * @default false
     * @type {Boolean}
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Fixed opening direction
     * @default ''
     * @type {String}
     */
    openDirection: {
      type: String,
      default: ''
    },
    /**
     * Shows slot with message about empty options
     * @default true
     * @type {Boolean}
     */
    showNoOptions: {
      type: Boolean,
      default: true
    },
    showNoResults: {
      type: Boolean,
      default: true
    },
    tabindex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isSingleLabelVisible: function isSingleLabelVisible() {
      return (this.singleValue || this.singleValue === 0) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
    },
    isPlaceholderVisible: function isPlaceholderVisible() {
      return !this.internalValue.length && (!this.searchable || !this.isOpen);
    },
    visibleValues: function visibleValues() {
      return this.multiple ? this.internalValue.slice(0, this.limit) : [];
    },
    singleValue: function singleValue() {
      return this.internalValue[0];
    },
    deselectLabelText: function deselectLabelText() {
      return this.showLabels ? this.deselectLabel : '';
    },
    deselectGroupLabelText: function deselectGroupLabelText() {
      return this.showLabels ? this.deselectGroupLabel : '';
    },
    selectLabelText: function selectLabelText() {
      return this.showLabels ? this.selectLabel : '';
    },
    selectGroupLabelText: function selectGroupLabelText() {
      return this.showLabels ? this.selectGroupLabel : '';
    },
    selectedLabelText: function selectedLabelText() {
      return this.showLabels ? this.selectedLabel : '';
    },
    inputStyle: function inputStyle() {
      if (this.searchable || this.multiple && this.value && this.value.length) {
        // Hide input by setting the width to 0 allowing it to receive focus
        return this.isOpen ? { width: '100%' } : { width: '0', position: 'absolute', padding: '0' };
      }
      return '';
    },
    contentStyle: function contentStyle() {
      return this.options.length ? { display: 'inline-block' } : { display: 'block' };
    },
    isAbove: function isAbove() {
      if (this.openDirection === 'above' || this.openDirection === 'top') {
        return true;
      } else if (this.openDirection === 'below' || this.openDirection === 'bottom') {
        return false;
      } else {
        return this.preferredOpenDirection === 'above';
      }
    },
    showSearchInput: function showSearchInput() {
      return this.searchable && (this.hasSingleSelectedSlot && (this.visibleSingleValue || this.visibleSingleValue === 0) ? this.isOpen : true);
    }
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Loading__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Loading__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data() {
    return {
      user: {
        email: '',
        password: ''
      },
      viewPass: false,
      type: 'password',
      redirect: '/',
      loading: false,
      errors: [],
      darkMode: true
    };
  },
  created: function created() {
    // remove localStorage
    delete localStorage.token;
    delete localStorage.session_account;
    delete localStorage.session_team;
    var saved = localStorage.getItem('loginDarkMode');
    this.darkMode = saved !== null ? saved === 'true' : true;
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    doLogin: function doLogin() {
      var _this = this;

      var vm = this;
      vm.loading = true;
      window.$('#login').button('loading');

      vm.login(this.user).then(function (user) {
        if (user.role === 1) {
          vm.$router.replace(_this.$route.query.redirect || '/admin/dashboard');
        } else {
          if ([2, 3, 5].includes(user.role)) {
            vm.$router.replace(_this.$route.query.redirect || '/admin/home');
          } else {
            vm.$router.replace(_this.$route.query.redirect || '/admin/home');
          }
        }
      }).catch(function (error) {
        window.$('#login').button('reset');
        console.log(error);
        if (error.response) {
          var data = error.response.data;
          vm.errors = typeof data.errors !== 'undefined' ? data.errors : [];
        }
      }).finally(function () {
        vm.loading = false;
      });
    },
    viewPassClick: function viewPassClick() {
      this.viewPass = !this.viewPass;
      this.type = this.type == 'password' ? 'text' : 'password';
    },
    toggleDarkMode: function toggleDarkMode() {
      this.darkMode = !this.darkMode;
      localStorage.setItem('loginDarkMode', this.darkMode);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['login'])),
  components: {
    appLoading: __WEBPACK_IMPORTED_MODULE_2__components_admin_partials_Loading___default.a
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);


function isEmpty(opt) {
  if (opt === 0) return false;
  if (Array.isArray(opt) && opt.length === 0) return true;
  return !opt;
}

function not(fun) {
  return function () {
    return !fun.apply(undefined, arguments);
  };
}

function includes(str, query) {
  /* istanbul ignore else */
  if (str === undefined) str = "undefined";
  if (str === null) str = "null";
  if (str === false) str = "false";
  var text = str.toString().toLowerCase();
  return text.indexOf(query.trim()) !== -1;
}

function filterOptions(options, search, label, customLabel) {
  return options.filter(function (option) {
    return includes(customLabel(option, label), search);
  });
}

function stripGroups(options) {
  return options.filter(function (option) {
    return !option.$isLabel;
  });
}

function flattenOptions(values, label) {
  return function (options) {
    return options.reduce(function (prev, curr) {
      /* istanbul ignore else */
      if (curr[values] && curr[values].length) {
        prev.push({
          $groupLabel: curr[label],
          $isLabel: true
        });
        return prev.concat(curr[values]);
      }
      return prev;
    }, []);
  };
}

function filterGroups(search, label, values, groupLabel, customLabel) {
  return function (groups) {
    return groups.map(function (group) {
      var _ref;

      /* istanbul ignore else */
      if (!group[values]) {
        console.warn("Options passed to vue-multiselect do not contain groups, despite the config.");
        return [];
      }
      var groupOptions = filterOptions(group[values], search, label, customLabel);

      return groupOptions.length ? (_ref = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, groupLabel, group[groupLabel]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, values, groupOptions), _ref) : [];
    });
  };
}

var flow = function flow() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (x) {
    return fns.reduce(function (v, f) {
      return f(v);
    }, x);
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: "",
      isOpen: false,
      preferredOpenDirection: "below",
      optimizedHeight: this.maxHeight
    };
  },

  props: {
    /**
     * Decide whether to filter the results based on search query.
     * Useful for async filtering, where we search through more complex data.
     * @type {Boolean}
     */
    internalSearch: {
      type: Boolean,
      default: true
    },
    /**
     * Array of available options: Objects, Strings or Integers.
     * If array of objects, visible label will default to option.label.
     * If `labal` prop is passed, label will equal option['label']
     * @type {Array}
     */
    options: {
      type: Array,
      required: true
    },
    /**
     * Equivalent to the `multiple` attribute on a `<select>` input.
     * @default false
     * @type {Boolean}
     */
    multiple: {
      type: Boolean,
      default: false
    },
    /**
     * Presets the selected options value.
     * @type {Object||Array||String||Integer}
     */
    value: {
      type: null,
      default: function _default() {
        return [];
      }
    },
    /**
     * Key to compare objects
     * @default 'id'
     * @type {String}
     */
    trackBy: {
      type: String
    },
    /**
     * Label to look for in option Object
     * @default 'label'
     * @type {String}
     */
    label: {
      type: String
    },
    /**
     * Enable/disable search in options
     * @default true
     * @type {Boolean}
     */
    searchable: {
      type: Boolean,
      default: true
    },
    /**
     * Clear the search input after `)
     * @default true
     * @type {Boolean}
     */
    clearOnSelect: {
      type: Boolean,
      default: true
    },
    /**
     * Hide already selected options
     * @default false
     * @type {Boolean}
     */
    hideSelected: {
      type: Boolean,
      default: false
    },
    /**
     * Equivalent to the `placeholder` attribute on a `<select>` input.
     * @default 'Select option'
     * @type {String}
     */
    placeholder: {
      type: String,
      default: "Agregue una url"
    },
    /**
     * Allow to remove all selected values
     * @default true
     * @type {Boolean}
     */
    allowEmpty: {
      type: Boolean,
      default: true
    },
    /**
     * Reset this.internalValue, this.search after this.internalValue changes.
     * Useful if want to create a stateless dropdown.
     * @default false
     * @type {Boolean}
     */
    resetAfter: {
      type: Boolean,
      default: false
    },
    /**
     * Enable/disable closing after selecting an option
     * @default true
     * @type {Boolean}
     */
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    /**
     * Function to interpolate the custom label
     * @default false
     * @type {Function}
     */
    customLabel: {
      type: Function,
      default: function _default(option, label) {
        if (isEmpty(option)) return "";
        return label ? option[label] : option;
      }
    },
    /**
     * Disable / Enable tagging
     * @default false
     * @type {Boolean}
     */
    taggable: {
      type: Boolean,
      default: false
    },
    /**
     * String to show when highlighting a potential tag
     * @default 'Press enter to create a tag'
     * @type {String}
     */
    tagPlaceholder: {
      type: String,
      default: "Presione enter para agregar una url"
    },
    /**
     * By default new tags will appear above the search results.
     * Changing to 'bottom' will revert this behaviour
     * and will proritize the search results
     * @default 'top'
     * @type {String}
     */
    tagPosition: {
      type: String,
      default: "top"
    },
    /**
     * Number of allowed selected options. No limit if 0.
     * @default 0
     * @type {Number}
     */
    max: {
      type: [Number, Boolean],
      default: false
    },
    /**
     * Will be passed with all events as second param.
     * Useful for identifying events origin.
     * @default null
     * @type {String|Integer}
     */
    id: {
      default: null
    },
    /**
     * Limits the options displayed in the dropdown
     * to the first X options.
     * @default 1000
     * @type {Integer}
     */
    optionsLimit: {
      type: Number,
      default: 1000
    },
    /**
     * Name of the property containing
     * the group values
     * @default 1000
     * @type {String}
     */
    groupValues: {
      type: String
    },
    /**
     * Name of the property containing
     * the group label
     * @default 1000
     * @type {String}
     */
    groupLabel: {
      type: String
    },
    /**
     * Allow to select all group values
     * by selecting the group label
     * @default false
     * @type {Boolean}
     */
    groupSelect: {
      type: Boolean,
      default: false
    },
    /**
     * Array of keyboard keys to block
     * when selecting
     * @default 1000
     * @type {String}
     */
    blockKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * Prevent from wiping up the search value
     * @default false
     * @type {Boolean}
     */
    preserveSearch: {
      type: Boolean,
      default: false
    },
    /**
     * Select 1st options if value is empty
     * @default false
     * @type {Boolean}
     */
    preselectFirst: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    /* istanbul ignore else */
    if (!this.multiple && this.max) {
      console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false.");
    }
    if (this.preselectFirst && !this.internalValue.length && this.options.length) {
      this.select(this.filteredOptions[0]);
    }
  },

  computed: {
    internalValue: function internalValue() {
      return this.value || this.value === 0 ? Array.isArray(this.value) ? this.value : [this.value] : [];
    },
    filteredOptions: function filteredOptions() {
      var search = this.search || "";
      var normalizedSearch = search.toLowerCase().trim();

      var options = this.options.concat();

      /* istanbul ignore else */
      if (this.internalSearch) {
        options = this.groupValues ? this.filterAndFlat(options, normalizedSearch, this.label) : filterOptions(options, normalizedSearch, this.label, this.customLabel);
      } else {
        options = this.groupValues ? flattenOptions(this.groupValues, this.groupLabel)(options) : options;
      }

      options = this.hideSelected ? options.filter(not(this.isSelected)) : options;

      /* istanbul ignore else */
      if (this.taggable && normalizedSearch.length && !this.isExistingOption(normalizedSearch)) {
        if (this.tagPosition === "bottom") {
          options.push({ isTag: true, label: search });
        } else {
          options.unshift({ isTag: true, label: search });
        }
      }

      return options.slice(0, this.optionsLimit);
    },
    valueKeys: function valueKeys() {
      var _this = this;

      if (this.trackBy) {
        return this.internalValue.map(function (element) {
          return element[_this.trackBy];
        });
      } else {
        return this.internalValue;
      }
    },
    optionKeys: function optionKeys() {
      var _this2 = this;

      var options = this.groupValues ? this.flatAndStrip(this.options) : this.options;
      return options.map(function (element) {
        return _this2.customLabel(element, _this2.label).toString().toLowerCase();
      });
    },
    currentOptionLabel: function currentOptionLabel() {
      return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
    }
  },
  watch: {
    internalValue: function internalValue() {
      /* istanbul ignore else */
      if (this.resetAfter && this.internalValue.length) {
        this.search = "";
        this.$emit("input", this.multiple ? [] : null);
      }
    },
    search: function search() {
      this.$emit("search-change", this.search, this.id);
    }
  },
  methods: {
    /**
     * Returns the internalValue in a way it can be emited to the parent
     * @returns {Object||Array||String||Integer}
     */
    getValue: function getValue() {
      return this.multiple ? this.internalValue : this.internalValue.length === 0 ? null : this.internalValue[0];
    },

    /**
     * Filters and then flattens the options list
     * @param  {Array}
     * @returns {Array} returns a filtered and flat options list
     */
    filterAndFlat: function filterAndFlat(options, search, label) {
      return flow(filterGroups(search, label, this.groupValues, this.groupLabel, this.customLabel), flattenOptions(this.groupValues, this.groupLabel))(options);
    },

    /**
     * Flattens and then strips the group labels from the options list
     * @param  {Array}
     * @returns {Array} returns a flat options list without group labels
     */
    flatAndStrip: function flatAndStrip(options) {
      return flow(flattenOptions(this.groupValues, this.groupLabel), stripGroups)(options);
    },

    /**
     * Updates the search value
     * @param  {String}
     */
    updateSearch: function updateSearch(query) {
      this.search = query;
    },

    /**
     * Finds out if the given query is already present
     * in the available options
     * @param  {String}
     * @returns {Boolean} returns true if element is available
     */
    isExistingOption: function isExistingOption(query) {
      return !this.options ? false : this.optionKeys.indexOf(query) > -1;
    },

    /**
     * Finds out if the given element is already present
     * in the result value
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is selected
     */
    isSelected: function isSelected(option) {
      var opt = this.trackBy ? option[this.trackBy] : option;
      return this.valueKeys.indexOf(opt) > -1;
    },

    /**
     * Finds out if the given option is disabled
     * @param  {Object||String||Integer} option passed element to check
     * @returns {Boolean} returns true if element is disabled
     */
    isOptionDisabled: function isOptionDisabled(option) {
      return !!option.$isDisabled;
    },

    /**
     * Returns empty string when options is null/undefined
     * Returns tag query if option is tag.
     * Returns the customLabel() results and casts it to string.
     *
     * @param  {Object||String||Integer} Passed option
     * @returns {Object||String}
     */
    getOptionLabel: function getOptionLabel(option) {
      if (isEmpty(option)) return "";
      /* istanbul ignore else */
      if (option.isTag) return option.label;
      /* istanbul ignore else */
      if (option.$isLabel) return option.$groupLabel;

      var label = this.customLabel(option, this.label);
      /* istanbul ignore else */
      if (isEmpty(label)) return "";
      return label;
    },

    /**
     * Add the given option to the list of selected options
     * or sets the option as the selected option.
     * If option is already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} option to select/deselect
     * @param  {Boolean} block removing
     */
    select: function select(option, key) {
      /* istanbul ignore else */
      if (option.$isLabel && this.groupSelect) {
        this.selectGroup(option);
        return;
      }
      if (this.blockKeys.indexOf(key) !== -1 || this.disabled || option.$isDisabled || option.$isLabel) return;
      /* istanbul ignore else */
      if (this.max && this.multiple && this.internalValue.length === this.max) return;
      /* istanbul ignore else */
      if (key === "Tab" && !this.pointerDirty) return;
      if (option.isTag) {
        this.$emit("tag", option.label, this.id);
        this.search = "";
        if (this.closeOnSelect && !this.multiple) this.deactivate();
      } else {
        var isSelected = this.isSelected(option);

        if (isSelected) {
          if (key !== "Tab") this.removeElement(option);
          return;
        }

        this.$emit("select", option, this.id);

        if (this.multiple) {
          this.$emit("input", this.internalValue.concat([option]), this.id);
        } else {
          this.$emit("input", option, this.id);
        }

        /* istanbul ignore else */
        if (this.clearOnSelect) this.search = "";
      }
      /* istanbul ignore else */
      if (this.closeOnSelect) this.deactivate();
    },

    /**
     * Add the given group options to the list of selected options
     * If all group optiona are already selected -> remove it from the results.
     *
     * @param  {Object||String||Integer} group to select/deselect
     */
    selectGroup: function selectGroup(selectedGroup) {
      var _this3 = this;

      var group = this.options.find(function (option) {
        return option[_this3.groupLabel] === selectedGroup.$groupLabel;
      });

      if (!group) return;

      if (this.wholeGroupSelected(group)) {
        this.$emit("remove", group[this.groupValues], this.id);

        var newValue = this.internalValue.filter(function (option) {
          return group[_this3.groupValues].indexOf(option) === -1;
        });

        this.$emit("input", newValue, this.id);
      } else {
        var optionsToAdd = group[this.groupValues].filter(function (option) {
          return !(_this3.isOptionDisabled(option) || _this3.isSelected(option));
        });

        this.$emit("select", optionsToAdd, this.id);
        this.$emit("input", this.internalValue.concat(optionsToAdd), this.id);
      }

      if (this.closeOnSelect) this.deactivate();
    },

    /**
     * Helper to identify if all values in a group are selected
     *
     * @param {Object} group to validated selected values against
     */
    wholeGroupSelected: function wholeGroupSelected(group) {
      var _this4 = this;

      return group[this.groupValues].every(function (option) {
        return _this4.isSelected(option) || _this4.isOptionDisabled(option);
      });
    },

    /**
     * Helper to identify if all values in a group are disabled
     *
     * @param {Object} group to check for disabled values
     */
    wholeGroupDisabled: function wholeGroupDisabled(group) {
      return group[this.groupValues].every(this.isOptionDisabled);
    },

    /**
     * Removes the given option from the selected options.
     * Additionally checks this.allowEmpty prop if option can be removed when
     * it is the last selected option.
     *
     * @param  {type} option description
     * @returns {type}        description
     */
    removeElement: function removeElement(option) {
      var shouldClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      /* istanbul ignore else */
      if (this.disabled) return;
      /* istanbul ignore else */
      if (option.$isDisabled) return;
      /* istanbul ignore else */
      if (!this.allowEmpty && this.internalValue.length <= 1) {
        this.deactivate();
        return;
      }

      var index = (typeof option === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(option)) === "object" ? this.valueKeys.indexOf(option[this.trackBy]) : this.valueKeys.indexOf(option);

      this.$emit("remove", option, this.id);
      if (this.multiple) {
        var newValue = this.internalValue.slice(0, index).concat(this.internalValue.slice(index + 1));
        this.$emit("input", newValue, this.id);
      } else {
        this.$emit("input", null, this.id);
      }

      /* istanbul ignore else */
      if (this.closeOnSelect && shouldClose) this.deactivate();
    },

    /**
     * Calls this.removeElement() with the last element
     * from this.internalValue (selected element Array)
     *
     * @fires this#removeElement
     */
    removeLastElement: function removeLastElement() {
      /* istanbul ignore else */
      if (this.blockKeys.indexOf("Delete") !== -1) return;
      /* istanbul ignore else */
      if (this.search.length === 0 && Array.isArray(this.internalValue) && this.internalValue.length) {
        this.removeElement(this.internalValue[this.internalValue.length - 1], false);
      }
    },

    /**
     * Opens the multiselect’s dropdown.
     * Sets this.isOpen to TRUE
     */
    activate: function activate() {
      var _this5 = this;

      /* istanbul ignore else */
      if (this.isOpen || this.disabled) return;

      this.adjustPosition();
      /* istanbul ignore else  */
      if (this.groupValues && this.pointer === 0 && this.filteredOptions.length) {
        this.pointer = 1;
      }

      this.isOpen = true;
      /* istanbul ignore else  */
      if (this.searchable) {
        if (!this.preserveSearch) this.search = "";
        this.$nextTick(function () {
          return _this5.$refs.search && _this5.$refs.search.focus();
        });
      } else {
        this.$el.focus();
      }
      this.$emit("open", this.id);
    },

    /**
     * Closes the multiselect’s dropdown.
     * Sets this.isOpen to FALSE
     */
    deactivate: function deactivate() {
      /* istanbul ignore else */
      if (!this.isOpen) return;

      this.isOpen = false;
      /* istanbul ignore else  */
      if (this.searchable) {
        this.$refs.search && this.$refs.search.blur();
      } else {
        this.$el.blur();
      }
      if (!this.preserveSearch) this.search = "";
      this.$emit("close", this.getValue(), this.id);
    },

    /**
     * Call this.activate() or this.deactivate()
     * depending on this.isOpen value.
     *
     * @fires this#activate || this#deactivate
     * @property {Boolean} isOpen indicates if dropdown is open
     */
    toggle: function toggle() {
      this.isOpen ? this.deactivate() : this.activate();
    },

    /**
     * Updates the hasEnoughSpace variable used for
     * detecting where to expand the dropdown
     */
    adjustPosition: function adjustPosition() {
      if (typeof window === "undefined") return;

      var spaceAbove = this.$el.getBoundingClientRect().top;
      var spaceBelow = window.innerHeight - this.$el.getBoundingClientRect().bottom;
      var hasEnoughSpaceBelow = spaceBelow > this.maxHeight;

      if (hasEnoughSpaceBelow || spaceBelow > spaceAbove || this.openDirection === "below" || this.openDirection === "bottom") {
        this.preferredOpenDirection = "below";
        this.optimizedHeight = Math.min(spaceBelow - 40, this.maxHeight);
      } else {
        this.preferredOpenDirection = "above";
        this.optimizedHeight = Math.min(spaceAbove - 40, this.maxHeight);
      }
    }
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pointer: 0,
      pointerDirty: false
    };
  },

  props: {
    /**
     * Enable/disable highlighting of the pointed value.
     * @type {Boolean}
     * @default true
     */
    showPointer: {
      type: Boolean,
      default: true
    },
    optionHeight: {
      type: Number,
      default: 40
    }
  },
  computed: {
    pointerPosition: function pointerPosition() {
      return this.pointer * this.optionHeight;
    },
    visibleElements: function visibleElements() {
      return this.optimizedHeight / this.optionHeight;
    }
  },
  watch: {
    filteredOptions: function filteredOptions() {
      this.pointerAdjust();
    },
    isOpen: function isOpen() {
      this.pointerDirty = false;
    },
    pointer: function pointer() {
      this.$refs.search && this.$refs.search.setAttribute("aria-activedescendant", this.id + "-" + this.pointer.toString());
    }
  },
  methods: {
    optionHighlight: function optionHighlight(index, option) {
      return {
        "multiselect__option--highlight": index === this.pointer && this.showPointer,
        "multiselect__option--selected": this.isSelected(option)
      };
    },
    groupHighlight: function groupHighlight(index, selectedGroup) {
      var _this = this;

      if (!this.groupSelect) {
        return ["multiselect__option--disabled", { "multiselect__option--group": selectedGroup.$isLabel }];
      }

      var group = this.options.find(function (option) {
        return option[_this.groupLabel] === selectedGroup.$groupLabel;
      });

      return group && !this.wholeGroupDisabled(group) ? ["multiselect__option--group", {
        "multiselect__option--highlight": index === this.pointer && this.showPointer
      }, {
        "multiselect__option--group-selected": this.wholeGroupSelected(group)
      }] : "multiselect__option--disabled";
    },
    addPointerElement: function addPointerElement() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Enter",
          key = _ref.key;

      /* istanbul ignore else */
      if (this.filteredOptions.length > 0) {
        this.select(this.filteredOptions[this.pointer], key);
      }
      this.pointerReset();
    },
    pointerForward: function pointerForward() {
      /* istanbul ignore else */
      if (this.pointer < this.filteredOptions.length - 1) {
        this.pointer++;
        /* istanbul ignore next */
        if (this.$refs.list.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight) {
          this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight;
        }
        /* istanbul ignore else */
        if (this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect) this.pointerForward();
      }
      this.pointerDirty = true;
    },
    pointerBackward: function pointerBackward() {
      if (this.pointer > 0) {
        this.pointer--;
        /* istanbul ignore else */
        if (this.$refs.list.scrollTop >= this.pointerPosition) {
          this.$refs.list.scrollTop = this.pointerPosition;
        }
        /* istanbul ignore else */
        if (this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect) this.pointerBackward();
      } else {
        /* istanbul ignore else */
        if (this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect) this.pointerForward();
      }
      this.pointerDirty = true;
    },
    pointerReset: function pointerReset() {
      /* istanbul ignore else */
      if (!this.closeOnSelect) return;
      this.pointer = 0;
      /* istanbul ignore else */
      if (this.$refs.list) {
        this.$refs.list.scrollTop = 0;
      }
    },
    pointerAdjust: function pointerAdjust() {
      /* istanbul ignore else */
      if (this.pointer >= this.filteredOptions.length - 1) {
        this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0;
      }

      if (this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect) {
        this.pointerForward();
      }
    },
    pointerSet: function pointerSet(index) {
      this.pointer = index;
      this.pointerDirty = true;
    }
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_store__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_currency_input__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_css__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






window.$ = window.jQuery = __webpack_require__(74);
window.$toast = __webpack_require__(108);
__webpack_require__(106);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_currency_input__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('limit', function (item) {
  var count = 30;
  return item.slice(0, count) + (item.length > count ? '...' : '');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('limit100', function (item) {
  var count = 100;
  return item.slice(0, count) + (item.length > count ? '...' : '');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('two_decimal', function (item) {
  return parseFloat(item).toFixed(2);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('number', function (item) {
  if (item != undefined && !isNaN(item)) {
    return new Intl.NumberFormat('de-DE').format(item);
  } else {
    return '0';
  }
});

$(function () {
  $('body').tooltip({
    selector: '[data-toggle="tooltip"]'
  });
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/service-worker.js');
  });
}

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* store */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_admin_Admin__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_admin_Admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_admin_Admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_admin_dashboard_Dashboard__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_admin_dashboard_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_admin_dashboard_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_dashboard_DashboardUser__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_dashboard_DashboardUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_dashboard_DashboardUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_user_AdminProfile__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_user_AdminProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_user_AdminProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_user_ListUser__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_user_ListUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_user_ListUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_team_Team__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_team_Team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_team_Team__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_task_TaskComponent__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_task_TaskComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_task_TaskComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_task_TaskHoursMonth__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_task_TaskHoursMonth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_task_TaskHoursMonth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_campaign_CampaignsTeam__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_campaign_CampaignsTeam___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_admin_campaign_CampaignsTeam__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_calendar_CalendarUser__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_calendar_CalendarUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_admin_calendar_CalendarUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin_calendar_Week__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin_calendar_Week___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_admin_calendar_Week__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_admin_account_AccountUser__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_admin_account_AccountUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_admin_account_AccountUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_email_EmailTeam__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_email_EmailTeam___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_admin_email_EmailTeam__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_admin_email_EmailCheck__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_admin_email_EmailCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_admin_email_EmailCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_admin_library_ListLibrary__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_admin_library_ListLibrary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_admin_library_ListLibrary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_admin_library_LibraryTeam__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_admin_library_LibraryTeam___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_admin_library_LibraryTeam__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_admin_activity_ListActivity__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_admin_activity_ListActivity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_admin_activity_ListActivity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_admin_points_ListPoints__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_admin_points_ListPoints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_admin_points_ListPoints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_admin_activity_CreateActivity__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_admin_activity_CreateActivity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_admin_activity_CreateActivity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_admin_activity_ListParticipations__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_admin_activity_ListParticipations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_admin_activity_ListParticipations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_admin_activity_ListUserAnswers__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_admin_activity_ListUserAnswers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_admin_activity_ListUserAnswers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_admin_user_AccountsAuth__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_admin_user_AccountsAuth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_admin_user_AccountsAuth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_admin_user_Platforms__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_admin_user_Platforms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_admin_user_Platforms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_admin_report_ReportTasks__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_admin_report_ReportTasks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_admin_report_ReportTasks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_admin_note_ListNotes__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_admin_note_ListNotes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_admin_note_ListNotes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_admin_development_ListDevelopments__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_admin_development_ListDevelopments___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_admin_development_ListDevelopments__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_admin_planning_Planning__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_admin_planning_Planning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_admin_planning_Planning__);





























/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/admin',
  //beforeEnter: requireAuth,
  name: 'Admin',
  component: __WEBPACK_IMPORTED_MODULE_0__components_admin_Admin___default.a,
  children: [{
    path: 'dashboard',
    component: __WEBPACK_IMPORTED_MODULE_1__components_admin_dashboard_Dashboard___default.a
  }, {
    path: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_admin_dashboard_DashboardUser___default.a
  }, {
    path: 'team',
    component: __WEBPACK_IMPORTED_MODULE_5__components_admin_team_Team___default.a
  }, {
    path: 'tasks',
    component: __WEBPACK_IMPORTED_MODULE_6__components_admin_task_TaskComponent___default.a
  }, {
    path: 'hours-tasks',
    component: __WEBPACK_IMPORTED_MODULE_7__components_admin_task_TaskHoursMonth___default.a
  }, {
    path: 'pendings-tasks',
    component: __WEBPACK_IMPORTED_MODULE_6__components_admin_task_TaskComponent___default.a
  }, {
    path: 'emails',
    component: __WEBPACK_IMPORTED_MODULE_12__components_admin_email_EmailTeam___default.a
  }, {
    path: 'pendings-emails',
    component: __WEBPACK_IMPORTED_MODULE_12__components_admin_email_EmailTeam___default.a
  }, {
    path: 'emails-check',
    component: __WEBPACK_IMPORTED_MODULE_13__components_admin_email_EmailCheck___default.a
  }, {
    path: 'emails-check/:id',
    component: __WEBPACK_IMPORTED_MODULE_13__components_admin_email_EmailCheck___default.a
  }, {
    name: 'campaigns',
    path: 'campaigns',
    component: __WEBPACK_IMPORTED_MODULE_8__components_admin_campaign_CampaignsTeam___default.a
  }, {
    path: 'profile',
    component: __WEBPACK_IMPORTED_MODULE_3__components_admin_user_AdminProfile___default.a
  }, {
    path: 'notes',
    component: __WEBPACK_IMPORTED_MODULE_24__components_admin_note_ListNotes___default.a
  }, {
    path: 'developments',
    component: __WEBPACK_IMPORTED_MODULE_25__components_admin_development_ListDevelopments___default.a
  }, {
    path: 'accounts-auth',
    component: __WEBPACK_IMPORTED_MODULE_21__components_admin_user_AccountsAuth___default.a
  }, {
    path: 'users',
    component: __WEBPACK_IMPORTED_MODULE_4__components_admin_user_ListUser___default.a
  }, {
    path: 'libraries',
    component: __WEBPACK_IMPORTED_MODULE_14__components_admin_library_ListLibrary___default.a
  }, {
    path: 'library',
    component: __WEBPACK_IMPORTED_MODULE_15__components_admin_library_LibraryTeam___default.a
  }, {
    name: 'calendar',
    path: 'calendar/:id',
    component: __WEBPACK_IMPORTED_MODULE_9__components_admin_calendar_CalendarUser___default.a
  }, {
    path: 'week',
    component: __WEBPACK_IMPORTED_MODULE_10__components_admin_calendar_Week___default.a
  }, {
    path: 'account-user/:id',
    component: __WEBPACK_IMPORTED_MODULE_11__components_admin_account_AccountUser___default.a
  }, {
    path: 'points',
    component: __WEBPACK_IMPORTED_MODULE_17__components_admin_points_ListPoints___default.a
  }, {
    path: 'activities',
    component: __WEBPACK_IMPORTED_MODULE_16__components_admin_activity_ListActivity___default.a
  }, {
    name: 'create-activity',
    path: 'activities/create',
    component: __WEBPACK_IMPORTED_MODULE_18__components_admin_activity_CreateActivity___default.a
  }, {
    name: 'edit-activity',
    path: 'activities/:slug/questions',
    component: __WEBPACK_IMPORTED_MODULE_18__components_admin_activity_CreateActivity___default.a
  }, {
    name: 'show-activity',
    path: 'activities/:slug',
    component: __WEBPACK_IMPORTED_MODULE_18__components_admin_activity_CreateActivity___default.a
  }, {
    name: 'show-activity-participation',
    path: 'activities/:slug/participations',
    component: __WEBPACK_IMPORTED_MODULE_19__components_admin_activity_ListParticipations___default.a
  }, {
    name: 'show-user-answers',
    path: 'activities/:slug/answers',
    component: __WEBPACK_IMPORTED_MODULE_20__components_admin_activity_ListUserAnswers___default.a
  }, {
    path: 'platforms',
    component: __WEBPACK_IMPORTED_MODULE_22__components_admin_user_Platforms___default.a
  }, {
    path: 'reports',
    component: __WEBPACK_IMPORTED_MODULE_23__components_admin_report_ReportTasks___default.a
  }, {
    path: 'planning',
    component: __WEBPACK_IMPORTED_MODULE_26__components_admin_planning_Planning___default.a
  }]
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_admin_AdminBusiness__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_admin_AdminBusiness___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_admin_AdminBusiness__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_admin_clients_ListClients__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_admin_clients_ListClients___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_admin_clients_ListClients__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_clients_RelationsClient__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_clients_RelationsClient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_clients_RelationsClient__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_suppliers_ListSuppliers__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_suppliers_ListSuppliers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_suppliers_ListSuppliers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_suppliers_RelationsSupplier__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_suppliers_RelationsSupplier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_suppliers_RelationsSupplier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_social_reasons_ListSocialReasons__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_social_reasons_ListSocialReasons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_social_reasons_ListSocialReasons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_budgets_CreateBudget__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_budgets_CreateBudget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_budgets_CreateBudget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_budgets_ListBudget__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_budgets_ListBudget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_budgets_ListBudget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_budgets_ShowBudget__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_budgets_ShowBudget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_admin_budgets_ShowBudget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_campaign_ListCampaign__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_campaign_ListCampaign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_admin_campaign_ListCampaign__);











/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/admin/business',
  //beforeEnter: requireAuth,
  name: 'AdminBusiness',
  component: __WEBPACK_IMPORTED_MODULE_0__components_admin_AdminBusiness___default.a,
  children: [{
    path: 'social-reasons',
    component: __WEBPACK_IMPORTED_MODULE_5__components_admin_social_reasons_ListSocialReasons___default.a
  }, {
    path: 'suppliers',
    component: __WEBPACK_IMPORTED_MODULE_3__components_admin_suppliers_ListSuppliers___default.a
  }, {
    path: 'suppliers/relations/:id',
    component: __WEBPACK_IMPORTED_MODULE_4__components_admin_suppliers_RelationsSupplier___default.a
  }, {
    path: 'clients',
    component: __WEBPACK_IMPORTED_MODULE_1__components_admin_clients_ListClients___default.a
  }, {
    path: 'clients/relations/:id',
    component: __WEBPACK_IMPORTED_MODULE_2__components_admin_clients_RelationsClient___default.a
  }, {
    path: 'budgets',
    component: __WEBPACK_IMPORTED_MODULE_7__components_admin_budgets_ListBudget___default.a
  }, {
    path: 'budgets/create',
    component: __WEBPACK_IMPORTED_MODULE_6__components_admin_budgets_CreateBudget___default.a
  }, {
    path: 'budgets/show/:id',
    component: __WEBPACK_IMPORTED_MODULE_8__components_admin_budgets_ShowBudget___default.a
  }, {
    path: 'campaigns',
    component: __WEBPACK_IMPORTED_MODULE_9__components_admin_campaign_ListCampaign___default.a
  }]
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_admin_AdminTraffic__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_admin_AdminTraffic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_admin_AdminTraffic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_admin_account_ListAccount__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_admin_account_ListAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_admin_account_ListAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_project_ListProject__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_admin_project_ListProject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_admin_project_ListProject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_project_EditProject__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin_project_EditProject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin_project_EditProject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_team_ListTeam__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_admin_team_ListTeam___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_admin_team_ListTeam__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_campaign_ListCampaign__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_campaign_ListCampaign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_admin_campaign_ListCampaign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_task_ListTask__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_task_ListTask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_admin_task_ListTask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_task_TaskWithoutFinish__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_task_TaskWithoutFinish___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_admin_task_TaskWithoutFinish__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_task_EditTask__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_task_EditTask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_admin_task_EditTask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_profile_ListProfile__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_profile_ListProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_admin_profile_ListProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin_hour_ListHour__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin_hour_ListHour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_admin_hour_ListHour__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_admin_email_ListEmail__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_admin_email_ListEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_admin_email_ListEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_email_EmailWithoutFinish__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_email_EmailWithoutFinish___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_admin_email_EmailWithoutFinish__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_admin_email_EditEmail__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_admin_email_EditEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_admin_email_EditEmail__);















/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/admin/traffic',
  //beforeEnter: requireAuth,
  name: 'AdminTraffic',
  component: __WEBPACK_IMPORTED_MODULE_0__components_admin_AdminTraffic___default.a,
  children: [{
    path: 'accounts',
    component: __WEBPACK_IMPORTED_MODULE_1__components_admin_account_ListAccount___default.a
  }, {
    path: 'projects',
    component: __WEBPACK_IMPORTED_MODULE_2__components_admin_project_ListProject___default.a
  }, {
    path: 'project/:id',
    component: __WEBPACK_IMPORTED_MODULE_3__components_admin_project_EditProject___default.a
  }, {
    path: 'teams',
    component: __WEBPACK_IMPORTED_MODULE_4__components_admin_team_ListTeam___default.a
  }, {
    path: 'campaigns',
    component: __WEBPACK_IMPORTED_MODULE_5__components_admin_campaign_ListCampaign___default.a
  }, {
    path: 'tasks',
    component: __WEBPACK_IMPORTED_MODULE_6__components_admin_task_ListTask___default.a
  }, {
    path: 'tasks-without-finish',
    component: __WEBPACK_IMPORTED_MODULE_7__components_admin_task_TaskWithoutFinish___default.a
  }, {
    path: 'task/:id',
    component: __WEBPACK_IMPORTED_MODULE_8__components_admin_task_EditTask___default.a
  }, {
    path: 'emails',
    component: __WEBPACK_IMPORTED_MODULE_11__components_admin_email_ListEmail___default.a
  }, {
    path: 'emails-without-finish',
    component: __WEBPACK_IMPORTED_MODULE_12__components_admin_email_EmailWithoutFinish___default.a
  }, {
    path: 'email/:id',
    component: __WEBPACK_IMPORTED_MODULE_13__components_admin_email_EditEmail___default.a
  }, {
    path: 'profiles',
    component: __WEBPACK_IMPORTED_MODULE_9__components_admin_profile_ListProfile___default.a
  }, {
    path: 'hours',
    component: __WEBPACK_IMPORTED_MODULE_10__components_admin_hour_ListHour___default.a
  }]
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: "https://myinxait.inxaitcorp.com/v4/api/",
  timeout: 18000,
  crossDomain: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
}));

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: "https://myinxait.inxaitcorp.com/v3/api/",
  timeout: 18000,
  crossDomain: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
}));

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: "https://myinxait.inxaitcorp.com/v2/api/",
  timeout: 18000,
  crossDomain: true,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
}));

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getList", function() { return getList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getListTasksMongo", function() { return getListTasksMongo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getListEmailsMongo", function() { return getListEmailsMongo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getListCalendarsMongo", function() { return getListCalendarsMongo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAll", function() { return getAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "store", function() { return store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "show", function() { return show; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "update", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remove", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "session", function() { return session; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "post", function() { return post; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "put", function() { return put; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteItem", function() { return deleteItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_axios_mongo_tasks__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_axios_mongo_emails__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_axios_mongo_calendars__ = __webpack_require__(227);










// CRUD
var getList = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, entity) {
    var commit = _ref2.commit;
    var query;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = '';

            if (Array.isArray(entity)) {
              query = '?' + entity['1'];
              entity = entity['0'];
            }
            //console.log(entity)
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].get(entity + '/list' + query).then(function (response) {
                var mutation = entity + '/LIST_' + entity.toUpperCase();
                commit(mutation, response.data.list);
                //console.log(response)
                resolve(response.data);
              }).catch(function (error) {
                console.log(error);
                if (error.response && error.response.data) {
                  window.$toast.info(error.response.data.message);
                } else {
                  //window.$toast.info('Error al listar datos, intente de nuevo!')
                }
                reject(error);
              });
            }));

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getList(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getListTasksMongo = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, entity) {
    var commit = _ref4.commit;
    var query;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            query = '';

            if (Array.isArray(entity)) {
              query = '?' + entity['1'];
              entity = entity['0'];
            }
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_5__services_axios_mongo_tasks__["a" /* default */].get(entity + '/list' + query).then(function (response) {
                var mutation = entity + '/LIST_' + entity.toUpperCase();
                commit(mutation, response.data.list);
                //console.log(response)
                resolve(response.data);
              }).catch(function (error) {
                console.log(error);
                if (error.response && error.response.data) {
                  window.$toast.info(error.response.data.message);
                } else {
                  //window.$toast.info('Error al listar datos, intente de nuevo!')
                }
                reject(error);
              });
            }));

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getListTasksMongo(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

var getListEmailsMongo = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6, entity) {
    var commit = _ref6.commit;
    var query;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            query = '';

            if (Array.isArray(entity)) {
              query = '?' + entity['1'];
              entity = entity['0'];
            }
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6__services_axios_mongo_emails__["a" /* default */].get(entity + '/list' + query).then(function (response) {
                var mutation = entity + '/LIST_' + entity.toUpperCase();
                commit(mutation, response.data.list);
                //console.log(response)
                resolve(response.data);
              }).catch(function (error) {
                console.log(error);
                if (error.response && error.response.data) {
                  window.$toast.info(error.response.data.message);
                } else {
                  //window.$toast.info('Error al listar datos, intente de nuevo!')
                }
                reject(error);
              });
            }));

          case 3:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getListEmailsMongo(_x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();

var getListCalendarsMongo = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref8, entity) {
    var commit = _ref8.commit;
    var query;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            query = '';

            if (Array.isArray(entity)) {
              query = '?' + entity['1'];
              entity = entity['0'];
            }
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_7__services_axios_mongo_calendars__["a" /* default */].get('' + entity + query).then(function (response) {
                //console.log(response)
                resolve(response.data);
              }).catch(function (error) {
                console.log(error);
                if (error.response && error.response.data) {
                  window.$toast.info(error.response.data.message);
                } else {
                  //window.$toast.info('Error al listar datos, intente de nuevo!')
                }
                reject(error);
              });
            }));

          case 3:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function getListCalendarsMongo(_x7, _x8) {
    return _ref7.apply(this, arguments);
  };
}();

var getAll = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(_ref10, entity) {
    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].get(entity).then(function (response) {
                var mutation = entity + '/ALL_' + entity.toUpperCase();
                commit(mutation, response.data.list);
                //console.log(response.data)
                resolve(response.data);
              }).catch(function (error) {
                console.log(error);
                if (error.response && error.response.data) {
                  window.$toast.info(error.response.data.message);
                } else {
                  //window.$toast.info('Error al listar datos, intente de nuevo!')
                }
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function getAll(_x9, _x10) {
    return _ref9.apply(this, arguments);
  };
}();

var store = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(_ref12, form) {
    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var query = '';
              if (Array.isArray(form)) {
                query = '?' + form['1'];
                form = form['0'];
              }
              var entity = form.entity;
              var header = {};
              if (form instanceof FormData) {
                entity = form.get('entity');
                console.log(entity);
                header = { 'Content-Type': 'multipart/form-data, application/json' };
              }
              // axios.post(entity, form, {headers : header})
              __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].post('' + entity + query, form).then(function (response) {
                var mutation = entity + '/REGISTER_' + entity.toUpperCase();
                commit(mutation, response.data);
                if (response.data.list) {
                  var mutationList = entity + '/ALL_' + entity.toUpperCase();
                  commit(mutationList, response.data.list);
                }
                window.$toast.success('Datos creados correctamente');
                resolve(response.data);
              }).catch(function (error) {
                if (error.response && error.response.data) {
                  window.$toast.info(error.response.data.message);
                } else {
                  window.$toast.info('Error modificando los datos, intente de nuevo!');
                }
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function store(_x11, _x12) {
    return _ref11.apply(this, arguments);
  };
}();

var show = function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(_ref14, form) {
    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var entity = form.entity;
              __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].get(entity + '/' + form.id).then(function (response) {
                var mutation = entity + '/SHOW_' + entity.toUpperCase();
                commit(mutation, response.data.model);
                //console.log(response.data)
                resolve(response.data.model);
              }).catch(function (error) {
                window.$toast.info('Error consultando los datos, intente de nuevo!');
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function show(_x13, _x14) {
    return _ref13.apply(this, arguments);
  };
}();

var update = function () {
  var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(_ref16, form) {
    var commit = _ref16.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var query = '';

              if (Array.isArray(form)) {
                query = '?' + form['1'];
                form = form['0'];
              }
              var entity = form.entity;
              var id = form.id;

              __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].put(entity + '/' + id + query, form).then(function (response) {
                var mutation = entity + '/UPDATE_' + entity.toUpperCase();
                commit(mutation, response.data);
                if (response.data.list) {
                  var mutationList = entity + '/ALL_' + entity.toUpperCase();
                  commit(mutationList, response.data.list);
                }
                window.$toast.success('Datos modificados correctamente');
                //console.log(response.data)
                resolve(response.data);
              }).catch(function (error) {
                console.log(error);
                if (error.response && error.response.data) {
                  window.$toast.info(error.response.data.message);
                } else {
                  window.$toast.info('Error modificando los datos, intente de nuevo!');
                }
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function update(_x15, _x16) {
    return _ref15.apply(this, arguments);
  };
}();

var remove = function () {
  var _ref17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(_ref18, form) {
    var commit = _ref18.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var entity = form.entity;
              __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].delete(entity + '/' + form.id).then(function (response) {
                var mutation = entity + '/REMOVE_' + entity.toUpperCase();
                commit(mutation, response.data.model);
                window.$toast.error('Se ha eliminado correctamente');
                //console.log(response.data)
                resolve(response.data.model);
              }).catch(function (error) {
                window.$toast.info('Error eliminando registro, intente de nuevo!');
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function remove(_x17, _x18) {
    return _ref17.apply(this, arguments);
  };
}();

// SESSION

var login = function () {
  var _ref19 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(_ref20, user) {
    var commit = _ref20.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].post('/auth/login', user).then(function (response) {
                commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* LOGIN */], response.data.auth);
                localStorage.token = response.data.access_token;
                __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].defaults.headers.Authorization = 'Bearer ' + response.data.access_token;
                resolve(response.data.auth);
              }).catch(function (error) {
                window.$toast.info('Error al iniciar sesión, intente de nuevo!');
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, this);
  }));

  return function login(_x19, _x20) {
    return _ref19.apply(this, arguments);
  };
}();

var logout = function () {
  var _ref21 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(_ref22, user) {
    var commit = _ref22.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              delete localStorage.token;
              delete localStorage.session_account;
              delete localStorage.session_team;
              commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["f" /* LOGOUT */], user);
              resolve(user);
            }));

          case 1:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));

  return function logout(_x21, _x22) {
    return _ref21.apply(this, arguments);
  };
}();

var session = function () {
  var _ref23 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(_ref24) {
    var commit = _ref24.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].get('/auth/user').then(function (response) {
                //console.log(response.data);
                commit(__WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* SESSION */], response.data.auth);
                resolve(response.data.auth);
              }).catch(function (error) {
                delete localStorage.token;
                delete localStorage.session_account;
                delete localStorage.session_team;
                if (error.response.data) {
                  window.$toast.info(error.response.data.message);
                }
                console.log('error session');
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, this);
  }));

  return function session(_x23) {
    return _ref23.apply(this, arguments);
  };
}();

// CRUD
var get = function () {
  var _ref25 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(_ref26, url) {
    var commit = _ref26.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].get(url).then(function (response) {
                //console.log(response)
                if (response.data.message) {
                  window.$toast.success(response.data.message);
                }
                resolve(response.data);
              }).catch(function (error) {
                console.log(error);
                if (error.response && error.response.data) {
                  window.$toast.info(error.response.data.message);
                } else {
                  //window.$toast.info('Error al listar datos, intente de nuevo!')
                }
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, this);
  }));

  return function get(_x24, _x25) {
    return _ref25.apply(this, arguments);
  };
}();

var post = function () {
  var _ref27 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(_ref28, form) {
    var commit = _ref28.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              if (Array.isArray(form)) {
                query = '?' + form['1'];
                form = form['0'];
              }
              var entity = form.entity;
              __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].post(entity, form).then(function (response) {
                //console.log(response)
                if (response.data.message) {
                  window.$toast.success(response.data.message);
                }
                resolve(response.data);
              }).catch(function (error) {
                console.log(error);
                if (error.response && error.response.data) {
                  window.$toast.info(error.response.data.message);
                } else {
                  //window.$toast.info('Error al listar datos, intente de nuevo!')
                }
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, this);
  }));

  return function post(_x26, _x27) {
    return _ref27.apply(this, arguments);
  };
}();

var put = function () {
  var _ref29 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(_ref30, data) {
    var commit = _ref30.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              if (Array.isArray(data)) {
                query = '?' + data['1'];
                data = data['0'];
              }
              var entity = data.entity;
              __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].put(entity + '/' + data['id'], data).then(function (response) {
                //console.log(response)
                if (response.data.message) {
                  window.$toast.success(response.data.message);
                }
                resolve(response.data);
              }).catch(function (error) {
                console.log(error);
                if (error.response && error.response.data) {
                  window.$toast.info(error.response.data.message);
                } else {
                  //window.$toast.info('Error al listar datos, intente de nuevo!')
                }
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, this);
  }));

  return function put(_x28, _x29) {
    return _ref29.apply(this, arguments);
  };
}();

var deleteItem = function () {
  var _ref31 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(_ref32, data) {
    var commit = _ref32.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_axios__["a" /* default */].delete(data['entity'] + '/' + data['id']).then(function (response) {
                //console.log(response)
                if (response.data.message) {
                  window.$toast.success(response.data.message);
                }
                resolve(response.data);
              }).catch(function (error) {
                console.log(error);
                if (error.response && error.response.data) {
                  window.$toast.info(error.response.data.message);
                } else {
                  //window.$toast.info('Error al listar datos, intente de nuevo!')
                }
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context16.stop();
        }
      }
    }, _callee16, this);
  }));

  return function deleteItem(_x30, _x31) {
    return _ref31.apply(this, arguments);
  };
}();

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUsers", function() { return getUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUser", function() { return getCurrentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSessionAccount", function() { return getSessionAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSessionTeam", function() { return getSessionTeam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAccounts", function() { return getAccounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAccount", function() { return getAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAccountCountries", function() { return getAccountCountries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjects", function() { return getProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProject", function() { return getProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTeams", function() { return getTeams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTeam", function() { return getTeam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCampaigns", function() { return getCampaigns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCampaign", function() { return getCampaign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSocialReasons", function() { return getSocialReasons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSuppliers", function() { return getSuppliers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSupplier", function() { return getSupplier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getClients", function() { return getClients; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getClient", function() { return getClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBudgets", function() { return getBudgets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBudget", function() { return getBudget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBudgetStates", function() { return getBudgetStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBudgetElements", function() { return getBudgetElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBudgetElement", function() { return getBudgetElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTasks", function() { return getTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTask", function() { return getTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskStates", function() { return getTaskStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskVersions", function() { return getTaskVersions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskVersion", function() { return getTaskVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmails", function() { return getEmails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmail", function() { return getEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmailStates", function() { return getEmailStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmailVersions", function() { return getEmailVersions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmailVersion", function() { return getEmailVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmailChecks", function() { return getEmailChecks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmailCheck", function() { return getEmailCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmailClassifications", function() { return getEmailClassifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmailClassification", function() { return getEmailClassification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProfiles", function() { return getProfiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProfile", function() { return getProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHours", function() { return getHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHour", function() { return getHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCalendars", function() { return getCalendars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCalendar", function() { return getCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNotifications", function() { return getNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNotification", function() { return getNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLibrary", function() { return getLibrary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLibraries", function() { return getLibraries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getActivity", function() { return getActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getActivities", function() { return getActivities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIsLoading", function() { return getIsLoading; });
var getUsers = function getUsers(state) {
  return state.users;
};
var getUser = function getUser(state) {
  return state.user;
};
var getCurrentUser = function getCurrentUser(state) {
  return state.current;
};

var getSessionAccount = function getSessionAccount(state) {
  return state.session_account;
};
var getSessionTeam = function getSessionTeam(state) {
  return state.session_team;
};

var getAccounts = function getAccounts(state) {
  return state.accounts;
};
var getAccount = function getAccount(state) {
  return state.account;
};
var getAccountCountries = function getAccountCountries(state) {
  return state.accountcountries;
};

var getProjects = function getProjects(state) {
  return state.projects;
};
var getProject = function getProject(state) {
  return state.project;
};

var getTeams = function getTeams(state) {
  return state.teams;
};
var getTeam = function getTeam(state) {
  return state.team;
};

var getCampaigns = function getCampaigns(state) {
  return state.campaigns;
};
var getCampaign = function getCampaign(state) {
  return state.campaign;
};

var getSocialReasons = function getSocialReasons(state) {
  return state.socialreasons;
};

var getSuppliers = function getSuppliers(state) {
  return state.suppliers;
};
var getSupplier = function getSupplier(state) {
  return state.supplier;
};

var getClients = function getClients(state) {
  return state.clients;
};
var getClient = function getClient(state) {
  return state.client;
};

var getBudgets = function getBudgets(state) {
  return state.budgets;
};
var getBudget = function getBudget(state) {
  return state.budget;
};
var getBudgetStates = function getBudgetStates(state) {
  return state.budgetstates;
};

var getBudgetElements = function getBudgetElements(state) {
  return state.budgetelements;
};
var getBudgetElement = function getBudgetElement(state) {
  return state.budgetelement;
};

var getTasks = function getTasks(state) {
  return state.tasks;
};
var getTask = function getTask(state) {
  return state.task;
};
var getTaskStates = function getTaskStates(state) {
  return state.taskstates;
};
var getTaskVersions = function getTaskVersions(state) {
  return state.taskversions;
};
var getTaskVersion = function getTaskVersion(state) {
  return state.taskversion;
};

var getEmails = function getEmails(state) {
  return state.emails;
};
var getEmail = function getEmail(state) {
  return state.email;
};
var getEmailStates = function getEmailStates(state) {
  return state.emailstates;
};
var getEmailVersions = function getEmailVersions(state) {
  return state.emailversions;
};
var getEmailVersion = function getEmailVersion(state) {
  return state.emailversion;
};
var getEmailChecks = function getEmailChecks(state) {
  return state.emailchecks;
};
var getEmailCheck = function getEmailCheck(state) {
  return state.emailcheck;
};
var getEmailClassifications = function getEmailClassifications(state) {
  return state.emailclassifications;
};
var getEmailClassification = function getEmailClassification(state) {
  return state.emailclassification;
};

var getProfiles = function getProfiles(state) {
  return state.profiles;
};
var getProfile = function getProfile(state) {
  return state.profile;
};

var getHours = function getHours(state) {
  return state.hours;
};
var getHour = function getHour(state) {
  return state.hour;
};

var getCalendars = function getCalendars(state) {
  return state.calendars;
};
var getCalendar = function getCalendar(state) {
  return state.calendar;
};

var getNotifications = function getNotifications(state) {
  return state.notifications;
};
var getNotification = function getNotification(state) {
  return state.notification;
};

var getLibrary = function getLibrary(state) {
  return state.library;
};
var getLibraries = function getLibraries(state) {
  return state.libraries;
};

var getActivity = function getActivity(state) {
  return state.activity;
};
var getActivities = function getActivities(state) {
  return state.activities;
};

var getIsLoading = function getIsLoading(state) {
  return state.isLoading;
};

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(43);



var _mutations;






var initialState = {
  isLoading: false,
  session_account: null,
  session_team: null,
  sidebarStatus: false,
  sidebarStatusResponsive: false,
  stateLogin: false,
  users: [],
  user: {},
  current: {
    accounts: []
  },
  accounts: [],
  accountcountries: [],
  account: {},
  projects: [],
  project: {},
  teams: [],
  team: {},
  campaigns: [],
  campaign: {},
  socialreasons: [],
  socialreason: {},
  suppliers: [],
  supplier: {},
  supplieraccounts: [],
  supplieraccount: {},
  suppliersocialreasons: [],
  suppliersocialreason: {},
  clients: [],
  client: {},
  clientaccounts: [],
  clientaccount: {},
  tasks: [],
  task: {},
  budgets: [],
  budget: {},
  budgetstates: [],
  budgetelements: [],
  budgetelement: {},
  taskstates: [],
  taskversions: [],
  taskversion: [],
  emails: [],
  email: {},
  emailstates: [],
  emailcheck: {},
  emailchecks: [],
  emailversions: [],
  emailversion: {},
  emailclassifications: {},
  emailclassification: {},
  profiles: [],
  profile: {},
  hours: [],
  hour: {},
  calendars: [],
  calendar: {},
  notifications: [],
  notification: {},
  accountusers: [],
  accountuser: {},
  libraries: [],
  library: {},
  activities: [],
  activity: {},
  points: {},
  point: {}
  // mutations
};var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["b" /* LOGIN */], function (state, user) {
  state.user = user;
  state.stateLogin = true;
  //DEFAULT ACCOUNT SESSION USER
  if (user.role != 1) {
    if (localStorage.session_account) {
      state.session_account = localStorage.session_account;
    } else {
      if (user.accounts.length) {
        localStorage.session_account = user.accounts[0].id;
        state.session_account = user.accounts[0].id;
      }
    }
  }
  //DEFAULT TEAM SESSION USER
  if (user.role != 1) {
    if (localStorage.session_team) {
      state.session_team = localStorage.session_team;
    } else {
      if (user.role == 5) {
        localStorage.session_team = 1;
        state.session_team = 1;
      } else {
        localStorage.session_team = user.team_id;
        state.session_team = user.team_id;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* SESSION */], function (state, user) {
  state.user = user;
  state.stateLogin = true;
  //DEFAULT ACCOUNT SESSION USER
  if (user.role != 1) {
    if (localStorage.session_account) {
      state.session_account = localStorage.session_account;
    } else {
      if (user.accounts.length) {
        localStorage.session_account = user.accounts[0].id;
        state.session_account = user.accounts[0].id;
      }
    }
  }
  //DEFAULT TEAM SESSION USER
  if (user.role != 1) {
    if (localStorage.session_team) {
      state.session_team = localStorage.session_team;
    } else {
      if (user.role == 5) {
        localStorage.session_team = 1;
        state.session_team = 1;
      } else {
        localStorage.session_team = user.team_id;
        state.session_team = user.team_id;
      }
    }
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["d" /* SESSION_ACCOUNT */], function (state, session) {
  state.session_account = session;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["e" /* SESSION_TEAM */], function (state, session) {
  state.session_team = session;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["f" /* LOGOUT */], function (state, user) {
  state.user = {
    name: '',
    email: ''
  };
  state.stateLogin = false;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["g" /* LIST_USER */], function (state, users) {
  state.users = users;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["h" /* ALL_USER */], function (state, users) {
  state.users = users;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["i" /* SHOW_USER */], function (state, current) {
  state.current = current;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["j" /* REGISTER_USER */], function (state, user) {
  state.user = user;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["k" /* UPDATE_USER */], function (state, current) {
  state.users = state.users.filter(function (u) {
    return u.id !== current.id;
  });
  state.current = current;
  if (state.current.id === state.user.id) {
    state.user = state.current;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["l" /* REMOVE_USER */], function (state, user) {
  state.users = state.users.filter(function (p) {
    return p.id !== user.id;
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["m" /* LIST_ACCOUNT */], function (state, accounts) {
  state.accounts = accounts;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["n" /* LIST_ACCOUNTCOUNTRY */], function (state, accountcountries) {
  state.accountcountries = accountcountries;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["o" /* ALL_ACCOUNT */], function (state, accounts) {
  state.accounts = accounts;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["p" /* SHOW_ACCOUNT */], function (state, account) {
  state.account = account;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["q" /* REGISTER_ACCOUNT */], function (state, account) {
  state.account = account;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["r" /* UPDATE_ACCOUNT */], function (state, account) {
  state.accounts = state.accounts.filter(function (item) {
    return item.id !== account.id;
  });
  state.account = account;

  if (state.account.id === state.account.id) {
    state.account = state.account;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["s" /* REMOVE_ACCOUNT */], function (state, account) {
  state.accounts = state.accounts.filter(function (item) {
    return item.id !== account.id;
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* LIST_PROJECT */], function (state, projects) {
  state.projects = projects;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["u" /* ALL_PROJECT */], function (state, projects) {
  state.projects = projects;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["v" /* SHOW_PROJECT */], function (state, project) {
  state.project = project;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["w" /* REGISTER_PROJECT */], function (state, project) {
  state.project = project;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["x" /* UPDATE_PROJECT */], function (state, project) {
  state.projects = state.projects.filter(function (item) {
    return item.id !== project.id;
  });
  state.project = project;
  if (state.project.id === state.project.id) {
    state.project = state.project;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["y" /* REMOVE_PROJECT */], function (state, project) {
  state.projects = state.projects.filter(function (item) {
    return item.id !== project.id;
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["z" /* LIST_TEAM */], function (state, teams) {
  state.teams = teams;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["A" /* ALL_TEAM */], function (state, teams) {
  state.teams = teams;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["B" /* SHOW_TEAM */], function (state, team) {
  state.team = team;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["C" /* REGISTER_TEAM */], function (state, team) {
  state.team = team;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["D" /* UPDATE_TEAM */], function (state, team) {
  state.teams = state.teams.filter(function (item) {
    return item.id !== team.id;
  });
  state.team = team;
  if (state.team.id === state.team.id) {
    state.team = state.team;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["E" /* REMOVE_TEAM */], function (state, team) {
  state.teams = state.teams.filter(function (item) {
    return item.id !== team.id;
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["F" /* LIST_CAMPAIGN */], function (state, campaigns) {
  state.campaigns = campaigns;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["G" /* ALL_CAMPAIGN */], function (state, campaigns) {
  state.campaigns = campaigns;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["H" /* SHOW_CAMPAIGN */], function (state, campaign) {
  state.campaign = campaign;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["I" /* REGISTER_CAMPAIGN */], function (state, campaign) {
  state.campaign = campaign;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["J" /* UPDATE_CAMPAIGN */], function (state, campaign) {
  state.campaigns = state.campaigns.filter(function (item) {
    return item.id !== campaign.id;
  });
  state.campaign = campaign;
  if (state.campaign.id === state.campaign.id) {
    state.campaign = state.campaign;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["K" /* REMOVE_CAMPAIGN */], function (state, campaign) {
  state.campaigns = state.campaigns.filter(function (item) {
    return item.id !== campaign.id;
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["L" /* LIST_SOCIALREASON */], function (state, socialreasons) {
  state.socialreasons = socialreasons;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["M" /* ALL_SOCIALREASON */], function (state, socialreasons) {
  state.socialreasons = socialreasons;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["N" /* REGISTER_SOCIALREASON */], function (state, socialreason) {
  state.socialreason = socialreason;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["O" /* UPDATE_SOCIALREASON */], function (state, socialreason) {
  state.socialreasons = state.socialreasons.filter(function (item) {
    return item.id !== socialreason.id;
  });
  state.socialreason = socialreason;
  if (state.socialreason.id === state.socialreason.id) {
    state.socialreason = state.socialreason;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["P" /* LIST_SUPPLIER */], function (state, suppliers) {
  state.suppliers = suppliers;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["Q" /* ALL_SUPPLIER */], function (state, suppliers) {
  state.suppliers = suppliers;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["R" /* SHOW_SUPPLIER */], function (state, supplier) {
  state.supplier = supplier;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["S" /* REGISTER_SUPPLIER */], function (state, supplier) {
  state.supplier = supplier;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["T" /* UPDATE_SUPPLIER */], function (state, supplier) {
  state.suppliers = state.suppliers.filter(function (item) {
    return item.id !== supplier.id;
  });
  state.supplier = supplier;
  if (state.supplier.id === state.supplier.id) {
    state.supplier = state.supplier;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["U" /* ALL_SUPPLIERACCOUNT */], function (state, supplieraccounts) {
  state.supplieraccounts = supplieraccounts;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["V" /* REGISTER_SUPPLIERACCOUNT */], function (state, supplieraccount) {
  state.supplieraccount = supplieraccount;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["W" /* UPDATE_SUPPLIERACCOUNT */], function (state, supplieraccount) {
  state.supplieraccounts = state.supplieraccounts.filter(function (item) {
    return item.id !== supplieraccount.id;
  });
  state.supplieraccount = supplieraccount;
  if (state.supplieraccount.id === state.supplieraccount.id) {
    state.supplieraccount = state.supplieraccount;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["X" /* ALL_SUPPLIERSOCIALREASON */], function (state, suppliersocialreasons) {
  state.suppliersocialreasons = suppliersocialreasons;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["Y" /* REGISTER_SUPPLIERSOCIALREASON */], function (state, suppliersocialreason) {
  state.suppliersocialreason = suppliersocialreason;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["Z" /* UPDATE_SUPPLIERSOCIALREASON */], function (state, suppliersocialreason) {
  state.suppliersocialreasons = state.suppliersocialreasons.filter(function (item) {
    return item.id !== suppliersocialreason.id;
  });
  state.suppliersocialreason = suppliersocialreason;
  if (state.suppliersocialreason.id === state.suppliersocialreason.id) {
    state.suppliersocialreason = state.suppliersocialreason;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_0" /* LIST_CLIENT */], function (state, clients) {
  state.clients = clients;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_1" /* ALL_CLIENT */], function (state, clients) {
  state.clients = clients;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_2" /* SHOW_CLIENT */], function (state, client) {
  state.client = client;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_3" /* REGISTER_CLIENT */], function (state, client) {
  state.client = client;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_4" /* UPDATE_CLIENT */], function (state, client) {
  state.clients = state.clients.filter(function (item) {
    return item.id !== client.id;
  });
  state.client = client;
  if (state.client.id === state.client.id) {
    state.client = state.client;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_5" /* ALL_CLIENTACCOUNT */], function (state, clientaccounts) {
  state.clientaccounts = clientaccounts;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_6" /* REGISTER_CLIENTACCOUNT */], function (state, clientaccount) {
  state.clientaccount = clientaccount;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_7" /* UPDATE_CLIENTACCOUNT */], function (state, clientaccount) {
  state.clientaccounts = state.clientaccounts.filter(function (item) {
    return item.id !== clientaccount.id;
  });
  state.clientaccount = clientaccount;
  if (state.clientaccount.id === state.clientaccount.id) {
    state.clientaccount = state.clientaccount;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_8" /* LIST_BUDGET */], function (state, budgets) {
  state.budgets = budgets;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_9" /* LIST_BUDGETSTATE */], function (state, budgetstates) {
  state.budgetstates = budgetstates;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_10" /* ALL_BUDGET */], function (state, budgets) {
  state.budgets = budgets;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_11" /* SHOW_BUDGET */], function (state, budget) {
  state.budget = budget;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_12" /* REGISTER_BUDGET */], function (state, budget) {
  state.budget = budget;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_13" /* UPDATE_BUDGET */], function (state, budget) {
  state.budgets = state.budgets.filter(function (item) {
    return item.id !== budget.id;
  });
  state.budget = budget;
  if (state.budget.id === state.budget.id) {
    state.budget = state.budget;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_14" /* LIST_BUDGETELEMENT */], function (state, budgetelements) {
  state.budgetelements = budgetelements;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_15" /* ALL_BUDGETELEMENT */], function (state, budgetelements) {
  state.budgetelements = budgetelements;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_16" /* SHOW_BUDGETELEMENT */], function (state, budgetelement) {
  state.budgetelement = budgetelement;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_17" /* REGISTER_BUDGETELEMENT */], function (state, budgetelement) {
  state.budgetelement = budgetelement;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_18" /* UPDATE_BUDGETELEMENT */], function (state, budgetelement) {
  state.budgetelements = state.budgetelements.filter(function (item) {
    return item.id !== budgetelement.id;
  });
  state.budgetelement = budgetelement;
  if (state.budgetelement.id === state.budgetelement.id) {
    state.budgetelement = state.budgetelement;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["t" /* LIST_PROJECT */], function (state, projects) {
  state.projects = projects;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_19" /* ALL_NOTIFICATION */], function (state, notifications) {
  state.notifications = notifications;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_20" /* LIST_TASK */], function (state, tasks) {
  state.tasks = tasks;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_21" /* LIST_TASKSTATE */], function (state, taskstates) {
  state.taskstates = taskstates;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_22" /* ALL_TASKVERSION */], function (state, taskversions) {
  state.taskversions = taskversions;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* SHOW_TASKVERSION */], function (state, taskversion) {
  state.taskversion = taskversion;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_23" /* ALL_TASK */], function (state, tasks) {
  state.tasks = tasks;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_24" /* SHOW_TASK */], function (state, task) {
  state.task = task;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_25" /* REGISTER_TASK */], function (state, task) {
  state.task = task;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_26" /* REGISTER_TASKVERSION */], function (state, taskversion) {
  state.taskversion = taskversion;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_27" /* UPDATE_TASK */], function (state, task) {
  state.tasks = state.tasks.filter(function (item) {
    return item.id !== task.id;
  });
  state.task = task;
  if (state.task.id === state.task.id) {
    state.task = state.task;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_28" /* REMOVE_POINT */], function (state, point) {
  //
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_29" /* LIST_EMAIL */], function (state, emails) {
  state.emails = emails;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_30" /* LIST_EMAILSTATE */], function (state, emailstates) {
  state.emailstates = emailstates;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_31" /* LIST_EMAILCHECK */], function (state, emailchecks) {
  state.emailchecks = emailchecks;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_32" /* ALL_EMAILVERSION */], function (state, emailversions) {
  state.emailversions = emailversions;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_33" /* SHOW_EMAILVERSION */], function (state, emailversion) {
  state.emailversion = emailversion;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_34" /* ALL_EMAIL */], function (state, emails) {
  state.emails = emails;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_35" /* SHOW_EMAIL */], function (state, email) {
  state.email = email;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_36" /* SHOW_EMAILCHECK */], function (state, emailcheck) {
  state.emailcheck = emailcheck;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_37" /* ALL_EMAILCHECK */], function (state, emailchecks) {
  state.emailchecks = emailchecks;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_38" /* REGISTER_EMAIL */], function (state, email) {
  state.email = email;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_39" /* REGISTER_EMAILVERSION */], function (state, emailversion) {
  state.emailversion = emailversion;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_40" /* REGISTER_EMAILCHECK */], function (state, emailcheck) {
  state.emailcheck = emailcheck;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_41" /* UPDATE_EMAIL */], function (state, email) {
  state.emails = state.emails.filter(function (item) {
    return item.id !== email.id;
  });
  state.email = email;
  if (state.email.id === state.email.id) {
    state.email = state.email;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_42" /* ALL_EMAILCLASSIFICATION */], function (state, emailclassifications) {
  state.emailclassifications = emailclassifications;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_43" /* SHOW_EMAILCLASSIFICATION */], function (state, emailclassification) {
  state.emailclassification = emailclassification;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_44" /* REGISTER_EMAILCLASSIFICATION */], function (state, emailclassification) {
  state.emailclassification = emailclassification;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_45" /* LIST_PROFILE */], function (state, profiles) {
  state.profiles = profiles;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_46" /* ALL_PROFILE */], function (state, profiles) {
  state.profiles = profiles;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_47" /* SHOW_PROFILE */], function (state, profile) {
  state.profile = profile;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_48" /* REGISTER_PROFILE */], function (state, profile) {
  state.profile = profile;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_49" /* UPDATE_PROFILE */], function (state, profile) {
  state.profiles = state.profiles.filter(function (item) {
    return item.id !== profile.id;
  });
  state.profile = profile;
  if (state.profile.id === state.profile.id) {
    state.profile = state.profile;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_50" /* REMOVE_PROFILE */], function (state, profile) {
  state.profiles = state.profiles.filter(function (item) {
    return item.id !== profile.id;
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_51" /* LIST_HOUR */], function (state, hours) {
  state.hours = hours;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_52" /* ALL_HOUR */], function (state, hours) {
  state.hours = hours;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_53" /* SHOW_HOUR */], function (state, hour) {
  state.hour = hour;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_54" /* REGISTER_HOUR */], function (state, hour) {
  state.hour = hour;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_55" /* UPDATE_HOUR */], function (state, hour) {
  state.hours = state.hours.filter(function (item) {
    return item.id !== hour.id;
  });
  state.hour = hour;
  if (state.hour.id === state.hour.id) {
    state.hour = state.hour;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_56" /* REMOVE_HOUR */], function (state, hour) {
  state.hours = state.hours.filter(function (item) {
    return item.id !== hour.id;
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_57" /* LIST_CALENDAR */], function (state, calendars) {
  state.calendars = calendars;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_58" /* ALL_CALENDAR */], function (state, calendars) {
  state.calendars = calendars;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_59" /* SHOW_CALENDAR */], function (state, calendar) {
  state.calendar = calendar;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_60" /* REGISTER_CALENDAR */], function (state, calendar) {
  state.calendar = calendar;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_61" /* UPDATE_CALENDAR */], function (state, calendar) {
  state.calendars = state.calendars.filter(function (item) {
    return item.id !== calendar.id;
  });
  state.calendar = calendar;
  if (state.calendar.id === state.calendar.id) {
    state.calendar = state.calendar;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_62" /* REMOVE_CALENDAR */], function (state, calendar) {
  state.calendars = state.calendars.filter(function (item) {
    return item.id !== calendar.id;
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_63" /* LIST_NOTIFICATION */], function (state, notifications) {
  state.notifications = notifications;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_64" /* UPDATE_NOTIFICATION */], function (state, notification) {
  state.notifications = state.notifications.filter(function (item) {
    return item.id !== notification.id;
  });
  state.notification = notification;
  if (state.notification.id === state.notification.id) {
    state.notification = state.notification;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_65" /* ALL_ACCOUNTUSER */], function (state, accountusers) {
  state.accountusers = accountusers;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_66" /* REGISTER_ACCOUNTUSER */], function (state, accountuser) {
  state.accountuser = accountuser;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_67" /* UPDATE_ACCOUNTUSER */], function (state, accountuser) {
  state.accountusers = state.accountusers.filter(function (item) {
    return item.id !== accountuser.id;
  });
  state.accountuser = accountuser;
  if (state.accountuser.id === state.accountuser.id) {
    state.accountuser = state.accountuser;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_68" /* LIST_LIBRARY */], function (state, libraries) {
  state.libraries = libraries;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_69" /* ALL_LIBRARY */], function (state, libraries) {
  state.libraries = libraries;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_70" /* SHOW_LIBRARY */], function (state, library) {
  state.library = library;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_71" /* REGISTER_LIBRARY */], function (state, library) {
  state.library = library;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_72" /* UPDATE_LIBRARY */], function (state, library) {
  state.libraries = state.libraries.filter(function (item) {
    return item.id !== library.id;
  });
  state.library = library;
  if (state.library.id === state.library.id) {
    state.library = state.library;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_73" /* REMOVE_LIBRARY */], function (state, library) {
  state.libraries = state.libraries.filter(function (item) {
    return item.id !== library.id;
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_74" /* LIST_ACTIVITY */], function (state, activities) {
  state.activities = activities;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_75" /* ALL_ACTIVITY */], function (state, activities) {
  state.activities = activities;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_76" /* SHOW_ACTIVITY */], function (state, activity) {
  state.activity = activity;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_77" /* REGISTER_ACTIVITY */], function (state, activity) {
  state.activity = activity;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_78" /* UPDATE_ACTIVITY */], function (state, activity) {
  state.activities = state.activities.filter(function (item) {
    return item.id !== activity.id;
  });
  state.activity = activity;
  if (state.activity.id === state.activity.id) {
    state.activity = state.activity;
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_79" /* REMOVE_ACTIVITY */], function (state, activity) {
  state.activities = state.activities.filter(function (item) {
    return item.id !== activity.id;
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["_80" /* SET_lOADING */], function (state) {
  var loading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  state.isLoading = loading;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, initialState),
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  mutations: mutations
});

/***/ }),
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/LOADING-2026.da241c8.gif";

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(454),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(417),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(455),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(426),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(481),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(427),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(413),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(451),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(402),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(399),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(424),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(480),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(465),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(488),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(448),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(450),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(485),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(420),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(484),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(406),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(457),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(306)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(462),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(459),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(467),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(446),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(477),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(468),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(474),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(471),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(434),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(298)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(410),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(439),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(479),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(447),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(404),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(472),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(443),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(456),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(473),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(463),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(303)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(431),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(422),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(453),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(461),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(436),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(435),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(469),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(440),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(411),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(428),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(490),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(412),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(419),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(489),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(408),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(414),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(475),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(449),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(297)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(409),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(452),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(470),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(423),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(309)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(482),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(430),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(442),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(437),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(418),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(478),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(401),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(476),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(415),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(296)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(407),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(487),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(486),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(441),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(403),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(433),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(438),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(432),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3918ef7b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(405),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('app-loading') : _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  })]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('div', {
    staticClass: "my-2 justify-end flex"
  }, [_c('DownloadParticipations', {
    attrs: {
      "activity": _vm.activity
    }
  })], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-report -mt-2"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("USUARIO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n              TIEMPO\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n              PORCENTAJE\n            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n              FECHA\n            ")]), _vm._v(" "), (_vm.activity.type === 'Extra') ? _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n              CALIFICACIÓN\n            ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.users), function(activity_user) {
    return _c('tr', {
      key: ("activity-" + (activity_user.user.slug)),
      staticClass: "intro-x"
    }, [_c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-900 font-bold text-xs whitespace-no-wrap"
    }, [_c('a', {
      attrs: {
        "href": _vm.activity.image,
        "target": "_blank"
      }
    }, [_vm._v("\n                  " + _vm._s(activity_user.user.name) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                  " + _vm._s(activity_user.user.email) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_c('a', {
      attrs: {
        "href": _vm.activity.image,
        "target": "_blank"
      }
    }, [_vm._v("\n                    " + _vm._s(activity_user.user.team ? activity_user.user.team.name : '') + "\n                  ")])])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(activity_user.time_to_respond) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(activity_user.percentage_correct) + "%\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(activity_user.created_at) + "\n              ")])]), _vm._v(" "), (_vm.activity.type === 'Extra') ? _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(activity_user.qualification === null ? 'Sin Calificar' : (activity_user.qualification == true ? 'Aprobado' : 'Rechazado')) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex flex-wrap justify-center items-center"
    }, [(_vm.activity.type !== 'Extra') ? _c('router-link', {
      staticClass: "flex items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      attrs: {
        "to": ("/admin/activities/" + (activity_user.slug) + "/answers")
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Ver\n                  Respuestas\n                ")], 1) : _vm._e(), _vm._v(" "), (_vm.activity.type === 'Extra' && activity_user.qualification === null) ? _c('button', {
      staticClass: "flex items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.showQualificationModal(activity_user.slug, activity_user.answer)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "eye",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Calificar\n                ")], 1) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "flex items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.showDeleteModal(activity_user.slug)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "trash",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Eliminar\n                  Participación\n                ")], 1)], 1)])])
  }), 0)])])]), _vm._v(" "), (_vm.showParticipationDeleteModal) ? _c('Modal', {
    attrs: {
      "title": "Eliminar Participación",
      "size": "lg"
    },
    on: {
      "close": _vm.closeDeleteModal
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitDeleteModal()
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 text-center"
  }, [_c('div', [_vm._v("Esta seguro de eliminar la Participación?")])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeDeleteModal
    }
  }, [_vm._v("\n          Cancelar\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Eliminar\n        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.showParticipationQualificationModal) ? _c('Modal', {
    attrs: {
      "title": "Calificar Participación",
      "size": "lg"
    },
    on: {
      "close": _vm.closeQualificationModal
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 text-center"
  }, [_c('div', [_vm._v(_vm._s(_vm.answer))]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 flex justify-center gap-5"
  }, [_c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitQualificationModal(true)
      }
    }
  }, [_vm._v("\n              Aprobar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-4 text-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitQualificationModal(false)
      }
    }
  }, [_vm._v("\n              Rechazar\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeQualificationModal
    }
  }, [_vm._v("\n          Cancelar\n        ")])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multiselect",
    class: {
      'multiselect--active': _vm.isOpen,
      'multiselect--disabled': _vm.disabled,
      'multiselect--above': _vm.isAbove
    },
    attrs: {
      "tabindex": _vm.searchable ? -1 : _vm.tabindex,
      "role": "combobox",
      "aria-owns": 'listbox-' + _vm.id
    },
    on: {
      "focus": function($event) {
        return _vm.activate()
      },
      "blur": function($event) {
        _vm.searchable ? false : _vm.deactivate()
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.pointerForward()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.pointerBackward()
      }],
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) { return null; }
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.addPointerElement($event)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.deactivate()
      }
    }
  }, [_vm._t("caret", function() {
    return [_c('div', {
      staticClass: "multiselect__select",
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.toggle()
        }
      }
    })]
  }, {
    "toggle": _vm.toggle
  }), _vm._v(" "), _vm._t("clear", null, {
    "search": _vm.search
  }), _vm._v(" "), _c('div', {
    ref: "tags",
    staticClass: "multiselect__tags"
  }, [_vm._t("selection", function() {
    return [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.visibleValues.length > 0),
        expression: "visibleValues.length > 0"
      }],
      staticClass: "multiselect__tags-wrap"
    }, [_vm._l((_vm.visibleValues), function(option, index) {
      return [_vm._t("tag", function() {
        return [_c('span', {
          key: index,
          staticClass: "multiselect__tag"
        }, [_c('span', {
          domProps: {
            "textContent": _vm._s(_vm.getOptionLabel(option))
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "multiselect__tag-icon",
          attrs: {
            "tabindex": "1"
          },
          on: {
            "keypress": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              $event.preventDefault();
              return _vm.removeElement(option)
            },
            "mousedown": function($event) {
              $event.preventDefault();
              return _vm.removeElement(option)
            }
          }
        })])]
      }, {
        "option": option,
        "search": _vm.search,
        "remove": _vm.removeElement
      })]
    })], 2), _vm._v(" "), (_vm.internalValue && _vm.internalValue.length > _vm.limit) ? [_vm._t("limit", function() {
      return [_c('strong', {
        staticClass: "multiselect__strong",
        domProps: {
          "textContent": _vm._s(_vm.limitText(_vm.internalValue.length - _vm.limit))
        }
      })]
    })] : _vm._e()]
  }, {
    "search": _vm.search,
    "remove": _vm.removeElement,
    "values": _vm.visibleValues,
    "isOpen": _vm.isOpen
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "multiselect__loading"
    }
  }, [_vm._t("loading", function() {
    return [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.loading),
        expression: "loading"
      }],
      staticClass: "multiselect__spinner"
    })]
  })], 2), _vm._v(" "), (_vm.searchable) ? _c('input', {
    ref: "search",
    staticClass: "multiselect__input",
    style: (_vm.inputStyle),
    attrs: {
      "name": _vm.name,
      "id": _vm.id,
      "type": "text",
      "autocomplete": "off",
      "spellcheck": "false",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "tabindex": _vm.tabindex,
      "aria-controls": 'listbox-' + _vm.id
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function($event) {
        return _vm.updateSearch($event.target.value)
      },
      "focus": function($event) {
        $event.preventDefault();
        return _vm.activate()
      },
      "blur": function($event) {
        $event.preventDefault();
        return _vm.deactivate()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.deactivate()
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.pointerForward()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.pointerBackward()
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        $event.stopPropagation();
        return _vm.removeLastElement()
      }],
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.addPointerElement($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSingleLabelVisible) ? _c('span', {
    staticClass: "multiselect__single",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.toggle.apply(null, arguments)
      }
    }
  }, [_vm._t("singleLabel", function() {
    return [
      [_vm._v(_vm._s(_vm.currentOptionLabel))]
    ]
  }, {
    "option": _vm.singleValue
  })], 2) : _vm._e(), _vm._v(" "), (_vm.isPlaceholderVisible) ? _c('span', {
    staticClass: "multiselect__placeholder",
    on: {
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.toggle.apply(null, arguments)
      }
    }
  }, [_vm._t("placeholder", function() {
    return [_vm._v("\n          " + _vm._s(_vm.placeholder) + "\n        ")]
  })], 2) : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "multiselect"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    ref: "list",
    staticClass: "multiselect__content-wrapper",
    style: ({
      maxHeight: _vm.optimizedHeight + 'px'
    }),
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "focus": _vm.activate,
      "mousedown": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('ul', {
    staticClass: "multiselect__content",
    style: (_vm.contentStyle),
    attrs: {
      "role": "listbox",
      "id": 'listbox-' + _vm.id
    }
  }, [_vm._t("beforeList"), _vm._v(" "), (_vm.multiple && _vm.max === _vm.internalValue.length) ? _c('li', [_c('span', {
    staticClass: "multiselect__option"
  }, [_vm._t("maxElements", function() {
    return [_vm._v("Maximum of " + _vm._s(_vm.max) + " options selected. First remove a selected option to select another.")]
  })], 2)]) : _vm._e(), _vm._v(" "), (!_vm.max || _vm.internalValue.length < _vm.max) ? _vm._l((_vm.filteredOptions), function(option, index) {
    return _c('li', {
      key: index,
      staticClass: "multiselect__element",
      attrs: {
        "id": _vm.id + '-' + index,
        "role": !(option && (option.$isLabel || option.$isDisabled)) ? 'option' : null
      }
    }, [(!(option && (option.$isLabel || option.$isDisabled))) ? _c('span', {
      staticClass: "multiselect__option",
      class: _vm.optionHighlight(index, option),
      attrs: {
        "data-select": option && option.isTag ? _vm.tagPlaceholder : _vm.selectLabelText,
        "data-selected": _vm.selectedLabelText,
        "data-deselect": _vm.deselectLabelText
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select(option)
        },
        "mouseenter": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          return _vm.pointerSet(index)
        }
      }
    }, [_vm._t("option", function() {
      return [_c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))])]
    }, {
      "option": option,
      "search": _vm.search,
      "index": index
    })], 2) : _vm._e(), _vm._v(" "), (option && (option.$isLabel || option.$isDisabled)) ? _c('span', {
      staticClass: "multiselect__option",
      class: _vm.groupHighlight(index, option),
      attrs: {
        "data-select": _vm.groupSelect && _vm.selectGroupLabelText,
        "data-deselect": _vm.groupSelect && _vm.deselectGroupLabelText
      },
      on: {
        "mouseenter": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.groupSelect && _vm.pointerSet(index)
        },
        "mousedown": function($event) {
          $event.preventDefault();
          return _vm.selectGroup(option)
        }
      }
    }, [_vm._t("option", function() {
      return [_c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))])]
    }, {
      "option": option,
      "search": _vm.search,
      "index": index
    })], 2) : _vm._e()])
  }) : _vm._e(), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNoResults && (_vm.filteredOptions.length === 0 && _vm.search && !_vm.loading)),
      expression: "showNoResults && (filteredOptions.length === 0 && search && !loading)"
    }]
  }, [_c('span', {
    staticClass: "multiselect__option"
  }, [_vm._t("noResult", function() {
    return [_vm._v("No elements found. Consider changing the search query.")]
  }, {
    "search": _vm.search
  })], 2)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNoOptions && (_vm.options.length === 0 && !_vm.search && !_vm.loading)),
      expression: "showNoOptions && (options.length === 0 && !search && !loading)"
    }]
  }, [_c('span', {
    staticClass: "multiselect__option"
  }, [_vm._t("noOptions", function() {
    return [_vm._v("La lista esta vacia.")]
  })], 2)]), _vm._v(" "), _vm._t("afterList")], 2)])])], 2)
},staticRenderFns: []}

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(parseInt(_vm.versions.length) > 0) ? _c('div', {
    staticClass: "report-timeline mt-5 relative"
  }, _vm._l((_vm.filteredVersions), function(version, index) {
    return _c('div', {
      key: version.id,
      staticClass: "intro-x relative flex items-center mb-3"
    }, [_c('div', {
      staticClass: "report-timeline__image"
    }, [_c('div', {
      staticClass: "flex h-10 w-10"
    }, [_c('div', {
      staticClass: "h-3 m-auto my-auto rounded-full w-3 z-10",
      class: index == parseInt(_vm.versions.length) - 1 ?
        'bg-theme-1' :
        'bg-gray-500'
    })])]), _vm._v(" "), _c('div', {
      staticClass: "box px-5 py-3 ml-4 flex-1 zoom-in cursor-default"
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [_c('div', [_c('div', {
      staticClass: "font-medium"
    }, [_vm._v("\n              Version " + _vm._s(index + 2) + "\n              "), (index == parseInt(_vm.versions.length) - 1) ? _c('span', [_vm._v("ACTUAL")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "text-xs text-gray-500 ml-auto"
    }, [_vm._v("\n            " + _vm._s(version.created_at) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center"
    }, [_c('div', {
      staticClass: "accordion accordion-boxed w-full"
    }, [_c('div', {
      staticClass: "accordion-item"
    }, [(
      _vm.open == index + 1 ||
      (index == parseInt(_vm.versions.length) - 1 && _vm.open == null)
    ) ? _c('div', {
      staticClass: "accordion-collapse collapse show"
    }, [_c('div', {
      staticClass: "overflow-auto"
    }, [_c('form', {
      staticClass: "form-task",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.updateTaskVersion(version)
        }
      }
    }, [_c('div', {
      staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.id),
        expression: "version.id"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": (version.id)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version, "id", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-span-6 sm:col-span-6"
    }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.name),
        expression: "version.name"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text",
        "required": "",
        "disabled": ![1].includes(_vm.usersession.role)
      },
      domProps: {
        "value": (version.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Fecha de entrega:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.date),
        expression: "version.date"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "date",
        "required": "",
        "disabled": _vm.usersession.role == 4
      },
      domProps: {
        "value": (version.date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version, "date", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.usersession.role == 4) ? _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Horas:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.hours),
        expression: "version.hours"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "number",
        "required": "",
        "disabled": ""
      },
      domProps: {
        "value": (version.hours)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version, "hours", $event.target.value)
        }
      }
    })]) : _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Horas:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.hours),
        expression: "version.hours"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      class: version.state_id == 4 ? 'cursor-not-allowed' : '',
      attrs: {
        "type": "number",
        "min": "0",
        "max": "100",
        "step": ".01",
        "required": "",
        "disabled": version.state_id == 4
      },
      domProps: {
        "value": (version.hours)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version, "hours", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
    }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.description),
        expression: "version.description"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "rows": "5",
        "disabled": ![1].includes(_vm.usersession.role)
      },
      domProps: {
        "value": (version.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.campaign_attribute.project_name),
        expression: "version.campaign_attribute.project_name"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text",
        "required": "",
        "disabled": ""
      },
      domProps: {
        "value": (version.campaign_attribute.project_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version.campaign_attribute, "project_name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.campaign_attribute.name),
        expression: "version.campaign_attribute.name"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text",
        "required": "",
        "disabled": ""
      },
      domProps: {
        "value": (version.campaign_attribute.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version.campaign_attribute, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.usersession.role == 4) ? _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.state_id),
        expression: "version.state_id"
      }],
      staticClass: "input w-full border mt-2",
      class: version.state_id == 4 ? 'bg-disabled' : '',
      attrs: {
        "disabled": version.state_id == 4,
        "required": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(version, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.changeStatus($event)
        }]
      }
    }, [_c('option', {
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("Seleccione el estado...")]), _vm._v(" "), _vm._l((_vm.filteredStates), function(state) {
      return _c('option', {
        domProps: {
          "value": state.id
        }
      }, [_vm._v("\n                            " + _vm._s(state.name) + "\n                          ")])
    })], 2)]) : _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.state_id),
        expression: "version.state_id"
      }],
      staticClass: "input w-full border mt-2",
      class: version.state_id == 4 ? 'bg-disabled' : '',
      attrs: {
        "disabled": version.state_id == 4,
        "required": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(version, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.changeStatus($event)
        }]
      }
    }, [_c('option', {
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("Seleccione el estado...")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        attrs: {
          "disabled": ![4].includes(state.id) &&
            _vm.usersession.team_id != version.team_id
        },
        domProps: {
          "value": state.id
        }
      }, [_vm._v("\n                            " + _vm._s(state.name) + "\n                          ")])
    })], 2)]), _vm._v(" "), (_vm.usersession.team_id == _vm.team_session) ? _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.user_id),
        expression: "version.user_id"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      class: version.state_id == 4 ? 'bg-disabled' : '',
      attrs: {
        "disabled": version.state_id == 4,
        "required": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(version, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("Seleccione el usuario")]), _vm._v("\n                          \\\n                          "), _vm._l((_vm.filteredUsers), function(user) {
      return [([2, 3, 4, 5].includes(user.roles[0].id)) ? _c('option', {
        key: user.id,
        domProps: {
          "value": user.id
        }
      }, [_vm._v("\n                              " + _vm._s(user.name) + "\n                            ")]) : _vm._e()]
    })], 2)]) : _vm._e(), _vm._v(" "), (version.path) ? _vm._l((version.path.split(',')), function(path, key) {
      return _c('div', {
        staticClass: "relative col-span-6 sm:col-span-6"
      }, [_c('label', [_vm._v("Url " + _vm._s(key + 1))]), _vm._v(" "), _c('input', {
        staticClass: "input w-full border mt-2 flex-1",
        attrs: {
          "type": "text",
          "disabled": ""
        },
        domProps: {
          "value": path
        }
      }), _vm._v(" "), (path) ? _c('div', {
        staticClass: "absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
      }, [_c('a', {
        attrs: {
          "href": path,
          "target": "_blank"
        }
      }, [_c('app-icon', {
        attrs: {
          "name": "link",
          "classname": "w-4 h-4"
        }
      })], 1)]) : _vm._e()])
    }) : _vm._e(), _vm._v(" "), ([3, 4, 5, 6, 7].includes(version.state_id)) ? _c('div', {
      staticClass: "col-span-12 gap-4 grid grid-cols-12 py-5 row-gap-3 sm:col-span-12 bg-gray-300 px-3 rounded"
    }, [_c('div', {
      staticClass: "col-span-6 sm:col-span-6"
    }, [_c('label', [_vm._v("Descripcion Respuesta")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.response_observations),
        expression: "version.response_observations"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "rows": "3",
        "required": "",
        "disabled": version.state_id == 6 ||
          version.state_id == 4 ||
          _vm.usersession.team_id != version.team_id
      },
      domProps: {
        "value": (version.response_observations)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version, "response_observations", $event.target.value)
        }
      }
    })]), _vm._v(" "), (!_vm.edit_response_path) ? [_c('p', {
      staticClass: "relative col-span-12 sm:col-span-12"
    }, [_vm._v("\n                            Urls Respuesta\n                            "), (version.state_id != 4) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.editResponsePath()
        }
      }
    }, [_vm._v("- Editar")]) : _vm._e()]), _vm._v(" "), _vm._l((version.response_path), function(path, key) {
      return _c('div', {
        staticClass: "relative col-span-6 sm:col-span-6"
      }, [_c('label', [_vm._v("Url Respuesta " + _vm._s(key + 1))]), _vm._v(" "), _c('input', {
        staticClass: "input w-full border mt-2 flex-1",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": path
        }
      }), _vm._v(" "), (path) ? _c('div', {
        staticClass: "absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
      }, [_c('a', {
        attrs: {
          "href": path,
          "target": "_blank"
        }
      }, [_c('app-icon', {
        attrs: {
          "name": "link",
          "classname": "w-4 h-4"
        }
      })], 1)]) : _vm._e()])
    })] : [_c('div', {
      staticClass: "relative col-span-6 sm:col-span-6"
    }, [_c('label', [_vm._v("Url Archivo Respuesta (opcional)")]), _vm._v(" "), _c('MultiSelect', {
      staticClass: "mt-2",
      attrs: {
        "options": _vm.responsePathOptions,
        "multiple": true,
        "taggable": true,
        "disabled": version.state_id == 6 ||
          version.state_id == 4 ||
          _vm.usersession.team_id != version.team_id
      },
      on: {
        "tag": function($event) {
          return _vm.addResponseTag($event, version)
        }
      },
      model: {
        value: (_vm.response_path),
        callback: function($$v) {
          _vm.response_path = $$v
        },
        expression: "response_path"
      }
    })], 1)]], 2) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "px-5 py-3 text-right border-t border-gray-200"
    }, [_c('button', {
      staticClass: "button bg-theme-1 text-white",
      attrs: {
        "type": "submit",
        "id": "editversion",
        "disabled": _vm.buttonIsLoading
      }
    }, [(_vm.buttonIsLoading) ? [_vm._v("\n                          Cargando...\n                        ")] : [_vm._v(" Modificar ")]], 2)])])])]) : _vm._e()])])]), _vm._v(" "), _c('hr', {
      staticClass: "my-4"
    }), _vm._v(" "), _c('div', {
      staticClass: "accordion-header cursor-pointer"
    }, [(_vm.open === null || _vm.open != index + 1) ? [_c('button', {
      staticClass: "accordion-button w-full text-left focus:outline-none",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.open = index + 1
        }
      }
    }, [_vm._v("\n              Ver\n            ")])] : (
      _vm.open === index + 1 && index != parseInt(_vm.versions.length) - 1
    ) ? [_c('button', {
      staticClass: "accordion-button w-full text-left focus:outline-none",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.open = null
        }
      }
    }, [_vm._v("\n              Ocultar\n            ")])] : _vm._e()], 2)])])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('app-loading') : _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center mt-10"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n          Actividades (" + _vm._s(_vm.activities.length) + ")\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        return _vm.toggleModalMessage(true)
      }
    }
  }, [_vm._v("\n          Mensaje Inxapp\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "to": "/admin/points"
    }
  }, [_vm._v("\n          Ver Puntos\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "to": "/admin/activities/create"
    }
  }, [_vm._v("\n          Crear Actividad\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("NOMBRE / DESCRIPCION")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ARCHIVOS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("TIPO / ESTADO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("FECHAS VIGENCIA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activities), function(activity) {
    return _c('tr', {
      key: ("activity-" + (activity.slug)),
      staticClass: "intro-x"
    }, [_c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-900 font-bold text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(_vm._f("limit")(activity.name)) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-500 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                  " + _vm._s(_vm._f("limit")(activity.description)) + "\n                ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                Imagen: "), _c('br'), _vm._v(" "), (activity.image) ? _c('a', {
      staticClass: "text-blue-600 underline",
      attrs: {
        "href": activity.image,
        "target": "_blank"
      }
    }, [_vm._v("\n                  Ver imagen\n                ")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                Material de estudio: "), _c('br'), _vm._v(" "), (activity.study_information) ? _c('a', {
      staticClass: "text-blue-600 underline",
      attrs: {
        "href": activity.study_information,
        "target": "_blank"
      }
    }, [_vm._v("\n                  Ver archivo\n                ")]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-900 font-bold text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(activity.type) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                  " + _vm._s(activity.status_name) + "\n                ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                Fecha inicial: "), _c('br'), _vm._v("\n                " + _vm._s(activity.start_date) + " "), _c('br'), _c('br'), _vm._v("\n                Fecha final: "), _c('br'), _vm._v("\n                " + _vm._s(activity.end_date) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('button', {
      staticClass: "flex items-center block py-1 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md text-xs",
      on: {
        "click": function($event) {
          return _vm.editActivity(activity)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Editar actividad\n                ")], 1)]), _vm._v(" "), (activity.type !== 'Extra') ? _c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('router-link', {
      staticClass: "flex items-center block py-1 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md text-xs",
      attrs: {
        "to": ("/admin/activities/" + (activity.slug) + "/questions")
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "table",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Editar preguntas\n                ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('router-link', {
      staticClass: "flex items-center block py-1 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md text-xs",
      attrs: {
        "to": ("/admin/activities/" + (activity.slug))
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "clipboard",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Detalle\n                ")], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('router-link', {
      staticClass: "flex items-center block py-1 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md text-xs",
      attrs: {
        "to": ("/admin/activities/" + (activity.slug) + "/participations")
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "eye",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Participaciones\n                ")], 1)], 1)])])
  }), 0)])]), _vm._v(" "), (_vm.show_activity_model) ? _c('ModalEditActivity', {
    attrs: {
      "current_activity": _vm.current_activity
    },
    on: {
      "close": _vm.closeEditActivity
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modalMessage) ? _c('ModalMessage', {
    on: {
      "close": function($event) {
        return _vm.toggleModalMessage(false)
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y box px-5 pt-5 mt-5"
  }, [_c('div', {
    staticClass: "flex flex-col lg:flex-row border-b border-gray-200 pb-5 -mx-5"
  }, [_c('div', {
    staticClass: "flex flex-1 px-5 items-center justify-center lg:justify-start"
  }, [_c('div', {
    staticClass: "w-20 h-20 sm:w-24 sm:h-24 flex-none lg:w-32 lg:h-32 image-fit relative"
  }, [(_vm.user && _vm.user.avatar) ? _c('img', {
    staticClass: "rounded-full",
    attrs: {
      "alt": "Profile",
      "src": _vm.user.avatar
    }
  }) : _c('img', {
    staticClass: "rounded-full",
    attrs: {
      "alt": "Profile",
      "src": "/static/images/profile.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ml-5"
  }, [_c('div', {
    staticClass: "truncate sm:whitespace-normal font-medium text-lg"
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
    staticClass: "text-gray-600 mb-4"
  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('form', [_c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": "image/png, image/jpeg"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), (_vm.loadImage) ? _c('div', {
    staticClass: "text-left"
  }, [_vm._m(1)]) : _c('label', {
    staticClass: "button bg-theme-10 text-white button-sm",
    attrs: {
      "for": "file"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cambiar Foto\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex mt-6 lg:mt-0 items-center lg:items-start flex-1 flex-col justify-center text-gray-600 px-5 border-l border-r border-gray-200 border-t lg:border-t-0 pt-5 lg:pt-0"
  }, [(_vm.user.profile) ? _c('div', {
    staticClass: "truncate sm:whitespace-normal flex items-center"
  }, [_vm._v("\n                  " + _vm._s(_vm.user.profile.name) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.user.team) ? _c('div', {
    staticClass: "truncate sm:whitespace-normal flex items-center mt-3"
  }, [_vm._v("\n                  " + _vm._s(_vm.user.team.name) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "truncate sm:whitespace-normal flex items-center mt-3"
  }, [_c('b', [_vm._v("ID compañia:")]), _vm._v("   " + _vm._s(_vm.user.id_company) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "truncate sm:whitespace-normal flex items-center mt-3"
  }, [_c('b', [_vm._v("Ingreso:")]), _vm._v("   " + _vm._s(_vm.user.admission_date) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "truncate sm:whitespace-normal flex items-center mt-3"
  }, [_c('b', [_vm._v("Nacimiento:")]), _vm._v("   " + _vm._s(_vm.user.birthday) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "truncate sm:whitespace-normal flex items-center mt-3"
  }, [_vm._v("\n                    Estas en MYINXAIT desde el " + _vm._s(_vm.user.created_at) + "\n                ")])]), _vm._v(" "), (_vm.user.team_id) ? _c('div', {
    staticClass: "w-20 h-20 px-5 sm:w-24 sm:h-24 mr-5 flex-none lg:w-32 lg:h-32 relative border-l hidden-xs border-gray-200"
  }, [_c('img', {
    staticClass: "mt-4",
    attrs: {
      "alt": "Team",
      "src": 'https://storage.googleapis.com/myinxait/teams/team-' + _vm.user.team_id + '.png'
    }
  })]) : _vm._e()]), _vm._v(" "), _vm._m(2)])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y flex items-center mt-8"
  }, [_c('h2', {
    staticClass: "text-lg font-medium mr-auto"
  }, [_vm._v("\n          Perfil\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Cargando...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-tabs flex flex-col sm:flex-row justify-center lg:justify-start hidden"
  }, [_c('a', {
    staticClass: "py-4 sm:mr-8 flex items-center active",
    attrs: {
      "data-toggle": "tab",
      "data-target": "#profile",
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "w-4 h-4 mr-2",
    attrs: {
      "data-feather": "user"
    }
  }), _vm._v(" Profile ")]), _vm._v(" "), _c('a', {
    staticClass: "py-4 sm:mr-8 flex items-center",
    attrs: {
      "data-toggle": "tab",
      "data-target": "#account",
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "w-4 h-4 mr-2",
    attrs: {
      "data-feather": "shield"
    }
  }), _vm._v(" Account ")]), _vm._v(" "), _c('a', {
    staticClass: "py-4 sm:mr-8 flex items-center",
    attrs: {
      "data-toggle": "tab",
      "data-target": "#change-password",
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "w-4 h-4 mr-2",
    attrs: {
      "data-feather": "lock"
    }
  }), _vm._v(" Change Password ")]), _vm._v(" "), _c('a', {
    staticClass: "py-4 sm:mr-8 flex items-center",
    attrs: {
      "data-toggle": "tab",
      "data-target": "#settings",
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "w-4 h-4 mr-2",
    attrs: {
      "data-feather": "settings"
    }
  }), _vm._v(" Settings ")])])
}]}

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Crear Libreria"
    },
    on: {
      "close": _vm.emitClose
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createLibrary.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.library.name),
      expression: "library.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.library.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.library, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Estado:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.library.active),
      expression: "library.active"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.library, "active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Activo")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Inactivo")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Descripción:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.library.description),
      expression: "library.description"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": (_vm.library.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.library, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Categoria")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.library.category),
      expression: "library.category"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.library, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccionar...")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: ("category-" + (category.name)),
      domProps: {
        "value": category.name
      }
    }, [_vm._v("\n            " + _vm._s(category.name) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Visualización")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.library.team_id),
      expression: "library.team_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.library, "team_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("TODOS")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return [_c('option', {
      key: ("team-" + (team.id)),
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n            " + _vm._s(team.name) + "\n            ")])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Creado Por")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.library.team_createdby_id),
      expression: "library.team_createdby_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.library, "team_createdby_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("TODOS")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return [_c('option', {
      key: ("team-" + (team.id)),
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n              " + _vm._s(team.name) + "\n              ")])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Url:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.library.url),
      expression: "library.url"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "placeholder": "No es necesaria para Tips o Anuncios"
    },
    domProps: {
      "value": (_vm.library.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.library, "url", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.emitClose
    }
  }, [_vm._v("\n        Cancelar\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n        Crear\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('app-loading') : _c('section', {
    class: ['login', _vm.darkMode ? 'dark' : 'light']
  }, [_c('div', {
    staticClass: "wrapper-login"
  }, [_c('button', {
    staticClass: "btn-theme-toggle",
    attrs: {
      "title": _vm.darkMode ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'
    },
    on: {
      "click": _vm.toggleDarkMode
    }
  }, [(_vm.darkMode) ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0z"
    }
  })]) : _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998z"
    }
  })])]), _vm._v(" "), _vm._l((30), function(n) {
    return _c('span', {
      key: n,
      staticClass: "bubble"
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doLogin.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "mb-8"
  }, [_c('img', {
    staticClass: "w-32 xl:block mx-auto mb-5",
    attrs: {
      "alt": "Logo",
      "src": "/static/images/LOGO-WHITE-2026.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ingresa tu usuario:")]), _vm._v(" "), _c('div', {
    staticClass: "box-input-user mt-4 mb-4 intro-x"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.email) ? _c('small', {
    staticClass: "text-red-600 -mt-2 flex"
  }, [_vm._v(_vm._s(_vm.errors.email[0]))]) : _vm._e(), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ingresa tu contraseña:")]), _vm._v(" "), _c('div', {
    staticClass: "box-input-pass mt-2 intro-x"
  }, [((_vm.type) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Password",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.password) ? _vm._i(_vm.user.password, null) > -1 : (_vm.user.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "password", $$c)
        }
      }
    }
  }) : ((_vm.type) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Password",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.user.password, null)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.user, "password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "placeholder": "Password",
      "type": _vm.type
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "absolute top-0 right-0 rounded-r w-10 h-full flex mr-1 items-center justify-center text-gray-600 cursor-pointer",
    on: {
      "click": _vm.viewPassClick
    }
  }, [(!_vm.viewPass) ? _c('svg', {
    staticClass: "w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    }
  })]) : _c('svg', {
    staticClass: "w-6 h-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
    }
  })])])]), _vm._v(" "), (_vm.errors.password) ? _c('small', {
    staticClass: "text-red-600 mt-2 flex"
  }, [_vm._v(_vm._s(_vm.errors.password[0]))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "intro-x mt-5 text-center"
  }, [_c('button', {
    staticClass: "button-login button w-full !text-white"
  }, [_vm._v("\n            Ingresar\n          ")])])])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "grid grid-cols-12 gap-3 mt-5"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto flex col-span-12"
  }, [_c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2 mx-auto",
    attrs: {
      "to": "/admin/business/clients"
    }
  }, [_vm._v("\n          Regresar\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 md:col-span-12 box bg-white content"
  }, [(_vm.current.accounts.length) ? _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n          Cuentas Asignadas\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-3 mt-5"
  }, _vm._l((_vm.current.accounts), function(account, index) {
    return _c('div', {
      key: index,
      staticClass: "intro-y col-span-12 md:col-span-6"
    }, [_c('div', {
      staticClass: "box bg-theme-1 text-white"
    }, [_c('div', {
      staticClass: "flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(account.name) + " - " + _vm._s(account.country.prefix))])]), _vm._v(" "), _c('div', {
      staticClass: "flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 zoom-in text-white",
      on: {
        "click": function($event) {
          return _vm.removeElement(account, 'clientaccount')
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "minus",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1)])])])])
  }), 0), _vm._v(" "), (_vm.filteredAccounts.length) ? _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n            Cuentas Sin Asignar\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-3 mt-5"
  }, _vm._l((_vm.filteredAccounts), function(account, index) {
    return _c('div', {
      key: index,
      staticClass: "intro-y col-span-12 md:col-span-6"
    }, [_c('div', {
      staticClass: "box bg-gray-300"
    }, [_c('div', {
      staticClass: "flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(account.name) + " - " + _vm._s(account.country.prefix))])]), _vm._v(" "), _c('div', {
      staticClass: "flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "bg-gray-100 border flex h-8 items-center justify-center ml-2 pl-2 rounded-full w-8 zoom-in",
      on: {
        "click": function($event) {
          return _vm.addElement(account, 'clientaccount')
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "plus",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1)])])])])
  }), 0)])]) : _c('app-loading')], 1)
},staticRenderFns: []}

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "Modal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [(_vm.task) ? _c('div', {
    staticClass: "modal__content modal__content--lg",
    attrs: {
      "id": "ModalContent"
    }
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            " + _vm._s(_vm.task.name) + " - ("), _c('b', [_vm._v(_vm._s(_vm.task.date) + ")")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "intro-y box py-5"
  }, [_c('div', {
    staticClass: "wizard flex flex-col px-5 scroll-modal"
  }, [_c('div', {
    staticClass: "bg-gray-200 p-2 rounded-md"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v("\n                " + _vm._s(_vm.task.campaign_attribute.project_name) + " -\n                " + _vm._s(_vm.task.campaign_attribute.project_account_name) + " -\n                " + _vm._s(_vm.task.campaign_attribute.project_account_country_prefix) + " -\n                " + _vm._s(_vm.task.campaign_attribute.name) + "\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_c('b', [_vm._v("Creada el día:")]), _vm._v(" " + _vm._s(_vm.task.created_at) + "\n                "), _c('b', [_vm._v("por")]), _vm._v(" " + _vm._s(_vm.task.user_created_name) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [_vm._v("\n                " + _vm._s(_vm.task.description) + " "), _c('br'), _vm._v(" "), (_vm.task.path) ? _vm._l((_vm.task.path.split(',')), function(taskPath) {
    return _c('a', {
      staticClass: "text-blue-500",
      attrs: {
        "href": taskPath,
        "target": "_blank"
      }
    }, [_vm._v("\n                    Ver archivo aquí\n                    "), _c('span', {
      staticClass: "text-gray-500"
    }, [_vm._v(",")])])
  }) : _vm._e()], 2), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v("\n                La tarea fue realizada por "), _c('b', [_vm._v(_vm._s(_vm.task.user_name))]), _vm._v(" en un total\n                de "), _c('b', [_vm._v(_vm._s(_vm.task.hours))]), _vm._v(" hora(s)\n              ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v("\n                " + _vm._s(_vm.task.response_observations) + " "), (_vm.task.response_observations) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.task.response_path) ? _vm._l((_vm.task.response_path.split(',')), function(taskResponsePath) {
    return _c('a', {
      staticClass: "text-blue-500",
      attrs: {
        "href": taskResponsePath,
        "target": "_blank"
      }
    }, [_vm._v("\n                    Ver archivo aquí\n                    "), _c('span', {
      staticClass: "text-gray-500"
    }, [_vm._v(",")])])
  }) : _vm._e()], 2)]), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr', {
    staticClass: "mb-2"
  }), _vm._v(" "), _vm._l((_vm.versions), function(version, index) {
    return _c('div', {
      key: version.id,
      staticClass: "bg-gray-100 rounded-md mb-2 p-2"
    }, [_c('p', {
      staticClass: "mb-2"
    }, [_vm._v("\n                " + _vm._s(version.campaign_attribute.project_name) + " -\n                " + _vm._s(version.campaign_attribute.project_account_name) + " -\n                " + _vm._s(version.campaign_attribute.project_account_country_prefix) + " -\n                " + _vm._s(version.campaign_attribute.name) + " -\n                " + _vm._s(("Versión " + (index + 1))) + "\n              ")]), _vm._v(" "), _c('p', {
      staticClass: "mb-2"
    }, [_c('b', [_vm._v("Creada el día:")]), _vm._v(" " + _vm._s(version.created_at) + "\n                "), _c('b', [_vm._v("por")]), _vm._v(" " + _vm._s(version.user_created_name) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "mb-2"
    }, [_vm._v("\n                " + _vm._s(version.description) + " "), _c('br'), _vm._v(" "), (version.path) ? _vm._l((version.path.split(',')), function(taskPath) {
      return _c('a', {
        staticClass: "text-blue-500",
        attrs: {
          "href": taskPath,
          "target": "_blank"
        }
      }, [_vm._v("\n                    Ver archivo aquí\n                    "), _c('span', {
        staticClass: "text-gray-500"
      }, [_vm._v(",")])])
    }) : _vm._e()], 2), _vm._v(" "), _c('p', {
      staticClass: "mb-2"
    }, [_vm._v("\n                La tarea fue realizada por "), _c('b', [_vm._v(_vm._s(version.user_name))]), _vm._v(" en un total\n                de "), _c('b', [_vm._v(_vm._s(version.hours))]), _vm._v(" hora(s)\n              ")]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('p', {
      staticClass: "mb-2"
    }, [_vm._v("\n                " + _vm._s(version.response_observations) + " "), (version.response_observations) ? _c('br') : _vm._e(), _vm._v(" "), (version.response_path) ? _vm._l((version.response_path.split(',')), function(taskResponsePath) {
      return _c('a', {
        staticClass: "text-blue-500",
        attrs: {
          "href": taskResponsePath,
          "target": "_blank"
        }
      }, [_vm._v("\n                    Ver archivo aquí\n                    "), _c('span', {
        staticClass: "text-gray-500"
      }, [_vm._v(",")])])
    }) : _vm._e()], 2)])
  })], 2)])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-2"
  }, [_c('b', [_vm._v("Respuesta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-2 text-center text-blue-800"
  }, [_c('b', [_vm._v("Versiones")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-2"
  }, [_c('b', [_vm._v("Respuesta")])])
}]}

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid grid-cols-12"
  }, [_c('div', {
    staticClass: "col-span-12 intro-y"
  }, [(!_vm.all) ? _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.changeReport(true)
      }
    }
  }, [_vm._v("\n      Ver " + _vm._s(_vm.team_session == 1 ? 'todos los proyectos' : 'todas las cuenta') + "\n    ")]) : _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.changeReport(false)
      }
    }
  }, [_vm._v("\n      Ver solo " + _vm._s(_vm.team_session == 1 ? 'un proyecto' : 'una cuenta') + "\n    ")])]), _vm._v(" "), (!_vm.all) ? _c('TasksMonthsAccount') : _c('TasksAccounts')], 1)
},staticRenderFns: []}

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "Modal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--md",
    attrs: {
      "id": "ModalContent"
    }
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            " + _vm._s(_vm.socialreason.name) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "overflow-x-auto"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(!_vm.socialreason.trm_change.length) ? _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No hay Elementos seleccionados")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.socialreason.trm_change), function(item, index) {
    return _c('tr', {
      key: ("" + item + index + "-budget-item"),
      staticClass: "border-b dark:border-dark-5"
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.socialreason.money_code) + "\n                  ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', [_vm._v("\n                    " + _vm._s(item.change) + "\n                  ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', [_vm._v("\n                    " + _vm._s(item.month) + "\n                  ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', [_vm._v("\n                    " + _vm._s(item.year) + "\n                  ")])])])
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "border-b dark:border-dark-5"
  }, [_c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("MONEDA")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("1 DOLAR EQUIVALE A")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("MES")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("AÑO")])])])
}]}

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "Modal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [(_vm.email) ? _c('div', {
    staticClass: "modal__content modal__content--md",
    attrs: {
      "id": "ModalContent"
    }
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            " + _vm._s(_vm.email.name) + " "), _c('app-title-custom')], 1), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "intro-y box py-5"
  }, [_c('div', {
    staticClass: "wizard flex flex-col px-5"
  }, [_c('div', {
    staticClass: "bg-gray-200 p-2 rounded-md"
  }, [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v("\n              " + _vm._s(_vm.email.campaign_attribute.project_name) + " -\n              " + _vm._s(_vm.email.campaign_attribute.project_account_name) + " -\n              " + _vm._s(_vm.email.campaign_attribute.project_account_country_prefix) + " -\n              " + _vm._s(_vm.email.campaign_attribute.name) + "\n            ")]), _vm._v(" "), (_vm.email.hours) ? _c('p', {
    staticClass: "mb-2"
  }, [_c('b', [_vm._v("HORAS:")]), _vm._v(" " + _vm._s(_vm.email.hours) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_c('b', [_vm._v("Creada el día:")]), _vm._v(" " + _vm._s(_vm.email.created_at) + "\n              "), _c('b', [_vm._v("por")]), _vm._v(" " + _vm._s(_vm.email.user_created_name) + "\n              "), (_vm.email.path) ? _c('a', {
    staticClass: "text-blue-500",
    attrs: {
      "href": _vm.email.path,
      "target": "_blank"
    }
  }, [_vm._v("Ver archivo aquí")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v("\n              La tarea fue realizada por "), _c('b', [_vm._v(_vm._s(_vm.email.user_name))])]), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v("\n              " + _vm._s(_vm.email.response_observations) + " "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.email.date))]), _vm._v(" "), (_vm.email.response_path) ? _c('a', {
    staticClass: "text-blue-500",
    attrs: {
      "href": _vm.email.response_path,
      "target": "_blank"
    }
  }, [_vm._v("\n                Ver archivo aquí\n              ")]) : _vm._e()])]), _vm._v(" "), _c('hr', {
    staticClass: "my-3"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.versions), function(version) {
    return (version.email_id == _vm.email.id) ? _c('div', {
      staticClass: "bg-gray-100 rounded-md mb-2 p-2"
    }, [_vm._v("\n            " + _vm._s(version.observations) + " "), _c('br'), _vm._v("\n            " + _vm._s(version.created_at) + "\n            "), (version.path) ? _c('a', {
      staticClass: "text-blue-500",
      attrs: {
        "href": version.path,
        "target": "_blank"
      }
    }, [_vm._v("Ver archivo aquí")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Respuesta")]), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(version.response_observations) + " "), _c('br'), _vm._v("\n            " + _vm._s(version.updated_at) + "\n            "), (version.response_path) ? _c('a', {
      staticClass: "text-blue-500",
      attrs: {
        "href": version.response_path,
        "target": "_blank"
      }
    }, [_vm._v("Ver archivo aquí")]) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e()
  })], 2)])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-2"
  }, [_c('b', [_vm._v("Respuesta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-2"
  }, [_c('b', [_vm._v("Versiones")])])
}]}

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Cargar Puntos"
    },
    on: {
      "close": _vm.emitClose
    }
  }, [(_vm.errors.length) ? _c('div', [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12"
  }, _vm._l((_vm.errors), function(error) {
    return _c('div', {
      key: ("error-" + error),
      staticClass: "bg-red-800 border border-red-600 rounded p-3 text-white",
      attrs: {
        "role": "alert"
      }
    }, _vm._l((error), function(singleError) {
      return _c('div', {
        key: ("singleError-" + singleError)
      }, [_vm._v("\n            - " + _vm._s(singleError) + "\n          ")])
    }), 0)
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createActivity.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('label', [_vm._v("Archivo: (\n        "), _c('a', {
    staticClass: "text-blue-500 underline",
    attrs: {
      "href": "/v1/files/formats/upload-users-points-format.xlsx"
    }
  }, [_vm._v("Descargar formato")]), _vm._v("\n        )\n      ")]), _vm._v(" "), _c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col mt-2 my-auto w-full"
  }, [(_vm.pointsUploader.file) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pointsUploader.fileName),
      expression: "pointsUploader.fileName"
    }],
    staticClass: "input w-full border",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.pointsUploader.fileName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pointsUploader, "fileName", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "button bg-theme-10 text-white button-sm",
    attrs: {
      "for": "file"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cargar Archivo\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('label', [_vm._v("Datos de las columnas:")]), _vm._v(" "), _c('div', {
    staticClass: "input w-full border mt-2"
  }, [_vm._v("\n        Evento: nombre del evento "), _c('br'), _vm._v("\n        Correo usuario: correo electrónico del usuario "), _c('br'), _vm._v("\n        Puntos: Numero de puntos (Numero entero, sin simbolos) "), _c('br'), _vm._v("\n        Tipo: 1 para Actividades 2 para Custom "), _c('br'), _vm._v("\n        Mes: Numero del mes (1 a 12) "), _c('br'), _vm._v("\n        Año: Numero del año "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.emitClose
    }
  }, [_vm._v("\n        Cancelar\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "edit"
    }
  }, [_vm._v("\n        Cargar Puntos\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-5"
  }, [_c('div', {
    staticClass: "intro-y col-span-12 lg:col-span-12"
  }, [_c('div', {
    staticClass: "intro-y box"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "p-5 grid grid-cols-12 gap-2",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.putProject.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.name
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('name', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.project.account_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('account_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                      " + _vm._s(account.name) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4 mt-3"
  }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.project.user_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('user_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                      " + _vm._s(user.name) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4 mt-3"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.project.status
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('status', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Activo")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4 mt-3"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Horas (Digital)")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.project.hours
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('hours', $event)
      }
    }
  })]), _vm._v(" "), _vm._m(1)])])])])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Editar Proyecto\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 mt-3"
  }, [_c('button', {
    staticClass: "button w-24 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "edit"
    }
  }, [_vm._v("\n                  Modificar\n                ")])])
}]}

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('AppLoading') : _c('div', [_c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-5"
  }, [_c('div', {
    staticClass: "intro-y col-span-12 lg:col-span-12"
  }, [_c('div', {
    staticClass: "intro-y box"
  }, [_c('div', {
    staticClass: "flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto w-full"
  }, [(_vm.existSlug) ? [(_vm.isShow) ? [_vm._v("Detalle Actividad")] : [_c('div', {
    staticClass: "flex justify-between"
  }, [_c('div', [_vm._v("Editar Preguntas | " + _vm._s(_vm.activity.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.activity.type))])])]] : [_vm._v("Crear Actividad")]], 2)]), _vm._v(" "), (!_vm.existSlug || _vm.isShow) ? _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createActivity.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.name),
      expression: "activity.name"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text",
      "disabled": _vm.checked,
      "maxlength": "60"
    },
    domProps: {
      "value": (_vm.activity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Imagen "), _c('span', {
    staticClass: "text-blue-700"
  }, [_vm._v("(460px x 400px, 1MB Max)")]), _vm._v(" "), (_vm.activity.image != null) ? _c('a', {
    staticClass: "text-blue-600 underline",
    attrs: {
      "href": _vm.activity.image,
      "target": "_blank"
    }
  }, [_vm._v("ver actual")]) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": "image/png, image/jpeg, image/jpg, image/gif, image/svg"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex mt-2 my-auto w-full"
  }, [(_vm.activity.image) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.image.name),
      expression: "activity.image.name"
    }],
    staticClass: "input w-2/3 border",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.activity.image.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.image, "name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "button bg-theme-10 text-white button-sm w-1/3",
    attrs: {
      "for": "file"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cargar Imagen\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.description),
      expression: "activity.description"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "disabled": _vm.checked
    },
    domProps: {
      "value": (_vm.activity.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Fecha inicio")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.start_date),
      expression: "activity.start_date"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "date",
      "disabled": _vm.checked
    },
    domProps: {
      "value": (_vm.activity.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "start_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Fecha final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.end_date),
      expression: "activity.end_date"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "date",
      "disabled": _vm.checked
    },
    domProps: {
      "value": (_vm.activity.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "end_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 md:col-span-4"
  }, [_c('label', [_vm._v("Tipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.type),
      expression: "activity.type"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "disabled": _vm.checked
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activity, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeType($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione ...")]), _vm._v(" "), _vm._l((_vm.activityTypes), function(activityType) {
    return _c('option', {
      key: (activityType + "-activityType"),
      domProps: {
        "value": activityType
      }
    }, [_vm._v("\n                  " + _vm._s(activityType) + "\n                ")])
  })], 2)]), _vm._v(" "), (_vm.type_content) ? _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 md:col-span-4"
  }, [_c('label', [_vm._v("Tipo Contenido")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.type_content),
      expression: "activity.type_content"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "disabled": _vm.checked
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activity, "type_content", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione ...")]), _vm._v(" "), _vm._l((_vm.activityTypeContents), function(activityTypeContent) {
    return _c('option', {
      key: (activityTypeContent + "-activityTypeContent"),
      domProps: {
        "value": activityTypeContent
      }
    }, [_vm._v("\n                  " + _vm._s(activityTypeContent) + "\n                ")])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Puntos de 90% a 100% correcto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.points_high_correct),
      expression: "activity.points_high_correct"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "number",
      "disabled": _vm.checked
    },
    domProps: {
      "value": (_vm.activity.points_high_correct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "points_high_correct", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.percentage_80) ? _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Puntos de 80% a 90% correcto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.points_medium_correct),
      expression: "activity.points_medium_correct"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "number",
      "disabled": _vm.checked
    },
    domProps: {
      "value": (_vm.activity.points_medium_correct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "points_medium_correct", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.percentage_70) ? _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Puntos de 70% a 80% correcto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.points_under_correct),
      expression: "activity.points_under_correct"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "number",
      "disabled": _vm.checked
    },
    domProps: {
      "value": (_vm.activity.points_under_correct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "points_under_correct", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 md:col-span-4"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.status),
      expression: "activity.status"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "disabled": _vm.checked
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activity, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Activa")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Inactiva")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Material de estudio "), _c('span', {
    staticClass: "text-blue-700"
  }, [_vm._v("(PDF, 5MB Max)")]), _vm._v(" "), (_vm.activity.study_information !== null) ? _c('a', {
    staticClass: "text-blue-600 underline",
    attrs: {
      "href": _vm.activity.study_information,
      "target": "_blank"
    }
  }, [_vm._v("ver actual")]) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "study_information"
    },
    on: {
      "change": _vm.onStudyActivityFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex mt-2 my-auto w-full"
  }, [(_vm.activity.study_information) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.study_information.name),
      expression: "activity.study_information.name"
    }],
    staticClass: "input w-2/3 border",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.activity.study_information.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity.study_information, "name", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "button bg-theme-10 text-white button-sm",
    attrs: {
      "for": "study_information"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cargar Material de estudio\n                ")])])]), _vm._v(" "), (!_vm.existSlug) ? [(_vm.checked) ? _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createBudget()
      }
    }
  }, [_vm._v("\n                  Confirmar Actividad\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-11 text-white mt-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.checked = false
      }
    }
  }, [_vm._v("\n                  Editar Actividad\n                ")])]) : _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  Crear Actividad\n                ")])])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.existSlug && _vm.activity.type != 'Extra') ? _c('ActivityQuestionsComponent', {
    attrs: {
      "activity": _vm.activity
    }
  }) : _vm._e()], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "col-span-12 intro-y"
  }, [_c('div', [(_vm.series.length > 0) ? _c('div', {
    staticClass: "my-2"
  }, [(_vm.start_date) ? _c('div', {
    staticClass: "flex flex-row justify-between mb-2"
  }, [_c('p', {
    staticClass: "mt-2"
  }, [_vm._v("\n          Reporte de horas por\n          " + _vm._s(_vm.team_session == 1 ? 'proyecto' : 'cuenta') + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "border rounded p-2"
  }, [_vm._v(_vm._s(_vm.start_date) + " a " + _vm._s(_vm.end_date))])]) : _vm._e(), _vm._v(" "), _c('VueApexCharts', {
    attrs: {
      "width": "100%",
      "type": "bar",
      "options": _vm.options,
      "series": _vm.series
    }
  })], 1) : _vm._e()])]) : _c('div', {
    staticClass: "col-span-12 intro-y"
  }, [_c('Loading')], 1)
},staticRenderFns: []}

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.tasks), function(task) {
    return _c('tr', {
      staticClass: "intro-x"
    }, [_c('td', [_c('div', {
      staticClass: "font-medium whitespace-no-wrap"
    }, [_vm._v(_vm._s(task.user_created_name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(task.total))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.finishTasks(task.user_created.id)
        }
      }
    }, [_vm._v("\n                  Finalizar todas\n                ")])])])
  }), 0)])])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("# TAREAS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
}]}

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "Modal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--md",
    attrs: {
      "id": "ModalContent"
    }
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n        " + _vm._s(_vm.socialreason.name) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "p-5 bg-yellow-500 text-yellow-100",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.confirmation) ? _c('form', {
    staticClass: "form-task",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.confirmation = true
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Moneda cambio")]), _vm._v(" "), _c('div', {
    staticClass: "input w-full border mt-2 flex-1"
  }, [_vm._v("\n            " + _vm._s(_vm.socialreason.money) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("1 dólar es igual a:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.change.change),
      expression: "change.change"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "step": ".01",
      "required": ""
    },
    domProps: {
      "value": (_vm.change.change)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.change, "change", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Seleccionar mes:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.change.month),
      expression: "change.month"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.change, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccionar...")]), _vm._v(" "), _vm._l((12), function(index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v("\n              " + _vm._s(index) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Seleccionar año:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.change.year),
      expression: "change.year"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.change, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccionar...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2026"
    }
  }, [_vm._v("2026")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2027"
    }
  }, [_vm._v("2027")])])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_vm._v("\n          Cancelar\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Actualizar\n        ")])])]) : _c('div', [_c('div', {
    staticClass: "p-6"
  }, [_vm._v("\n        Está seguro de guardar el TRM de este mes donde un Dólar $1 equivale a\n        " + _vm._s(_vm.change.change) + " " + _vm._s(_vm.socialreason.money) + " ?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.confirmation = false
      }
    }
  }, [_vm._v("\n          Cancelar\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updateTrmChange()
      }
    }
  }, [_vm._v("\n          Confirmar\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Moneda")]), _vm._v(" "), _c('div', {
    staticClass: "input w-full border mt-2 flex-1"
  }, [_vm._v("USD - $1")])])
}]}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "admin"
  }, [_c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "mobile-menu md:hidden"
  }, [_c('div', {
    staticClass: "mobile-menu-bar"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.menuMobile
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "bars",
      "classname": "w-8 h-8 text-white transform -rotate-90"
    }
  })], 1)]), _vm._v(" "), (!_vm.openmenu) ? _c('ul', {
    staticClass: "border-t border-theme-29 py-5 d-block"
  }, [_c('app-side-bar', {
    attrs: {
      "classname": "menu"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('nav', {
    staticClass: "side-nav"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "side-nav__devider my-6"
  }), _vm._v(" "), _c('app-side-bar', {
    attrs: {
      "classname": "side-menu"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('app-top'), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-8"
  }, [_c('div', {
    staticClass: "col-span-12"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n              Administrativo\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "intro-y box p-5 mt-6"
  }, [_c('div', {
    staticClass: "mt-1 grid grid-cols-5 gap-6"
  }, [_c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: _vm.subIsActive('/admin/business/budgets') ?
      'bg-theme-1 text-white font-medium' :
      'bg-theme-2',
    attrs: {
      "to": "/admin/business/budgets"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "briefcase",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n                  Presupuestos\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: _vm.subIsActive('/admin/business/clients') ?
      'bg-theme-1 text-white font-medium' :
      'bg-theme-2',
    attrs: {
      "to": "/admin/business/clients"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "file",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v(" Clientes\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: _vm.subIsActive('/admin/business/suppliers') ?
      'bg-theme-1 text-white font-medium' :
      'bg-theme-2',
    attrs: {
      "to": "/admin/business/suppliers"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "grid",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n                  Proveedores\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: _vm.subIsActive('/admin/business/social-reasons') ?
      'bg-theme-1 text-white font-medium' :
      'bg-theme-2',
    attrs: {
      "to": "/admin/business/social-reasons"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "briefcase",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n                  Razones Sociales\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: _vm.subIsActive('/admin/business/campaigns') ?
      'bg-theme-1 text-white font-medium' :
      'bg-theme-2',
    attrs: {
      "to": "/admin/business/campaigns"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "file",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v(" Campañas\n                ")], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12"
  }, [_c('router-view')], 1)])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "flex mr-auto",
    attrs: {
      "href": ""
    }
  }, [_c('img', {
    staticClass: "w-6",
    attrs: {
      "alt": "My Inxait",
      "src": "/static/images/logo.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "intro-x flex items-center pl-5 pt-4",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "w-32 xl:block",
    attrs: {
      "alt": "Logo",
      "src": "/static/images/LOGO-WHITE-2026.png"
    }
  })])
}]}

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [(this.$route.path !== '/admin/pendings-tasks') ? _c('HoursTasksComponent', {
    attrs: {
      "team_session": _vm.team_session,
      "account_session": _vm.account_session
    }
  }) : _vm._e(), _vm._v(" "), (_vm.boxedit && _vm.task_current) ? _c('TaskEditModal', {
    attrs: {
      "users": _vm.users,
      "states": _vm.states,
      "defineQuery": _vm.defineQuery,
      "usersession": _vm.usersession,
      "team_session": _vm.team_session,
      "task_current": _vm.task_current
    },
    on: {
      "taskEdited": _vm.taskEdited,
      "closeEditTask": function($event) {
        return _vm.closeEditTask()
      }
    }
  }) : _vm._e(), _vm._v(" "), (this.$route.path !== '/admin/pendings-tasks') ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("\n          Tareas "), (_vm.account_session) ? _c('app-title-custom') : _vm._e(), _vm._v(" (" + _vm._s(_vm.filteredTasks.length) + ")\n        ")], 1), _vm._v(" "), (_vm.tasks_by_finish > 0) ? _c('div', {
    staticClass: "rounded-md flex items-center px-5 py-2 mt-2 mb-2 border cursor-pointer",
    class: [
      _vm.clic_taskspendingauth ?
      'border-theme-1 text-theme-1' :
      'border-theme-6 text-theme-6' ],
    on: {
      "click": function($event) {
        return _vm.taskPendingAuth()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.clic_taskspendingauth ?
    'Ver todas las tareas' :
    ("Ver " + _vm.tasks_by_finish + " tarea(s) pendiente(s) por finalizar.")) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-2 sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": "search",
      "classname": "w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.name),
      expression: "filter.name"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre"
    },
    domProps: {
      "value": (_vm.filter.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter dropdown hidden md:block md:absolute inset-y-0 mr-3 right-0 flex items-center"
  }, [_c('app-icon', {
    attrs: {
      "name": "chevron-down",
      "classname": "dropdown-toggle w-4 h-4 mt-3 cursor-pointer text-gray-700"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box p-5"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.state),
      expression: "filter.state"
    }],
    staticClass: "input w-full border mt-2 flex-13",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione una opción")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return (state.id != 5) ? _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n                        " + _vm._s(state.name) + "\n                      ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Fecha entrega")]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.date),
      expression: "filter.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filter.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Codigo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.slug),
      expression: "filter.slug"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por codigo"
    },
    domProps: {
      "value": (_vm.filter.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "slug", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Creada por")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.created_by),
      expression: "filter.created_by"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "created_by", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Seleccione un usuario")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                        " + _vm._s(user.name) + "\n                      ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.start_date),
      expression: "filter.start_date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filter.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "start_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.end_date),
      expression: "filter.end_date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filter.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "end_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button mt-28 text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        _vm.filter = _vm.clearFilter()
      }
    }
  }, [_vm._v("\n                        Borrar Filtro\n                      ")])])])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "intro-y w-full mt-2 mb-4 flex sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full hidden md:block sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex items-center sm:ml-auto mt-0 sm:mt-0"
  }, [(_vm.account_session) ? _c('button', {
    staticClass: "button button--sm mr-1 mb-1 mt-1",
    class: _vm.completed_tasks ?
      'bg-theme-1 text-white' :
      'border border-theme-1 border-theme-10 text-theme-10',
    on: {
      "click": function($event) {
        return _vm.viewTaskFinish()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.completed_tasks ?
    'Quitar tareas finalizadas' :
    'Ver tareas finalizadas') + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        return _vm.setCreateTaskModal(true)
      }
    }
  }, [_vm._v("\n              Crear tarea\n            ")])])])])]) : _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-10 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("\n        Tareas Pendientes\n        "), (_vm.account_session) ? _c('app-title-custom') : _vm._e(), _vm._v("\n        (" + _vm._s(_vm.filteredTasks.length) + ")\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex items-center sm:ml-auto mt-0 sm:mt-0"
  }, [(_vm.account_session) ? _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.viewAccounts('all')
      }
    }
  }, [_vm._v("\n          Ver todas las cuentas\n        ")]) : _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.viewAccounts('one')
      }
    }
  }, [_vm._v("\n          Ver solo una cuenta\n        ")]), _vm._v(" "), (_vm.usersession.team_id == 1) ? _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.removeSupport()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.filter.support ? 'Quitar' : 'Agregar') + " Tareas de Soporte\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.assignedToMe()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.filter.assigned_to_me ?
    'Ver todas las tareas' :
    'Ver mis asignadas') + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredTasks), function(task) {
    return _c('tr', {
      staticClass: "intro-x zindex-0"
    }, [_c('td', [_c('a', {
      staticClass: "font-medium whitespace-no-wrap flex",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          task.campaign_attribute.project_account_id ==
            _vm.auth_session_account ?
            _vm.editTask(task) :
            _vm.viewAccountTask(task)
        }
      }
    }, [(task.path) ? _c('app-icon', {
      attrs: {
        "name": "link",
        "classname": "w-4 h-3 mt-1 mr-1"
      }
    }) : _vm._e(), _vm._v("\n                " + _vm._s(_vm._f("limit")(task.name.toUpperCase())) + "\n              ")], 1), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.slug) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.created_at) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center w-40"
    }, [_c('div', {
      staticClass: "text-center text-xs",
      class: [
        task.campaign_attribute.project_hours > 1 &&
        task.team_id == 1 ?
        'text-theme-1 font-bold' :
        '' ]
    }, [_vm._v("\n                " + _vm._s(task.campaign_attribute.project_name) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-center text-xs"
    }, [_vm._v("\n                " + _vm._s(task.campaign_attribute.project_account_name) + " -\n                " + _vm._s(task.campaign_attribute.project_account_country_prefix) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.campaign_attribute.name) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40"
    }, [_c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._l((_vm.users), function(user) {
      return [(task.created_by === user.id) ? _c('div', {
        key: ("user-created_by-" + (user.id)),
        staticClass: "w-10 h-10 image-fit zoom-in"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": task.user_created_name,
          "src": user.avatar ?
            user.avatar :
            "/static/images/profile.png",
          "title": task.user_created_name
        }
      })]) : _vm._e()]
    }), _vm._v(" "), _vm._l((_vm.users), function(user) {
      return [(task.user_id === user.id) ? _c('div', {
        key: ("user-user_id-" + (user.id)),
        staticClass: "w-10 h-10 image-fit zoom-in -ml-5"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": task.user_name,
          "src": user.avatar ?
            user.avatar :
            "/static/images/profile.png",
          "title": task.user_name
        }
      })]) : _vm._e()]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._v("\n                " + _vm._s(task.state_name) + " - " + _vm._s(task.hours) + "hs\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "button button--sm w-24 text-white",
      class: _vm.dateClass(task)
    }, [_vm._v("\n                " + _vm._s(task.date) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action"
    }, [(
      task.campaign_attribute.project_account_id ==
      _vm.auth_session_account
    ) ? _c('div', {
      staticClass: "flex justify-center items-center"
    }, [(task.state_id != 4) ? _c('a', {
      staticClass: "cursor-pointer flex items-center mr-3",
      on: {
        "click": function($event) {
          return _vm.editTask(task)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v(" Editar\n                ")], 1) : _c('a', {
      staticClass: "cursor-pointer flex items-center mr-3",
      on: {
        "click": function($event) {
          return _vm.viewTask(task)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "eye",
        "classname": "w-5 h-5 mr-2"
      }
    }), _vm._v(" Ver\n                ")], 1), _vm._v(" "), _c('a', {
      staticClass: "cursor-pointer flex items-center mr-3",
      on: {
        "click": function($event) {
          return _vm.createDuplicateModal(task)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "duplicate",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("\n                  Duplicar\n                ")], 1)]) : _c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('a', {
      staticClass: "cursor-pointer flex items-center mr-3",
      on: {
        "click": function($event) {
          return _vm.viewAccountTask(task)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v(" Editar\n                ")], 1)])])])
  }), 0)])])], 1) : _c('app-loading'), _vm._v(" "), (_vm.createTaskModal) ? _c('CreateTaskModal', {
    attrs: {
      "task": _vm.task,
      "options": _vm.options,
      "defineQuery": _vm.defineQuery,
      "team_session": _vm.team_session
    },
    on: {
      "addTag": _vm.addTag,
      "closeModal": function($event) {
        return _vm.setCreateTaskModal(false)
      },
      "taskCreated": function($event) {
        return _vm.taskCreated()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDuplicateModal) ? _c('DuplicateTaskComponent', {
    attrs: {
      "task": _vm.task_duplicate
    },
    on: {
      "clearDuplicateTask": function($event) {
        _vm.showDuplicateModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.task_view) ? _c('ViewTaskModal', {
    attrs: {
      "task": _vm.task_view
    },
    on: {
      "closeModal": function($event) {
        _vm.task_view = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-xs"
  }, [_vm._v("\n                      Desde "), _c('span', [_vm._v("(Fecha creación)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-xs"
  }, [_vm._v("\n                      Hasta "), _c('span', [_vm._v("(Fecha creación)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PROYECTO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ESTADO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("FECHA ENTREGA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
}]}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y flex mb-4 flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": 'search',
      "classname": 'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.name),
      expression: "filter.name"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre"
    },
    domProps: {
      "value": (_vm.filter.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
  }, [_c('app-icon', {
    attrs: {
      "name": 'chevron-down',
      "classname": 'dropdown-toggle w-4 h-4 cursor-pointer text-gray-700'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box p-5"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.account),
      expression: "filter.account"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "account", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: account.id,
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                      " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n                    ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.status),
      expression: "filter.status"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Activo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Horas")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.hours),
      expression: "filter.hours"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "hours", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione una opción")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Sin horas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1 Hora")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("+1 Hora")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")])])])])])])], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('h1', {
    staticClass: "mb-2 text-lg font-bold"
  }, [_vm._v("\n      Proyectos (" + _vm._s(_vm.filteredProjects.length) + ")\n    ")]), _vm._v(" "), _vm._l((_vm.filteredProjects), function(project) {
    return _c('div', {
      key: project.id,
      staticClass: "intro-y col-span-6 sm:col-span-4 md:col-span-3 xxl:col-span-2"
    }, [_c('div', {
      staticClass: "bg-white mb-1 flex justify-between rounded-md py-3 px-5 sm:px-10 relative zoom-in"
    }, [_c('div', {
      staticClass: "w-1/3 block font-medium ext-center truncate"
    }, [_vm._v("\n          " + _vm._s(project.name) + "(" + _vm._s(project.hours) + ")\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs text-center"
    }, [_vm._v("\n          " + _vm._s(project.account.name) + " - " + _vm._s(project.account.country.prefix) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "file__icon__file-name"
    }, [_vm._v("\n          " + _vm._s(project.status === 0 ? 'Inactivo' : 'Activo') + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "absolute top-0 right-0 mr-2 mt-2 dropdown ml-auto"
    }, [_c('a', {
      staticClass: "dropdown-toggle w-5 h-5 block",
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'more-vertical',
        "classname": 'w-5 h-5 text-gray-500'
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "dropdown-box mt-5 absolute w-40 top-0 right-0 z-10"
    }, [_c('div', {
      staticClass: "dropdown-box__content box p-2"
    }, [_c('router-link', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      attrs: {
        "to": '/admin/traffic/project/' + project.id
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v("\n                Editar\n              ")], 1), _vm._v(" "), _c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.removeProject(project)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'trash',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v("\n                Eliminar\n              ")], 1)], 1)])])])])
  })], 2) : _c('app-loading'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "project"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--sm"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createProject.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.name),
      expression: "project.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.project.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.account_id),
      expression: "project.account_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: account.id,
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.user_id),
      expression: "project.user_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.project, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return (user.roles[0].id >= 3) ? _c('option', {
      key: user.id,
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                " + _vm._s(user.name) + "\n              ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Horas (Digital)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.hours),
      expression: "project.hours"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.project.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.project, "hours", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(2)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#project",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Proyecto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Proyecto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n            Crear\n          ")])])
}]}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [(_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateCampaign.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.campaign.name
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('name', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.campaign.project_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('project_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el proyecto")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.campaign.status
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('status', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Activo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditCampaign()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Modificar")])])])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("\n        Campañas\n    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5"
  }, _vm._l((_vm.campaigns), function(campaign) {
    return _c('div', {
      staticClass: "intro-y col-span-12 md:col-span-6"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "flex flex-col lg:flex-row items-center p-5"
    }, [_c('div', {
      staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(campaign.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v(_vm._s(campaign.status === 0 ? 'Inactivo' : 'Activo') + " - " + _vm._s(campaign.project.name))])]), _vm._v(" "), _c('div', {
      staticClass: "flex mt-4 lg:mt-0"
    }, [_c('button', {
      staticClass: "button button--sm text-white bg-theme-1 mr-2",
      on: {
        "click": function($event) {
          return _vm.editCampaign(campaign)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4'
      }
    })], 1), _vm._v(" "), _c('button', {
      staticClass: "button button--sm text-gray-700 border border-gray-300",
      on: {
        "click": function($event) {
          return _vm.removeCampaign(campaign)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'trash',
        "classname": 'w-4 h-4'
      }
    })], 1)])])])])
  }), 0)]) : _c('div', [_c('app-loading')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "campaign"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--sm"
  }, [_vm._m(2), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createCampaign.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.name),
      expression: "campaign.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.campaign.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.project_id),
      expression: "campaign.project_id"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el proyecto")]), _vm._v(" "), _vm._l((_vm.filteredProjects), function(project) {
    return _c('option', {
      key: ("campaign-" + (project.id)),
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + "\n                ")])
  })], 2)])]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Editar Campaña\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y mt-6 flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#campaign",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Campaña")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Crear Campaña\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Crear")])])
}]}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.$route.path
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "intro-y box p-2 bg-white border border-theme-1 mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createTask.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.task),
      expression: "task_current.task"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.task_current.task)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current, "task", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Asignado a")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.user.name),
      expression: "task_current.user.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.task_current.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current.user, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Fecha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.date),
      expression: "task_current.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.task_current.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.account.name),
      expression: "task_current.account.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.task_current.account.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current.account, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.project_id),
      expression: "form.project_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredProjects), function(project) {
    return _c('option', {
      key: ("create-task-project-" + (project.id)),
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n              " + _vm._s(project.name) + " - " + _vm._s(project.account.prefix) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.campaign_id),
      expression: "form.campaign_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "campaign_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      key: ("create-task-campaign-" + (campaign.id)),
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n              " + _vm._s(campaign.name) + " - " + _vm._s(campaign.project.name) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('MultiSelect', {
    staticClass: "mt-2",
    attrs: {
      "options": _vm.options,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.form.path),
      callback: function($$v) {
        _vm.$set(_vm.form, "path", $$v)
      },
      expression: "form.path"
    }
  })], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_vm._v("\n          Cancelar\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    class: _vm.createButtonLoading ? 'cursor-not-allowed opacity-50' : '',
    attrs: {
      "type": "submit",
      "disabled": _vm.createButtonLoading
    }
  }, [_vm._v("\n          " + _vm._s(_vm.createButtonLoading ? 'Creando...' : 'Crear') + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Tarea")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
  }, [_c('div', {
    staticClass: "rounded-md items-center px-5 py-4 mb-2 border border-theme-1 text-theme-1"
  }, [_c('b', [_vm._v("Nota:")]), _vm._v(" Recuerda compartir la carpeta o archivo a las\n            personas involucradas.\n          ")])])
}]}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal modal-special",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--lg"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [(!_vm.task_validated) ? [_vm._v("Crear Tarea")] : [_vm._v("Confirmar Tarea")], _vm._v(" "), _c('br'), _vm._v(" "), _c('AppTitleCustom')], 2)]), _vm._v(" "), _c('form', {
    staticClass: "form-task",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createTask.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.name),
      expression: "task.name"
    }],
    class: ("input w-full border mt-2 flex-1 " + (_vm.task_validated && 'border-theme-12')),
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.task_validated
    },
    domProps: {
      "value": (_vm.task.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.description),
      expression: "task.description"
    }],
    staticClass: "input w-full border mt-2",
    class: {
      'border-theme-12': _vm.task_validated
    },
    attrs: {
      "rows": "3",
      "disabled": _vm.task_validated
    },
    domProps: {
      "value": (_vm.task.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
  }, [_c('div', {
    staticClass: "rounded-md items-center px-5 py-4 mb-2 border border-theme-1 text-theme-1"
  }, [_c('b', [_vm._v("Nota:")]), _vm._v(" Proporciona una descripción completa y clara de\n                lo que necesitas.\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Fecha de entrega")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.date),
      expression: "task.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    class: {
      'border-theme-12': _vm.task_validated
    },
    attrs: {
      "type": "date",
      "required": "",
      "disabled": _vm.task_validated
    },
    domProps: {
      "value": (_vm.task.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.project_id),
      expression: "task.project_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    class: {
      'border-theme-12': _vm.task_validated
    },
    attrs: {
      "required": "",
      "disabled": _vm.task_validated
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredProjects), function(project) {
    return _c('option', {
      key: ("create-task-project-" + (project.id)),
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + " - " + _vm._s(project.account.prefix) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.campaign_id),
      expression: "task.campaign_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    class: {
      'border-theme-12': _vm.task_validated
    },
    attrs: {
      "required": "",
      "disabled": _vm.task_validated
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "campaign_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      key: ("create-task-campaign-" + (campaign.id)),
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n                  " + _vm._s(campaign.name) + " - " + _vm._s(campaign.project.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('MultiSelect', {
    staticClass: "mt-2",
    class: {
      'border-theme-12 border': _vm.task_validated
    },
    attrs: {
      "options": _vm.options,
      "multiple": true,
      "taggable": true,
      "disabled": _vm.task_validated
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.task.path),
      callback: function($$v) {
        _vm.$set(_vm.task, "path", $$v)
      },
      expression: "task.path"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
  }, [_c('div', {
    staticClass: "rounded-md items-center px-5 py-4 mb-2 border border-theme-1 text-theme-1"
  }, [_c('b', [_vm._v("Nota:")]), _vm._v(" Recuerda compartir la carpeta o archivo a las\n                personas involucradas.\n              ")])]), _vm._v(" "), (_vm.task_loading < 11 && 0 < _vm.task_loading) ? _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('p', {
    staticClass: "text-theme-1 font-extrabold block"
  }, [_vm._v("\n                El botón se activara en " + _vm._s(_vm.task_loading) + " segundos, mientras\n                verificas la información.\n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.task_validated),
      expression: "!task_validated"
    }],
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n              Verificar Tarea\n            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.task_validated),
      expression: "task_validated"
    }],
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('a', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.task_validated = !_vm.task_validated
      }
    }
  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "disabled": _vm.taskButtonLoading
    }
  }, [(_vm.taskButtonLoading) ? [_vm._v("\n                Verificando Tarea...\n              ")] : [_vm._v(" Confirmar Tarea ")]], 2)])])])])])])
},staticRenderFns: []}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('app-loading') : _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  })]), _vm._v(" "), _c('div', {
    staticClass: "intro-y col-span-12 overflow-auto lg:overflow-visible"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("CORREO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("EQUIPO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-nowrap"
  }, [_vm._v("ACTIVIDAD")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-nowrap"
  }, [_vm._v("ACCIONES")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "intro-x"
  }, [_c('td', {
    staticClass: "Text-center"
  }, [_c('div', {
    staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
  }, [_vm._v("\n                " + _vm._s(_vm.activity.user.name) + "\n              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
  }, [_vm._v("\n                " + _vm._s(_vm.activity.user.email) + "\n              ")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
  }, [_vm._v("\n                " + _vm._s(_vm.activity.user.team ? _vm.activity.user.team.name : '-') + "\n              ")])]), _vm._v(" "), _c('td', {
    staticClass: "w-40"
  }, [_c('div', {
    staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
  }, [_vm._v("\n                " + _vm._s(_vm.activity.activity.name) + "\n              ")])]), _vm._v(" "), _c('td', {
    staticClass: "table-report__action w-56"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('router-link', {
    staticClass: "flex mx-auto items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
    attrs: {
      "to": ("/admin/activities/" + (_vm.activity.activity.slug) + "/participations")
    }
  }, [_vm._v("\n                  Regresar\n                ")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PREGUNTA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("RESPUESTA")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activity.answers), function(answer) {
    return _c('tr', {
      key: ("activity-" + (answer.slug)),
      staticClass: "intro-x"
    }, [_c('td', {
      staticClass: "w-40 text-center"
    }, [(answer.question) ? _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(answer.question.title) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [(answer.question_answer) ? _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap",
      class: answer.is_correct ? 'text-green-400' : 'text-red-400'
    }, [_vm._v("\n                " + _vm._s(answer.question_answer.text_answer) + "\n              ")]) : _vm._e()])])
  }), 0)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "top-bar"
  }, [_vm._m(0), _vm._v(" "), ([2, 3, 4, 5].includes(_vm.user.role)) ? _c('div', {
    staticClass: "intro-x dropdown mr-auto sm:mr-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.session_account_current),
      expression: "session_account_current"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.session_account_current = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeAccount($event)
      }]
    }
  }, _vm._l((_vm.user.accounts), function(account) {
    return _c('option', {
      key: ("account-" + (account.id)),
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n          " + _vm._s(account.name) + " - "), _c('b', [_vm._v(_vm._s(account.prefix))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (
    [2, 3, 4, 5].includes(_vm.user.role) &&
    !['calendar', 'emails', 'campaigns'].includes(_vm.$route.name)
  ) ? _c('div', {
    staticClass: "intro-x dropdown mr-auto sm:mr-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.session_team_current),
      expression: "session_team_current"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.session_team_current = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeTeam($event)
      }]
    }
  }, _vm._l((_vm.filteredTeams), function(team) {
    return _c('option', {
      key: ("team-" + (team.id)),
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n          " + _vm._s(team.name) + "\n        ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro-x dropdown mr-auto sm:mr-2"
  }, [_c('a', {
    staticClass: "dropdown-toggle notification cursor-pointer flex gap-1",
    attrs: {
      "href": "/activities",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "flex mt-1 gap-1 border-theme-1 zoom-in py-1 px-2 text-theme-1 rounded-full border border-white z-50"
  }, [_c('app-icon', {
    attrs: {
      "name": "activities",
      "classname": "notification__icon"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden sm:block"
  }, [_vm._v("Actividades")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "intro-x dropdown mr-auto sm:mr-2"
  }, [_c('a', {
    staticClass: "dropdown-toggle notification cursor-pointer flex gap-1",
    attrs: {
      "href": "/rrhh",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "flex mt-1 gap-1 border-theme-1 text-theme-1 zoom-in py-1 px-2 rounded-full border z-50"
  }, [_c('app-icon', {
    attrs: {
      "name": "newspaper",
      "classname": "notification__icon"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden sm:block"
  }, [_vm._v("Solicitudes")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "intro-x dropdown mr-auto sm:ml-4 sm:mr-2 hidden-xs"
  }, [_c('div', {
    staticClass: "dropdown-toggle notification cursor-pointer",
    class: {
      'notification--bullet': _vm.filteredNotificationsNotViews.length,
    },
    on: {
      "mouseover": function($event) {
        _vm.btn_noti = true
      },
      "mouseleave": function($event) {
        _vm.btn_noti = false
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'bell',
      "classname": 'notification__icon text-theme-1'
    }
  }), _vm._v(" "), (_vm.btn_noti) ? _c('div', {
    staticClass: "fixed bg-theme-1 py-1 px-2 text-white rounded border border-white z-50 -mt-12 -ml-24 mr-2"
  }, [_vm._v("\n          Notificaciones\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "notification-content dropdown-box mt-8 absolute top-0 left-0 sm:left-auto sm:right-0 z-20 -ml-10 sm:ml-0"
  }, [_c('div', {
    staticClass: "notification-content__box dropdown-box__content box"
  }, [_c('div', {
    staticClass: "flex justify-between"
  }, [_c('div', {
    staticClass: "notification-content__title mb-0"
  }, [_vm._v("Notificaciones")]), _vm._v(" "), (_vm.filteredNotificationsNotViews.length > 0) ? _c('div', {
    staticClass: "hover:text-blue-600 hover:underline cursor-pointer text-xs",
    on: {
      "click": function($event) {
        return _vm.readAllNotifications()
      }
    }
  }, [_vm._v("\n              Marcar todas como leidas\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-notifications"
  }, _vm._l((_vm.filteredNotifications), function(notification) {
    return _c('div', {
      key: ("notification-" + (notification.id)),
      staticClass: "border-t-2 flex items-center pt-1 relative"
    }, [_c('div', {
      staticClass: "ml-2 overflow-hidden w-full mb-2"
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [_c('div', {
      staticClass: "text-xs text-gray-500 ml-auto whitespace-no-wrap courser-not"
    }, [_vm._v("\n                    " + _vm._s(notification.created_at) + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "w-full cursor-pointer",
      class: {
        'text-gray-600': notification.view == 1,
        'text-blue-600': notification.view == 0,
      },
      on: {
        "click": function($event) {
          return _vm.updateNotification(notification)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(notification.name) + "\n                ")])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "intro-x dropdown mr-auto sm:ml-2 sm:mr-4 hidden-xs cursor-pointer",
    on: {
      "click": _vm.changeTheme
    }
  }, [_c('app-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDark),
      expression: "isDark"
    }],
    attrs: {
      "name": "sun",
      "classname": "notification__icon text-theme-1"
    }
  }), _vm._v(" "), _c('app-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDark),
      expression: "!isDark"
    }],
    attrs: {
      "name": "moon",
      "classname": "notification__icon text-theme-1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "intro-x dropdown w-8 h-8 relative"
  }, [_c('div', {
    staticClass: "dropdown-toggle w-8 h-8 rounded-full overflow-hidden shadow-lg image-fit zoom-in"
  }, [(_vm.user.avatar) ? _c('img', {
    attrs: {
      "alt": "Profile",
      "src": _vm.user.avatar
    }
  }) : _c('img', {
    attrs: {
      "alt": "Profile",
      "src": "/static/FAVICON-2026.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-box mt-10 absolute w-56 top-0 right-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box bg-theme-38 text-white"
  }, [_c('div', {
    staticClass: "p-4 border-b border-theme-40"
  }, [_c('div', {
    staticClass: "font-medium flex"
  }, [_vm._v("\n              " + _vm._s(_vm.user.name) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs"
  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), (_vm.user.team) ? _c('div', {
    staticClass: "text-xs"
  }, [_vm._v("\n              " + _vm._s(_vm.user.team.name) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-2"
  }, [_c('router-link', {
    staticClass: "flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 rounded-md",
    attrs: {
      "to": "/admin/profile"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "user",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n              Perfil\n            ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-2"
  }, [_c('router-link', {
    staticClass: "flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 rounded-md",
    attrs: {
      "to": "/admin/accounts-auth"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "folder",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n              Cuentas\n            ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-2"
  }, [_c('router-link', {
    staticClass: "flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 rounded-md",
    attrs: {
      "to": "/admin/notes"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "edit",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n              Mis Notas\n            ")], 1)], 1), _vm._v(" "), (_vm.session_team_current == 1 || _vm.user.role == 1) ? _c('div', {
    staticClass: "p-2"
  }, [_c('router-link', {
    staticClass: "flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 rounded-md",
    attrs: {
      "to": "/admin/developments"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "code",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n              Desarrollos\n            ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-2 border-t border-theme-40"
  }, [_c('a', {
    staticClass: "flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 rounded-md",
    on: {
      "click": _vm.doLogout
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "toggle-right",
      "classname": "w-4 h-4 mr-2"
    }
  }), _vm._v("\n              Salir\n            ")], 1)])])])]), _vm._v(" "), _c('app-alerts', {
    attrs: {
      "category": "Anuncios"
    }
  })], 1), _vm._v(" "), (_vm.birthday) ? _c('div', [_c('div', {
    staticClass: "birthday rounded py-2 px-4 shadow-lg bg-white flex justify-between"
  }, [_c('div', {
    staticClass: "text-lg text-theme-10 font-bold bg-white"
  }, [_vm._v("\n        ¡Feliz cumpleaños " + _vm._s(_vm.user.name) + " !\n      ")]), _vm._v(" "), (_vm.user.prize) ? _c('a', {
    staticClass: "bg-theme-10 rounded text-white font-bold p-1 text-center",
    attrs: {
      "href": _vm.user.prize,
      "target": "_blank"
    }
  }, [_vm._v("REDIMIR BONO")]) : _vm._e()])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "-intro-x breadcrumb mr-auto hidden-xs"
  }, [_c('a', {
    staticClass: "hidden-xs",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("MyInxait")])])
}]}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [(_vm.current.accounts.length) ? _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n        Cuentas Asignadas (" + _vm._s(_vm.current.accounts.length) + ")\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-3 mt-5"
  }, _vm._l((_vm.current.accounts), function(account, index) {
    return _c('div', {
      key: index,
      staticClass: "intro-y col-span-12 md:col-span-3"
    }, [_c('div', {
      staticClass: "box bg-theme-1 text-white"
    }, [_c('div', {
      staticClass: "flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(account.name) + " - " + _vm._s(account.country.prefix))])]), _vm._v(" "), _c('div', {
      staticClass: "flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 zoom-in text-white",
      on: {
        "click": function($event) {
          return _vm.removeAccount(account)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "minus",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1)])])])])
  }), 0), _vm._v(" "), (_vm.filteredAccounts.length) ? _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n        Cuentas Sin Asignar (" + _vm._s(_vm.filteredAccounts.length) + ")\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-3 mt-5"
  }, _vm._l((_vm.filteredAccounts), function(account, index) {
    return _c('div', {
      key: index,
      staticClass: "intro-y col-span-12 md:col-span-3"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(account.name) + " - " + _vm._s(account.country.prefix))])]), _vm._v(" "), _c('div', {
      staticClass: "flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      on: {
        "click": function($event) {
          return _vm.addAccount(account)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "plus",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1)])])])])
  }), 0)]) : _c('div', [_c('app-loading')], 1)])
},staticRenderFns: []}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12"
  }, [_c('div', {
    staticClass: "px-5 sm:px-8 py-5 sm:py-10"
  }, [(_vm.activity.type == 'Parejas') ? _c('div', {
    staticClass: "border-red-600 border-2 p-4 text-red-600 rounded"
  }, [_vm._v("\n      Recuerda que el numero de preguntas para la actividad de "), _c('b', [_vm._v("Parejas")]), _vm._v(" debe ser multiplos de 4.\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.checked && !_vm.isShow) ? _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 py-0",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addQuestionToActivity()
      }
    }
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-4"
  }, [_c('label', [_vm._v("Agregar pregunta:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentActivityQuestion.title),
      expression: "currentActivityQuestion.title"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.currentActivityQuestion.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentActivityQuestion, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-4"
  }, [_c('label', [_vm._v("Tiempo para respoder (en segundos):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentActivityQuestion.time_in_seconds),
      expression: "currentActivityQuestion.time_in_seconds"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.currentActivityQuestion.time_in_seconds)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentActivityQuestion, "time_in_seconds", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "overflow-x-auto"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), (!_vm.activityQuestions.length) ? _c('tbody', [_vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.activityQuestions), function(item, questionIndex) {
    return _c('tbody', {
      key: ((item.title) + "-question-item-" + questionIndex),
      staticClass: "border-b dark:border-dark-5"
    }, [_c('tr', {
      staticClass: "border"
    }, [_c('td', {
      staticClass: "whitespace-nowrap text-center cursor-pointer",
      class: _vm.showCurrentQuestion == questionIndex ? 'text-indigo-600 mobile-menu' : '',
      on: {
        "click": function($event) {
          _vm.showCurrentQuestion = questionIndex
        }
      }
    }, [_vm._v("\n              No. " + _vm._s(questionIndex + 1) + "\n            ")]), _vm._v(" "), _c('td', [(!_vm.checked) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.lazy",
        value: (item.title),
        expression: "item.title",
        modifiers: {
          "lazy": true
        }
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.title)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "title", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap"
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "whitespace-nowrap text-center"
    }, [(!_vm.checked) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.lazy",
        value: (item.time_in_seconds),
        expression: "item.time_in_seconds",
        modifiers: {
          "lazy": true
        }
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (item.time_in_seconds)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "time_in_seconds", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap"
    }, [_vm._v("\n                " + _vm._s(item.time_in_seconds) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      attrs: {
        "rowspan": "1"
      }
    }, [(!_vm.checked && !_vm.isShow) ? _c('button', {
      staticClass: "button bg-theme-6 text-white mt-auto",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.activityQuestions.splice(questionIndex, 1)
        }
      }
    }, [_vm._v("\n                Eliminar Pregunta\n              ")]) : _vm._e()])]), _vm._v(" "), _c('tr', {
      staticClass: "border mb-3"
    }, [_c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showCurrentQuestion == questionIndex),
        expression: "showCurrentQuestion == questionIndex"
      }],
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', {
      staticClass: "flex flex-col"
    }, [_c('h5', {
      staticClass: "mx-auto"
    }, [_vm._v("RESPUESTAS:")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "w-full"
    }, [(item.answers.length) ? _c('thead', [_vm._m(3, true)]) : _vm._e(), _vm._v(" "), _c('tbody', {
      staticClass: "border-b"
    }, _vm._l((item.answers), function(answer, index) {
      return _c('tr', {
        key: ("answers-key-" + index)
      }, [_c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.lazy",
          value: (answer.text_answer),
          expression: "answer.text_answer",
          modifiers: {
            "lazy": true
          }
        }],
        staticClass: "input w-full border mt-2",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (answer.text_answer)
        },
        on: {
          "change": function($event) {
            return _vm.$set(answer, "text_answer", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "flex"
      }, [_c('div', {
        staticClass: "mx-auto"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.lazy",
          value: (answer.correct),
          expression: "answer.correct",
          modifiers: {
            "lazy": true
          }
        }],
        staticClass: "checkbox mt-2 border",
        attrs: {
          "type": "checkbox",
          "name": questionIndex,
          "disabled": answer.correct
        },
        domProps: {
          "checked": Array.isArray(answer.correct) ? _vm._i(answer.correct, null) > -1 : (answer.correct)
        },
        on: {
          "change": [function($event) {
            var $$a = answer.correct,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(answer, "correct", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(answer, "correct", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(answer, "correct", $$c)
            }
          }, function($event) {
            return _vm.checkWhichAnswerChanged(questionIndex, index)
          }]
        }
      }), _vm._v("\n                            " + _vm._s(answer.correct ? 'Si' : 'No') + "\n                          ")])]), _vm._v(" "), _c('td', [(!_vm.isShow) ? _c('div', {
        staticClass: "flex"
      }, [_c('button', {
        staticClass: "button bg-theme-6 text-white mx-auto",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return item.answers.splice(index, 1)
          }
        }
      }, [_vm._v("\n                              Eliminar Respuesta\n                            ")])]) : _vm._e()])])
    }), 0), _vm._v(" "), (item.answers.length < 4 && _vm.activity.type == 'Trivia' || item.answers.length < 1 && _vm.activity.type == 'Ordenar Letras' ||
      item.answers.length < 1 && _vm.activity.type == 'Parejas') ? _c('tbody', {
      staticClass: "mt-3"
    }, [(!_vm.isShow) ? _c('tr', [_vm._m(4, true), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentQuestionAnswer.text_answer),
        expression: "currentQuestionAnswer.text_answer"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.currentQuestionAnswer.text_answer)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.currentQuestionAnswer, "text_answer", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button bg-theme-1 text-white mt-auto",
      attrs: {
        "type": "button",
        "disabled": !_vm.currentQuestionAnswer.text_answer
      },
      on: {
        "click": function($event) {
          return _vm.addAnswerToQuestion(questionIndex)
        }
      }
    }, [_vm._v("\n                            Agregar Respuesta\n                          ")])])]) : _vm._e()]) : _vm._e()])])])])]), _vm._v(" "), _vm._m(5, true)])
  }), _vm._v(" "), (!_vm.isShow) ? _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white mt-auto w-auto",
    on: {
      "click": _vm.updateOrCreateQuestions
    }
  }, [_vm._v("\n                Guardar preguntas y respuestas\n              ")])])])]) : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-4 flex"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n            Agregar Pregunta\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "border-b dark:border-dark-5"
  }, [_c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("PREGUNTA")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("TIEMPO")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("ACCIONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("No hay Elementos seleccionados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "border-b dark:border-dark-5"
  }, [_c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("Respuesta")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("Correcta")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("Acciones")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('label', [_vm._v("Agregar nueva respuesta:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td')])
}]}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("\n          Perfiles (" + _vm._s(_vm.profiles.length) + ")\n        ")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateProfile.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.profile.name
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('name', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6 xxl:col-span-6"
  }, [_c('label', [_vm._v("Equipo")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.profile.team_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('team_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', {
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n                  " + _vm._s(team.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.profile.status
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('status', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Activo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditProfile()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Modificar")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5"
  }, _vm._l((_vm.profiles), function(profile, index) {
    return _c('div', {
      staticClass: "col-span-12 sm:col-span-4 xxl:col-span-3 box p-5 cursor-pointer zoom-in",
      class: {
        'bg-theme-1': index % 2 !== 0
      }
    }, [_c('div', {
      staticClass: "font-medium text-base",
      class: {
        'text-white': index % 2 !== 0
      }
    }, [_vm._v("\n            " + _vm._s(profile.name) + "\n          ")]), _vm._v(" "), _c('div', {
      class: {
        'text-gray-600': index % 2 === 0,
        'text-theme-25': index % 2 !== 0
      }
    }, [_vm._v("\n            " + _vm._s(profile.team.name) + " - " + _vm._s(profile.status === 0 ? 'Inactivo' : 'Activo') + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "absolute top-0 right-0 mr-2 mt-2 dropdown ml-auto"
    }, [_c('a', {
      staticClass: "dropdown-toggle w-5 h-5 block",
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'more-vertical',
        "classname": 'w-5 h-5 text-gray-500'
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "dropdown-box mt-5 absolute w-40 top-0 right-0 z-10"
    }, [_c('div', {
      staticClass: "dropdown-box__content box p-2"
    }, [_c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.editProfile(profile)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v(" Editar\n                      ")], 1), _vm._v(" "), _c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.removeProfile(profile)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'trash',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v(" Eliminar\n                      ")], 1)])])])])
  }), 0)]) : _c('div', [_c('app-loading')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "profile"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--sm"
  }, [_vm._m(2), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createProfile.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.name),
      expression: "profile.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.profile.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Equipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.team_id),
      expression: "profile.team_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "team_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', {
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n                    " + _vm._s(team.name) + "\n                  ")])
  })], 2)])]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#profile",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Perfil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Editar Perfil\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n              Crear Perfil\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Crear")])])
}]}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal overflow-y-auto modal__overlap in show"
  }, [_c('div', {
    class: ("modal__content modal__content--" + _vm.size)
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")])]), _vm._v(" "), _vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-backdrop in",
    on: {
      "click": _vm.emitClose
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('app-loading') : _c('div', [_c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-5"
  }, [_c('div', {
    staticClass: "intro-y col-span-12 lg:col-span-12"
  }, [_c('div', {
    staticClass: "intro-y box"
  }, [_c('div', {
    staticClass: "flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n              Editar Tarea (Admin) - "), _c('app-title-custom')], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check w-full sm:w-auto sm:ml-auto mt-3 sm:mt-0"
  }, [_vm._v("\n              Creada por:"), _c('label', {
    staticClass: "form-check-label ml-0 sm:ml-2",
    attrs: {
      "for": "show-example-1"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.task.user_created_name) + " - " + _vm._s(_vm.task.created_at) + "\n              ")])])]), _vm._v(" "), _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5 form-task",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateTask.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6 xxl:col-span-12"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.task.name
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('name', $event)
      }
    }
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Fecha de entrega")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.task.date
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('date', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6 xxl:col-span-12"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": _vm.task.description
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('description', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Horas")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "step": ".01"
    },
    domProps: {
      "value": _vm.task.hours
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('hours', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "v-model": _vm.aux_task.project_id,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('project_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + "\n                  " + _vm._s(project.account.country.prefix) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.aux_task.campaign_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('campaign_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione la campaña")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n                  " + _vm._s(campaign.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', [_vm._v("Equipo")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.task.team_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('team_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', {
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n                  " + _vm._s(team.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.task.state_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('state_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n                  " + _vm._s(state.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.task.user_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('user_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                  " + _vm._s(user.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "my-3 col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.task.path
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('path', $event)
      }
    }
  })]), _vm._v(" "), ([4, 5, 7].includes(_vm.task.state_id)) ? _c('div', {
    staticClass: "col-span-12 gap-4 grid grid-cols-12 py-5 row-gap-3 sm:col-span-12"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Descripcion Respuesta")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.response_observations),
      expression: "task.response_observations"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "1",
      "required": ""
    },
    domProps: {
      "value": (_vm.task.response_observations)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "response_observations", $event.target.value)
      }, function($event) {
        return _vm.updateValue('response_observations', $event)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Url Archivo Respuesta (opcional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.response_path),
      expression: "task.response_path"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.task.response_path)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "response_path", $event.target.value)
      }, function($event) {
        return _vm.updateValue('response_path', $event)
      }]
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button w-24 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "edit",
      "disabled": _vm.buttonIsLoading
    }
  }, [(_vm.buttonIsLoading) ? [_vm._v(" Cargando... ")] : [_vm._v(" Modificar ")]], 2)])]), _vm._v(" "), (_vm.task.versions.length) ? _c('div', [_c('div', {
    staticClass: "flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Versiones")])]), _vm._v(" "), _vm._l((_vm.task.versions), function(version) {
    return _c('div', {
      staticClass: "grid grid-cols-12 items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_vm._v("\n                " + _vm._s(version.observations) + "\n                "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v("\n                  " + _vm._s(version.created_at) + "\n                ")]), _vm._v(" "), (version.path) ? _c('a', {
      attrs: {
        "href": version.path,
        "target": "_blank"
      }
    }, [_vm._v("Abrir Url")]) : _vm._e()]), _vm._v(" "), (version.response_observations) ? _c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_vm._v("\n                " + _vm._s(version.response_observations) + "\n                "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v("\n                  " + _vm._s(version.updated_at) + "\n                ")]), _vm._v(" "), (version.response_path) ? _c('a', {
      attrs: {
        "href": version.response_path,
        "target": "_blank"
      }
    }, [_vm._v("Abrir Url")]) : _vm._e()]) : _c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_c('form', {
      staticClass: "intro-y gap-3",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.updateVersion(version)
        }
      }
    }, [_c('div', {
      staticClass: "col-span-6 sm:col-span-6"
    }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.version_current.response_observations),
        expression: "version_current.response_observations"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "rows": "1",
        "required": ""
      },
      domProps: {
        "value": (_vm.version_current.response_observations)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.version_current, "response_observations", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-span-6 sm:col-span-6"
    }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.version_current.response_path),
        expression: "version_current.response_path"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.version_current.response_path)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.version_current, "response_path", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 col-span-12 sm:col-span-12"
    }, [_c('button', {
      staticClass: "button bg-theme-1 text-white",
      attrs: {
        "type": "submit",
        "id": "editversion"
      }
    }, [_vm._v("\n                      Responder\n                    ")])])])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5 form-task",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createVersion.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.observations),
      expression: "version.observations"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "1",
      "required": ""
    },
    domProps: {
      "value": (_vm.version.observations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "observations", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.path),
      expression: "version.path"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.version.path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "path", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Fecha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.date),
      expression: "version.date"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.version.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-8 col-span-3 sm:col-span-3"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n                Crear Nueva Version\n              ")])])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal modal-special",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--lg"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Registro")])]), _vm._v(" "), _c('form', {
    staticClass: "form-planning",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createPlanning.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Tarea")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planning.task),
      expression: "planning.task"
    }],
    class: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.planning.task)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.planning, "task", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planning.account_id),
      expression: "planning.account_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.planning, "account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: ("account-" + (account.id)),
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                  " + _vm._s(account.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planning.user_id),
      expression: "planning.user_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.planning, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return _c('option', {
      key: ("user-" + (user.id)),
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                  " + _vm._s(user.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Horas")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planning.hours),
      expression: "planning.hours"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "required": "",
      "step": ".01"
    },
    domProps: {
      "value": (_vm.planning.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.planning, "hours", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Fecha de entrega")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planning.date),
      expression: "planning.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.planning.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.planning, "date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    class: _vm.planningButtonLoading ? 'cursor-not-allowed opacity-50' : '',
    attrs: {
      "type": "submit",
      "disabled": _vm.planningButtonLoading
    }
  }, [_vm._v("\n              " + _vm._s(_vm.planningButtonLoading ? 'Creando...' : 'Crear') + "\n            ")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._m(0), _vm._v(" "), _c('div', {
    ref: "stage",
    staticClass: "hub intro-y mt-5",
    on: {
      "pointermove": _vm.onMove,
      "pointerleave": _vm.onLeave
    }
  }, [_c('div', {
    ref: "world",
    staticClass: "world"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "face floor floor-bg"
  }), _vm._v(" "), _vm._l((_vm.walls), function(wall) {
    return _c('div', {
      key: wall.id,
      staticClass: "face wall-bg",
      class: wall.id
    }, _vm._l((_vm.doorsOn(wall.id)), function(door, k) {
      return _c('button', {
        key: door.name,
        staticClass: "door",
        style: ({
          left: _vm.slotLeft(wall, k) + 'px'
        }),
        attrs: {
          "type": "button",
          "aria-label": 'Abrir ' + door.name,
          "title": door.description,
          "disabled": _vm.busy
        },
        on: {
          "mouseenter": function($event) {
            _vm.hovered = door.name
          },
          "mouseleave": function($event) {
            _vm.hovered = null
          },
          "focus": function($event) {
            _vm.hovered = door.name
          },
          "blur": function($event) {
            _vm.hovered = null
          },
          "click": function($event) {
            return _vm.enter(door)
          }
        }
      }, [_c('span', {
        staticClass: "sign",
        class: {
          'sign--active': _vm.isActive(door)
        }
      }, [_vm._v(_vm._s(door.name))]), _vm._v(" "), _c('span', {
        staticClass: "frame"
      }, [_c('span', {
        staticClass: "hole"
      }), _vm._v(" "), _c('span', {
        staticClass: "glow",
        style: ({
          opacity: _vm.glowOpacity(door)
        })
      }), _vm._v(" "), _c('span', {
        staticClass: "peek-wrap"
      }, [_c('span', {
        staticClass: "peek",
        style: (_vm.peekStyle(door)),
        domProps: {
          "innerHTML": _vm._s(_vm.icon(door.icon, 40))
        }
      })]), _vm._v(" "), _c('span', {
        staticClass: "leaf",
        style: (_vm.leafStyle(door))
      }, [_c('span', {
        staticClass: "leaf-icon",
        style: (_vm.iconStyle(door)),
        domProps: {
          "innerHTML": _vm._s(_vm.icon(door.icon, 32))
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "leaf-line"
      }), _vm._v(" "), _c('span', {
        staticClass: "leaf-line"
      }), _vm._v(" "), _c('span', {
        staticClass: "knob"
      })])])])
    }), 0)
  })], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.overlay) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "overlay-icon",
    domProps: {
      "innerHTML": _vm._s(_vm.icon(_vm.overlay.icon, 48))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "overlay-title"
  }, [_vm._v("Abriendo " + _vm._s(_vm.overlay.name) + "…")]), _vm._v(" "), _c('p', {
    staticClass: "overlay-text"
  }, [_vm._v(_vm._s(_vm.overlay.description))]), _vm._v(" "), _c('div', {
    staticClass: "overlay-bar"
  }, [_c('div', {
    staticClass: "overlay-bar__fill"
  })])]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5"
  }, [_c('div', {
    staticClass: "col-span-12"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("Plataformas")]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-600 text-xs mt-1"
  }, [_vm._v("Pasa el mouse sobre una puerta para abrirla · Clic para entrar")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "face ceil ceil-bg"
  }, [_c('div', {
    staticClass: "lamp lamp--neon flicker",
    staticStyle: {
      "top": "20%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lamp lamp--neon",
    staticStyle: {
      "top": "55%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lamp lamp--brand",
    staticStyle: {
      "top": "85%"
    }
  })])
}]}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "my-5"
  }, [_c('form', [_c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": "image/png, image/jpeg"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), (_vm.loadImage) ? _c('div', {
    staticClass: "text-left"
  }, [_vm._m(0)]) : _c('label', {
    staticClass: "button bg-theme-7 text-white button-sm",
    attrs: {
      "for": "file"
    }
  }, [_c('i', {
    staticClass: "fa fa-photo"
  }), _vm._v(" Cambiar Foto\n                ")])])])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Cargando...")])
}]}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('email-download-list-button', {
    staticClass: "mr-2"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "to": "/admin/traffic/emails-without-finish"
    }
  }, [_vm._v("Cortes sin finalizar")]), _vm._v(" "), _c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#email",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Corte")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredTasks), function(email) {
    return _c('tr', {
      staticClass: "intro-x"
    }, [_c('td', [_c('a', {
      staticClass: "font-medium whitespace-no-wrap",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(_vm._f("limit")(email.name)) + " - " + _vm._s(email.number))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(email.campaign_attribute.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(email.slug))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center text-xs"
    }, [_vm._v(_vm._s(email.campaign_attribute.project_name))]), _vm._v(" "), _c('div', {
      staticClass: "text-center text-xs"
    }, [_vm._v(_vm._s(email.campaign_attribute.project_account_name) + " " + _vm._s(email.campaign_attribute.project_account_country_prefix))])]), _vm._v(" "), _c('td', {
      staticClass: "w-40"
    }, [_c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._l((_vm.users), function(user) {
      return [(email.created_by === user.id) ? _c('div', {
        key: ("user-created_by-" + (user.id)),
        staticClass: "w-10 h-10 image-fit zoom-in"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": email.user_created_name,
          "src": user.avatar ? user.avatar : "/static/images/profile.png",
          "title": email.user_created_name
        }
      })]) : _vm._e()]
    }), _vm._v(" "), _vm._l((_vm.users), function(user) {
      return [(email.user_id === user.id) ? _c('div', {
        key: ("user-user_id-" + (user.id)),
        staticClass: "w-10 h-10 image-fit zoom-in -ml-5"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": email.user_name,
          "src": user.avatar ? user.avatar : "/static/images/profile.png",
          "title": email.user_name
        }
      })]) : _vm._e()]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._v(_vm._s(email.state_name) + _vm._s(email.hours ? (" - " + (email.hours) + " hs") : ''))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button button--sm w-24 text-white",
      class: email.time
    }, [_vm._v(_vm._s(email.date))])]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('router-link', {
      staticClass: "cursor-pointer flex items-center mr-3",
      attrs: {
        "to": '/admin/traffic/email/' + email.id
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1)], 1)])])
  }), 0)])])]) : _c('app-loading'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "email"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--sm"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createEmail.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.name),
      expression: "email.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.email.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Numero de pieza(s)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.number),
      expression: "email.number"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "number", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.nums), function(num) {
    return _c('option', {
      domProps: {
        "value": num
      }
    }, [_vm._v("\n                  " + _vm._s(num) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Fecha de entrega")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.date),
      expression: "email.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.email.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.project_id),
      expression: "email.project_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + " " + _vm._s(project.account.country.prefix) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.campaign_id),
      expression: "email.campaign_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "campaign_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n                    " + _vm._s(campaign.name) + "\n                  ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Url Archivo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.path),
      expression: "email.path"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.email.path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "path", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(2)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PROYECTO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ESTADO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("FECHA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n              Crear Corte\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Crear")])])
}]}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "mt-4"
  }, [_c('h2', {
    staticClass: "mb-2 font-bold text-lg"
  }, [_vm._v("Planeación")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between"
  }, [([1, 2, 3, 5].includes(_vm.user.team_id)) ? _c('planning-download-list-button', {
    staticClass: "mr-2"
  }) : _vm._e(), _vm._v(" "), ([1, 2, 3].includes(_vm.user.team_id)) ? _c('button', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        return _vm.setCreatePlanningModal(true)
      }
    }
  }, [_vm._v("\n          Crear Registro\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex w-1/2"
  }, [_c('div', {
    staticClass: "w-2/4 flex gap-2"
  }, [_c('div', {
    staticClass: "py-2 pt-2 w-20"
  }, [_vm._v("Filtrar por:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.group),
      expression: "filter.group"
    }],
    staticClass: "input w-full border flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeGroup($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('option', {
      key: group.id,
      domProps: {
        "value": group.id
      }
    }, [_vm._v("\n                " + _vm._s(group.name) + "\n              ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("TODAS")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "flex gap-1"
  }, [_c('button', {
    staticClass: "button button--sm border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.changeWeek('minus')
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'chevron-left',
      "classname": 'w-5'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "border border-theme-1 p-2 text-theme-1 rounded-lg"
  }, [_c('b', [_vm._v(_vm._s(_vm.start_date))]), _vm._v(" al "), _c('b', [_vm._v(_vm._s(_vm.end_date))])]), _vm._v(" "), _c('button', {
    staticClass: "button button--sm border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.changeWeek('plus')
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'chevron-right',
      "classname": 'w-5'
    }
  })], 1)])], 1), _vm._v(" "), _c('HoursPlanning', {
    attrs: {
      "dates": _vm.dates,
      "hours": _vm.hours,
      "hours_by_dates": _vm.hours_by_dates
    }
  }), _vm._v(" "), _c('HoursUsersPlanning', {
    attrs: {
      "dates": _vm.dates,
      "users": _vm.users_team,
      "users_dates": _vm.users_dates
    }
  }), _vm._v(" "), _c('ListPlanning', {
    attrs: {
      "accounts": _vm.accounts,
      "users": _vm.users,
      "items": _vm.items,
      "user": _vm.user,
      "team_session": _vm.team_session
    },
    on: {
      "planningCreated": function($event) {
        return _vm.planningCreated()
      },
      "setPlanningId": _vm.setPlanningId
    }
  }), _vm._v(" "), (_vm.createPlanningModal) ? _c('CreatePlanningModal', {
    attrs: {
      "team_session": _vm.team_session,
      "accounts": _vm.accounts,
      "users": _vm.users,
      "planning_id": _vm.planning_id
    },
    on: {
      "closeModal": function($event) {
        return _vm.setCreatePlanningModal(false)
      },
      "planningCreated": function($event) {
        return _vm.planningCreated()
      }
    }
  }) : _vm._e()], 1)]) : _c('div', [_c('app-loading')], 1)])
},staticRenderFns: []}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-md font-medium text-white py-2 px-5 rounded mt-4 cursor-pointer flex justify-between",
    class: _vm.show_div ?
      'bg-theme-1 text-white' :
      'bg-white border border-theme-1 text-theme-1 hover:bg-theme-1 hover:text-white',
    on: {
      "click": function($event) {
        _vm.show_div = !_vm.show_div
      }
    }
  }, [_c('span', {
    staticClass: "my-auto"
  }, [_vm._v(_vm._s(_vm.show_div ? 'Ocultar' : 'Ver') + " listado")]), _vm._v(" "), _c('span', {
    staticClass: "font-bold text-lg"
  }, [_vm._v(_vm._s(_vm.show_div ? '-' : '+'))])]), _vm._v(" "), (_vm.createTaskModalOption) ? _c('CreateTaskModal', {
    attrs: {
      "task_current": _vm.task_current
    },
    on: {
      "closeModal": function($event) {
        return _vm.setCreateTaskModal(false)
      },
      "secondPlanningCreated": function($event) {
        return _vm.secondPlanningCreated()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_div && !_vm.createTaskModalOption) ? _c('div', {
    staticClass: "overflow-auto intro-y"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("TAREA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("HORAS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [(_vm.filter_date) ? _c('div', {
    staticClass: "flex justify-center gap-2 cursor-pointer hover:text-theme-1",
    on: {
      "click": function($event) {
        _vm.filter_date = !_vm.filter_date
      }
    }
  }, [_vm._v("\n              FECHA\n              "), _c('svg', {
    staticClass: "w-4 h-4",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M3.792 2.938A49.069 49.069 0 0 1 12 2.25c2.797 0 5.54.236 8.209.688a1.857 1.857 0 0 1 1.541 1.836v1.044a3 3 0 0 1-.879 2.121l-6.182 6.182a1.5 1.5 0 0 0-.439 1.061v2.927a3 3 0 0 1-1.658 2.684l-1.757.878A.75.75 0 0 1 9.75 21v-5.818a1.5 1.5 0 0 0-.44-1.06L3.13 7.938a3 3 0 0 1-.879-2.121V4.774c0-.897.64-1.683 1.542-1.836Z",
      "clip-rule": "evenodd"
    }
  })])]) : _c('div', {
    staticClass: "flex justify-center gap-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.date),
      expression: "filter.date"
    }],
    staticClass: "input w-full border mt-2 flex-1 text-center",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.filter.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('svg', {
    staticClass: "w-4 h-4 my-auto cursor-pointer hover:text-theme-1",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "currentColor"
    },
    on: {
      "click": function($event) {
        return _vm.closeFilterDate()
      }
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z",
      "clip-rule": "evenodd"
    }
  })])])]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap w-40"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.account_id),
      expression: "filter.account_id"
    }],
    staticClass: "input w-full border mt-2 flex-1 text-center",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-",
      "selected": ""
    }
  }, [_vm._v("CUENTAS")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: ("account-" + (account.id)),
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                " + _vm._s(account.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap w-40"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.user_id),
      expression: "filter.user_id"
    }],
    staticClass: "input w-full border mt-2 flex-1 text-center",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-",
      "selected": ""
    }
  }, [_vm._v("ASIGNADO")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return _c('option', {
      key: ("user-" + (user.id)),
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                " + _vm._s(user.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredItems), function(item, index) {
    return _c('tr', {
      key: 'list' + index,
      staticClass: "intro-x"
    }, [_c('td', [(_vm.editIndex === index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.current_planning.task),
        expression: "current_planning.task"
      }],
      class: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text",
        "required": ""
      },
      domProps: {
        "value": (_vm.current_planning.task)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.current_planning, "task", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap flex gap-1",
      class: item.task_created ? 'text-theme-1' : ''
    }, [(item.planning_id) ? _c('app-icon', {
      attrs: {
        "name": 'check-circle',
        "classname": 'w-5 h-5 text-theme-9'
      }
    }) : _vm._e(), _vm._v(" "), (item.task_created) ? _c('app-icon', {
      attrs: {
        "name": 'check-circle',
        "classname": 'w-5 h-5 text-theme-1'
      }
    }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm._f("limit")(item.task)) + "\n            ")], 1)]), _vm._v(" "), _c('td', {
      staticClass: "w-32"
    }, [(_vm.editIndex === index && [2, 3].includes(_vm.user.team_id)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.current_planning.hours),
        expression: "current_planning.hours"
      }],
      class: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.current_planning.hours)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.current_planning, "hours", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center"
    }, [_vm._v("\n              " + _vm._s(item.hours) + "\n            ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-24"
    }, [(_vm.editIndex === index && [2, 3].includes(_vm.user.team_id)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.current_planning.date),
        expression: "current_planning.date"
      }],
      class: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "date",
        "required": ""
      },
      domProps: {
        "value": (_vm.current_planning.date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.current_planning, "date", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center"
    }, [_vm._v("\n              " + _vm._s(item.date) + "\n            ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40"
    }, [(_vm.editIndex === index && [2, 3].includes(_vm.user.team_id)) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.current_planning.account_id),
        expression: "current_planning.account_id"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.current_planning, "account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
      return _c('option', {
        key: ("account-" + (account.id)),
        domProps: {
          "value": account.id
        }
      }, [_vm._v("\n                " + _vm._s(account.name) + "\n              ")])
    })], 2) : _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center"
    }, [_vm._v("\n              " + _vm._s(item.account.name) + "\n            ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-20"
    }, [(_vm.editIndex === index && [2, 3].includes(_vm.user.team_id)) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.current_planning.user_id),
        expression: "current_planning.user_id"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.current_planning, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
      return _c('option', {
        key: ("user-" + (user.id)),
        domProps: {
          "value": user.id
        }
      }, [_vm._v("\n                " + _vm._s(user.name) + "\n              ")])
    })], 2) : _c('div', {
      staticClass: "w-24 h-24 lg:w-12 lg:h-12 image-fit mx-auto"
    }, [(item.created_user) ? _c('img', {
      staticClass: "rounded-full mx-auto -ml-6",
      attrs: {
        "title": item.created_user.name,
        "src": item.created_user.avatar
      }
    }) : _vm._e(), _vm._v(" "), (item.user) ? _c('img', {
      staticClass: "rounded-full mx-auto",
      attrs: {
        "title": item.user.name,
        "src": item.user.avatar
      }
    }) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action text-center"
    }, [(_vm.editIndex === index) ? _c('button', {
      staticClass: "bg-green-400 text-white rounded py-1 px-2 text-xs",
      on: {
        "click": function($event) {
          return _vm.updateItem()
        }
      }
    }, [_vm._v("\n              Guardar\n            ")]) : _c('button', {
      staticClass: "bg-theme-1 text-white rounded py-1 px-2 text-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editItem(index, item)
        }
      }
    }, [_vm._v("\n              Editar\n            ")]), _vm._v(" "), ([2, 3].includes(_vm.user.team_id)) ? _c('button', {
      staticClass: "bg-red-600 text-white rounded py-1 px-2 text-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(item)
        }
      }
    }, [_vm._v("\n              Eliminar\n            ")]) : _vm._e(), _vm._v(" "), (!item.task_created) ? _c('button', {
      staticClass: "bg-theme-3 text-white rounded py-1 px-2 text-xs",
      on: {
        "click": function($event) {
          return _vm.openCreateTask(item)
        }
      }
    }, [_vm._v("\n              Crear Tarea\n            ")]) : _vm._e(), _vm._v(" "), (item.number_versions == 0) ? _c('button', {
      staticClass: "bg-theme-11 text-white rounded py-1 px-2 text-xs",
      on: {
        "click": function($event) {
          return _vm.newVersion(item)
        }
      }
    }, [_vm._v("\n              Nueva Versión\n            ")]) : _vm._e()])])
  }), 0)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('h1', {
    staticClass: "mb-2 text-lg font-bold"
  }, [_vm._v("\n      Tareas (" + _vm._s(_vm.filteredTasks.length) + ")\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": 'search',
      "classname": 'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.slug),
      expression: "filter.slug"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por codigo"
    },
    domProps: {
      "value": (_vm.filter.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "slug", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
  }, [_c('app-icon', {
    attrs: {
      "name": 'chevron-down',
      "classname": 'dropdown-toggle w-4 h-4 cursor-pointer text-gray-700'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box p-5"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.account),
      expression: "filter.account"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "account", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                                  " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n                                ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.state),
      expression: "filter.state"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n                                    " + _vm._s(state.name) + "\n                                  ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button mt-28 text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        _vm.filter = _vm.clearFilter()
      }
    }
  }, [_vm._v("Borrar Filtro")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.state),
      expression: "filter.state"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n                    " + _vm._s(state.name) + "\n                  ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button mt-28 text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        _vm.filter = _vm.clearFilter()
      }
    }
  }, [_vm._v("\n                    Borrar Filtro\n                  ")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "to": "/admin/traffic/tasks-without-finish"
    }
  }, [_vm._v("Tareas sin finalizar")]), _vm._v(" "), _c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#task",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Tarea")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto intro-y"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredTasks), function(task) {
    return _c('tr', {
      staticClass: "intro-x"
    }, [_c('td', [_c('a', {
      staticClass: "font-medium whitespace-no-wrap",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(_vm._f("limit")(task.name)))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.slug) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.created_at) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.campaign_attribute.name) + " - " + _vm._s(task.team_name) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.campaign_attribute.project_name) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(task.campaign_attribute.project_account_name) + " -\n                " + _vm._s(task.campaign_attribute.project_account_country_prefix) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40"
    }, [_c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._l((_vm.users), function(user) {
      return [(task.created_by === user.id) ? _c('div', {
        key: ("user-created_by-" + (user.id)),
        staticClass: "w-10 h-10 image-fit zoom-in"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": task.user_created_name,
          "src": user.avatar ?
            user.avatar :
            "/static/images/profile.png",
          "title": task.user_created_name
        }
      })]) : _vm._e()]
    }), _vm._v(" "), _vm._l((_vm.users), function(user) {
      return [(task.user_id === user.id) ? _c('div', {
        key: ("user-user_id-" + (user.id)),
        staticClass: "w-10 h-10 image-fit zoom-in -ml-5"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": task.user_name,
          "src": user.avatar ?
            user.avatar :
            "/static/images/profile.png",
          "title": task.user_name
        }
      })]) : _vm._e()]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._v("\n                " + _vm._s(task.state_name) + " - " + _vm._s(task.hours) + "hs\n              ")])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button button--sm w-24 text-white",
      class: _vm.dateClass(task)
    }, [_vm._v("\n                " + _vm._s(task.date) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('router-link', {
      staticClass: "cursor-pointer flex items-center mr-3",
      attrs: {
        "to": '/admin/traffic/task/' + task.id
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1)], 1)])])
  }), 0)])])]) : _c('app-loading'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "task"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--md"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    staticClass: "form-task",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createTask.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.name),
      expression: "task.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.task.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.description),
      expression: "task.description"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.task.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-12"
  }, [_c('label', [_vm._v("Fecha de entrega")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.date),
      expression: "task.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.task.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-12"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.project_id),
      expression: "task.project_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + "\n                " + _vm._s(project.account.country.prefix) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.campaign_id),
      expression: "task.campaign_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "campaign_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n                " + _vm._s(campaign.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Equipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.team_id),
      expression: "task.team_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task, "team_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', {
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n                " + _vm._s(team.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('MultiSelect', {
    staticClass: "mt-2",
    attrs: {
      "options": _vm.options,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.task.path),
      callback: function($$v) {
        _vm.$set(_vm.task, "path", $$v)
      },
      expression: "task.path"
    }
  })], 1)]), _vm._v(" "), _vm._m(2)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ESTADO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("FECHA ENTREGA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Tarea")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n            Crear\n          ")])])
}]}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [(_vm.boxedit) ? _c('div', {
    ref: "boxedit",
    staticClass: "intro-y box mt-6"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateUser.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.user.name
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('name', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Apodo:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.user.nickname
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('nickname', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Correo:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": _vm.user.email
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('email', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Contraseña (opcional):")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.user.password
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('password', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Equipo")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.user.team_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('team_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', {
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n                " + _vm._s(team.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Perfil")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.user.profile_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('profile_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.profiles), function(profile) {
    return _c('option', {
      domProps: {
        "value": profile.id
      }
    }, [_vm._v("\n                " + _vm._s(profile.name) + " - " + _vm._s(profile.team.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.user.roles[0].id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('role', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el role")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Administrativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Lider")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Coordinador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Trabajador")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.user.active
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('active', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Activo")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("ID Compañia")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "integer",
      "required": ""
    },
    domProps: {
      "value": _vm.user.id_company
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('id_company', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 sm:col-span-2"
  }, [_c('label', [_vm._v("Cumpleaños")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": _vm.user.birthday
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('birthday', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-4"
  }, [_c('label', [_vm._v("Bono Cumpleaños")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.user.prize
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('prize', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 sm:col-span-2"
  }, [_c('label', [_vm._v("Fecha Ingreso")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.user.admission_date
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('admission_date', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Foto")]), _vm._v(" "), _c('EditPhoto', {
    attrs: {
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Url foto PNG")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.user.img_png
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('img_png', $event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditUser()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "update"
    }
  }, [_vm._v("\n            Modificar\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n        Usuarios (" + _vm._s(_vm.filteredUsers.length) + ")\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": 'search',
      "classname": 'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.name),
      expression: "filter.name"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre"
    },
    domProps: {
      "value": (_vm.filter.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "name", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
  }, [_c('app-icon', {
    attrs: {
      "name": "chevron-down",
      "classname": "dropdown-toggle w-4 h-4 cursor-pointer text-gray-700"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box p-5"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Equipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.team),
      expression: "filter.team"
    }],
    staticClass: "input w-full border mt-2 flex-13",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "team", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione una opción")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', {
      key: team.id,
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n                      " + _vm._s(team.name) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button mt-28 text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        _vm.filter = _vm.clearFilter()
      }
    }
  }, [_vm._v("\n                      Borrar Filtro\n                    ")])])])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex mr-2"
  }, [_c('button', {
    staticClass: "button text-white bg-theme-1 zoom-in",
    on: {
      "click": _vm.downloadList
    }
  }, [_vm._v("\n          Descargar\n        ")]), _vm._v(" "), _c('a', {
    ref: "download_users",
    staticClass: "hidden",
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer nofollow"
    }
  }, [_vm._v("Descargar")])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.users_incomplete.length) ? _c('div', {
    staticClass: "p-4 bg-white mt-5 rounded"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.users_incomplete), function(item) {
    return _c('p', [_vm._v("\n          - " + _vm._s(item.name) + " (" + _vm._s(item.email) + ")\n        ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro-y flex grid grid-cols-12 gap-6 mt-5"
  }, _vm._l((_vm.filteredUsers), function(user) {
    return _c('div', {
      key: user.id,
      staticClass: "intro-y col-span-12 md:col-span-6"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "w-24 h-24 lg:w-12 lg:h-12 image-fit lg:mr-1"
    }, [(user.avatar) ? _c('img', {
      staticClass: "rounded-full",
      attrs: {
        "alt": "Profile",
        "src": user.avatar
      }
    }) : _c('img', {
      staticClass: "rounded-full",
      attrs: {
        "alt": "Profile",
        "src": "/static/images/profile.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(user.name) + " (" + _vm._s(user.roles[0].name) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v("\n                " + _vm._s(user.team ? user.team.name : '-') + " :\n                " + _vm._s(user.profile ? user.profile.name : '-') + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0"
    }, [(user.active === 0) ? _c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      attrs: {
        "title": "Estado"
      },
      on: {
        "click": function($event) {
          return _vm.editUser(user)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'alert-triangle',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "pl-2 w-12 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      class: {
        'back-red': !user.accounts.length
      },
      attrs: {
        "to": ("/admin/account-user/" + (user.id))
      }
    }, [_vm._v("\n                " + _vm._s(user.accounts.length) + "\n                "), _c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 ml-1 mr-2"
      }
    })], 1), _vm._v(" "), _c('router-link', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      attrs: {
        "to": '/admin/calendar/' + user.slug
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'calendar',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      on: {
        "click": function($event) {
          return _vm.editUser(user)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      on: {
        "click": function($event) {
          return _vm.removeUser(user)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'trash',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1)], 1)])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "user"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--md"
  }, [_vm._m(3), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createUser.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Contraseña:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Correo:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Equipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.team_id),
      expression: "user.team_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "team_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', {
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n                  " + _vm._s(team.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Perfil")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile_id),
      expression: "user.profile_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "profile_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el perfil")]), _vm._v(" "), _vm._l((_vm.filteredProfiles), function(profile) {
    return _c('option', {
      domProps: {
        "value": profile.id
      }
    }, [_vm._v("\n                  " + _vm._s(profile.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role),
      expression: "user.role"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el role")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "business"
    }
  }, [_vm._v("Administrativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "leader"
    }
  }, [_vm._v("Lider")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "coordinator"
    }
  }, [_vm._v("Coordinador")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "employee"
    }
  }, [_vm._v("Trabajador")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("ID Compañia")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.id_company),
      expression: "user.id_company"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "integer",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.id_company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "id_company", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(4)])])])]) : _c('div', [_c('app-loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Editar Usuario")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#user",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Usuario")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb-2"
  }, [_vm._v("Los siguientes usuarios no tienen la informacion completa: "), _c('b', [_vm._v("(Apodo, Cumpleaños, fecha ingreso)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Usuario")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n              Crear\n            ")])])
}]}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": 'search',
      "classname": 'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.name),
      expression: "filter.name"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre"
    },
    domProps: {
      "value": (_vm.filter.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
  }, [_c('app-icon', {
    attrs: {
      "name": 'chevron-down',
      "classname": 'dropdown-toggle w-4 h-4 cursor-pointer text-gray-700'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box p-5"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.account),
      expression: "filter.account"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "account", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: account.id,
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                      " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n                    ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")])], 2)])])])])], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateHour.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Cuenta:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.hour.account.name + ' - ' + _vm.hour.account.country.prefix
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Equipo:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.hour.team.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Horas Por Semana:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.hour.hours
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('hours', $event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditHour()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Modificar")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro-y grid grid-cols-12 mt-5"
  }, _vm._l((_vm.filteredAccounts), function(account) {
    return _c('div', {
      staticClass: "col-span-12 sm:col-span-6 xxl:col-span-6 p-2"
    }, [_c('div', {
      staticClass: "pos__ticket box p-2 mt-5"
    }, [_c('span', {
      staticClass: "flex items-center p-3 transition duration-300 ease-in-out bg-theme-2 hover:bg-gray-200 rounded-md"
    }, [_c('div', {
      staticClass: "pos__ticket__item-name truncate mr-1"
    }, [_vm._v(_vm._s(account.name) + " - " + _vm._s(account.country.prefix))])]), _vm._v(" "), _vm._l((_vm.hours), function(hour) {
      return (hour.account_id === account.id) ? _c('a', {
        staticClass: "flex items-center p-3 cursor-pointer transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
        on: {
          "click": function($event) {
            return _vm.editHour(hour)
          }
        }
      }, [_c('div', {
        staticClass: "pos__ticket__item-name truncate mr-1"
      }, [_vm._v(_vm._s(hour.team.name))]), _vm._v(" "), _c('app-icon', {
        attrs: {
          "name": 'edit',
          "classname": 'w-4 h-4 mr-2'
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "text-xs text-gray-400"
      }, [_vm._v(_vm._s(hour.period.start_date) + " - " + _vm._s(hour.period.finish_date))]), _vm._v(" "), _c('div', {
        staticClass: "ml-auto"
      }, [_vm._v(_vm._s(hour.hours))])], 1) : _vm._e()
    })], 2)])
  }), 0)]) : _c('div', [_c('app-loading')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "hour"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--sm"
  }, [_vm._m(2), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createHour.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hour.account_id),
      expression: "hour.account_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.hour, "account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                    " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n                  ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Equipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hour.team_id),
      expression: "hour.team_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.hour, "team_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', {
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n                    " + _vm._s(team.name) + "\n                  ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Horas Por Semana:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hour.hours),
      expression: "hour.hours"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.hour.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.hour, "hours", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#hour",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Horas Soporte")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Editar Hora de Soporte\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n              Crear Horas de Soporte\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Crear")])])
}]}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('app-loading') : [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center mt-10"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        return _vm.toggleModalPoints(true)
      }
    }
  }, [_vm._v("\n          Cargar Puntos\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("USUARIO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("EVENTO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("FECHA (MES - AÑO)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PUNTOS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("TIPO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.points), function(point) {
    return _c('tr', {
      key: ("point-" + (point.slug)),
      staticClass: "intro-x"
    }, [_c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_c('div', {
      staticClass: "flex flex-wrap"
    }, [_c('div', {
      staticClass: "w-full md:w-1/4"
    }, [_c('div', {
      staticClass: "w-24 h-24 lg:w-12 lg:h-12 image-fit mx-auto"
    }, [(point.user_avatar) ? _c('img', {
      staticClass: "rounded-full",
      attrs: {
        "alt": "Profile",
        "src": point.user_avatar
      }
    }) : _c('img', {
      staticClass: "rounded-full",
      attrs: {
        "alt": "Profile",
        "src": "/static/images/profile.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "w-full md:w-3/4 my-auto whitespace-no-wrap"
    }, [_vm._v("\n                    " + _vm._s(point.user_name) + " "), _c('br'), _vm._v("\n                    " + _vm._s(point.user_email) + "\n                  ")])])])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(point.event) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [(point.month) ? _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(((String(point.month).padStart(2, '0')) + " - " + (point.year))) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(point.value) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(point.type) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('button', {
      staticClass: "flex items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.showDeleteModal(point.slug)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "name": "trash",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Eliminar\n                ")], 1)])])
  }), 0)])]), _vm._v(" "), (_vm.showPointsDeleteModal) ? _c('Modal', {
    attrs: {
      "title": "Eliminar Puntos",
      "size": "lg"
    },
    on: {
      "close": _vm.closeDeleteModal
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.deletePoints()
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 text-center"
  }, [_c('div', [_vm._v("Esta seguro de eliminar los puntos?")])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeDeleteModal
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n            Eliminar\n          ")])])])]) : _vm._e()], _vm._v(" "), (_vm.modalLoadPoints) ? _c('ModalLoadPoints', {
    on: {
      "close": function($event) {
        return _vm.toggleModalPoints(false)
      },
      "upload": _vm.uploadedPointsFile
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.country),
      expression: "filter.country"
    }],
    staticClass: "input w-full border mt-2 flex-13",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": ''
    }
  }, [_vm._v("Filtrar por país")]), _vm._v(" "), _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country.id
      }
    }, [_vm._v("\n                " + _vm._s(country.name) + "\n              ")])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-2 sm:gap-3 mt-5"
  }, _vm._l((_vm.filteredAccounts), function(account) {
    return _c('div', {
      staticClass: "intro-y col-span-6 sm:col-span-4 md:col-span-3 xxl:col-span-2"
    }, [_c('div', {
      staticClass: "file box rounded-md px-5 pt-8 pb-5 px-3 sm:px-5 relative zoom-in"
    }, [_vm._m(1, true), _vm._v(" "), _c('a', {
      staticClass: "block font-medium mt-4 text-center truncate",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(account.name) + " - " + _vm._s(account.country.prefix))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-center"
    }, [_vm._v(_vm._s(account.prefix))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-center"
    }, [_vm._v(_vm._s(account.id))])])])
  }), 0)]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y flex items-center mt-8"
  }, [_c('h2', {
    staticClass: "text-lg font-medium mr-auto"
  }, [_vm._v("Cuentas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "w-3/5 file__icon file__icon--directory mx-auto",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "file__icon__file-name"
  })])
}]}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.team_session != 1) ? _c('div', {
    staticClass: "intro-y box"
  }, [_c('div', {
    staticClass: "flex flex-col px-5 pt-5 pb-2"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v("Horas usadas en la semana del "), _c('b', [_vm._v(_vm._s(_vm.start_date))]), _vm._v(" al "), _c('b', [_vm._v(_vm._s(_vm.end_date))])]), _vm._v(" "), _c('div', {
    staticClass: "w-full h-4 bg-gray-400 rounded"
  }, [(_vm.percentage > 100) ? _c('div', {
    staticClass: "h-full rounded text-center text-xs text-white bg-theme-6",
    style: ({
      width: '100%'
    })
  }, [_vm._v(_vm._s(_vm.percentage) + "%")]) : _c('div', {
    staticClass: "h-full rounded text-center text-xs text-white bg-theme-1",
    style: ({
      width: _vm.percentage > 0 ? _vm.percentage + '%' : '0px'
    })
  }, [_vm._v(_vm._s(_vm.percentage) + "%")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between mx-5 pb-3"
  }, [_c('div', [_vm._v(_vm._s(_vm.hours_used) + " Horas Usadas")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.hours_account) + " Horas")])])]) : _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_c('div', {
    staticClass: "flex flex-col px-5 pb-2"
  }, _vm._l((_vm.projects), function(project) {
    return _c('div', [_c('div', {
      staticClass: "flex flex-col px-5 pt-5 pb-2"
    }, [_c('div', {
      staticClass: "mb-2"
    }, [_c('b', {
      class: [
        project.hours > 1 ?
        'text-theme-1' :
        '' ]
    }, [_vm._v(_vm._s(project.name))])]), _vm._v(" "), _c('div', {
      staticClass: "w-full h-4 bg-gray-400 rounded"
    }, [(project.percentage > 100) ? _c('div', {
      staticClass: "h-full rounded text-center text-xs text-white bg-theme-6",
      style: ({
        width: '100%'
      })
    }, [_vm._v(_vm._s(project.percentage) + "%")]) : _c('div', {
      staticClass: "h-full rounded text-center text-xs text-white bg-theme-1",
      style: ({
        width: project.percentage > 0 ? project.percentage + '%' : '0px'
      })
    }, [_vm._v(_vm._s(project.percentage) + "%")])])]), _vm._v(" "), _c('div', {
      staticClass: "flex justify-between mx-5 pb-3"
    }, [_c('div', [_vm._v(_vm._s(project.hours_used) + " Horas Usadas")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(project.hours) + " Horas")])])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "grid grid-cols-12 mt-8"
  }, [_c('div', {
    staticClass: "col-span-6 lg:col-span-6 xxl:col-span-6"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n            Mis Notas (" + _vm._s(_vm.notes.length) + ")\n          ")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateNote.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Titulo:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.note.title
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('title', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Descripción:")]), _vm._v(" "), _c('textarea', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": _vm.note.description
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('description', $event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditNote()
      }
    }
  }, [_vm._v("\n                Cancelar\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "update"
    }
  }, [_vm._v("\n                Modificar\n              ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5"
  }, _vm._l((_vm.notes), function(note) {
    return _c('div', {
      staticClass: "intro-y col-span-12 sm:col-span-12 md:col-span-6 xxl:col-span-6"
    }, [_c('div', {
      staticClass: "file box rounded-md px-5 pt-5 pb-5 px-3 sm:px-5 relative zoom-in"
    }, [_c('div', {
      staticClass: "text-gray-900 font-bold"
    }, [_vm._v(_vm._s(note.title))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs text-wrap mt-2"
    }, [_c('pre', [_vm._v(_vm._s(note.description))])]), _vm._v(" "), _c('div', {
      staticClass: "absolute top-0 right-0 mr-2 mt-2 dropdown ml-auto"
    }, [_c('a', {
      staticClass: "dropdown-toggle w-5 h-5 block",
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'more-vertical',
        "classname": 'w-5 h-5 text-gray-500'
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "dropdown-box mt-5 absolute w-40 top-0 right-0 z-10"
    }, [_c('div', {
      staticClass: "dropdown-box__content box p-2"
    }, [_c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.editNote(note)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v("\n                            Editar\n                          ")], 1), _vm._v(" "), _c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.removeNote(note)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'trash',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v(" Eliminar\n                          ")], 1)])])])])])
  }), 0)]) : _c('app-loading'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "note"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--sm"
  }, [_vm._m(2), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createNote.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Titulo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.title),
      expression: "note.title"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.note.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.note, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Descripción")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.description),
      expression: "note.description"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.note.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.note, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(3)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-6 sm:w-auto flex justify-end"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#note",
      "data-toggle": "modal"
    }
  }, [_vm._v("Agregar Nota")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Editar Nota")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n              Agregar Nota\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Crear")])])
}]}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    class: [
      'button flex py-2 text-white bg-theme-1 zoom-in',
      _vm.classname ],
    on: {
      "click": _vm.downloadList
    }
  }, [_c('Icon', {
    attrs: {
      "name": 'download',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n    " + _vm._s(_vm.text) + "\n  ")], 1), _vm._v(" "), _c('a', {
    ref: "download_emails",
    staticClass: "hidden",
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer nofollow"
    }
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_vm._l((_vm.menu), function(item, index) {
    return _c('li', {
      key: index,
      class: [
        item.team ? (item.team.includes(_vm.user.team_id) ? '' : 'hidden') : '',
        item.t_session ?
        item.t_session.includes(_vm.session_team_current) ?
        '' :
        'hidden' :
        '' ]
    }, [(item.role.includes(_vm.user.role)) ? _c('router-link', {
      class: [
        _vm.classname,
        _vm.subIsActive(item.to) ? (_vm.classname + "--active") : '' ],
      attrs: {
        "to": item.to
      }
    }, [_c('div', {
      class: (_vm.classname + "__icon")
    }, [_c('app-icon', {
      attrs: {
        "name": item.icon
      }
    })], 1), _vm._v(" "), _c('div', {
      class: (_vm.classname + "__title")
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")])]) : _vm._e()], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-5"
  }, [_c('div', {
    staticClass: "intro-y col-span-12 lg:col-span-12"
  }, [_c('div', {
    staticClass: "intro-y box"
  }, [_c('div', {
    staticClass: "flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Editar Corte")]), _vm._v(" "), _c('div', {
    staticClass: "form-check w-full sm:w-auto sm:ml-auto mt-3 sm:mt-0"
  }, [_vm._v("\n              Creada por:"), _c('label', {
    staticClass: "form-check-label ml-0 sm:ml-2",
    attrs: {
      "for": "show-example-1"
    }
  }, [_vm._v(_vm._s(_vm.email.user_created.name) + " - " + _vm._s(_vm.email.created_at) + "\n              ")])])]), _vm._v(" "), _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateEmail.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6 xxl:col-span-12"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.email.name
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('name', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3 xxl:col-span-12"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Numero de Pieza(s)")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "v-model": _vm.email.number,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('number', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.nums), function(num) {
    return _c('option', {
      domProps: {
        "value": num
      }
    }, [_vm._v("\n                  " + _vm._s(num) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3 xxl:col-span-12"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Fecha de entrega")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.email.date
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('date', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "v-model": _vm.aux_email.project_id,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('project_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + "\n                  " + _vm._s(project.account.country.prefix) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.aux_email.campaign_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('campaign_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione la campaña")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n                  " + _vm._s(campaign.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.email.state_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('state_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n                  " + _vm._s(state.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.email.user_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('user_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                  " + _vm._s(user.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "my-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Url Archivo")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.email.path
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('path', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "my-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Url Respuesta")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.email.response
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('response', $event)
      }
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.email.versions.length) ? _c('div', [_vm._m(1), _vm._v(" "), _vm._l((_vm.email.versions), function(version) {
    return _c('div', {
      staticClass: "grid grid-cols-12 items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_vm._v("\n                " + _vm._s(version.observations) + "\n                "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v("\n                  " + _vm._s(version.created_at) + "\n                ")]), _vm._v(" "), (version.path) ? _c('a', {
      attrs: {
        "href": version.path,
        "target": "_blank"
      }
    }, [_vm._v("Abrir Url")]) : _vm._e()]), _vm._v(" "), (version.response_observations) ? _c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_vm._v("\n                " + _vm._s(version.response_observations) + "\n                "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v("\n                  " + _vm._s(version.updated_at) + "\n                ")]), _vm._v(" "), (version.response_path) ? _c('a', {
      attrs: {
        "href": version.response_path,
        "target": "_blank"
      }
    }, [_vm._v("Abrir Url")]) : _vm._e()]) : _c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_c('form', {
      staticClass: "intro-y gap-3",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.updateVersion(version)
        }
      }
    }, [_c('div', {
      staticClass: "col-span-6 sm:col-span-6"
    }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.version_current.response_observations),
        expression: "version_current.response_observations"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "rows": "1",
        "required": ""
      },
      domProps: {
        "value": (_vm.version_current.response_observations)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.version_current, "response_observations", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-span-6 sm:col-span-6"
    }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.version_current.response_path),
        expression: "version_current.response_path"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.version_current.response_path)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.version_current, "response_path", $event.target.value)
        }
      }
    })]), _vm._v(" "), _vm._m(2, true)])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createVersion.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-span-5 sm:col-span-5"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.observations),
      expression: "version.observations"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "1",
      "required": ""
    },
    domProps: {
      "value": (_vm.version.observations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "observations", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.path),
      expression: "version.path"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.version.path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "path", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(3)])])])])]) : _c('div', [_c('app-loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button w-24 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "edit"
    }
  }, [_vm._v("\n                Modificar\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Versiones")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "editversion"
    }
  }, [_vm._v("\n                      Responder\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-8 col-span-3 sm:col-span-3"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n                Crear Nueva Version\n              ")])])
}]}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? [_c('div', {
    staticClass: "grid grid-cols-12 mt-8"
  }, [_c('div', {
    staticClass: "col-span-6 lg:col-span-6 xxl:col-span-6"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n          Biblioteca (" + _vm._s(_vm.filteredLibraries.length) + ")\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 lg:col-span-6 xxl:col-span-6 mb-4 text-right"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        _vm.create_modal = true
      }
    }
  }, [_vm._v("\n          Crear Libreria\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 lg:col-span-6 xxl:col-span-6 mb-2"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.slug),
      expression: "filter.slug"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre..."
    },
    domProps: {
      "value": (_vm.filter.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "slug", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 lg:col-span-12 xxl:col-span-12 mb-4"
  }, [_c('p', {
    staticClass: "w-full"
  }, [_vm._v("Filtrar por cualquiera de las siguientes categorías:")]), _vm._v(" "), _c('div', {
    staticClass: "intro-y mt-2 flex flex-wrap"
  }, [_c('button', {
    staticClass: "button border-theme-5 border flex mr-1 mb-2",
    class: {
      'bg-theme-1 text-white': _vm.filter.category == null
    },
    on: {
      "click": function($event) {
        return _vm.setCategory(null)
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "layers",
      "classname": "w-4 h-4 mr-2 mt-1"
    }
  }), _vm._v("\n              Todas las categorías\n            ")], 1), _vm._v(" "), _vm._l((_vm.categories), function(categoryMenu) {
    return _c('button', {
      key: ("category-" + (categoryMenu.name)),
      staticClass: "button border-theme-5 border flex mr-1 mb-2",
      class: {
        'bg-theme-1 text-white': categoryMenu.name == _vm.filter.category
      },
      on: {
        "click": function($event) {
          return _vm.setCategory(categoryMenu.name)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": categoryMenu.icon ? categoryMenu.icon : 'file',
        "classname": "w-4 h-4 mr-2 mt-1"
      }
    }), _vm._v("\n              " + _vm._s(categoryMenu.name) + "\n            ")], 1)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 lg:col-span-12 xxl:col-span-12 mb-4"
  }, [_c('p', {
    staticClass: "w-full"
  }, [_vm._v("Filtrar por cualquiera de los siguientes equipos:")]), _vm._v(" "), _c('div', {
    staticClass: "intro-y mt-2 flex flex-wrap"
  }, [_c('button', {
    staticClass: "button border-theme-5 border flex mr-1 mb-2",
    class: {
      'bg-theme-1 text-white': _vm.filter.team == null
    },
    on: {
      "click": function($event) {
        return _vm.setTeam(null)
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "layers",
      "classname": "w-4 h-4 mr-2 mt-1"
    }
  }), _vm._v("\n                Todos los equipos\n              ")], 1), _vm._v(" "), _vm._l((_vm.teams), function(teamMenu) {
    return _c('button', {
      key: ("team-" + (teamMenu.name)),
      staticClass: "button border-theme-5 border flex mr-1 mb-2",
      class: {
        'bg-theme-1 text-white': teamMenu.id == _vm.filter.team
      },
      on: {
        "click": function($event) {
          return _vm.setTeam(teamMenu.id)
        }
      }
    }, [_vm._v("\n                " + _vm._s(teamMenu.name) + "\n              ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredLibraries), function(library) {
    return _c('tr', {
      key: ("library-" + (library.id)),
      staticClass: "intro-x"
    }, [_c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(library.name))])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(library.category))])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(library.team.name))])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [(library.url) ? _c('a', {
      attrs: {
        "href": library.url,
        "target": "_blank"
      }
    }, [_vm._v("\n                  ver link\n                ")]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(library.status))])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(library.team_created_by.name))])]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.editModal(library)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Editar\n                ")], 1)])])])
  }), 0)])])] : _c('app-loading'), _vm._v(" "), (_vm.create_modal) ? _c('ModalCreateLibrary', {
    attrs: {
      "categories": _vm.categories,
      "teams": _vm.teams
    },
    on: {
      "created": _vm.libraryCreated,
      "close": function($event) {
        _vm.create_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.edit_modal) ? _c('ModalEditLibrary', {
    attrs: {
      "library_current": _vm.library_current,
      "categories": _vm.categories,
      "teams": _vm.teams
    },
    on: {
      "edited": _vm.libraryEdited,
      "close": function($event) {
        _vm.edit_modal = false
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("CATEGORÍA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("VISUALIZACIÓN")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("URL")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ESTADO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("CREADO POR")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
}]}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "to": "/admin/business/budgets/create"
    }
  }, [_vm._v("\n          Crear Presupuesto\n        ")])], 1)]), _vm._v(" "), (true) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n          Presupuesto " + _vm._s(_vm.current.reference) + "\n        ")])]), _vm._v(" "), _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkBudget.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Cliente")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.client_id),
      expression: "current.client_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current, "client_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": "",
      "value": "null"
    }
  }, [_vm._v("Seleccione Cliente...")]), _vm._v(" "), _vm._l((_vm.clients), function(client) {
    return _c('option', {
      key: ((client.id) + "-client"),
      domProps: {
        "value": client.id
      }
    }, [_vm._v("\n              " + _vm._s(client.social_reason) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Ejecutivo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.ejecutive_id),
      expression: "current.ejecutive_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current, "ejecutive_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione Ejecutivo...")]), _vm._v(" "), _vm._l((_vm.filteredEjecutives), function(ejecutive) {
    return _c('option', {
      key: ((ejecutive.id) + "-ejecutive"),
      domProps: {
        "value": ejecutive.id
      }
    }, [_vm._v("\n              " + _vm._s(ejecutive.name) + " - " + _vm._s(ejecutive.email) + "\n            ")])
  })], 2)]), _vm._v(" "), (_vm.current.social_reason_id) ? _c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Moneda cambio")]), _vm._v(" "), _c('div', {
    staticClass: "input w-full border mt-2 flex-1"
  }, [_vm._v("\n            " + _vm._s(_vm.current.money_code) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.current.social_reason_id) ? _c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("1 dólar es igual a:")]), _vm._v(" "), _c('div', {
    staticClass: "input w-full border mt-2 flex-1"
  }, [_vm._v("\n            " + _vm._s(_vm.current.usd_convertion) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Referencia")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.reference),
      expression: "current.reference"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.current.reference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current, "reference", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Razon Social")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.social_reason_id),
      expression: "current.social_reason_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current, "social_reason_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.resetBudgetItems('social_reason_id')
      }]
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione la Razon Social")]), _vm._v(" "), _vm._l((_vm.socialreasons), function(socialreason) {
    return _c('option', {
      key: ((socialreason.id) + "-social-reason"),
      domProps: {
        "value": socialreason.id
      }
    }, [_vm._v("\n              " + _vm._s(socialreason.name) + " - " + _vm._s(socialreason.country_prefix) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.account_id),
      expression: "current.account_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current, "account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.resetBudgetItems('account_id')
      }]
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione una cuenta")]), _vm._v(" "), _vm._l((_vm.filteredAccounts), function(account) {
    return _c('option', {
      key: ((account.id) + "-account"),
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n              " + _vm._s(account.name) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.project_id),
      expression: "current.project_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione un proyecto")]), _vm._v(" "), _vm._l((_vm.filteredProjects), function(project) {
    return _c('option', {
      key: ((project.id) + "-project"),
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n              " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + "\n              " + _vm._s(project.account.country.prefix) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.campaign_id),
      expression: "current.campaign_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current, "campaign_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione la campaña")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      key: ((campaign.id) + "-campaign"),
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n              " + _vm._s(campaign.name) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Tipo de presupuesto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.type),
      expression: "current.type"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": "",
      "value": "null"
    }
  }, [_vm._v("Seleccione tipo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cliente"
    }
  }, [_vm._v("Cliente")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cargo agencia"
    }
  }, [_vm._v("Cargo Agencia")])])]), _vm._v(" "), (_vm.current.type) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Comision Agencia")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.commission_agency),
      expression: "current.commission_agency"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "step": ".01",
      "required": "",
      "disabled": _vm.checked
    },
    domProps: {
      "value": (_vm.current.commission_agency)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current, "commission_agency", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.createNewVersion) ? _c('div', {
    staticClass: "col-span-12"
  }, [_c('div', {
    staticClass: "px-5 sm:px-8 py-5 sm:py-10"
  }, [(!_vm.checked) ? _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-3 py-5 bg-gray-400 rounded px-2"
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Agregar item:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCurrentItem.id),
      expression: "budgetCurrentItem.id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budgetCurrentItem, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredBudgetElements), function(element) {
    return _c('option', {
      key: ((element.id) + "-budget-element"),
      domProps: {
        "value": element.id
      }
    }, [_vm._v("\n                    " + _vm._s(element.name) + " - $ " + _vm._s(_vm.formatPrice(element.value)) + "\n                  ")])
  }), _vm._v(" "), (_vm.filteredBudgetElements.length) ? _c('option', {
    attrs: {
      "value": "special"
    }
  }, [_vm._v("\n                    Nuevo Elemento\n                  ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-3"
  }, [_c('label', [_vm._v("Cantidad:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCurrentItem.quantity),
      expression: "budgetCurrentItem.quantity"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.budgetCurrentItem.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.budgetCurrentItem, "quantity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-3 flex"
  }, [_c('button', {
    staticClass: "button w-24 bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "button",
      "disabled": !_vm.budgetCurrentItem.id
    },
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_vm._v("\n                  Agregar\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "overflow-x-auto"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(!_vm.budgetitems.length) ? _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n                      No hay Elementos seleccionados\n                    ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.budgetitems), function(item, index) {
    return _c('tr', {
      key: ((item.name) + "-budget-item-" + index),
      staticClass: "border-b dark:border-dark-5"
    }, [_c('td', [(!_vm.checked) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.lazy",
        value: (item.name),
        expression: "item.name",
        modifiers: {
          "lazy": true
        }
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "name", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap"
    }, [_vm._v("\n                        " + _vm._s(item.name) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "text-left whitespace-no-wrap"
    }, [_vm._v("\n                          DESCRIPCION:\n                        ")]), _vm._v(" "), (!_vm.checked) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "rows": "3"
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap"
    }, [_vm._v("\n                          " + _vm._s(item.description) + "\n                        ")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.quantity),
        expression: "item.quantity"
      }],
      staticClass: "input w-full border mt-auto flex-1",
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": (item.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "quantity", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                        " + _vm._s(item.quantity) + "\n                      ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('currency-input', {
      staticClass: "input w-full border mt-2",
      attrs: {
        "id": item.id,
        "locale": "es",
        "precision": 2,
        "valueRange": {
          min: 0
        },
        "distraction-free": {
          hideNegligibleDecimalDigits: true,
        },
        "currency": {
          prefix: '$ '
        }
      },
      on: {
        "blur": function($event) {
          item.unit_value == null ? (item.unit_value = 0) : ''
        }
      },
      model: {
        value: (item.unit_value),
        callback: function($$v) {
          _vm.$set(item, "unit_value", $$v)
        },
        expression: "item.unit_value"
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                        $" + _vm._s(_vm.formatPrice(item.unit_value)) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "text-left"
    }, [_vm._v("SUBTOTAL:")]), _vm._v(" "), _c('div', {
      staticClass: "text-center"
    }, [_vm._v("\n                          $ " + _vm._s(_vm.formatPrice(item.quantity * item.unit_value)) + "\n                        ")])])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.iva),
        expression: "item.iva"
      }],
      staticClass: "input w-full border mt-auto flex-1",
      attrs: {
        "name": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "iva", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("0%")]), _vm._v(" "), (
      _vm.selectedSocialReason && _vm.selectedSocialReason.iva
    ) ? _c('option', {
      domProps: {
        "value": _vm.selectedSocialReason.iva
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.selectedSocialReason.iva) + "%\n                        ")]) : _vm._e()]) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                        " + _vm._s(item.iva) + "%\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "text-left whitespace-no-wrap"
    }, [_vm._v("\n                          VALOR IVA:\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "text-center whitespace-no-wrap"
    }, [_vm._v("\n                          $\n                          " + _vm._s(_vm.formatPrice(
      _vm.percentCalculator(
        item.iva,
        item.quantity * item.unit_value
      )
    )) + "\n                        ")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.commission),
        expression: "item.commission"
      }],
      staticClass: "input w-full border mt-auto flex-1 text-center",
      attrs: {
        "name": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "commission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("0%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("1%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2.5
      }
    }, [_vm._v("2,5%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 3
      }
    }, [_vm._v("3%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 3.2
      }
    }, [_vm._v("3,2%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 4
      }
    }, [_vm._v("4%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 4.2
      }
    }, [_vm._v("4,2%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 6
      }
    }, [_vm._v("6%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 7.2
      }
    }, [_vm._v("7,2%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 8
      }
    }, [_vm._v("8%")])]) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                        " + _vm._s(item.commission) + "%\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "text-left whitespace-no-wrap"
    }, [_vm._v("\n                          VALOR COMISION:\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "text-center whitespace-no-wrap"
    }, [_vm._v("\n                          $\n                          " + _vm._s(_vm.formatPrice(
      _vm.percentCalculator(
        item.commission,
        item.quantity * item.unit_value
      )
    )) + "\n                        ")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "whitespace-no-wrap text-center"
    }, [_vm._v("\n                        $\n                        " + _vm._s(_vm.formatPrice(
      item.quantity * item.unit_value +
      _vm.percentCalculator(
        item.iva,
        item.quantity * item.unit_value,
        false
      ) +
      _vm.percentCalculator(
        item.commission,
        item.quantity * item.unit_value,
        false
      )
    )) + "\n                      ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('button', {
      staticClass: "button bg-theme-6 text-white mt-auto",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.budgetitems.splice(index, 1)
        }
      }
    }, [_vm._v("\n                        Eliminar\n                      ")]) : _vm._e()])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 sm:px-20 pb-10 sm:pb-20 flex flex-col-reverse sm:flex-row"
  }, [_c('div', {
    staticClass: "text-center sm:text-right sm:ml-auto mt-5"
  }, [_c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                  Subtotal:\n                  "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                    " + _vm._s(_vm.current.money_code) + " $ " + _vm._s(_vm.formatPrice(_vm.subtotal)) + "\n                  ")])]), _vm._v(" "), (_vm.subtotal) ? _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                  Subtotal:\n                  "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                    USD $ " + _vm._s(_vm.formatPrice(_vm.current.usd_subtotal)) + "\n                  ")])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                  Impuestos subtotal:\n                  "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                    " + _vm._s(_vm.current.money_code) + " $ " + _vm._s(_vm.formatPrice(_vm.taxSubtotal)) + "\n                  ")])]), _vm._v(" "), (_vm.current.usd_convertion) ? _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                  Impuestos subtotal:\n                  "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                    USD $\n                    " + _vm._s(_vm.formatPrice(_vm.taxSubtotal / _vm.current.usd_convertion)) + "\n                  ")])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                  Comision subtotal:\n                  "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                    " + _vm._s(_vm.budget.money_code) + " $\n                    " + _vm._s(_vm.formatPrice(_vm.commissionSubtotal)) + "\n                  ")])]), _vm._v(" "), (_vm.current.usd_convertion) ? _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                  Comision subtotal:\n                  "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                    USD $\n                    " + _vm._s(_vm.formatPrice(_vm.commissionSubtotal / _vm.current.usd_convertion)) + "\n                  ")])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xl text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v("TOTAL:")]), _vm._v("\n                  " + _vm._s(_vm.current.money_code) + " $ " + _vm._s(_vm.formatPrice(_vm.total)) + "\n                ")]), _vm._v(" "), (_vm.total) ? _c('div', {
    staticClass: "text-xl text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v("TOTAL: ")]), _vm._v("\n                  USD $ " + _vm._s(_vm.formatPrice(_vm.current.usd_total)) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-1 tetx-xs"
  }, [_vm._v("Incluye Impuestos")])])])]), _vm._v(" "), (_vm.checked) ? _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-9 text-white mt-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createVersion()
      }
    }
  }, [_vm._v("\n              Confirmar version\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-11 text-white mt-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.checked = false
      }
    }
  }, [_vm._v("\n              Editar version\n            ")])]) : _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n              Crear version\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-16 text-white mt-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createNewVersion = !_vm.createNewVersion
      }
    }
  }, [_vm._v("\n              Cancelar\n            ")])])]) : _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createNewVersion = !_vm.createNewVersion
      }
    }
  }, [_vm._v("\n            Crear nueva version\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 md:col-span-6 xl:col-span-4 xxl:col-span-12 mt-3"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "report-timeline mt-5 relative"
  }, _vm._l((_vm.current.versions), function(version, index) {
    return _c('div', {
      staticClass: "intro-x relative flex items-center mb-3"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "box px-5 py-3 ml-4 flex-1 zoom-in"
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [_c('div', [_c('div', {
      staticClass: "font-medium"
    }, [_vm._v("\n                  Version #" + _vm._s(_vm.current.versions.length - index) + "\n                  "), (!index) ? _c('span', [_vm._v("ACTUAL")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "text-xs text-gray-500"
    }, [_vm._v("\n                  Usuario: " + _vm._s(version.user_name) + " - " + _vm._s(version.user_email) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "text-xs text-gray-500 ml-auto"
    }, [_vm._v("\n                " + _vm._s(version.created_at) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center"
    }, [_c('div', {
      staticClass: "accordion accordion-boxed"
    }, [_c('div', {
      staticClass: "accordion-item"
    }, [(version.show) ? _c('div', {
      staticClass: "accordion-collapse collapse show"
    }, [_c('div', {
      staticClass: "overflow-auto"
    }, [_c('table', {
      staticClass: "table table-report -mt-2"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', _vm._l((version.items), function(item, index) {
      return _c('tr', {
        key: ("item-" + (item.id) + "-" + index),
        staticClass: "intro-x"
      }, [_c('td', {
        staticClass: "w-40 text-center"
      }, [_c('div', {
        staticClass: "text-left whitespace-no-wrap"
      }, [_vm._v("\n                                ITEM:\n                              ")]), _vm._v(" "), _c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_vm._v("\n                                " + _vm._s(item.name) + "\n                              ")]), _vm._v(" "), _c('div', {
        staticClass: "text-left whitespace-no-wrap"
      }, [_vm._v("\n                                DESCRIPCION:\n                              ")]), _vm._v(" "), _c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_c('a', {
        staticClass: "text-white",
        attrs: {
          "data-target": ("#description-" + index),
          "data-toggle": "modal"
        }
      }, [_vm._v("ver más")])])]), _vm._v(" "), _c('td', {
        staticClass: "w-40 text-center"
      }, [_c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_vm._v("\n                                " + _vm._s(item.quantity) + "\n                              ")])]), _vm._v(" "), _c('td', {
        staticClass: "w-40 text-center"
      }, [_c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_vm._v("\n                                $ " + _vm._s(_vm.formatPrice(item.unit_value)) + "\n                              ")])]), _vm._v(" "), _c('td', {
        staticClass: "w-40 text-center"
      }, [_c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_vm._v("\n                                $ " + _vm._s(_vm.formatPrice(item.subtotal)) + "\n                              ")])]), _vm._v(" "), _c('td', {
        staticClass: "w-40 text-center"
      }, [_c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_vm._v("\n                                $ " + _vm._s(_vm.formatPrice(item.iva_value)) + "\n                              ")])]), _vm._v(" "), _c('td', {
        staticClass: "w-40 text-center"
      }, [_c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_vm._v("\n                                $ " + _vm._s(_vm.formatPrice(item.commission_value)) + "\n                              ")])]), _vm._v(" "), _c('td', {
        staticClass: "w-40 text-center"
      }, [_c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_vm._v("\n                                $ " + _vm._s(_vm.formatPrice(item.total)) + "\n                              ")])]), _vm._v(" "), _c('div', {
        staticClass: "modal",
        attrs: {
          "id": ("description-" + index)
        }
      }, [_c('div', {
        staticClass: "modal__content modal__content--md"
      }, [_c('div', {
        staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
      }, [_c('h2', {
        staticClass: "font-medium text-base mr-auto"
      }, [_vm._v("\n                                    ITEM: " + _vm._s(item.name) + "\n                                  ")]), _vm._v(" "), _vm._m(4, true)]), _vm._v(" "), _c('div', [_c('div', {
        staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
      }, [_c('div', {
        staticClass: "col-span-12 sm:col-span-12"
      }, [_c('label', [_vm._v("DESCRIPCION:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.description))])])])]), _vm._v(" "), _vm._m(5, true)])])])
    }), 0)])])]) : _vm._e()])])]), _vm._v(" "), _c('hr', {
      staticClass: "my-4"
    }), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              SUBTOTAL: $ " + _vm._s(_vm.formatPrice(version.subtotal)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              SUBTOTAL: USD $ " + _vm._s(_vm.formatPrice(version.usd_subtotal)) + "\n            ")]), _vm._v(" "), _c('hr', {
      staticClass: "my-4"
    }), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              IMPUESTOS: $ " + _vm._s(_vm.formatPrice(version.iva)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              IMPUESTOS: USD $ " + _vm._s(_vm.formatPrice(version.usd_tax)) + "\n            ")]), _vm._v(" "), _c('hr', {
      staticClass: "my-4"
    }), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              IMPUESTOS: $ " + _vm._s(_vm.formatPrice(version.commission)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              IMPUESTOS: USD $ " + _vm._s(_vm.formatPrice(version.usd_commission)) + "\n            ")]), _vm._v(" "), _c('hr', {
      staticClass: "my-4"
    }), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              TOTAL: $ " + _vm._s(_vm.formatPrice(version.total)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              TOTAL: USD $ " + _vm._s(_vm.formatPrice(version.usd_total)) + "\n            ")]), _vm._v(" "), (version.items.length) ? _c('div', {
      staticClass: "accordion-header"
    }, [_c('button', {
      staticClass: "accordion-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          version.show = !version.show
        }
      }
    }, [(!version.show) ? _c('span', [_vm._v("Ver")]) : _c('span', [_vm._v("Ocultar")]), _vm._v("\n                (" + _vm._s(version.items.length) + ") items\n              ")])]) : _vm._e()])])
  }), 0)])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "border-b dark:border-dark-5"
  }, [_c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("\n                      CONCEPTO ITEM\n                    ")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("QTY")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("\n                      VALOR UNITARIO\n                    ")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("IVA")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("COMISION")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("ACCIONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-x flex items-center h-10"
  }, [_c('h2', {
    staticClass: "text-lg font-medium truncate mr-5"
  }, [_vm._v("\n          Historial de versiones\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-timeline__image"
  }, [_c('div', {
    staticClass: "flex h-10 w-10"
  }, [_c('div', {
    staticClass: "bg-theme-1 h-3 m-auto my-auto rounded-full w-3 z-10"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n                              CONCEPTO ITEM\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n                              QTY\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n                              PRECIO\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n                              SUBTOTAL\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n                              IVA\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n                              COMISION\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n                              TOTAL\n                            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                                    Cerrar\n                                  ")])])
}]}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_vm._m(0), _vm._v(" "), (_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateEditSocialReason.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialreason_current.name),
      expression: "socialreason_current.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.socialreason_current.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.socialreason_current, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Moneda")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialreason_current.money),
      expression: "socialreason_current.money"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.socialreason_current.money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.socialreason_current, "money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Codigo de Moneda")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialreason_current.money_code),
      expression: "socialreason_current.money_code"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.socialreason_current.money_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.socialreason_current, "money_code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Prefijo de Moneda Ej: (USD, $, P/)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialreason_current.money_prefix),
      expression: "socialreason_current.money_prefix"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.socialreason_current.money_prefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.socialreason_current, "money_prefix", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Formato de moneda Ej: (1,000.00)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialreason_current.money_format),
      expression: "socialreason_current.money_format"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.socialreason_current.money_format)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.socialreason_current, "money_format", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Prefijo de impuesto Ej: (IVA, IGV)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialreason_current.tax_prefix),
      expression: "socialreason_current.tax_prefix"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.socialreason_current.tax_prefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.socialreason_current, "tax_prefix", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Pais")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialreason_current.country_id),
      expression: "socialreason_current.country_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.socialreason_current, "country_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione el país")]), _vm._v(" "), _vm._l((_vm.countries), function(country) {
    return _c('option', {
      key: ("country-" + (country.id)),
      domProps: {
        "value": country.id
      }
    }, [_vm._v("\n              " + _vm._s(country.name) + "\n            ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditSocialReason()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Modificar")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.socialreasons), function(socialreason) {
    return _c('tr', {
      key: ("social-reason-" + (socialreason.id)),
      staticClass: "intro-x"
    }, [_c('td', [_c('a', {
      staticClass: "font-medium whitespace-no-wrap",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(socialreason.name))])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(socialreason.country_name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center"
    }, [_vm._v(_vm._s(socialreason.money))])]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex justify-center items-center flex-wrap"
    }, [_c('button', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.editSocialReason(socialreason)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v(" Editar\n                    ")], 1), _vm._v(" "), (!socialreason.usd_convertion) ? _c('button', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.trmChange(socialreason)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v(" Actualizar Trm\n                    ")], 1) : _vm._e(), _vm._v(" "), (socialreason.trm_change.length) ? _c('button', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.trmChangeHistory(socialreason)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v(" Ver Historial Trm\n                    ")], 1) : _vm._e()])])])
  }), 0)])])]) : _c('app-loading'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "socialreason"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--sm"
  }, [_vm._m(3), _vm._v(" "), _c('form', {
    staticClass: "form-task",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createSocialReason.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialreason.name),
      expression: "socialreason.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.socialreason.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.socialreason, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Moneda")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialreason.money),
      expression: "socialreason.money"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.socialreason.money)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.socialreason, "money", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Codigo de Moneda")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialreason.money_code),
      expression: "socialreason.money_code"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.socialreason.money_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.socialreason, "money_code", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Prefijo de Moneda Ej: (USD, $, P/)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialreason.money_prefix),
      expression: "socialreason.money_prefix"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.socialreason.money_prefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.socialreason, "money_prefix", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Formato de moneda Ej: (1,000.00)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialreason.money_format),
      expression: "socialreason.money_format"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.socialreason.money_format)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.socialreason, "money_format", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Prefijo de impuesto Ej: (IVA, IGV)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialreason.tax_prefix),
      expression: "socialreason.tax_prefix"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.socialreason.tax_prefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.socialreason, "tax_prefix", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Pais")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.socialreason.country_id),
      expression: "socialreason.country_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.socialreason, "country_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": "",
      "value": "null"
    }
  }, [_vm._v("Seleccione el país")]), _vm._v(" "), _vm._l((_vm.countries), function(country) {
    return _c('option', {
      key: ("country-" + (country.id)),
      domProps: {
        "value": country.id
      }
    }, [_vm._v("\n                  " + _vm._s(country.name) + "\n                ")])
  })], 2)])]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), (_vm.boxtrmchangehistory) ? _c('TrmChangeHistoryModal', {
    attrs: {
      "socialreason": _vm.socialreason_current
    },
    on: {
      "closeModal": function($event) {
        return _vm.closeTrmChangeHistoryModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.boxtrmchange) ? _c('TrmChangeModal', {
    attrs: {
      "socialreason": _vm.socialreason_current
    },
    on: {
      "closeModal": function($event) {
        return _vm.closeTrmChangeModal()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#socialreason",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Razon Social")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n          Editar Cuenta\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PAIS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("MONEDA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Crear Razon Social\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Crear")])])
}]}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [(!_vm.start_ia) ? _c('div', {
    staticClass: "flex bg-theme-1 p-2 rounded mb-4 cursor-pointer w-10 justify-center hidden",
    on: {
      "click": function($event) {
        return _vm.IAreport()
      }
    }
  }, [_c('app-icon', {
    staticClass: "w-5 h-5 text-white",
    attrs: {
      "name": "rocket"
    }
  })], 1) : _c('div', {
    staticClass: "flex bg-theme-1 p-2 rounded gap-2 mb-4 cursor-pointer w-full"
  }, [(_vm.icon_ia) ? _c('app-icon', {
    staticClass: "w-5 h-5 text-white",
    attrs: {
      "name": "rocket"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "text-white w-full",
    domProps: {
      "innerHTML": _vm._s(_vm.simpleMarkdownToHTML(_vm.message))
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.loadCalendar) ? _c('app-kalendar', {
    attrs: {
      "configuration": _vm.calendar_settings,
      "events": _vm.calendars
    },
    on: {
      "update:events": function($event) {
        _vm.calendars = $event
      },
      "click": _vm.handleEventClick
    },
    scopedSlots: _vm._u([{
      key: "created-card",
      fn: function(ref) {
        var event_information = ref.event_information;

        return _c('div', {
          staticClass: "details-card cursor-pointer",
          on: {
            "click": function($event) {
              return _vm.handleEventClick(event_information)
            }
          }
        }, [_c('h4', {
          staticClass: "appointment-description"
        }, [_vm._v("\n          " + _vm._s(event_information.data.title) + "\n        ")]), _vm._v(" "), _c('span', {
          staticClass: "time"
        }, [_vm._v(_vm._s(_vm._f("formatToHours")(event_information.start_time)) + " -\n          " + _vm._s(_vm._f("formatToHours")(event_information.end_time)))]), _vm._v(" "), (_vm.id == _vm.user.slug) ? _c('button', {
          staticClass: "remove",
          on: {
            "click": function($event) {
              return _vm.removeEventKalendar(event_information)
            }
          }
        }, [_c('app-icon', {
          staticClass: "text-white w-4 h-4",
          attrs: {
            "name": "trash"
          }
        })], 1) : _vm._e()])
      }
    }, {
      key: "creating-card",
      fn: function(ref) {
        var event_information = ref.event_information;

        return _c('div', {}, [_c('h4', {
          staticClass: "appointment-title",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n          Nuevo Evento\n        ")]), _vm._v(" "), _c('span', {
          staticClass: "time"
        }, [_vm._v("\n          " + _vm._s(_vm._f("formatToHours")(event_information.start_time)) + " -\n          " + _vm._s(_vm._f("formatToHours")(event_information.end_time)) + "\n        ")])])
      }
    }, {
      key: "popup-form",
      fn: function(ref) {
        var popup_information = ref.popup_information;

        return _c('div', {
          staticStyle: {
            "display": "flex",
            "flex-direction": "column"
          }
        }, [_c('h4', {
          staticStyle: {
            "margin-bottom": "10px"
          }
        }, [_vm._v("Nuevo Evento")]), _vm._v(" "), _c('form', {
          on: {
            "submit": function($event) {
              $event.preventDefault();
              return _vm.addEvent(popup_information)
            }
          }
        }, [_c('textarea', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.new_appointment['description']),
            expression: "new_appointment['description']"
          }],
          attrs: {
            "type": "text",
            "placeholder": "Titulo",
            "rows": "2",
            "required": ""
          },
          domProps: {
            "value": (_vm.new_appointment['description'])
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(_vm.new_appointment, 'description', $event.target.value)
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "buttons"
        }, [_c('button', {
          staticClass: "cancel",
          on: {
            "click": function($event) {
              return _vm.closePopups()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
          attrs: {
            "type": "submit",
            "disabled": _vm.buttonIsLoading
          }
        }, [_vm._v("Guardar")])])])])
      }
    }], null, false, 1533033317)
  }) : _vm._e(), _vm._v(" "), (_vm.event_current) ? _c('div', {
    staticClass: "fixed bg-white w-56 bottom-0 left-0 h-40 p-2 rounded"
  }, [_c('div', {
    staticClass: "flex flex-col justify-center items-center border border-theme-1 p-2 h-32 mt-2"
  }, [_c('p', {
    staticClass: "text-theme-1 mb-2"
  }, [_vm._v("\n          " + _vm._s(_vm._f("limit100")(_vm.event_current.data.title)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex gap-3"
  }, [_c('button', {
    staticClass: "border border-theme-1 text-theme-1 rounded py-1 px-2 text-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.event_current = null
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), (_vm.id == _vm.user.slug) ? _c('button', {
    staticClass: "bg-theme-1 text-white rounded py-1 px-2 text-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeEventList(_vm.event_current.data)
      }
    }
  }, [_vm._v("\n            Eliminar\n          ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('h2', {
    staticClass: "mb-2 font-bold text-lg"
  }, [_vm._v("\n        Lista de Eventos (" + _vm._s(_vm.filteredCalendars.length) + ")\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-4 inline-flex gap-2"
  }, [_c('div', {
    staticClass: "py-2"
  }, [_vm._v("Filtrar por fecha:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.date),
      expression: "filter.date"
    }],
    staticClass: "input w-56 border flex-1",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filter.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "date", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.filter.date) ? _c('div', {
    staticClass: "bg-theme-1 p-2 rounded w-10 h-10 cursor-pointer hover:bg-theme-6",
    on: {
      "click": function($event) {
        _vm.filter.date = null
      }
    }
  }, [_c('app-icon', {
    staticClass: "text-white w-4 h-4",
    attrs: {
      "name": "trash"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _vm._l((_vm.filteredCalendars), function(calendar, index) {
    return _c('div', {
      key: calendar.id,
      staticClass: "bg-white p-2 rounded mb-2 flex px-5"
    }, [(_vm.editIndex === index) ? _c('div', {
      staticClass: "w-2/6"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.current_calendar.title),
        expression: "current_calendar.title"
      }],
      class: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text",
        "required": ""
      },
      domProps: {
        "value": (_vm.current_calendar.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.current_calendar, "title", $event.target.value)
        }
      }
    })]) : _c('div', {
      staticClass: "w-2/6"
    }, [_vm._v(_vm._s(calendar.title))]), _vm._v(" "), _c('div', {
      staticClass: "w-1/4"
    }, [_vm._v(_vm._s(calendar.from.substr(0, 10)))]), _vm._v(" "), _c('div', {
      staticClass: "w-1/4"
    }, [_vm._v(_vm._s(_vm._f("formatToHours")(calendar.from)))]), _vm._v(" "), _c('div', {
      staticClass: "w-1/4"
    }, [_vm._v(_vm._s(_vm._f("formatToHours")(calendar.to)))]), _vm._v(" "), _c('div', {
      staticClass: "w-1/4 text-center"
    }, [(_vm.editIndex === index) ? _c('button', {
      staticClass: "bg-green-400 text-white rounded py-1 px-2 text-xs",
      on: {
        "click": function($event) {
          return _vm.updateItem()
        }
      }
    }, [_vm._v("\n            Guardar\n          ")]) : _c('button', {
      staticClass: "bg-theme-1 text-white rounded py-1 px-2 text-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editItem(index, calendar)
        }
      }
    }, [_vm._v("\n            Editar\n          ")]), _vm._v(" "), (_vm.id == _vm.user.slug) ? _c('button', {
      staticClass: "bg-red-600 text-white rounded py-1 px-2 text-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeEventList(calendar)
        }
      }
    }, [_vm._v("\n            Eliminar\n          ")]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('h2', {
    staticClass: "font-medium mr-auto fixed bottom-0 bg-theme-1 text-white border-1 border-white py-2 px-4 rounded-t-lg z-10"
  }, [_vm._v("\n      Calendario "), (_vm.user_calendar) ? _c('span', [_vm._v(" - " + _vm._s(_vm.user_calendar.name))]) : _vm._e()])], 1) : _c('div', [_c('app-loading')], 1)])
},staticRenderFns: []}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": _vm.downloadList
    }
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]), _vm._v(" "), _c('a', {
    ref: "download",
    staticClass: "hidden",
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer nofollow"
    }
  }, [_vm._v(_vm._s(_vm.text) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_vm._m(0), _vm._v(" "), (_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateEditSupplier.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Razon Social*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.social_reason),
      expression: "supplier_current.social_reason"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.supplier_current.social_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "social_reason", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Nit*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.nit),
      expression: "supplier_current.nit"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.supplier_current.nit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "nit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Contacto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.contact),
      expression: "supplier_current.contact"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.contact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "contact", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Pais")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.country),
      expression: "supplier_current.country"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "country", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Ciudad")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.city),
      expression: "supplier_current.city"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Direccion")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.address),
      expression: "supplier_current.address"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Telefono fijo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.telphone),
      expression: "supplier_current.telphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "telphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.cellphone),
      expression: "supplier_current.cellphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.cellphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "cellphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.email),
      expression: "supplier_current.email"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.supplier_current.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.contact_name),
      expression: "supplier_current.contact_name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.contact_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "contact_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.contact_cellphone),
      expression: "supplier_current.contact_cellphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.contact_cellphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "contact_cellphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.contact_email),
      expression: "supplier_current.contact_email"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.supplier_current.contact_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "contact_email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier_current.link),
      expression: "supplier_current.link"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier_current.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier_current, "link", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditSupplier()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Modificar")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.suppliers), function(supplier) {
    return _c('tr', {
      key: ("supplier-" + (supplier.id)),
      staticClass: "intro-x"
    }, [_c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(supplier.social_reason))])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(supplier.nit))])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(supplier.email))])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(supplier.country))])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [(supplier.link) ? _c('a', {
      staticClass: "font-medium whitespace-no-wrap",
      attrs: {
        "href": supplier.link,
        "target": "_blank"
      }
    }, [_vm._v("link")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('router-link', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      attrs: {
        "to": ("/admin/business/suppliers/relations/" + (supplier.id))
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Razones\n                  ")], 1), _vm._v(" "), _c('button', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.editSupplier(supplier)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1)], 1)])])
  }), 0)])])]) : _c('app-loading'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "supplier"
    }
  }, [_c('div', {
    staticClass: "modal__content"
  }, [_vm._m(4), _vm._v(" "), _c('form', {
    staticClass: "form-task",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createSupplier.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Razon Social*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.social_reason),
      expression: "supplier.social_reason"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.supplier.social_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "social_reason", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Nit*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.nit),
      expression: "supplier.nit"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.supplier.nit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "nit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Contacto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.contact),
      expression: "supplier.contact"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.contact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "contact", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Pais")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.country),
      expression: "supplier.country"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "country", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Ciudad")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.city),
      expression: "supplier.city"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Direccion")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.address),
      expression: "supplier.address"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Telefono fijo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.telphone),
      expression: "supplier.telphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "telphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.cellphone),
      expression: "supplier.cellphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.cellphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "cellphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.email),
      expression: "supplier.email"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.supplier.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.contact_name),
      expression: "supplier.contact_name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.contact_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "contact_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.contact_cellphone),
      expression: "supplier.contact_cellphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.contact_cellphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "contact_cellphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.contact_email),
      expression: "supplier.contact_email"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.supplier.contact_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "contact_email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.supplier.link),
      expression: "supplier.link"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.supplier.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.supplier, "link", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(6)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#supplier",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Proveedor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n          Editar Cuenta\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h3', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n              Contacto Adicional\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("RAZON SOCIAL")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("NIT")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("CORREO ELECTRONICO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PAIS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("URL")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Proveedor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h3', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n                Contacto Adicional\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Crear")])])
}]}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-md font-medium text-white py-2 px-5 rounded mt-4 cursor-pointer flex justify-between",
    class: _vm.show_div ?
      'bg-theme-1 text-white' :
      'bg-white border border-theme-1 text-theme-1 hover:bg-theme-1 hover:text-white',
    on: {
      "click": function($event) {
        _vm.show_div = !_vm.show_div
      }
    }
  }, [_c('span', {
    staticClass: "my-auto"
  }, [_vm._v(_vm._s(_vm.show_div ? 'Ocultar' : 'Ver') + " horas por cuenta")]), _vm._v(" "), _c('span', {
    staticClass: "font-bold text-lg"
  }, [_vm._v(_vm._s(_vm.show_div ? '-' : '+'))])]), _vm._v(" "), (_vm.show_div) ? _c('div', {
    staticClass: "overflow-auto intro-y mt-4"
  }, [_c('table', {
    staticClass: "w-full mb-4"
  }, [_c('thead', [_c('tr', {
    staticClass: "intro-x bg-white"
  }, [_c('th', {
    staticClass: "text-center whitespace-no-wrap p-1 border border-gray-100"
  }, [_vm._v("\n            CUENTA\n          ")]), _vm._v(" "), _vm._l((_vm.dates), function(item, key) {
    return _c('th', {
      key: 'headers' + key,
      staticClass: "text-center whitespace-no-wrap p-1 border border-gray-100",
      class: item == _vm.today ? 'bg-theme-1 text-white' : ''
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")])
  }), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap p-1 border border-gray-100"
  }, [_vm._v("\n            HORAS SEMAMA\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap p-1 border border-gray-100"
  }, [_vm._v("\n            HORAS USADAS\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap p-1 border border-gray-100"
  }, [_vm._v("\n            DIS\n          ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap p-1 border border-gray-100"
  }, [_vm._v("\n            %\n          ")])], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hours), function(hour, index) {
    return _c('tr', {
      key: 'hours' + index,
      staticClass: "intro-x bg-white"
    }, [_c('td', {
      staticClass: "border border-gray-100"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1"
    }, [_vm._v("\n              " + _vm._s(hour.account) + "\n            ")])]), _vm._v(" "), _vm._l((_vm.dates), function(item, key) {
      return _c('td', {
        key: 'accounts' + key,
        staticClass: "border border-gray-100"
      }, [_c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1"
      }, [_vm._v("\n              " + _vm._s(hour[item]) + "\n            ")])])
    }), _vm._v(" "), _c('td', {
      staticClass: "border border-gray-100"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1"
    }, [_vm._v("\n              " + _vm._s(hour.hours) + "\n            ")])]), _vm._v(" "), _c('td', {
      staticClass: "border border-gray-100"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1"
    }, [_vm._v("\n              " + _vm._s(hour.hours_used) + "\n            ")])]), _vm._v(" "), _c('td', {
      staticClass: "border border-gray-100",
      class: hour.percentage_color
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1"
    }, [_vm._v("\n              " + _vm._s((hour.hours - hour.hours_used).toFixed(2)) + "\n            ")])]), _vm._v(" "), _c('td', {
      staticClass: "border border-gray-100",
      class: hour.percentage_color
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1"
    }, [_vm._v("\n              " + _vm._s(hour.percentage) + "%\n            ")])])], 2)
  }), _vm._v(" "), _c('tr', {
    staticClass: "intro-x bg-white/20"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.dates), function(item, key) {
    return _c('td', {
      key: 'accounts' + key,
      staticClass: "border border-gray-100"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1"
    }, [_c('b', [_vm._v(_vm._s(_vm.hours_by_dates[item]))]), _vm._v(" /\n              " + _vm._s(_vm.hours_by_today.toFixed(2)) + "\n            ")])])
  }), _vm._v(" "), _c('td', {
    staticClass: "border border-gray-100"
  }, [_c('div', {
    staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1"
  }, [_vm._v("\n              " + _vm._s(_vm.sumHoursWeek) + "\n            ")])]), _vm._v(" "), _c('td', {
    staticClass: "border border-gray-100"
  }, [_c('div', {
    staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1 font-bold"
  }, [_vm._v("\n              " + _vm._s(_vm.sumHoursUsedWeek) + "\n            ")])]), _vm._v(" "), _c('td', {
    staticClass: "border border-gray-100"
  }, [_c('div', {
    staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1 font-bold"
  }, [_vm._v("\n              " + _vm._s((_vm.sumHoursWeek - _vm.sumHoursUsedWeek).toFixed(0)) + "\n            ")])]), _vm._v(" "), _c('td', {
    staticClass: "border border-gray-100"
  }, [_c('div', {
    staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1 font-bold"
  }, [_vm._v("\n              " + _vm._s(((_vm.sumHoursUsedWeek * 100) / _vm.sumHoursWeek).toFixed(0)) + "%\n            ")])])], 2), _vm._v(" "), _c('tr', {
    staticClass: "intro-x bg-white/20"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.dates), function(item, key) {
    return _c('td', {
      key: 'accounts' + key,
      staticClass: "border border-gray-100",
      class: _vm.hours_by_today < _vm.hours_by_dates[item] ?
        'bg-red-200' :
        _vm.hours_by_today == _vm.hours_by_dates[item] ?
        'bg-gray-200' :
        'bg-green-200'
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1"
    }, [_vm._v("\n              " + _vm._s((_vm.hours_by_today - _vm.hours_by_dates[item]).toFixed(2)) + "\n            ")])])
  }), _vm._v(" "), _c('td', {
    staticClass: "border border-gray-100 font-bold",
    class: _vm.sumHoursUsedWeek > _vm.sumHoursWeek ?
      'bg-red-300' :
      _vm.sumHoursUsedWeek == _vm.sumHoursWeek ?
      'bg-gray-200' :
      'bg-green-300',
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1"
  }, [_vm._v("\n              " + _vm._s((_vm.sumHoursWeek - _vm.sumHoursUsedWeek).toFixed(2)) + "\n            ")])]), _vm._v(" "), _c('td', {
    staticClass: "border border-gray-100"
  }), _vm._v(" "), _c('td', {
    staticClass: "border border-gray-100"
  })], 2)], 2)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "border border-gray-100"
  }, [_c('div', {
    staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1 font-bold"
  }, [_vm._v("\n              TOTAL DIA\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "border border-gray-100"
  }, [_c('div', {
    staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1 font-bold"
  }, [_vm._v("\n              DISPONIBLES\n            ")])])
}]}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "admin"
  }, [_c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "mobile-menu md:hidden"
  }, [_c('div', {
    staticClass: "mobile-menu-bar"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.menuMobile
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "bars",
      "classname": "w-8 h-8 text-white transform -rotate-90"
    }
  })], 1)]), _vm._v(" "), (!_vm.openmenu) ? _c('ul', {
    staticClass: "border-t border-theme-29 py-5 d-block"
  }, [_c('app-side-bar', {
    attrs: {
      "classname": "menu"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('nav', {
    staticClass: "side-nav"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "side-nav__devider my-6"
  }), _vm._v(" "), _c('app-side-bar', {
    attrs: {
      "classname": "side-menu"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('app-top'), _vm._v(" "), (_vm.isLoading) ? _c('app-loading') : _c('router-view')], 1), _vm._v(" "), (_vm.user.id && _vm.user.lastPasswordUpdated != true) ? _c('modal-password-updated') : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "flex mr-auto",
    attrs: {
      "href": ""
    }
  }, [_c('img', {
    staticClass: "w-6",
    attrs: {
      "alt": "My Inxait",
      "src": "/static/FAVICON-2026.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "intro-x flex items-center pl-5 pt-4",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "w-32 xl:block",
    attrs: {
      "alt": "Logo",
      "src": "/static/images/LOGO-WHITE-2026.png"
    }
  })])
}]}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "admin"
  }, [_c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "mobile-menu md:hidden"
  }, [_c('div', {
    staticClass: "mobile-menu-bar"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.menuMobile
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'bars',
      "classname": 'w-8 h-8 text-white transform -rotate-90'
    }
  })], 1)]), _vm._v(" "), (!_vm.openmenu) ? _c('ul', {
    staticClass: "border-t border-theme-29 py-5 d-block"
  }, [_c('app-side-bar', {
    attrs: {
      "classname": 'menu'
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('nav', {
    staticClass: "side-nav"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "side-nav__devider my-6"
  }), _vm._v(" "), _c('app-side-bar', {
    attrs: {
      "classname": 'side-menu'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('app-top'), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-8"
  }, [_c('div', {
    staticClass: "col-span-12 lg:col-span-3 xxl:col-span-2"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("Trafico")]), _vm._v(" "), _c('div', {
    staticClass: "intro-y box p-5 mt-6"
  }, [_c('div', {
    staticClass: "mt-1"
  }, [_c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/tasks'
      ),
    },
    attrs: {
      "to": "/admin/traffic/tasks"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'file-plus',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Tareas\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/emails'
      ),
    },
    attrs: {
      "to": "/admin/traffic/emails"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'code',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Cortes\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/campaigns'
      ),
    },
    attrs: {
      "to": "/admin/traffic/campaigns"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'file',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Campañas\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/hours'
      ),
    },
    attrs: {
      "to": "/admin/traffic/hours"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'clock',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Horas Soporte\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/projects'
      ),
    },
    attrs: {
      "to": "/admin/traffic/projects"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'file',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Proyectos\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/accounts'
      ),
    },
    attrs: {
      "to": "/admin/traffic/accounts"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'folder',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Cuentas\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/profiles'
      ),
    },
    attrs: {
      "to": "/admin/traffic/profiles"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'target',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Perfiles\n                ")], 1), _vm._v(" "), _c('router-link', {
    staticClass: "flex items-center px-3 py-2 mt-2 rounded-md",
    class: {
      'bg-theme-1 text-white font-medium': _vm.subIsActive(
        '/admin/traffic/teams'
      ),
    },
    attrs: {
      "to": "/admin/traffic/teams"
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'users',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                  Equipos\n                ")], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 lg:col-span-9 xxl:col-span-10"
  }, [_c('router-view')], 1)])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "flex mr-auto",
    attrs: {
      "href": ""
    }
  }, [_c('img', {
    staticClass: "w-6",
    attrs: {
      "alt": "My Inxait",
      "src": "/static/images/logo.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "intro-x flex items-center pl-5 pt-4",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "w-32 xl:block",
    attrs: {
      "alt": "Logo",
      "src": "/static/images/LOGO-WHITE-2026.png"
    }
  })])
}]}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "grid grid-cols-12 gap-6"
  }, [_c('div', {
    staticClass: "col-span-12 xxl:col-span-9 grid grid-cols-12 gap-6"
  }, [_c('div', {
    staticClass: "col-span-12 mt-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-5"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-6 xl:col-span-3 intro-y"
  }, [_c('div', {
    staticClass: "report-box zoom-in"
  }, [_c('div', {
    staticClass: "box p-5",
    on: {
      "click": function($event) {
        return _vm.$router.push('traffic/tasks')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('app-icon', {
    attrs: {
      "name": "file-plus",
      "classname": "report-box__icon text-theme-10"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-3xl font-bold leading-8 mt-6"
  }, [_vm._v(_vm._s(_vm.tasks.length))]), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600 mt-1"
  }, [_vm._v("Tareas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6 xl:col-span-3 intro-y"
  }, [_c('div', {
    staticClass: "report-box zoom-in"
  }, [_c('div', {
    staticClass: "box p-5",
    on: {
      "click": function($event) {
        return _vm.$router.push('traffic/campaigns')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('app-icon', {
    attrs: {
      "name": "file",
      "classname": "report-box__icon text-theme-11"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-3xl font-bold leading-8 mt-6"
  }, [_vm._v(_vm._s(_vm.campaigns.length))]), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600 mt-1"
  }, [_vm._v("Campañas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6 xl:col-span-3 intro-y"
  }, [_c('div', {
    staticClass: "report-box zoom-in"
  }, [_c('div', {
    staticClass: "box p-5",
    on: {
      "click": function($event) {
        return _vm.$router.push('traffic/accounts')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('app-icon', {
    attrs: {
      "name": "folder",
      "classname": "report-box__icon text-theme-12"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-3xl font-bold leading-8 mt-6"
  }, [_vm._v(_vm._s(_vm.accounts.length))]), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600 mt-1"
  }, [_vm._v("Cuentas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6 xl:col-span-3 intro-y"
  }, [_c('div', {
    staticClass: "report-box zoom-in"
  }, [_c('div', {
    staticClass: "box p-5",
    on: {
      "click": function($event) {
        return _vm.$router.push('users')
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('app-icon', {
    attrs: {
      "name": "user",
      "classname": "report-box__icon text-theme-9"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-3xl font-bold leading-8 mt-6"
  }, [_vm._v(_vm._s(_vm.users.length))]), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600 mt-1"
  }, [_vm._v("Usuarios")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y flex items-center h-10"
  }, [_c('h2', {
    staticClass: "text-lg font-medium truncate mr-5"
  }, [_vm._v("\n                  Reporte General\n                ")])])
}]}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("\n\"EQUIPO\n"), (_vm.filteredTeams.length) ? _c('span', [_vm._v(_vm._s(_vm.filteredTeams[0].name))]) : _vm._e(), _vm._v(" -\n"), (_vm.filteredAccounts.length) ? _c('span', [_vm._v(_vm._s(_vm.filteredAccounts[0].name) + " " + _vm._s(_vm.filteredAccounts[0].country.prefix))]) : _vm._e(), _vm._v("\"\n")])
},staticRenderFns: []}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "grid grid-cols-12 mt-8"
  }, [_c('div', {
    staticClass: "col-span-6 lg:col-span-6 xxl:col-span-6"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto my-2"
  }, [_vm._v("\n          Cotizaciones Desarrollos (" + _vm._s(_vm.filteredDevelopments.length) + ")\n        ")])]), _vm._v(" "), ([1].includes(_vm.user.role)) ? _c('div', {
    staticClass: "col-span-6 sm:w-auto flex justify-end mb-4"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#development",
      "data-toggle": "modal"
    }
  }, [_vm._v("Agregar")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 lg:col-span-12 xxl:col-span-12 grid grid-cols-6 gap-5"
  }, [_vm._l((_vm.status), function(item) {
    return _c('div', {
      key: item.name,
      staticClass: "hover:bg-theme-1 hover:text-white cursor-pointer border border-gray-400 px-2 py-1 w-full font-bold text-center rounded",
      class: item.name === _vm.filter.status ? 'bg-theme-1 text-white' : 'bg-white',
      on: {
        "click": function($event) {
          return _vm.setFilter(item.name)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "hover:bg-theme-1 hover:text-white cursor-pointer border border-gray-400 px-2 py-1 w-full font-bold text-center rounded",
    class: _vm.filter.status == '' ? 'bg-theme-1 text-white' : 'bg-white',
    on: {
      "click": function($event) {
        return _vm.setFilter(null)
      }
    }
  }, [_vm._v("\n          Todos\n        ")])], 2)]), _vm._v(" "), (_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateDevelopment.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Titulo:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.user.role != 1 ? '' : _vm.disabled
    },
    domProps: {
      "value": _vm.development.title
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('title', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "disabled": _vm.user.role != 1 ? '' : _vm.disabled,
      "required": ""
    },
    domProps: {
      "value": _vm.development.account_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('account_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: account.id,
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n              ")])
  })], 2)]), _vm._v(" "), (_vm.user.role == 1) ? _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Horas:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": _vm.development.hours
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('hours', $event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user.role == 1) ? _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Fecha:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": _vm.development.date
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('date', $event)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.development.status
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('status', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.status), function(status) {
    return _c('option', {
      key: status.name,
      domProps: {
        "value": status.name
      }
    }, [_vm._v("\n                " + _vm._s(status.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Observaciones")]), _vm._v(" "), _c('textarea', {
    staticClass: "input w-full border mt-2 flex-1",
    domProps: {
      "value": _vm.development.observations
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('observations', $event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditDevelopment()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "update"
    }
  }, [_vm._v("\n            Modificar\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5"
  }, _vm._l((_vm.filteredDevelopments), function(development) {
    return _c('div', {
      key: development.id,
      staticClass: "intro-y col-span-12 sm:col-span-12 md:col-span-12 xxl:col-span-12"
    }, [_c('div', {
      staticClass: "file box rounded-md py-3 px-5 sm:px-8 relative zoom-in flex justify-between"
    }, [_c('div', {
      staticClass: "uppercase my-auto w-1/3"
    }, [_vm._v("\n            " + _vm._s(development.title) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "my-auto w-48"
    }, [_vm._v("\n            " + _vm._s(development.account.name) + " -\n            " + _vm._s(development.account.country.prefix) + "\n          ")]), _vm._v(" "), ([1].includes(_vm.user.role)) ? _c('div', {
      staticClass: "text-xs my-auto font-bold"
    }, [_vm._v("\n            " + _vm._s(development.hours) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs text-wrap mt-2 font-bold w-24"
    }, [_c('span', {
      staticClass: "border border-gray-200 p-2 rounded"
    }, [_vm._v("\n              " + _vm._s(development.status) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs my-auto font-bold"
    }, [_vm._v("\n            " + _vm._s(development.observations) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs text-wrap mt-2"
    }, [_vm._v("\n            " + _vm._s(development.date) + "\n          ")]), _vm._v(" "), ([1, 5].includes(_vm.user.role)) ? _c('div', {
      staticClass: "absolute top-0 right-0 mr-2 mt-4 dropdown ml-auto"
    }, [_c('a', {
      staticClass: "dropdown-toggle w-5 h-5 block",
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'more-vertical',
        "classname": 'w-5 h-5 text-gray-500'
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "dropdown-box mt-5 absolute w-40 top-0 right-0 z-10"
    }, [_c('div', {
      staticClass: "dropdown-box__content box p-2"
    }, [_c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.editDevelopment(development)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v("\n                  Editar\n                ")], 1), _vm._v(" "), ([1].includes(_vm.user.role)) ? _c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.removeDevelopment(development)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'trash',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v("\n                  Eliminar\n                ")], 1) : _vm._e()])])]) : _vm._e()])])
  }), 0)]) : _c('app-loading'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "development"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--md"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createDevelopment.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Titulo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.development.title),
      expression: "development.title"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.development.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.development, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.development.account_id),
      expression: "development.account_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.development, "account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: account.id,
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Horas")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.development.hours),
      expression: "development.hours"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.development.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.development, "hours", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Fecha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.development.date),
      expression: "development.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.development.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.development, "date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(2)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Editar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Agregar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n            Crear\n          ")])])
}]}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [(_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateCampaign.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.campaign.name
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('name', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.campaign.project_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('project_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el proyecto")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + " " + _vm._s(project.account.country.prefix) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.campaign.status
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('status', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Activo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditCampaign()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Modificar")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro-y mt-6 flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("\n          Campañas (" + _vm._s(_vm.campaigns.length) + ")\n        ")])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5"
  }, _vm._l((_vm.campaigns), function(campaign) {
    return _c('div', {
      staticClass: "intro-y col-span-12 md:col-span-6"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "flex flex-col lg:flex-row items-center p-5"
    }, [_c('div', {
      staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(campaign.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v("\n                          " + _vm._s(campaign.status === 0 ? 'Inactivo' : 'Activo') + " -\n                          " + _vm._s(campaign.project.name) + " - " + _vm._s(campaign.project.account.name) + "\n                        " + _vm._s(campaign.project.account.country.prefix))])]), _vm._v(" "), _c('div', {
      staticClass: "flex mt-4 lg:mt-0"
    }, [_c('button', {
      staticClass: "button button--sm text-white bg-theme-1 mr-2",
      on: {
        "click": function($event) {
          return _vm.editCampaign(campaign)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4'
      }
    })], 1), _vm._v(" "), _c('button', {
      staticClass: "button button--sm text-gray-700 border border-gray-300",
      on: {
        "click": function($event) {
          return _vm.removeCampaign(campaign)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'trash',
        "classname": 'w-4 h-4'
      }
    })], 1)])])])])
  }), 0)]) : _c('app-loading'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "campaign"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--sm"
  }, [_vm._m(2), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createCampaign.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.name),
      expression: "campaign.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.campaign.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account_id),
      expression: "account_id"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.account_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione una cuenta")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: ("account-" + (account.id)),
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                " + _vm._s(account.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.project_id),
      expression: "campaign.project_id"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.account_id) ? _c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el proyecto")]) : _c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione una cuenta")]), _vm._v(" "), _vm._l((_vm.filteredProjects), function(project) {
    return _c('option', {
      key: ("project-" + (project.id)),
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + " " + _vm._s(project.account.country.prefix) + "\n                ")])
  })], 2)])]), _vm._v(" "), _vm._m(3)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Editar Campaña\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#campaign",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Campaña")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Crear Campaña\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Crear")])])
}]}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-md font-medium text-white py-2 px-5 rounded mt-4 cursor-pointer flex justify-between",
    class: _vm.show_div ?
      'bg-theme-1 text-white' :
      'bg-white border border-theme-1 text-theme-1 hover:bg-theme-1 hover:text-white',
    on: {
      "click": function($event) {
        _vm.show_div = !_vm.show_div
      }
    }
  }, [_c('span', {
    staticClass: "my-auto"
  }, [_vm._v(_vm._s(_vm.show_div ? 'Ocultar' : 'Ver') + " horas por usuario")]), _vm._v(" "), _c('span', {
    staticClass: "font-bold text-lg"
  }, [_vm._v(_vm._s(_vm.show_div ? '-' : '+'))])]), _vm._v(" "), (_vm.show_div) ? _c('div', {
    staticClass: "overflow-auto intro-y mt-4"
  }, [_c('table', {
    staticClass: "w-full mb-4"
  }, [_c('thead', [_c('tr', {
    staticClass: "intro-x bg-white"
  }, [_c('th', {
    staticClass: "text-center whitespace-no-wrap p-1 border border-gray-100"
  }, [_vm._v("\n            USUARIO\n          ")]), _vm._v(" "), _vm._l((_vm.dates), function(item, key) {
    return _c('th', {
      key: 'headers' + key,
      staticClass: "text-center whitespace-no-wrap p-1 border border-gray-100",
      class: item == _vm.today ? 'bg-theme-1 text-white' : ''
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.users), function(user, index) {
    return _c('tr', {
      key: 'hours' + index,
      staticClass: "intro-x bg-white"
    }, [_c('td', {
      staticClass: "border border-gray-100"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1"
    }, [_vm._v("\n              " + _vm._s(user.user) + "\n            ")])]), _vm._v(" "), _vm._l((_vm.dates), function(item, key) {
      return _c('td', {
        key: 'users' + key,
        staticClass: "border border-gray-100"
      }, [_c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1"
      }, [_c('b', {
        staticClass: "text-md",
        class: user[item] > 0 ? 'text-theme-1' : 'text-gray-400'
      }, [_vm._v(_vm._s(user[item].toFixed(1)))]), _vm._v("\n              / " + _vm._s(_vm.hours_by_today) + "\n            ")])])
    })], 2)
  }), _vm._v(" "), _c('tr', {
    staticClass: "intro-x bg-white/20"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.dates), function(item, key) {
    return _c('td', {
      key: 'accounts' + key,
      staticClass: "border border-gray-100"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1"
    }, [_vm._v("\n              " + _vm._s(_vm.users_dates[item].toFixed(1)) + " /\n              " + _vm._s(_vm.hours_by_today * _vm.users.length) + "\n            ")])])
  })], 2), _vm._v(" "), _c('tr', {
    staticClass: "intro-x bg-white/20"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.dates), function(item, key) {
    return _c('td', {
      key: 'accounts' + key,
      staticClass: "border border-gray-100",
      class: _vm.hours_by_today * _vm.users.length < _vm.users_dates[item] ?
        'bg-red-200' :
        _vm.hours_by_today * _vm.users.length == _vm.users_dates[item] ?
        'bg-gray-200' :
        'bg-green-200'
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1"
    }, [_vm._v("\n              " + _vm._s((_vm.hours_by_today * _vm.users.length - _vm.users_dates[item]).toFixed(1)) + "\n            ")])])
  })], 2)], 2)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "border border-gray-100"
  }, [_c('div', {
    staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1 font-bold"
  }, [_vm._v("\n              TOTAL DIA\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "border border-gray-100"
  }, [_c('div', {
    staticClass: "text-gray-600 text-xs whitespace-no-wrap text-center p-1 font-bold"
  }, [_vm._v("\n              DISPONIBLES\n            ")])])
}]}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "grid grid-cols-12 gap-6"
  }, [_c('div', {
    staticClass: "col-span-12 xxl:col-span-9 grid grid-cols-12 gap-6"
  }, [_c('div', {
    staticClass: "col-span-12 mt-8"
  }, [_c('div', {
    staticClass: "intro-y flex h-10 justify-between"
  }, [_c('h2', {
    staticClass: "text-lg font-medium truncate mr-5"
  }, [_vm._v("Reporte General")]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-2"
  }, [(_vm.emailsdownload.includes(_vm.usersession.email)) ? _c('email-download-list-button', {
    attrs: {
      "classname": 'mr-0 button--sm',
      "text": "Descargar Lista de Cortes"
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/admin/hours-tasks'
    }
  }, [_c('button', {
    staticClass: "button button--sm xs:w-10 sm:w-52 flex items-center justify-center bg-theme-1 text-white zoom-in"
  }, [_c('Icon', {
    attrs: {
      "name": 'file',
      "classname": 'w-4 h-4 sm:mr-2'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden sm:block"
  }, [_vm._v("Resumen de horas")])], 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/admin/calendar/' + _vm.usersession.slug
    }
  }, [_c('button', {
    staticClass: "button button--sm xs:w-10 sm:w-32 flex items-center justify-center bg-theme-1 text-white zoom-in"
  }, [_c('Icon', {
    attrs: {
      "name": 'calendar',
      "classname": 'w-4 h-4 sm:mr-2'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden sm:block"
  }, [_vm._v("Calendario")])], 1)]), _vm._v(" "), _c('router-link', {
    staticClass: "w-50",
    attrs: {
      "to": "/admin/platforms"
    }
  }, [_c('button', {
    staticClass: "button button--sm xs:w-10 sm:w-32 flex items-center justify-center bg-theme-1 text-white zoom-in"
  }, [_c('Icon', {
    attrs: {
      "name": 'globe',
      "classname": 'w-4 h-4 sm:mr-2'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden sm:block"
  }, [_vm._v("Plataformas")])], 1)])], 1)]), _vm._v(" "), (_vm.usersession) ? _c('p', {
    staticClass: "typing text-md mb-2 hidden sm:block",
    style: ({
      width: 48 + _vm.usersession.name.length + 'ch'
    })
  }, [_vm._v("\n            Bienvenido(a) " + _vm._s(_vm.usersession.nickname) + ", a continuación\n            encontraras el reporte general.\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-6"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-6 xl:col-span-5 intro-y"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "text-lg font-medium px-5 py-3 border-b"
  }, [_vm._v("\n                  Generar Contraseñas\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col lg:flex-row items-center p-5"
  }, [(_vm.password) ? _c('div', {
    staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: "input border flex-1 w-64",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('Copy', {
    attrs: {
      "text": _vm.password
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "flex mt-1 text-xs"
  }, [_vm._v("\n                      Clic en el icono\n                      "), _c('Icon', {
    attrs: {
      "name": "copy",
      "classname": "w-4 h-4 mx-2 text-gray-500"
    }
  }), _vm._v("\n                      para copiar.\n                    ")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex mt-4 lg:mt-0"
  }, [_c('button', {
    staticClass: "button text-white bg-theme-1 mr-2 zoom-in",
    on: {
      "click": function($event) {
        return _vm.generatePassword()
      }
    }
  }, [_vm._v("\n                      Generar " + _vm._s(_vm.password != '' ? 'Nueva' : '') + "\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4 xl:col-span-4 intro-y"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "text-lg font-medium px-5 py-4 border-b"
  }, [_vm._v("Tip")]), _vm._v(" "), (_vm.tip) ? _c('div', {
    staticClass: "flex flex-col lg:flex-row items-center py-3 px-5"
  }, [_c('div', {
    staticClass: "col-span-12 bg-white p-2 text-md"
  }, [_vm._v("\n                    " + _vm._s(_vm.tip.description) + "\n                  ")])]) : _vm._e()])])])])])])]) : _c('div', [_c('app-loading')], 1)])
},staticRenderFns: []}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    staticClass: "img-loading",
    attrs: {
      "src": "/static/images/white.gif",
      "width": "150",
      "alt": "Loading"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-loading"
  }, [_vm._v("Cargando")])])
}]}

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-white"
  }, [_c('img', {
    staticClass: "mx-auto",
    attrs: {
      "src": __webpack_require__(318)
    }
  })])
}]}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-5"
  }, [_c('div', {
    staticClass: "intro-y col-span-12 lg:col-span-12"
  }, [_c('div', {
    staticClass: "intro-y box"
  }, [_vm._m(0), _vm._v(" "), (_vm.filteredSocialReasonsWithoutTrm.length) ? _c('div', {
    staticClass: "mx-2 mt-4"
  }, [_c('div', {
    staticClass: "flex flex-col bg-red-200 rounded-lg p-4 mb-2 text-sm text-red-700",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticClass: "flex mb-2"
  }, [_c('svg', {
    staticClass: "w-5 h-5 inline mr-3",
    attrs: {
      "fill": "currentColor",
      "viewBox": "0 0 20 20",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-medium"
  }, [_vm._v("Algunas razones sociales no tienen Trm para este mes:\n                ")])]), _vm._v(" "), _vm._l((_vm.filteredSocialReasonsWithoutTrm), function(socialreason) {
    return _c('ul', {
      key: ("" + (socialreason.id)),
      staticClass: "list-disc list-inside"
    }, [_c('li', {
      staticClass: "font-medium"
    }, [_vm._v("\n                  " + _vm._s(socialreason.name) + " - " + _vm._s(socialreason.country_prefix) + "\n                ")])])
  }), _vm._v(" "), _c('a', {
    staticClass: "underline font-bold mt-2 hover:text-red-600",
    attrs: {
      "href": '/admin/business/social-reasons'
    }
  }, [_vm._v("Ir a Razones Sociales")])], 2)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkBudget.apply(null, arguments)
      }
    }
  }, [(_vm.budget.social_reason_id) ? _c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Moneda cambio")]), _vm._v(" "), _c('div', {
    staticClass: "input w-full border mt-2 flex-1 bg-gray-200"
  }, [_vm._v("\n                " + _vm._s(_vm.budget.money_code) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.budget.social_reason_id) ? _c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("1 dólar es igual a:")]), _vm._v(" "), _c('div', {
    staticClass: "input w-full border mt-2 flex-1 bg-gray-200"
  }, [_vm._v("\n                " + _vm._s(_vm.budget.usd_convertion) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Razon Social")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.social_reason_id),
      expression: "budget.social_reason_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": _vm.checked
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budget, "social_reason_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.resetBudgetItems('social_reason_id')
        _vm.selectSocialReason()
      }]
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                  Seleccione la Razon Social\n                ")]), _vm._v(" "), _vm._l((_vm.socialreasons), function(socialreason) {
    return _c('option', {
      key: ((socialreason.id) + "-social-reason"),
      domProps: {
        "value": socialreason.id
      }
    }, [_vm._v("\n                  " + _vm._s(socialreason.name) + " - " + _vm._s(socialreason.country_prefix) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Referencia")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.reference),
      expression: "budget.reference"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.checked
    },
    domProps: {
      "value": (_vm.budget.reference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.budget, "reference", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.budget.social_reason_id) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Cliente")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.client_id),
      expression: "budget.client_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": _vm.checked
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budget, "client_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.accountsClient()
      }]
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione Cliente...")]), _vm._v(" "), _vm._l((_vm.filteredClients), function(client) {
    return _c('option', {
      key: ((client.id) + "-client"),
      domProps: {
        "value": client.id
      }
    }, [_vm._v("\n                  " + _vm._s(client.social_reason) + " (" + _vm._s(client.accounts.length) + "\n                  Cuentas)\n                ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.budget.client_id) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.account_id),
      expression: "budget.account_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": !_vm.budget.social_reason_id || _vm.checked
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budget, "account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.resetBudgetItems('account_id')
      }]
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione una cuenta")]), _vm._v(" "), _vm._l((_vm.accounts_client), function(account) {
    return _c('option', {
      key: ((account.id) + "-account"),
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                  " + _vm._s(account.name) + "\n                ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.budget.account_id) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Director")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.ejecutive_id),
      expression: "budget.ejecutive_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": _vm.checked
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budget, "ejecutive_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione Director...")]), _vm._v(" "), _vm._l((_vm.filteredEjecutives), function(ejecutive) {
    return _c('option', {
      key: ((ejecutive.id) + "-ejecutive"),
      domProps: {
        "value": ejecutive.id
      }
    }, [_vm._v("\n                  " + _vm._s(ejecutive.name) + " - " + _vm._s(ejecutive.email) + "\n                ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.budget.ejecutive_id) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.project_id),
      expression: "budget.project_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": !_vm.budget.account_id || _vm.checked
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budget, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione un proyecto")]), _vm._v(" "), _vm._l((_vm.filteredProjects), function(project) {
    return _c('option', {
      key: ((project.id) + "-project"),
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + "\n                  " + _vm._s(project.account.country.prefix) + "\n                ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.budget.project_id) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.campaign_id),
      expression: "budget.campaign_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": !_vm.budget.project_id || _vm.checked
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budget, "campaign_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione la campaña")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      key: ((campaign.id) + "-campaign"),
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n                  " + _vm._s(campaign.name) + "\n                ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.budget.campaign_id) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Tipo de presupuesto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.type),
      expression: "budget.type"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": _vm.checked
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budget, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": "",
      "value": "null"
    }
  }, [_vm._v("Seleccione tipo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cliente"
    }
  }, [_vm._v("Cliente")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cargo agencia"
    }
  }, [_vm._v("Cargo Agencia")])])]) : _vm._e(), _vm._v(" "), (_vm.budget.type) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Comision Agencia")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.commission_agency),
      expression: "budget.commission_agency"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "step": ".01",
      "required": "",
      "disabled": _vm.checked
    },
    domProps: {
      "value": (_vm.budget.commission_agency)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.budget, "commission_agency", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.budget.type) ? _c('div', {
    staticClass: "col-span-12"
  }, [_c('div', {
    staticClass: "px-5 sm:px-8 py-5 sm:py-10"
  }, [_c('div', {
    staticClass: "overflow-x-auto"
  }, [_c('table', {
    staticClass: "table table-custom"
  }, [_vm._m(1), _vm._v(" "), (!_vm.budgetitems.length) ? _c('tbody', [_vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.budgetitems), function(item, index) {
    return _c('tbody', {
      key: ((item.name) + "-budget-item-" + index),
      staticClass: "border-b dark:border-dark-5"
    }, [_c('tr', [_c('td', [(!_vm.checked) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.lazy",
        value: (item.name),
        expression: "item.name",
        modifiers: {
          "lazy": true
        }
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "name", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap"
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.quantity),
        expression: "item.quantity"
      }],
      staticClass: "input w-20 border mt-auto flex-1",
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": (item.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "quantity", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                            " + _vm._s(item.quantity) + "\n                          ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('currency-input', {
      staticClass: "input w-full border mt-2 text-center",
      attrs: {
        "id": item.id,
        "locale": "es",
        "precision": 5,
        "valueRange": {
          min: 0
        },
        "distraction-free": {
          hideNegligibleDecimalDigits: true,
        },
        "currency": {
          prefix: '$ '
        }
      },
      on: {
        "blur": function($event) {
          item.unit_value == null ?
            (item.unit_value = 0) :
            ''
        }
      },
      model: {
        value: (item.unit_value),
        callback: function($$v) {
          _vm.$set(item, "unit_value", $$v)
        },
        expression: "item.unit_value"
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                            $" + _vm._s(_vm.formatPrice(item.unit_value)) + "\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "text-center"
    }, [_vm._v("SUBTOTAL:")]), _vm._v(" "), _c('div', {
      staticClass: "text-center"
    }, [_vm._v("\n                              $\n                              " + _vm._s(_vm.formatPrice(item.quantity * item.unit_value)) + "\n                            ")])])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.iva),
        expression: "item.iva"
      }],
      staticClass: "input w-full border mt-auto flex-1",
      attrs: {
        "name": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "iva", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("0%")]), _vm._v(" "), (_vm.selectedSocialReason.iva) ? _c('option', {
      domProps: {
        "value": _vm.selectedSocialReason.iva
      }
    }, [_vm._v("\n                              " + _vm._s(_vm.selectedSocialReason.iva) + "%\n                            ")]) : _vm._e()]) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                            " + _vm._s(item.iva) + "%\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "text-center whitespace-no-wrap"
    }, [_vm._v("\n                              VALOR:\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-center whitespace-no-wrap"
    }, [_vm._v("\n                              $\n                              " + _vm._s(_vm.formatPrice(
      _vm.percentCalculator(
        item.iva,
        item.quantity * item.unit_value
      )
    )) + "\n                            ")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.commission),
        expression: "item.commission"
      }],
      staticClass: "input w-full border mt-auto flex-1 text-center",
      attrs: {
        "name": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "commission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("0%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("1%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2.5
      }
    }, [_vm._v("2,5%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 3
      }
    }, [_vm._v("3%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 3.2
      }
    }, [_vm._v("3,2%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 4
      }
    }, [_vm._v("4%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 4.2
      }
    }, [_vm._v("4,2%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 6
      }
    }, [_vm._v("6%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 7.2
      }
    }, [_vm._v("7,2%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 8
      }
    }, [_vm._v("8%")])]) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                            " + _vm._s(item.commission) + "%\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "text-center whitespace-no-wrap"
    }, [_vm._v("\n                              VALOR:\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-center whitespace-no-wrap"
    }, [_vm._v("\n                              $\n                              " + _vm._s(_vm.formatPrice(
      _vm.percentCalculator(
        item.commission,
        item.quantity * item.unit_value
      )
    )) + "\n                            ")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "whitespace-no-wrap text-center"
    }, [_vm._v("\n                            $\n                            " + _vm._s(_vm.formatPrice(
      item.quantity * item.unit_value +
      _vm.percentCalculator(
        item.iva,
        item.quantity * item.unit_value,
        false
      ) +
      _vm.percentCalculator(
        item.commission,
        item.quantity * item.unit_value,
        false
      )
    )) + "\n                          ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "flex flex-col"
    }, [(!_vm.checked) ? _c('currency-input', {
      staticClass: "input w-full border mt-2 text-center",
      attrs: {
        "id": item.id,
        "locale": "es",
        "precision": 5,
        "valueRange": {
          min: 0
        },
        "distraction-free": {
          hideNegligibleDecimalDigits: true,
        },
        "currency": {
          prefix: '$ '
        }
      },
      model: {
        value: (item.unit_value_internal),
        callback: function($$v) {
          _vm.$set(item, "unit_value_internal", $$v)
        },
        expression: "item.unit_value_internal"
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                              $" + _vm._s(_vm.formatPrice(item.unit_value_internal)) + "\n                            ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.supplier_id),
        expression: "item.supplier_id"
      }],
      staticClass: "input w-full border mt-auto flex-1 text-center",
      attrs: {
        "disabled": _vm.checked
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "supplier_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("Seleccionar ...")]), _vm._v(" "), _vm._l((_vm.suppliers), function(supplier, index) {
      return _c('option', {
        key: ((supplier.id) + "-" + index + "-supplier"),
        domProps: {
          "value": supplier.id
        }
      }, [_vm._v("\n                                " + _vm._s(supplier.social_reason) + "\n                              ")])
    })], 2)], 1)]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      attrs: {
        "rowspan": "2"
      }
    }, [(!_vm.checked) ? _c('button', {
      staticClass: "button bg-theme-6 text-white mt-auto",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.budgetitems.splice(index, 1)
        }
      }
    }, [_vm._v("\n                            Eliminar\n                          ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v("DESCRIPCION(*):")]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [(!_vm.checked) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "rows": "3",
        "required": ""
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap"
    }, [_vm._v("\n                            " + _vm._s(item.description) + "\n                          ")])])])])
  })], 2)]), _vm._v(" "), (!_vm.checked) ? _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-3 py-5 bg-gray-400 px-2 rounded"
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Agregar item:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCurrentItem.id),
      expression: "budgetCurrentItem.id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budgetCurrentItem, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredBudgetElements), function(element) {
    return _c('option', {
      key: ((element.id) + "-budget-element"),
      domProps: {
        "value": element.id
      }
    }, [_vm._v("\n                        " + _vm._s(element.name) + " - $\n                        " + _vm._s(_vm.formatPrice(element.value)) + "\n                      ")])
  }), _vm._v(" "), (_vm.filteredBudgetElements.length) ? _c('option', {
    attrs: {
      "value": "special"
    }
  }, [_vm._v("\n                        Nuevo Elemento\n                      ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-3"
  }, [_c('label', [_vm._v("Cantidad:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCurrentItem.quantity),
      expression: "budgetCurrentItem.quantity"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.budgetCurrentItem.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.budgetCurrentItem, "quantity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-3 flex"
  }, [_c('button', {
    staticClass: "button w-24 bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "button",
      "disabled": !_vm.budgetCurrentItem.id
    },
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_vm._v("\n                      Agregar\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "px-5 sm:px-20 pb-10 sm:pb-20 flex flex-col-reverse sm:flex-row"
  }, [_c('div', {
    staticClass: "text-center sm:text-right sm:ml-auto mt-5"
  }, [_c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                      Subtotal:\n                      "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                        " + _vm._s(_vm.budget.money_code) + " $ " + _vm._s(_vm.formatPrice(_vm.subtotal)) + "\n                      ")])]), _vm._v(" "), (_vm.subtotal) ? _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                      Subtotal:\n                      "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                        USD $ " + _vm._s(_vm.formatPrice(_vm.budget.usd_subtotal)) + "\n                      ")])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                      Impuestos subtotal:\n                      "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                        " + _vm._s(_vm.budget.money_code) + " $\n                        " + _vm._s(_vm.formatPrice(_vm.taxSubtotal)) + "\n                      ")])]), _vm._v(" "), (_vm.budget.usd_convertion) ? _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                      Impuestos subtotal:\n                      "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                        USD $\n                        " + _vm._s(_vm.formatPrice(_vm.taxSubtotal / _vm.budget.usd_convertion)) + "\n                      ")])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                      Comision subtotal:\n                      "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                        " + _vm._s(_vm.budget.money_code) + " $\n                        " + _vm._s(_vm.formatPrice(_vm.commissionSubtotal)) + "\n                      ")])]), _vm._v(" "), (_vm.budget.usd_convertion) ? _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                      Comision subtotal:\n                      "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                        USD $\n                        " + _vm._s(_vm.formatPrice(
    _vm.commissionSubtotal / _vm.budget.usd_convertion
  )) + "\n                      ")])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xl text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v("TOTAL:")]), _vm._v("\n                      " + _vm._s(_vm.budget.money_code) + " $ " + _vm._s(_vm.formatPrice(_vm.total)) + "\n                    ")]), _vm._v(" "), (_vm.total) ? _c('div', {
    staticClass: "text-xl text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v("TOTAL: ")]), _vm._v("\n                      USD $ " + _vm._s(_vm.formatPrice(_vm.budget.usd_total)) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-1 tetx-xs"
  }, [_vm._v("Incluye Impuestos")])])])])]) : _vm._e(), _vm._v(" "), (_vm.checked) ? _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createBudget()
      }
    }
  }, [_vm._v("\n                Confirmar Presupuesto\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-11 text-white mt-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.checked = false
      }
    }
  }, [_vm._v("\n                Editar Presupuesto\n              ")])]) : _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                Crear Presupuesto\n              ")])])])])])])]) : _c('app-loading'), _vm._v(" "), (_vm.boxtrmchange) ? _c('TrmChangeModal', {
    attrs: {
      "socialreason": _vm.selectedSocialReason,
      "message": "No se ha actualizado este mes el TRM"
    },
    on: {
      "closeModal": function($event) {
        _vm.boxtrmchange = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Presupuesto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "border-b dark:border-dark-5"
  }, [_c('th', {
    staticClass: "whitespace-nowrap text-center p-1"
  }, [_vm._v("\n                          CONCEPTO ITEM\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("QTY")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("\n                          VALOR UNITARIO\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("IVA")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("\n                          COMISION\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("\n                          V INTERNO/PROVEEDOR\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("\n                          ACCIONES\n                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("\n                          No hay Elementos seleccionados\n                        ")])])
}]}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [(_vm.boxedit) ? _c('email-edit-modal', {
    attrs: {
      "nums": _vm.nums,
      "users": _vm.users,
      "states": _vm.states,
      "usersession": _vm.usersession,
      "email_current": _vm.email_current,
      "email_id": _vm.email_current || _vm.route.query.email
    },
    on: {
      "emailEdited": function($event) {
        return _vm.emailEdited()
      },
      "closeEditEmail": function($event) {
        return _vm.closeEditEmail()
      }
    }
  }) : _vm._e(), _vm._v(" "), (this.$route.path !== '/admin/pendings-emails') ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("\n          Cortes "), _c('app-title-custom'), _vm._v(" (" + _vm._s(_vm.filteredEmails.length) + ")\n        ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-2 sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": "search",
      "classname": "w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.name),
      expression: "filter.name"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre"
    },
    domProps: {
      "value": (_vm.filter.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter dropdown hidden md:block md:absolute inset-y-0 mr-3 right-0 flex items-center"
  }, [_c('app-icon', {
    attrs: {
      "name": "chevron-down",
      "classname": "dropdown-toggle w-4 h-4 mt-3 cursor-pointer text-gray-700"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box p-5"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.state),
      expression: "filter.state"
    }],
    staticClass: "input w-full border mt-2 flex-13",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione una opción")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return (state.id != 7) ? _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n                        " + _vm._s(state.name) + "\n                      ")]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Fecha entrega")]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.date),
      expression: "filter.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filter.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "date", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Codigo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.slug),
      expression: "filter.slug"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por codigo"
    },
    domProps: {
      "value": (_vm.filter.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "slug", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Creada por")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.created_by),
      expression: "filter.created_by"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "created_by", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("Seleccione un usuario")]), _vm._v(" "), _vm._l((_vm.filteredUsersAccount), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                        " + _vm._s(user.name) + "\n                      ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button mt-28 text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        _vm.filter = _vm.clearFilter()
      }
    }
  }, [_vm._v("\n                        Borrar Filtro\n                      ")])])])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "intro-y mb-4 flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [(_vm.user.team_id == 1) ? _c('email-download-list-button', {
    attrs: {
      "classname": 'mr-2'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.account_session) ? _c('button', {
    staticClass: "button button--sm mr-1",
    class: _vm.completed_emails ?
      'bg-theme-1 text-white' :
      'border border-theme-1 border-theme-10 text-theme-10',
    on: {
      "click": function($event) {
        return _vm.viewEmailFinish()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.completed_emails ?
    'Quitar cortes finalizados' :
    'Ver cortes finalizados') + "\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        return _vm.setCreateEmailModal(true)
      }
    }
  }, [_vm._v("\n              Crear Corte\n            ")])], 1)])])]) : _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-2 zindex-0 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("\n        Cortes Pendientes\n        "), (_vm.account_session) ? _c('app-title-custom') : _vm._e(), _vm._v("\n        (" + _vm._s(_vm.filteredEmails.length) + ")\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex items-center sm:ml-auto mt-0 sm:mt-0"
  }, [(_vm.account_session) ? _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.viewAccounts('all')
      }
    }
  }, [_vm._v("\n          Ver todas las cuentas\n        ")]) : _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-5 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.viewAccounts('one')
      }
    }
  }, [_vm._v("\n          Ver solo una cuenta\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report mt-8"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredEmails), function(email) {
    return _c('tr', {
      staticClass: "intro-x zindex-0"
    }, [_c('td', [_c('a', {
      staticClass: "font-medium whitespace-no-wrap",
      class: email.urgent == true ? 'text-red-700' : '',
      attrs: {
        "href": "#"
      }
    }, [_vm._v("\n                " + _vm._s(email.urgent == true ? 'URG-' : '') + _vm._s(_vm._f("limit")(email.name.toUpperCase())) + " - " + _vm._s(email.number) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(email.slug) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(email.created_at) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center w-40"
    }, [_c('div', {
      staticClass: "text-center text-xs"
    }, [_vm._v("\n                " + _vm._s(email.campaign_attribute.project_name) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-center text-xs"
    }, [_vm._v("\n                " + _vm._s(email.campaign_attribute.project_account_name) + " -\n                " + _vm._s(email.campaign_attribute.project_account_country_prefix) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-sm whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(email.campaign_attribute.name) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40"
    }, [_c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._l((_vm.users), function(user) {
      return [(email.created_by === user.id) ? _c('div', {
        key: ("user-created_by-" + (email.id) + "-1"),
        staticClass: "w-10 h-10 image-fit zoom-in"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": email.user_created_name,
          "src": user.avatar ?
            user.avatar :
            "/static/images/profile.png",
          "title": email.user_created_name
        }
      })]) : _vm._e()]
    }), _vm._v(" "), _vm._l((_vm.users), function(user) {
      return [(email.user_id === user.id) ? _c('div', {
        key: ("user-user_id-" + (email.id) + "-2"),
        staticClass: "w-10 h-10 image-fit zoom-in -ml-5"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": email.user_name,
          "src": user.avatar ?
            user.avatar :
            "/static/images/profile.png",
          "title": email.user_name
        }
      })]) : _vm._e()]
    }), _vm._v(" "), _vm._l((_vm.users), function(user) {
      return [(email.reviewed_by === user.id) ? _c('div', {
        key: ("user-user_id-" + (email.id) + "-3"),
        staticClass: "w-10 h-10 image-fit zoom-in -ml-5"
      }, [_c('img', {
        staticClass: "tooltip rounded-full tooltipstered",
        attrs: {
          "alt": user.name,
          "src": user.avatar ?
            user.avatar :
            "/static/images/profile.png",
          "title": user.name
        }
      })]) : _vm._e()]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "flex items-center justify-center"
    }, [_vm._v("\n                " + _vm._s(email.state_name) + _vm._s(email.hours ? (" - " + (email.hours) + " hs") : '') + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "button button--sm w-24 text-white",
      class: _vm.dateClass(email)
    }, [_vm._v("\n                " + _vm._s(email.date) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('a', {
      staticClass: "cursor-pointer flex items-center pr-3",
      on: {
        "click": function($event) {
          return _vm.showEmailClassification(email)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "file",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v(" Tipos\n                ")], 1), _vm._v("\n                 \n                "), (email.state_id >= 5) ? _c('a', {
      staticClass: "cursor-pointer flex items-center pr-3",
      on: {
        "click": function($event) {
          return _vm.viewEmail(email)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "eye",
        "classname": "w-5 h-5 mr-2"
      }
    }), _vm._v(" Ver\n                ")], 1) : _vm._e(), _vm._v("\n                 \n                "), (email.state_id != 6) ? _c('div', [(
      email.campaign_attribute.account_id ==
      _vm.auth_session_account
    ) ? _c('button', {
      staticClass: "cursor-pointer flex items-center pr-3",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.editElement(email)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v(" Editar\n                  ")], 1) : _c('button', {
      staticClass: "cursor-pointer flex items-center pr-3",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.viewAccountEmail(email)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Editar\n                  ")], 1)]) : _vm._e(), _vm._v(" "), (email.state_id >= 5) ? _c('router-link', {
      staticClass: "cursor-pointer flex items-center pr-3",
      attrs: {
        "to": ("/admin/emails-check/" + (email.id))
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v(" Check\n                ")], 1) : _vm._e()], 1)])])
  }), 0)])])], 1) : _c('app-loading'), _vm._v(" "), (_vm.createEmailModal) ? _c('CreateEmailModal', {
    attrs: {
      "nums": _vm.nums,
      "email": _vm.email,
      "user": _vm.user
    },
    on: {
      "closeModal": function($event) {
        return _vm.setCreateEmailModal(false)
      },
      "emailCreated": function($event) {
        return _vm.emailCreated()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.emailClassification) ? _c('EmailClassificationModal', {
    attrs: {
      "email": _vm.emailClassification
    },
    on: {
      "closeModal": function($event) {
        return _vm.closeEmailClassificationModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.email_view) ? _c('ViewEmailModal', {
    attrs: {
      "email": _vm.email_view,
      "versions": _vm.email_view.versions
    },
    on: {
      "closeModal": function($event) {
        _vm.email_view = null
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PROYECTO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ESTADO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("FECHA ENTREGA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
}]}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal modal-special",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--lg"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Crear Corte - "), _c('app-title-custom')], 1)]), _vm._v(" "), _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createElement.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.name),
      expression: "email.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.email.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Numero de pieza(s)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.number),
      expression: "email.number"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "number", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.nums), function(num) {
    return _c('option', {
      domProps: {
        "value": num
      }
    }, [_vm._v("\n                  " + _vm._s(num) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Urgente")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.urgent),
      expression: "email.urgent"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "urgent", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("NO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("SI")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Fecha de entrega")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.date),
      expression: "email.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.email.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.project_id),
      expression: "email.project_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredProjects), function(project) {
    return _c('option', {
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + "\n                  " + _vm._s(project.account.country.prefix) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.campaign_id),
      expression: "email.campaign_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email, "campaign_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n                  " + _vm._s(campaign.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Url Archivo (Opcional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email.path),
      expression: "email.path"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.email.path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email, "path", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
  }, [_c('div', {
    staticClass: "rounded-md items-center px-5 py-4 mb-2 border border-theme-1 text-theme-1"
  }, [_c('b', [_vm._v("Nota:")]), _vm._v(" Recuerda compartir la carpeta o archivo a las personas involucradas.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "disabled": _vm.emailButtonLoading
    }
  }, [(_vm.emailButtonLoading) ? [_vm._v("\n                Creando Corte...\n              ")] : [_vm._v(" Crear Corte ")]], 2)])])])])])])
},staticRenderFns: []}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "emailClassificationModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--xl",
    attrs: {
      "id": "emailClassificationModalContent"
    }
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n        CAMBIAR TIPO CORTE: " + _vm._s(_vm.emailClassification.name) + " "), _c('br')]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeModal')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "intro-y box py-10 mt-5"
  }, [_c('div', {
    staticClass: "wizard flex justify-center px-5 sm:px-20"
  }, [_vm._l((_vm.classifications), function(email) {
    return _c('div', {
      key: email.position,
      staticClass: "intro-x lg:text-center flex items-center md:block flex-1 z-10 w-10"
    }, [_c('button', {
      staticClass: "w-10 h-10 rounded-full button",
      class: email.checked ?
        'text-white bg-theme-1' :
        'text-gray-600 bg-gray-200'
    }, [_vm._v("\n            " + _vm._s(email.position) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "lg:w-32 text-base lg:mt-3 ml-3 lg:mx-auto",
      class: email.checked ? 'font-medium' : 'text-gray-700'
    }, [_vm._v("\n            " + _vm._s(email.name) + "\n          ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "wizard__line hidden lg:block w-2/3 bg-gray-200 absolute mt-5"
  })], 2), _vm._v(" "), (_vm.isLoading) ? _c('app-loading') : [(_vm.classifications[_vm.form.current]) ? _c('div', {
    staticClass: "px-5 sm:px-20 mt-10 pt-10 border-t border-gray-200"
  }, [_c('div', {
    staticClass: "font-medium text-base"
  }, [_vm._v("\n            Pieza #" + _vm._s(_vm.classifications[_vm.form.current].position) + "\n          ")]), _vm._v(" "), _c('form', {
    staticClass: "form-task",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.proccessEmailType('sum')
      }
    }
  }, [_vm._l((_vm.errors), function(error) {
    return _c('div', {
      key: error
    }, [_c('p', {
      staticClass: "px-5 py-2 grid text-red-700 font-extrabold"
    }, [_vm._v("\n                " + _vm._s(error) + "\n              ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("NOMBRE")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.classifications[_vm.form.current].name),
      expression: "classifications[form.current].name",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "name": "name",
      "required": "",
      "autocomplete": "new-name",
      "disabled": _vm.user.team_id != 1
    },
    domProps: {
      "value": (_vm.classifications[_vm.form.current].name)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.classifications[_vm.form.current], "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("TIPO")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.classifications[_vm.form.current].type),
      expression: "classifications[form.current].type",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": _vm.user.team_id != 1
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.classifications[_vm.form.current], "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("\n                    Seleccione una opción\n                  ")]), _vm._v(" "), _vm._l((_vm.types), function(type) {
    return _c('option', {
      key: type.value,
      domProps: {
        "value": type.value
      }
    }, [_vm._v("\n                    " + _vm._s(type.name) + "\n                  ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("CANTIDAD DE PAGINAS")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.classifications[_vm.form.current].quantity),
      expression: "classifications[form.current].quantity",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "5",
      "step": ".01",
      "required": "",
      "disabled": _vm.user.team_id != 1
    },
    domProps: {
      "value": (_vm.classifications[_vm.form.current].quantity)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.classifications[_vm.form.current], "quantity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("HORAS")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.classifications[_vm.form.current].hours),
      expression: "classifications[form.current].hours",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "step": ".01",
      "required": "",
      "disabled": _vm.user.team_id != 1
    },
    domProps: {
      "value": (_vm.classifications[_vm.form.current].hours)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.classifications[_vm.form.current], "hours", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-left border-t border-gray-200"
  }, [_c('button', {
    staticClass: "btn btn-secondary w-24",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.proccessEmailType
    }
  }, [_vm._v("\n                Anterior\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "button text-white",
    class: _vm.isLastElement ? 'btn-secondary' : 'bg-theme-1',
    attrs: {
      "type": "submit",
      "disabled": _vm.isLastElement
    }
  }, [_vm._v("\n                Siguiente\n              ")]), _vm._v(" "), (_vm.isLastElement && _vm.user.team_id == 1) ? _c('button', {
    staticClass: "button bg-theme-1 text-white float-right",
    attrs: {
      "type": "submit",
      "disabled": _vm.buttonisLoading
    }
  }, [_vm._v("\n                " + _vm._s(_vm.buttonisLoading ? 'Cargando...' : 'Guardar Cambios') + "\n              ")]) : _vm._e()])], 2)]) : _vm._e()]], 2)])])
},staticRenderFns: []}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    class: ['button flex py-2 text-white bg-theme-1 zoom-in', _vm.classname],
    on: {
      "click": _vm.downloadList
    }
  }, [_c('Icon', {
    attrs: {
      "name": 'download',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n    " + _vm._s(_vm.text) + "\n  ")], 1), _vm._v(" "), _c('a', {
    ref: "download_planning",
    staticClass: "hidden",
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer nofollow"
    }
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "grid grid-cols-12 gap-3 mt-5"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto flex col-span-12"
  }, [_c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2 mx-auto",
    attrs: {
      "to": "/admin/business/suppliers"
    }
  }, [_vm._v("\n          Regresar\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 md:col-span-12 box bg-white content"
  }, [(_vm.current.socialreasons.length) ? _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n          Razones Sociales Asignadas\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-3 mt-5"
  }, _vm._l((_vm.current.socialreasons), function(socialreason, index) {
    return _c('div', {
      key: index,
      staticClass: "intro-y col-span-12 md:col-span-6"
    }, [_c('div', {
      staticClass: "box bg-theme-1 text-white"
    }, [_c('div', {
      staticClass: "flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(socialreason.name) + " - " + _vm._s(socialreason.country_prefix))])]), _vm._v(" "), _c('div', {
      staticClass: "flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 zoom-in text-white",
      on: {
        "click": function($event) {
          return _vm.removeElement(socialreason, 'suppliersocialreason')
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "minus",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1)])])])])
  }), 0), _vm._v(" "), (_vm.filteredSocialReasons.length) ? _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n            Razones Sociales Sin Asignar\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-3 mt-5"
  }, _vm._l((_vm.filteredSocialReasons), function(socialreason, index) {
    return _c('div', {
      key: index,
      staticClass: "intro-y col-span-12 md:col-span-6"
    }, [_c('div', {
      staticClass: "box bg-gray-300"
    }, [_c('div', {
      staticClass: "flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(socialreason.name) + " - " + _vm._s(socialreason.country_prefix))])]), _vm._v(" "), _c('div', {
      staticClass: "flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "bg-gray-100 border flex h-8 items-center justify-center ml-2 pl-2 rounded-full w-8 zoom-in",
      on: {
        "click": function($event) {
          return _vm.addElement(socialreason, 'suppliersocialreason')
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "plus",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1)])])])])
  }), 0)])]) : _c('app-loading')], 1)
},staticRenderFns: []}

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.emails), function(email) {
    return _c('tr', {
      staticClass: "intro-x"
    }, [_c('td', [_c('div', {
      staticClass: "font-medium whitespace-no-wrap"
    }, [_vm._v(_vm._s(email.user_created_name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(email.total))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.finishEmails(email.user_created.id)
        }
      }
    }, [_vm._v("\n                  Finalizar todas\n                ")])])])
  }), 0)])])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("NOMBRE")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("# TAREAS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
}]}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Editar Libreria"
    },
    on: {
      "close": _vm.emitClose
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateLibrary.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.library.name),
      expression: "library.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.library.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.library, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Estado:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.library.active),
      expression: "library.active"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.library, "active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Activo")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Inactivo")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Descripción:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.library.description),
      expression: "library.description"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": (_vm.library.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.library, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Categoria")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.library.category),
      expression: "library.category"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.library, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccionar...")]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: ("category-" + (category.name)),
      domProps: {
        "value": category.name
      }
    }, [_vm._v("\n            " + _vm._s(category.name) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Visualización")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.library.team_id),
      expression: "library.team_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.library, "team_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("TODOS")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return [_c('option', {
      key: ("team-" + (team.id)),
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n              " + _vm._s(team.name) + "\n            ")])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Creado Por")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.library.team_createdby_id),
      expression: "library.team_createdby_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.library, "team_createdby_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("TODOS")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return [_c('option', {
      key: ("team-" + (team.id)),
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n              " + _vm._s(team.name) + "\n            ")])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Url:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.library.url),
      expression: "library.url"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.library.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.library, "url", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.emitClose
    }
  }, [_vm._v("\n        Cancelar\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "edit"
    }
  }, [_vm._v("\n        Editar\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("absolute top-0 right-0 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600 zoom-in cursor-pointer " + _vm.classes),
    on: {
      "click": function($event) {
        return _vm.CopyClipboard(_vm.text)
      }
    }
  }, [_c('a', [_c('Icon', {
    attrs: {
      "name": "copy",
      "classname": "w-6 h-6"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n      Editar Email - "), _c('app-title-custom')], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check w-full sm:w-auto sm:ml-auto mt-3 sm:mt-0"
  }, [_vm._v("\n      Creada por:"), _c('label', {
    staticClass: "form-check-label ml-0 sm:ml-2",
    attrs: {
      "for": "show-example-1"
    }
  }, [_vm._v(_vm._s(_vm.email_current.user_created_name) + " -\n        " + _vm._s(_vm.email_current.created_at) + "\n      ")])])]), _vm._v(" "), _c('form', {
    staticClass: "form-task",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateElement.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.name),
      expression: "email_current.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.email_current.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_current, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Numero de pieza(s)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.number),
      expression: "email_current.number"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email_current, "number", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.nums), function(num) {
    return _c('option', {
      domProps: {
        "value": num
      }
    }, [_vm._v("\n            " + _vm._s(num) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.campaign_attribute.project_name),
      expression: "email_current.campaign_attribute.project_name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.email_current.campaign_attribute.project_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_current.campaign_attribute, "project_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.campaign_attribute.name),
      expression: "email_current.campaign_attribute.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.email_current.campaign_attribute.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_current.campaign_attribute, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Fecha de entrega:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.date),
      expression: "email_current.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.email_current.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_current, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Urgente")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.urgent),
      expression: "email_current.urgent"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email_current, "urgent", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("NO")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("SI")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.state_id),
      expression: "email_current.state_id"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email_current, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n            " + _vm._s(state.name) + "\n          ")])
  })], 2)]), _vm._v(" "), (_vm.usersession.team_id == 1) ? _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Realizado Por")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.user_id),
      expression: "email_current.user_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email_current, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n            " + _vm._s(user.name) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.usersession.team_id == 1) ? _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Revisado Por")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.reviewed_by),
      expression: "email_current.reviewed_by"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.email_current, "reviewed_by", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n            " + _vm._s(user.name) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.email_current.path) ? _c('div', {
    staticClass: "relative col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Url Archivo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.path),
      expression: "email_current.path"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email_current.path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_current, "path", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.email_current.path,
      "target": "_blank"
    }
  }, [(_vm.email_current.path) ? _c('div', {
    staticClass: "absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
  }, [_c('app-icon', {
    attrs: {
      "name": "link",
      "classname": "w-4 h-4"
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (
    [5, 7].includes(_vm.email_current.state_id) ||
    (_vm.email_current.state_id == 4 && _vm.usersession.team_id == 1)
  ) ? _c('div', {
    staticClass: "col-span-12 gap-4 grid grid-cols-12 py-5 row-gap-3 sm:col-span-12 bg-gray-300 px-3 rounded"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Descripcion Respuesta")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.response_observations),
      expression: "email_current.response_observations"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "4",
      "required": ""
    },
    domProps: {
      "value": (_vm.email_current.response_observations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_current, "response_observations", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "relative col-span-6 sm:col-span-6"
  }, [_c('div', {
    staticClass: "mb-2 relative"
  }, [_c('label', [_vm._v("Url Archivo Respuesta (Opcional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email_current.response_path),
      expression: "email_current.response_path"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email_current.response_path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.email_current, "response_path", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.email_current.response_path) ? _c('a', {
    staticClass: "courser-pointer",
    attrs: {
      "href": _vm.email_current.response_path,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
  }, [_c('app-icon', {
    attrs: {
      "name": "link",
      "classname": "w-4 h-4"
    }
  })], 1)]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeEditEmail')
      }
    }
  }, [_vm._v("\n        Cancelar\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "edit",
      "disabled": _vm.buttonIsLoading
    }
  }, [(_vm.buttonIsLoading) ? [_vm._v(" Cargando... ")] : [_vm._v(" Modificar ")]], 2)])]), _vm._v(" "), (_vm.email_current.versions) ? _c('div', [_vm._m(0), _vm._v(" "), _vm._l((_vm.email_current.versions), function(version) {
    return _c('div', {
      staticClass: "grid grid-cols-12 items-center gap-5 p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_vm._v("\n        " + _vm._s(version.observations) + "\n        "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v(_vm._s(version.created_at))]), _vm._v(" "), (version.path) ? _c('a', {
      staticClass: "button couser-pointer inline-block inline-flex bg-gray-200",
      attrs: {
        "href": version.path,
        "target": "_blank"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "link",
        "classname": "w-4 h-3 mt-1"
      }
    }), _vm._v("   Abrir Url\n        ")], 1) : _vm._e()]), _vm._v(" "), (version.response_observations) ? _c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_vm._v("\n        " + _vm._s(version.response_observations) + "\n        "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v(_vm._s(version.updated_at))]), _vm._v(" "), (version.response_path) ? _c('a', {
      staticClass: "button couser-pointer inline-block inline-flex bg-gray-200",
      attrs: {
        "href": version.response_path,
        "target": "_blank"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "link",
        "classname": "w-4 h-3 mt-1"
      }
    }), _vm._v("   Abrir Url\n        ")], 1) : _vm._e()]) : _c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_c('form', {
      staticClass: "intro-y gap-3",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.updateVersion(version)
        }
      }
    }, [_c('div', {
      staticClass: "col-span-6 sm:col-span-6 mb-1"
    }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.version_current.response_observations),
        expression: "version_current.response_observations"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "rows": "3",
        "required": ""
      },
      domProps: {
        "value": (_vm.version_current.response_observations)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.version_current, "response_observations", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-span-6 sm:col-span-6"
    }, [_c('div', {
      staticClass: "mb-2"
    }, [_c('label', [_vm._v("Url Archivo (Opcional)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.version_current.response_path),
        expression: "version_current.response_path"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.version_current.response_path)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.version_current, "response_path", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 col-span-12 sm:col-span-12"
    }, [_c('button', {
      staticClass: "button bg-theme-1 text-white",
      attrs: {
        "type": "submit",
        "id": "editversion",
        "disabled": _vm.buttonIsLoading
      }
    }, [(_vm.buttonIsLoading) ? [_vm._v(" Cargando... ")] : [_vm._v(" Responder ")]], 2)])])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5 form-task",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createVersion.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.observations),
      expression: "version.observations"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "4",
      "required": ""
    },
    domProps: {
      "value": (_vm.version.observations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "observations", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('label', [_vm._v("Url Archivo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.path),
      expression: "version.path"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.version.path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "path", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mt-8 col-span-12 sm:col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "createversion",
      "disabled": _vm.buttonIsLoading
    }
  }, [(_vm.buttonIsLoading) ? [_vm._v(" Cargando... ")] : [_vm._v(" Confirmar Nueva Version ")]], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Versiones")])])
}]}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "col-span-12 intro-y"
  }, [_c('div', [(_vm.series.length > 0) ? _c('div', {
    staticClass: "my-2"
  }, [(_vm.start_date) ? _c('div', {
    staticClass: "flex flex-row justify-between mb-2"
  }, [_c('p', {
    staticClass: "mt-2"
  }, [_vm._v("Reporte de horas por mes")]), _vm._v(" "), _c('span', {
    staticClass: "border rounded p-2"
  }, [_vm._v(_vm._s(_vm.start_date) + " a " + _vm._s(_vm.end_date))])]) : _vm._e(), _vm._v(" "), _c('VueApexCharts', {
    attrs: {
      "width": "100%",
      "height": "500",
      "type": "bar",
      "options": _vm.options,
      "series": _vm.series
    }
  })], 1) : _vm._e()])]) : _c('div', {
    staticClass: "col-span-12 intro-y"
  }, [_c('Loading')], 1)
},staticRenderFns: []}

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "overflow-auto"
  }, [_c('div', {
    staticClass: "flex justify-between my-2"
  }, [_c('div', {
    staticClass: "flex text-center"
  }, [_c('div', {
    staticClass: "font-bold bg-theme-1 text-white text-bold rounded text-md mx-auto w-76 p-2"
  }, [_vm._v(_vm._s(_vm.start_date) + " a " + _vm._s(_vm.end_date))])]), _vm._v(" "), _c('router-link', {
    staticClass: "w-50",
    attrs: {
      "to": '/admin/reports'
    }
  }, [_c('button', {
    staticClass: "button button--sm w-32 flex items-center justify-center bg-theme-1 text-white zoom-in"
  }, [_c('app-icon', {
    attrs: {
      "name": 'chart',
      "classname": 'w-4 h-4 mr-2'
    }
  }), _vm._v("\n                    Reporte\n                ")], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex w-1/2"
  }, [_c('div', {
    staticClass: "w-2/4 flex gap-2"
  }, [_c('p', {
    staticClass: "py-2 pt-2 w-20"
  }, [_vm._v("Ordenar por:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order_select),
      expression: "order_select"
    }],
    staticClass: "input w-full border flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.order_select = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeOrder($event)
      }]
    }
  }, [_vm._l((_vm.orders), function(item) {
    return [_c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                            ")])]
  })], 2)])]), _vm._v(" "), ([1, 2, 3, 9].includes(_vm.user.team_id)) ? _c('div', {
    staticClass: "flex w-1/2"
  }, [_c('div', {
    staticClass: "w-2/4 flex gap-2"
  }, [_c('div', {
    staticClass: "py-2 pt-2 w-20"
  }, [_vm._v("Filtrar por:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.group),
      expression: "filter.group"
    }],
    staticClass: "input w-full border flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeGroup($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('option', {
      key: group.id,
      domProps: {
        "value": group.id
      }
    }, [_vm._v("\n                                " + _vm._s(group.name) + "\n                            ")])
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex py-4 gap-2"
  }, [_c('div', {
    staticClass: "w-1/3 text-center bg-white shadow-lg p-2 rounded-lg"
  }, [_vm._v("\n                    Total Horas: "), _c('b', [_vm._v(_vm._s(_vm.total_hours))])]), _vm._v(" "), _c('div', {
    staticClass: "w-1/3 text-center bg-white shadow-lg p-2 rounded-lg"
  }, [_vm._v("\n                    Total Horas Usadas: "), _c('b', [_vm._v(_vm._s(_vm.total_hours_used.toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "w-1/3 text-center bg-white shadow-lg p-2 rounded-lg"
  }, [_vm._v("\n                    Horas Disponibles: "), _c('b', [_vm._v(_vm._s(parseFloat(_vm.total_hours - _vm.total_hours_used).toFixed(2)))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.tasks), function(task) {
    return _c('tr', {
      staticClass: "intro-x"
    }, [_c('td', [_c('div', {
      staticClass: "font-medium whitespace-no-wrap"
    }, [_c('b', {
      class: [
        task.hours > 1 ?
        'text-theme-1' :
        '' ]
    }, [_vm._v(_vm._s(task.name))])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(task.group))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(task.hours))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-center text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(task.hours_used))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "w-full h-4 bg-gray-400 rounded"
    }, [(task.percentage > 100) ? _c('div', {
      staticClass: "h-full rounded text-center text-xs text-white bg-theme-6",
      style: ({
        width: '100%'
      })
    }, [_vm._v(_vm._s(task.percentage) + "%")]) : _c('div', {
      staticClass: "h-full rounded text-center text-xs text-white bg-theme-1",
      style: ({
        width: task.percentage > 0 ? task.percentage + '%' : '0px'
      })
    }, [_vm._v(_vm._s(task.percentage) + "%")])])])])
  }), 0)])])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "whitespace-no-wrap"
  }, [_vm._v("CUENTA - PROYECTO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("GRUPO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("HORAS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("USADAS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PORCENTAJE")])])])
}]}

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("\n          Cortes "), _c('app-title-custom')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-2 sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": 'search',
      "classname": 'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.slug),
      expression: "filter.slug"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por codigo"
    },
    domProps: {
      "value": (_vm.filter.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "slug", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "intro-y mt-2 mb-4 flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "to": "/admin/emails"
    }
  }, [_vm._v("Regresar")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "intro-y chat grid grid-cols-12 gap-5 mt-5"
  }, [_c('div', {
    staticClass: "col-span-12 lg:col-span-4 xxl:col-span-3"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "chats",
      "role": "tabpanel",
      "aria-labelledby": "chats-tab"
    }
  }, [_c('div', {
    staticClass: "chat__chat-list overflow-y-auto scrollbar-hidden pr-1 pt-1"
  }, _vm._l((_vm.filteredEmails), function(email, index) {
    return (email.state_id == 4 || email.state_id == 6) ? _c('div', {
      key: email.slug,
      staticClass: "intro-x cursor-pointer box relative flex items-center p-5",
      class: {
        'mt-5': index != 0
      },
      on: {
        "click": function($event) {
          return _vm.checkElement(email.id)
        }
      }
    }, [_c('div', {
      staticClass: "ml-2 overflow-hidden"
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [_c('div', [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(email.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v(_vm._s(email.campaign.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "w-full truncate text-gray-600 mt-0.5"
    }, [_vm._v(_vm._s(email.slug))]), _vm._v(" "), _c('div', {
      staticClass: "text-xs text-gray-500 ml-auto"
    }, [_vm._v(_vm._s(email.date))])]), _vm._v(" "), _c('div', {
      staticClass: "w-5 h-5 flex items-center justify-center absolute top-0 right-0 text-xs text-white rounded-full bg-theme-1 font-medium -mt-1 -mr-1"
    }, [_vm._v(_vm._s(email.pendingCheck))])]) : _vm._e()
  }), 0)])])]), _vm._v(" "), (_vm.emailCheck.state_id == 4 || _vm.emailCheck.state_id == 6) ? _c('div', {
    staticClass: "intro-y box col-span-12 lg:col-span-8 xxl:col-span-9"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-0 border-b border-gray-200 dark:border-dark-5"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n              Lista de aprobación: " + _vm._s(_vm.emailCheck.name) + "\n            ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "p-5"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "latest-tasks-new",
      "role": "tabpanel",
      "aria-labelledby": "latest-tasks-new-tab"
    }
  }, _vm._l((_vm.filteredCheckList), function(check, index) {
    return _c('div', {
      key: (index + "-checker"),
      staticClass: "flex items-center",
      class: {
        'mt-5': index != 0
      }
    }, [_c('div', {
      staticClass: "border-l-2 border-theme-1 pl-4"
    }, [_c('p', {
      staticClass: "font-medium"
    }, [_vm._v(_vm._s(check.type.description))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600"
    }, [_vm._v("Equipo: " + _vm._s(check.type.teamName))])]), _vm._v(" "), (!check.user_id && check.type.team_id == _vm.user.team_id) ? _c('div', {
      staticClass: "flex ml-auto"
    }, [_c('button', {
      staticClass: "bg-green-600 button--sm button mb-2 mr-1",
      on: {
        "click": function($event) {
          return _vm.changeCheckStatus(check, true)
        }
      }
    }, [_c('app-icon', {
      staticClass: "text-white",
      attrs: {
        "name": "check"
      }
    })], 1), _vm._v(" "), _c('button', {
      staticClass: "bg-red-600 button--sm button mb-2 mr-1",
      on: {
        "click": function($event) {
          return _vm.changeCheckStatus(check, false)
        }
      }
    }, [_c('app-icon', {
      staticClass: "text-white",
      attrs: {
        "name": "cancel"
      }
    })], 1)]) : _c('div', {
      staticClass: "flex ml-auto"
    }, [(check.user_id) ? _c('div', [(check.check) ? _c('button', {
      staticClass: "bg-green-900 button--sm button mb-2 mr-1",
      attrs: {
        "disabled": ""
      }
    }, [_c('app-icon', {
      staticClass: "text-white",
      attrs: {
        "name": "check"
      }
    })], 1) : _c('button', {
      staticClass: "bg-red-900 button--sm button mb-2 mr-1",
      attrs: {
        "disabled": ""
      }
    }, [_c('app-icon', {
      staticClass: "text-white",
      attrs: {
        "name": "cancel"
      }
    })], 1)]) : _vm._e()])])
  }), 0)])])]) : _vm._e()])]) : _c('div', [_c('app-loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav nav-tabs ml-auto hidden sm:flex",
    attrs: {
      "role": "tablist"
    }
  }, [_c('a', {
    staticClass: "py-5 ml-6 active",
    attrs: {
      "data-toggle": "tab",
      "data-target": "#latest-tasks-new",
      "href": "javascript:;",
      "id": "latest-tasks-mobile-new-tab",
      "role": "tab",
      "aria-selected": "true"
    }
  }, [_vm._v("Actual")])])
}]}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "intro-y box mt-6"
  }, [_c('div', {
    staticClass: "flex flex-col sm:flex-row items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n        Editar Tarea - "), _c('app-title-custom')], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check w-full sm:w-auto sm:ml-auto mt-3 sm:mt-0"
  }, [_vm._v("\n        Creada por:\n        "), _c('label', {
    staticClass: "form-check-label ml-0 sm:ml-2",
    attrs: {
      "for": "show-example-1"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.task_current.user_created_name) + " - " + _vm._s(_vm.task_current.created_at) + "\n        ")])])]), _vm._v(" "), _c('form', {
    staticClass: "form-task",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateTask()
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.name),
      expression: "task_current.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": ![1].includes(_vm.usersession.role)
    },
    domProps: {
      "value": (_vm.task_current.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Fecha de entrega:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.date),
      expression: "task_current.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "date",
      "required": "",
      "disabled": _vm.usersession.role == 4 || _vm.task_current.state_id == 4
    },
    domProps: {
      "value": (_vm.task_current.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.usersession.role == 4) ? _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Horas:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.hours),
      expression: "task_current.hours"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.task_current.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current, "hours", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Horas:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.hours),
      expression: "task_current.hours"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    class: _vm.task_current.state_id == 4 ? 'cursor-not-allowed' : '',
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "step": ".01",
      "required": "",
      "disabled": _vm.task_current.state_id == 4
    },
    domProps: {
      "value": (_vm.task_current.hours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current, "hours", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.description),
      expression: "task_current.description"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "5",
      "disabled": ![1].includes(_vm.usersession.role)
    },
    domProps: {
      "value": (_vm.task_current.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.task_current.campaign_attribute) ? _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.campaign_attribute.project_name),
      expression: "task_current.campaign_attribute.project_name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.task_current.campaign_attribute.project_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current.campaign_attribute, "project_name", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.task_current.campaign_attribute) ? _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.campaign_attribute.name),
      expression: "task_current.campaign_attribute.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.task_current.campaign_attribute.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current.campaign_attribute, "name", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.usersession.role == 4) ? _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.state_id),
      expression: "task_current.state_id"
    }],
    staticClass: "input w-full border mt-2",
    class: _vm.task_current.state_id == 4 ? 'bg-disabled' : '',
    attrs: {
      "disabled": _vm.task_current.state_id == 4,
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task_current, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado...")]), _vm._v(" "), _vm._l((_vm.filteredStates), function(state) {
    return _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n              " + _vm._s(state.name) + "\n            ")])
  })], 2)]) : _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.state_id),
      expression: "task_current.state_id"
    }],
    staticClass: "input w-full border mt-2",
    class: _vm.task_current.state_id == 4 ? 'bg-disabled' : '',
    attrs: {
      "disabled": _vm.task_current.state_id == 4,
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task_current, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado...")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      attrs: {
        "disabled": ![4].includes(state.id) &&
          _vm.usersession.team_id != _vm.task_current.team_id
      },
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n              " + _vm._s(state.name) + "\n            ")])
  })], 2)]), _vm._v(" "), (_vm.usersession.team_id == this.team_session) ? _c('div', {
    staticClass: "col-span-12 sm:col-span-3"
  }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.user_id),
      expression: "task_current.user_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    class: _vm.task_current.state_id == 4 ? 'bg-disabled' : '',
    attrs: {
      "disabled": _vm.task_current.state_id == 4,
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task_current, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return [([2, 3, 4, 5].includes(user.roles[0].id)) ? _c('option', {
      key: user.id,
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                " + _vm._s(user.name) + "\n              ")]) : _vm._e()]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.task_current.path) ? _vm._l((_vm.task_current.path.split(',')), function(path, key) {
    return _c('div', {
      staticClass: "relative col-span-12 sm:col-span-4"
    }, [_c('label', [_vm._v("Url " + _vm._s(key + 1))]), _vm._v(" "), _c('input', {
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text",
        "disabled": ""
      },
      domProps: {
        "value": path
      }
    }), _vm._v(" "), (path) ? _c('div', {
      staticClass: "absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
    }, [_c('a', {
      attrs: {
        "href": path,
        "target": "_blank"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "link",
        "classname": "w-4 h-4"
      }
    })], 1)]) : _vm._e()])
  }) : _vm._e(), _vm._v(" "), ([3, 4, 5, 6, 7].includes(_vm.task_current.state_id)) ? _c('div', {
    staticClass: "col-span-12 gap-4 grid grid-cols-12 py-5 row-gap-3 sm:col-span-12 bg-gray-300 px-3 rounded"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Descripcion Respuesta")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_current.response_observations),
      expression: "task_current.response_observations"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "3",
      "required": "",
      "disabled": _vm.task_current.state_id == 6 ||
        _vm.task_current.state_id == 4 ||
        _vm.usersession.team_id != _vm.task_current.team_id
    },
    domProps: {
      "value": (_vm.task_current.response_observations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_current, "response_observations", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.edit_response_path) ? [_c('p', {
    staticClass: "relative col-span-12 sm:col-span-12"
  }, [_vm._v("\n              Urls Respuesta\n              "), (_vm.task_current.state_id != 4) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.editResponsePath()
      }
    }
  }, [_vm._v("- Editar")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.task_current.response_path), function(path, key) {
    return _c('div', {
      staticClass: "relative col-span-12 sm:col-span-12"
    }, [_c('label', [_vm._v("Url Respuesta " + _vm._s(key + 1))]), _vm._v(" "), _c('input', {
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": path
      }
    }), _vm._v(" "), (path) ? _c('div', {
      staticClass: "absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
    }, [_c('a', {
      attrs: {
        "href": path,
        "target": "_blank"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "link",
        "classname": "w-4 h-4"
      }
    })], 1)]) : _vm._e()])
  })] : [_c('div', {
    staticClass: "relative col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Url Archivo Respuesta (opcional)")]), _vm._v(" "), _c('MultiSelect', {
    staticClass: "mt-2",
    attrs: {
      "options": _vm.responsePathOptions,
      "multiple": true,
      "taggable": true,
      "disabled": _vm.task_current.state_id == 6 ||
        _vm.task_current.state_id == 4 ||
        _vm.usersession.team_id != _vm.task_current.team_id
    },
    on: {
      "tag": _vm.addResponseTag
    },
    model: {
      value: (_vm.response_path),
      callback: function($$v) {
        _vm.response_path = $$v
      },
      expression: "response_path"
    }
  })], 1)]], 2) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeEditTask')
      }
    }
  }, [_vm._v("\n          Cancelar\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create",
      "disabled": _vm.buttonIsLoading
    }
  }, [(_vm.buttonIsLoading) ? [_vm._v(" Cargando... ")] : [_vm._v(" Modificar ")]], 2)])]), _vm._v(" "), _c('h4', {
    staticClass: "ml-6 font-bold text-sm pb-2"
  }, [_vm._v("Listado de Versiones")]), _vm._v(" "), _c('hr', {
    staticClass: "mx-5"
  }), _vm._v(" "), _c('TaskEditVersions', {
    attrs: {
      "users": _vm.users,
      "states": _vm.states,
      "usersession": _vm.usersession,
      "task_current": _vm.task_current,
      "team_session": _vm.team_session
    }
  }), _vm._v(" "), (!_vm.createVersionVariable) ? _c('div', {
    staticClass: "border-b border-gray-200 flex flex-col items-center p-5 sm:flex-row"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createVersionVariable = true
      }
    }
  }, [_vm._v("\n        Crear Nueva Version\n      ")])]) : _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5 form-task",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createVersion()
      }
    }
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.observations),
      expression: "version.observations"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.version.observations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "observations", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('label', [_vm._v("Fecha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.date),
      expression: "version.date"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.version.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('MultiSelect', {
    staticClass: "mt-2",
    attrs: {
      "options": _vm.options,
      "multiple": true,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.version.path),
      callback: function($$v) {
        _vm.$set(_vm.version, "path", $$v)
      },
      expression: "version.path"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-8 col-span-3 sm:col-span-3"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "createversion",
      "disabled": _vm.buttonIsLoading
    }
  }, [(_vm.buttonIsLoading) ? [_vm._v(" Cargando... ")] : [_vm._v(" Confirmar Nueva Version ")]], 2)])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "grid grid-cols-12 mt-8"
  }, [_c('div', {
    staticClass: "col-span-6 lg:col-span-6 xxl:col-span-6"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2 mb-2"
  }, [_vm._v("\n        Biblioteca (" + _vm._s(_vm.filteredLibraries.length) + ")\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 lg:col-span-6 xxl:col-span-6"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.slug),
      expression: "filter.slug"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre..."
    },
    domProps: {
      "value": (_vm.filter.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "slug", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 lg:col-span-12 xxl:col-span-12 mb-4"
  }, [_c('p', {
    staticClass: "w-full"
  }, [_vm._v("Filtrar por cualquiera de las siguientes categorias:")]), _vm._v(" "), _c('div', {
    staticClass: "intro-y mt-2 flex flex-wrap"
  }, [_c('button', {
    staticClass: "button border-theme-5 border flex mr-1 mb-2",
    class: {
      'bg-theme-1 text-white': _vm.filter.category == null
    },
    on: {
      "click": function($event) {
        return _vm.setCategory(null)
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "layers",
      "classname": "w-4 h-4 mr-2 mt-1"
    }
  }), _vm._v("\n            Todas las categorias\n          ")], 1), _vm._v(" "), _vm._l((_vm.filteredCategories), function(categoryMenu) {
    return _c('button', {
      key: ("category-" + (categoryMenu.name)),
      staticClass: "button border-theme-5 border flex mr-1 mb-2",
      class: {
        'bg-theme-1 text-white': categoryMenu.name == _vm.filter.category
      },
      on: {
        "click": function($event) {
          return _vm.setCategory(categoryMenu.name)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": categoryMenu.icon ? categoryMenu.icon : 'file',
        "classname": "w-4 h-4 mr-2 mt-1"
      }
    }), _vm._v("\n            " + _vm._s(categoryMenu.name) + "\n          ")], 1)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 lg:col-span-12 xxl:col-span-12 mb-4"
  }, [_c('p', {
    staticClass: "w-full"
  }, [_vm._v("Filtrar por cualquiera de los siguientes equipos:")]), _vm._v(" "), _c('div', {
    staticClass: "intro-y mt-2 flex flex-wrap"
  }, [_c('button', {
    staticClass: "button border-theme-5 border flex mr-1 mb-2",
    class: {
      'bg-theme-1 text-white': _vm.filter.team == null
    },
    on: {
      "click": function($event) {
        return _vm.setTeam(null)
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "layers",
      "classname": "w-4 h-4 mr-2 mt-1"
    }
  }), _vm._v("\n            Todos los equipos\n          ")], 1), _vm._v(" "), _vm._l((_vm.teams), function(teamMenu) {
    return _c('button', {
      key: ("team-" + (teamMenu.name)),
      staticClass: "button border-theme-5 border flex mr-1 mb-2",
      class: {
        'bg-theme-1 text-white': teamMenu.id == _vm.filter.team
      },
      on: {
        "click": function($event) {
          return _vm.setTeam(teamMenu.id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(teamMenu.name) + "\n          ")])
  })], 2)])]), _vm._v(" "), (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "grid grid-cols-12"
  }, _vm._l((_vm.filteredLibraries), function(library) {
    return _c('div', {
      key: ("library-" + (library.slug)),
      staticClass: "intro-y col-span-12 sm:col-span-12 md:col-span-4 xxl:col-span-4 mr-2 mb-2"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": library.url
      }
    }, [_c('div', {
      staticClass: "box h-full zoom-in"
    }, [_c('div', {
      staticClass: "rounded-md px-5 py-4 mb-2"
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [_c('div', {
      staticClass: "font-medium text-lg"
    }, [_vm._v(_vm._s(library.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-xs bg-gray-600 px-1 rounded-md text-white ml-auto"
    }, [_vm._v(_vm._s(library.category))])]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 mb-2"
    }, [_vm._v("\n                " + _vm._s(library.description) + "\n              ")]), _vm._v(" "), (library.url) ? _c('div', {
      staticClass: "text-theme-1 hidden text-right font-bold"
    }, [_vm._v("\n                Da clic para abrir\n              ")]) : _vm._e()])])])])
  }), 0)]) : _c('app-loading')], 1)
},staticRenderFns: []}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Editar Actividad",
      "size": "xl"
    },
    on: {
      "close": _vm.emitClose
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateActivity.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.name),
      expression: "activity.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.activity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Imagen "), _c('span', {
    staticClass: "text-blue-700"
  }, [_vm._v("(460px x 400px, 1MB Max)")]), _vm._v(":"), _c('br'), _vm._v(" "), (_vm.current_activity.image != null) ? _c('a', {
    staticClass: "text-blue-600 underline",
    attrs: {
      "href": _vm.current_activity.image,
      "target": "_blank"
    }
  }, [_vm._v("ver actual")]) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": "image/png, image/jpeg, image/jpg, image/gif, image/svg"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex mt-2 my-auto w-full"
  }, [(_vm.current_activity.image) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.image_path),
      expression: "activity.image_path"
    }],
    staticClass: "input w-2/3 border hidden",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.activity.image_path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "image_path", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "button bg-theme-10 text-white button-sm",
    attrs: {
      "for": "file"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cargar Imagen\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Descripción:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.description),
      expression: "activity.description"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": (_vm.activity.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Fecha inicio")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.start_date),
      expression: "activity.start_date"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.activity.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "start_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Fecha final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.end_date),
      expression: "activity.end_date"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.activity.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "end_date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Puntos de 90% a 100% correcto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.points_high_correct),
      expression: "activity.points_high_correct"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.activity.points_high_correct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "points_high_correct", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.activity.type != 'Extra') ? _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Puntos de 80% a 90% correcto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.points_medium_correct),
      expression: "activity.points_medium_correct"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.activity.points_medium_correct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "points_medium_correct", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.activity.type != 'Extra') ? _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Puntos de 70% a 80% correcto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.points_under_correct),
      expression: "activity.points_under_correct"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "number",
      "required": ""
    },
    domProps: {
      "value": (_vm.activity.points_under_correct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.activity, "points_under_correct", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Estado:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.status),
      expression: "activity.status"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activity, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Activa")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Inactiva")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4"
  }, [_c('label', [_vm._v("Tipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.type),
      expression: "activity.type"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activity, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione ...")]), _vm._v(" "), _vm._l((_vm.activityTypes), function(activityType) {
    return _c('option', {
      key: (activityType + "-activityType"),
      domProps: {
        "value": activityType
      }
    }, [_vm._v("\n            " + _vm._s(activityType) + "\n          ")])
  })], 2)]), _vm._v(" "), (_vm.activity.type == 'Extra') ? _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 md:col-span-4"
  }, [_c('label', [_vm._v("Tipo Contenido")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activity.type_content),
      expression: "activity.type_content"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "disabled": _vm.checked
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.activity, "type_content", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione ...")]), _vm._v(" "), _vm._l((_vm.activityTypeContents), function(activityTypeContent) {
    return _c('option', {
      key: (activityTypeContent + "-activityTypeContent"),
      domProps: {
        "value": activityTypeContent
      }
    }, [_vm._v("\n            " + _vm._s(activityTypeContent) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Material de estudio "), _c('span', {
    staticClass: "text-blue-700"
  }, [_vm._v("(PDF, 5MB Max)")]), _vm._v(":\n          "), (_vm.current_activity.study_information != null) ? _c('a', {
    staticClass: "text-blue-600 underline",
    attrs: {
      "href": _vm.current_activity.study_information,
      "target": "_blank"
    }
  }, [_vm._v("ver actual")]) : _vm._e()]), _vm._v(" "), _c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "study_information"
    },
    on: {
      "change": _vm.onStudyActivityFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex mt-2 my-auto w-full"
  }, [(_vm.current_activity.study_information != 'null') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current_activity.study_information_path),
      expression: "current_activity.study_information_path"
    }],
    staticClass: "input w-2/3 border hidden",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.current_activity.study_information_path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current_activity, "study_information_path", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "button bg-theme-10 text-white button-sm",
    attrs: {
      "for": "study_information"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cargar Material de estudio\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.emitClose
    }
  }, [_vm._v("\n        Cancelar\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "edit"
    }
  }, [_vm._v("\n        Editar\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center mb-4"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": 'search',
      "classname": 'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.name),
      expression: "filter.name"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por nombre"
    },
    domProps: {
      "value": (_vm.filter.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
  }, [_c('app-icon', {
    attrs: {
      "name": 'chevron-down',
      "classname": 'dropdown-toggle w-4 h-4 cursor-pointer text-gray-700'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box p-5"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Grupo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.group),
      expression: "filter.group"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Seleccione la cuenta")]), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('option', {
      key: group.id,
      domProps: {
        "value": group.id
      }
    }, [_vm._v("\n                      " + _vm._s(group.name) + "\n                    ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todos")])], 2)])])])])], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateAccount.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account_current.name),
      expression: "account_current.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.account_current.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account_current, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Prefijo:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account_current.prefix),
      expression: "account_current.prefix"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.account_current.prefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account_current, "prefix", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("País")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account_current.country_id),
      expression: "account_current.country_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.account_current, "country_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": "",
      "value": ""
    }
  }, [_vm._v("Seleccione el país")]), _vm._v(" "), _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country.id
      }
    }, [_vm._v("\n                " + _vm._s(country.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Grupo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account_current.account_group_id),
      expression: "account_current.account_group_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.account_current, "account_group_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione el grupo")]), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('option', {
      domProps: {
        "value": group.id
      }
    }, [_vm._v("\n                " + _vm._s(group.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Razon Social")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account_current.social_reason_id),
      expression: "account_current.social_reason_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": !_vm.account_current.country_id
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.account_current, "social_reason_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                Seleccione la Razon Social\n              ")]), _vm._v(" "), _vm._l((_vm.socialreasonsfiltered), function(socialreason) {
    return _c('option', {
      domProps: {
        "value": socialreason.id
      }
    }, [_vm._v("\n                " + _vm._s(socialreason.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account_current.status),
      expression: "account_current.status"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.account_current, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Activo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditAccount()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n            Modificar\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "mb-2 text-lg font-bold"
  }, [_vm._v("\n        Cuentas (" + _vm._s(_vm.accounts.length) + ")\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5"
  }, _vm._l((_vm.filteredAccounts), function(account) {
    return _c('div', {
      staticClass: "intro-y col-span-6 sm:col-span-4 md:col-span-3 xxl:col-span-2"
    }, [_c('div', {
      staticClass: "file box rounded-md px-5 pt-8 pb-5 px-3 sm:px-5 relative zoom-in"
    }, [_vm._m(2, true), _vm._v(" "), _c('a', {
      staticClass: "block font-medium mt-4 text-center truncate text-xs text-gray-500",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(account.group.name))]), _vm._v(" "), _c('a', {
      staticClass: "block font-medium mt-1 text-center truncate",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(account.name) + " - " + _vm._s(account.country.prefix))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs text-center"
    }, [_vm._v("\n            " + _vm._s(account.status === 0 ? 'Inactivo' : 'Activo') + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "absolute top-0 right-0 mr-2 mt-2 dropdown ml-auto"
    }, [_c('a', {
      staticClass: "dropdown-toggle w-5 h-5 block",
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'more-vertical',
        "classname": 'w-5 h-5 text-gray-500'
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "dropdown-box mt-5 absolute w-40 top-0 right-0 z-10"
    }, [_c('div', {
      staticClass: "dropdown-box__content box p-2"
    }, [_c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.editAccount(account)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v("\n                  Editar\n                ")], 1), _vm._v(" "), _c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.removeAccount(account)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'trash',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v("\n                  Eliminar\n                ")], 1)])])])])])
  }), 0)]) : _c('div', [_c('app-loading')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "account"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--md"
  }, [_vm._m(3), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createAccount.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.name),
      expression: "account.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "placeholder": "Mayusculas",
      "required": ""
    },
    domProps: {
      "value": (_vm.account.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Prefijo:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.prefix),
      expression: "account.prefix"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "placeholder": "5 Letras",
      "required": ""
    },
    domProps: {
      "value": (_vm.account.prefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account, "prefix", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("País")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.country_id),
      expression: "account.country_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.account, "country_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": "",
      "value": ""
    }
  }, [_vm._v("Seleccione el país")]), _vm._v(" "), _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country.id
      }
    }, [_vm._v("\n                " + _vm._s(country.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Grupo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.account_group_id),
      expression: "account.account_group_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.account, "account_group_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione el grupo")]), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('option', {
      domProps: {
        "value": group.id
      }
    }, [_vm._v("\n                " + _vm._s(group.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Razon Social")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account.social_reason_id),
      expression: "account.social_reason_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": !_vm.account.country_id
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.account, "social_reason_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                Seleccione la Razon Social\n              ")]), _vm._v(" "), _vm._l((_vm.socialreasonsfiltered), function(socialreason) {
    return _c('option', {
      domProps: {
        "value": socialreason.id
      }
    }, [_vm._v("\n                " + _vm._s(socialreason.name) + "\n              ")])
  })], 2)])]), _vm._v(" "), _vm._m(4)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#account",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Cuenta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Editar Cuenta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "w-3/5 file__icon file__icon--directory mx-auto",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "file__icon__file-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Cuenta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n            Crear\n          ")])])
}]}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal modal-special",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--md"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [(!_vm.task_validated) ? [_vm._v(" Duplicar Tarea ")] : [_vm._v(" Confirmar Tarea ")]], 2)]), _vm._v(" "), (_vm.isLoading) ? _c('Loading') : _c('form', {
    staticClass: "form-task",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createDuplicateTask.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_duplicate.name),
      expression: "task_duplicate.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    class: {
      'border-theme-12': _vm.task_validated
    },
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.task_duplicate.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_duplicate, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_duplicate.description),
      expression: "task_duplicate.description"
    }],
    staticClass: "input w-full border mt-2",
    class: {
      'border-theme-12': _vm.task_validated
    },
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": (_vm.task_duplicate.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_duplicate, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Fecha de entrega")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_duplicate.date),
      expression: "task_duplicate.date"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    class: {
      'border-theme-12': _vm.task_validated
    },
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": (_vm.task_duplicate.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task_duplicate, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_duplicate.project_id),
      expression: "task_duplicate.project_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    class: {
      'border-theme-12': _vm.task_validated
    },
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task_duplicate, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + "\n                  " + _vm._s(project.account.country.prefix) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_duplicate.campaign_id),
      expression: "task_duplicate.campaign_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    class: {
      'border-theme-12': _vm.task_validated
    },
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task_duplicate, "campaign_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.campaigns), function(campaign) {
    return _c('option', {
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n                  " + _vm._s(campaign.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6 hidden"
  }, [_c('label', [_vm._v("Equipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task_duplicate.team_id),
      expression: "task_duplicate.team_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    class: {
      'border-theme-12': _vm.task_validated
    },
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.task_duplicate, "team_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', {
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n                  " + _vm._s(team.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('MultiSelect', {
    staticClass: "mt-2",
    class: {
      'border-theme-12 border': _vm.task_validated
    },
    attrs: {
      "options": _vm.options,
      "multiple": true,
      "taggable": true,
      "disabled": _vm.task_validated
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.task_duplicate.path),
      callback: function($$v) {
        _vm.$set(_vm.task_duplicate, "path", $$v)
      },
      expression: "task_duplicate.path"
    }
  })], 1), _vm._v(" "), (_vm.task_loading < 11 && 0 < _vm.task_loading) ? _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('p', {
    staticClass: "text-theme-1 font-extrabold block"
  }, [_vm._v("\n                El botón se activara en " + _vm._s(_vm.task_loading) + " segundos, mientras\n                verificas la información.\n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.task_validated),
      expression: "!task_validated"
    }],
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearDuplicateTask()
      }
    }
  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n              Verificar Tarea\n            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.task_validated),
      expression: "task_validated"
    }],
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('a', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.task_validated = !_vm.task_validated
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create_duplicate"
    }
  }, [_vm._v("\n              Confirmar Tarea\n            ")])])])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.name == 'activities') ? _c('svg', {
    staticClass: "icon-svg feather feather-dribbble",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'alert-triangle') ? _c('svg', {
    staticClass: "feather feather-alert-triangle",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "9",
      "x2": "12",
      "y2": "13"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "17",
      "x2": "12.01",
      "y2": "17"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'archive') ? _c('svg', {
    staticClass: "feather feather-archive",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "21 8 21 21 3 21 3 8"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "1",
      "y": "3",
      "width": "22",
      "height": "5"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "10",
      "y1": "12",
      "x2": "14",
      "y2": "12"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'bars') ? _c('svg', {
    staticClass: "feather feather-bar-chart-2",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "20",
      "x2": "18",
      "y2": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "20",
      "x2": "12",
      "y2": "4"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "20",
      "x2": "6",
      "y2": "14"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'bell') ? _c('svg', {
    staticClass: "feather feather-bell",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M13.73 21a2 2 0 0 1-3.46 0"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'briefcase') ? _c('svg', {
    staticClass: "feather feather-briefcase",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "data-v-4c034fe6": "",
      "x": "2",
      "y": "7",
      "width": "20",
      "height": "14",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "data-v-4c034fe6": "",
      "d": "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'calendar') ? _c('svg', {
    staticClass: "feather feather-calendar",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "4",
      "width": "18",
      "height": "18",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "16",
      "y1": "2",
      "x2": "16",
      "y2": "6"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "2",
      "x2": "8",
      "y2": "6"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "3",
      "y1": "10",
      "x2": "21",
      "y2": "10"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'cancel') ? _c('svg', {
    staticClass: "feather feather-cancel",
    class: _vm.classname,
    attrs: {
      "data-v-4c034fe6": "",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "data-v-4c034fe6": "",
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "data-v-4c034fe6": "",
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'chart') ? _c('svg', {
    staticClass: "feather feather-pie-chart",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21.21 15.89A10 10 0 1 1 8 2.83"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22 12A10 10 0 0 0 12 2v10z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'check') ? _c('svg', {
    staticClass: "feather feather-check",
    class: _vm.classname,
    attrs: {
      "data-v-4c034fe6": "",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "data-v-4c034fe6": "",
      "points": "20 6 9 17 4 12"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'check-circle') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
      "clip-rule": "evenodd"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'chevron-down') ? _c('svg', {
    staticClass: "feather feather-chevron-down",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "6 9 12 15 18 9"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'chevron-left') ? _c('svg', {
    staticClass: "feather feather-chevron-left",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "data-v-4c034fe6": "",
      "points": "15 18 9 12 15 6"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'chevron-right') ? _c('svg', {
    staticClass: "feather feather-chevron-right",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "9 18 15 12 9 6"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'chevrons-left') ? _c('svg', {
    staticClass: "feather feather-chevrons-left",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "11 17 6 12 11 7"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "18 17 13 12 18 7"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'chevrons-right') ? _c('svg', {
    staticClass: "feather feather-chevrons-right",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "13 17 18 12 13 7"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "6 17 11 12 6 7"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'circle-plus') ? _c('svg', {
    staticClass: "feather feather-plus-circle",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12",
      "y2": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "8",
      "y1": "12",
      "x2": "16",
      "y2": "12"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'clipboard') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "24",
      "height": "24",
      "stroke": "currentColor",
      "stroke-width": "2",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "8",
      "y": "2",
      "width": "8",
      "height": "4",
      "rx": "1",
      "ry": "1"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'clock') ? _c('svg', {
    staticClass: "feather feather-clock",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "12 6 12 12 16 14"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'code') ? _c('svg', {
    staticClass: "icon-svg feather feather-code",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "data-v-4c034fe6": "",
      "points": "16 18 22 12 16 6"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "data-v-4c034fe6": "",
      "points": "8 6 2 12 8 18"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'copy') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'cpu') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "24",
      "height": "24",
      "stroke": "currentColor",
      "stroke-width": "2",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "4",
      "y": "4",
      "width": "16",
      "height": "16",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "9",
      "y": "9",
      "width": "6",
      "height": "6"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "1",
      "x2": "9",
      "y2": "4"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "15",
      "y1": "1",
      "x2": "15",
      "y2": "4"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "20",
      "x2": "9",
      "y2": "23"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "15",
      "y1": "20",
      "x2": "15",
      "y2": "23"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "9",
      "x2": "23",
      "y2": "9"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "20",
      "y1": "14",
      "x2": "23",
      "y2": "14"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "1",
      "y1": "9",
      "x2": "4",
      "y2": "9"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "1",
      "y1": "14",
      "x2": "4",
      "y2": "14"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'download') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'duplicate') ? _c('svg', {
    staticClass: "feather feather-copy block mx-auto",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "9",
      "y": "9",
      "width": "13",
      "height": "13",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'edit') ? _c('svg', {
    staticClass: "feather feather-edit",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'eye') ? _c('svg', {
    staticClass: "feather feather-eye",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "data-v-4c034fe6": "",
      "d": "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "data-v-4c034fe6": "",
      "cx": "12",
      "cy": "12",
      "r": "3"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'file') ? _c('svg', {
    staticClass: "feather feather-file",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "13 2 13 9 20 9"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'file-plus') ? _c('svg', {
    staticClass: "feather feather-file-plus",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "14 2 14 8 20 8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "18",
      "x2": "12",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "15",
      "x2": "15",
      "y2": "15"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'film') ? _c('svg', {
    staticClass: "lucide lucide-book-open block mx-auto",
    class: _vm.classname,
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "24",
      "height": "24",
      "stroke": "currentColor",
      "stroke-width": "2",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "2",
      "y": "2",
      "width": "20",
      "height": "20",
      "rx": "2.18",
      "ry": "2.18"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "7",
      "y1": "2",
      "x2": "7",
      "y2": "22"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "17",
      "y1": "2",
      "x2": "17",
      "y2": "22"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "2",
      "y1": "12",
      "x2": "22",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "2",
      "y1": "7",
      "x2": "7",
      "y2": "7"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "2",
      "y1": "17",
      "x2": "7",
      "y2": "17"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "17",
      "y1": "17",
      "x2": "22",
      "y2": "17"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "17",
      "y1": "7",
      "x2": "22",
      "y2": "7"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'folder') ? _c('svg', {
    staticClass: "feather feather-folder",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'globe') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'grid') ? _c('svg', {
    staticClass: "icon-svg feather feather-grid",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "data-v-4c034fe6": "",
      "x": "3",
      "y": "3",
      "width": "7",
      "height": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "data-v-4c034fe6": "",
      "x": "14",
      "y": "3",
      "width": "7",
      "height": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "data-v-4c034fe6": "",
      "x": "14",
      "y": "14",
      "width": "7",
      "height": "7"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "data-v-4c034fe6": "",
      "x": "3",
      "y": "14",
      "width": "7",
      "height": "7"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'hard-drive') ? _c('svg', {
    staticClass: "feather feather-hard-drive",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "22",
      "y1": "12",
      "x2": "2",
      "y2": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "16",
      "x2": "6.01",
      "y2": "16"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "10",
      "y1": "16",
      "x2": "10.01",
      "y2": "16"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'home') ? _c('svg', {
    staticClass: "feather feather-home",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "9 22 9 12 15 12 15 22"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'layers') ? _c('svg', {
    staticClass: "feather feather-layers",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "12 2 2 7 12 12 22 7 12 2"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "2 17 12 22 22 17"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "2 12 12 17 22 12"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'libraries') ? _c('svg', {
    staticClass: "lucide lucide-book-open block mx-auto",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'link') ? _c('svg', {
    staticClass: "feather feather-link",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24px",
      "height": "24px",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "data-v-4c034fe6": "",
      "d": "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "data-v-4c034fe6": "",
      "d": "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'mail') ? _c('svg', {
    staticClass: "feather feather-mail",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "22,6 12,13 2,6"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'minus') ? _c('svg', {
    staticClass: "feather feather-minus",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "5",
      "y1": "12",
      "x2": "19",
      "y2": "12"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'moon') ? _c('svg', {
    staticClass: "css-i6dzq1",
    class: _vm.classname,
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "24",
      "height": "24",
      "stroke": "currentColor",
      "stroke-width": "2",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'more-vertical') ? _c('svg', {
    staticClass: "feather feather-more-vertical",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "5",
      "r": "1"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "19",
      "r": "1"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'newspaper') ? _c('svg', {
    staticClass: "w-6 h-6",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M4.125 3C3.089 3 2.25 3.84 2.25 4.875V18a3 3 0 003 3h15a3 3 0 01-3-3V4.875C17.25 3.839 16.41 3 15.375 3H4.125zM12 9.75a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5H12zm-.75-2.25a.75.75 0 01.75-.75h1.5a.75.75 0 010 1.5H12a.75.75 0 01-.75-.75zM6 12.75a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5H6zm-.75 3.75a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75zM6 6.75a.75.75 0 00-.75.75v3c0 .414.336.75.75.75h3a.75.75 0 00.75-.75v-3A.75.75 0 009 6.75H6z",
      "clip-rule": "evenodd"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M18.75 6.75h1.875c.621 0 1.125.504 1.125 1.125V18a1.5 1.5 0 01-3 0V6.75z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'package') ? _c('svg', {
    staticClass: "feather feather-package",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "16.5",
      "y1": "9.4",
      "x2": "7.5",
      "y2": "4.21"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "3.27 6.96 12 12.01 20.73 6.96"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "22.08",
      "x2": "12",
      "y2": "12"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'plus') ? _c('svg', {
    staticClass: "feather feather-plus",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "12",
      "y1": "5",
      "x2": "12",
      "y2": "19"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "5",
      "y1": "12",
      "x2": "19",
      "y2": "12"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'refresh') ? _c('svg', {
    staticClass: "feather feather-refresh-cw",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "23 4 23 10 17 10"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "1 20 1 14 7 14"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'rocket') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke-width": "1.5",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "d": "M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'search') ? _c('svg', {
    staticClass: "feather feather-search",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "11",
      "cy": "11",
      "r": "8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "21",
      "y1": "21",
      "x2": "16.65",
      "y2": "16.65"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'sun') ? _c('svg', {
    staticClass: "css-i6dzq1",
    class: _vm.classname,
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "24",
      "height": "24",
      "stroke": "currentColor",
      "stroke-width": "2",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "5"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "1",
      "x2": "12",
      "y2": "3"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "21",
      "x2": "12",
      "y2": "23"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "4.22",
      "y1": "4.22",
      "x2": "5.64",
      "y2": "5.64"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "18.36",
      "y1": "18.36",
      "x2": "19.78",
      "y2": "19.78"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "1",
      "y1": "12",
      "x2": "3",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "21",
      "y1": "12",
      "x2": "23",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "4.22",
      "y1": "19.78",
      "x2": "5.64",
      "y2": "18.36"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "18.36",
      "y1": "5.64",
      "x2": "19.78",
      "y2": "4.22"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'table') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "24",
      "height": "24",
      "stroke": "currentColor",
      "stroke-width": "2",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'target') ? _c('svg', {
    staticClass: "feather feather-target",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "6"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "2"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'toggle-right') ? _c('svg', {
    staticClass: "feather feather-toggle-right",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "1",
      "y": "5",
      "width": "22",
      "height": "14",
      "rx": "7",
      "ry": "7"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "16",
      "cy": "12",
      "r": "3"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'trash') ? _c('svg', {
    staticClass: "feather feather-trash",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "3 6 5 6 21 6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'triangle') ? _c('svg', {
    class: _vm.classname,
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "24",
      "height": "24",
      "stroke": "currentColor",
      "stroke-width": "2",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'user') ? _c('svg', {
    staticClass: "feather feather-user",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "12",
      "cy": "7",
      "r": "4"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.name == 'users') ? _c('svg', {
    staticClass: "feather feather-users",
    class: _vm.classname,
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "9",
      "cy": "7",
      "r": "4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M23 21v-2a4 4 0 0 0-3-3.87"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M16 3.13a4 4 0 0 1 0 7.75"
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_vm._m(0), _vm._v(" "), (_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateEditElement.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Razon Social*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.social_reason),
      expression: "client_current.social_reason"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.client_current.social_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "social_reason", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Nit*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.nit),
      expression: "client_current.nit"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.client_current.nit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "nit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Pais")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.country_id),
      expression: "client_current.country_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.client_current, "country_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione el país")]), _vm._v(" "), _vm._l((_vm.countries), function(country) {
    return _c('option', {
      key: ("country-" + (country.id)),
      domProps: {
        "value": country.id
      }
    }, [_vm._v("\n                " + _vm._s(country.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Direccion")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.address),
      expression: "client_current.address"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client_current.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Telefono fijo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.telphone),
      expression: "client_current.telphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client_current.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "telphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.contact_purchasing),
      expression: "client_current.contact_purchasing"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client_current.contact_purchasing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "contact_purchasing", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.cellphone_purchasing),
      expression: "client_current.cellphone_purchasing"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client_current.cellphone_purchasing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "cellphone_purchasing", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.email_purchasing),
      expression: "client_current.email_purchasing"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.client_current.email_purchasing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "email_purchasing", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.contact_treasury),
      expression: "client_current.contact_treasury"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client_current.contact_treasury)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "contact_treasury", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.cellphone_treasury),
      expression: "client_current.cellphone_treasury"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client_current.cellphone_treasury)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "cellphone_treasury", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.email_treasury),
      expression: "client_current.email_treasury"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.client_current.email_treasury)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "email_treasury", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client_current.link),
      expression: "client_current.link"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client_current.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client_current, "link", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditElement()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n            Modificar\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.clients), function(client) {
    return _c('tr', {
      key: ("client-" + (client.id)),
      staticClass: "intro-x"
    }, [_c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(_vm._f("limit")(client.social_reason)) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(client.nit) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(client.country.name) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [(client.link) ? _c('a', {
      staticClass: "font-medium whitespace-no-wrap",
      attrs: {
        "href": client.link,
        "target": "_blank"
      }
    }, [_vm._v("link")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('router-link', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      attrs: {
        "to": ("/admin/business/clients/relations/" + (client.id))
      }
    }, [_vm._v("\n                  " + _vm._s(client.accounts.length) + "\n                  "), _c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1), _vm._v(" "), _c('button', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.editElement(client)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "edit",
        "classname": "w-4 h-4 mr-2"
      }
    })], 1)], 1)])])
  }), 0)])])]) : _c('app-loading'), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "create-modal"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--xl"
  }, [_vm._m(5), _vm._v(" "), _c('form', {
    staticClass: "form-task",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createElement.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Razon Social*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.social_reason),
      expression: "client.social_reason"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.client.social_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "social_reason", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Nit*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.nit),
      expression: "client.nit"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.client.nit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "nit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Pais")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.country_id),
      expression: "client.country_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.client, "country_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": "",
      "value": "null"
    }
  }, [_vm._v("Seleccione el país")]), _vm._v(" "), _vm._l((_vm.countries), function(country) {
    return _c('option', {
      key: ("country-" + (country.id)),
      domProps: {
        "value": country.id
      }
    }, [_vm._v("\n                " + _vm._s(country.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Direccion")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.address),
      expression: "client.address"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-6"
  }, [_c('label', [_vm._v("Telefono fijo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.telphone),
      expression: "client.telphone"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.telphone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "telphone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.contact_purchasing),
      expression: "client.contact_purchasing"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.contact_purchasing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "contact_purchasing", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.cellphone_purchasing),
      expression: "client.cellphone_purchasing"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.cellphone_purchasing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "cellphone_purchasing", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.email_purchasing),
      expression: "client.email_purchasing"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.client.email_purchasing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "email_purchasing", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.contact_treasury),
      expression: "client.contact_treasury"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.contact_treasury)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "contact_treasury", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Celular")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.cellphone_treasury),
      expression: "client.cellphone_treasury"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.cellphone_treasury)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "cellphone_treasury", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-4"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.email_treasury),
      expression: "client.email_treasury"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.client.email_treasury)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "email_treasury", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.link),
      expression: "client.link"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "link", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(8)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#create-modal",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Cliente")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Editar Cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h3', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Contacto Compras")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h3', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n                Contacto Tesoreria\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("RAZON SOCIAL")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("NIT")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PAIS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("URL")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h3', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Contacto Compras")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h3', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n                Contacto Tesoreria\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n            Crear\n          ")])])
}]}

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "flex flex-col sm:flex-row items-center mt-8 border-b border-gray-200"
  }, [(_vm.team_session == 1) ? _c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n        Trafico Mensual\n      ")]) : _c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n        Trafico Semanal\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex items-center sm:ml-auto mt-3 sm:mt-0"
  }, [(_vm.account_session) ? _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.viewAccounts('all')
      }
    }
  }, [_vm._v("\n            Ver todas las cuentas\n          ")]) : _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.viewAccounts('one')
      }
    }
  }, [_vm._v("\n            Ver solo una cuenta\n          ")]), _vm._v("  \n          "), _c('div', {
    staticClass: "mr-3"
  }, [_vm._v("Fechas:")]), _vm._v(" "), _c('button', {
    staticClass: "button button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.changeWeek('minus')
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'chevron-left',
      "classname": 'w-5'
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "button mr-1 mb-2 mt-2 bg-theme-1 text-white courser-not"
  }, [_vm._v("\n            " + _vm._s(_vm.firstday.toISOString().slice(0, 10)) + " - " + _vm._s(_vm.lastday.toISOString().slice(0, 10)) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button inline-flex button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10",
    on: {
      "click": function($event) {
        return _vm.changeWeek('plus')
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": 'chevron-right',
      "classname": 'w-5'
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-6"
  }, [_c('div', {
    staticClass: "col-span-12 xxl:col-span-9 grid grid-cols-12 gap-6"
  }, [(_vm.team_session == 1) ? _c('div', {
    staticClass: "col-span-12"
  }, [_c('div', {
    staticClass: "intro-y box mt-4 p-2"
  }, _vm._l((_vm.projects), function(project) {
    return _c('div', {
      key: project.id
    }, _vm._l((_vm.sumHoursByProject), function(sum) {
      return (sum.project_id == project.id && project.hours > 1) ? _c('div', [(project.hours - sum.total < 0) ? _c('div', {
        staticClass: "flex bg-red-200 rounded-lg p-4 mb-2 text-sm text-red-700",
        attrs: {
          "role": "alert"
        }
      }, [_c('svg', {
        staticClass: "w-5 h-5 inline mr-3",
        attrs: {
          "fill": "currentColor",
          "viewBox": "0 0 20 20",
          "xmlns": "http://www.w3.org/2000/svg"
        }
      }, [_c('path', {
        attrs: {
          "fill-rule": "evenodd",
          "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
          "clip-rule": "evenodd"
        }
      })]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "font-medium"
      }, [_vm._v(_vm._s(project.name) + " - " + _vm._s(project.account.name) + " - " + _vm._s(project.account.country.prefix))]), _vm._v(" excedió el número de horas asignadas.\n                      ")])]) : _vm._e()]) : _vm._e()
    }), 0)
  }), 0), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return (project.account_id == _vm.account_session || _vm.account_session == null) ? _c('div', {
      staticClass: "intro-y box mt-1"
    }, [_c('div', {
      staticClass: "flex flex-col sm:flex-row items-center p-5 mt-8 border-b border-gray-200"
    }, [_c('h2', {
      staticClass: "font-medium text-base mr-auto",
      class: [
        project.hours > 1 ?
        'text-theme-1' :
        '' ]
    }, [_vm._v("\n                    " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + " - " + _vm._s(project.account.country.prefix) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "w-full sm:w-auto flex items-center sm:ml-auto mt-3 sm:mt-0"
    }, [_c('button', {
      staticClass: "button button--sm mr-1 mb-2 mt-2 border dark:border-dark-5 dark:text-gray-300 courser-not"
    }, [_vm._l((_vm.sumHoursByProject), function(sum) {
      return (sum.project_id == project.id) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm._f("two_decimal")(project.hours - sum.total)))])]) : _vm._e()
    }), _vm._v("\n                       Horas Disponibles\n                    ")], 2), _vm._v(" "), _c('button', {
      staticClass: "button button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10 courser-not"
    }, [_vm._l((_vm.sumHoursByProject), function(sum) {
      return (sum.project_id == project.id) ? _c('span', [_vm._v(_vm._s(_vm._f("two_decimal")(sum.total)))]) : _vm._e()
    }), _vm._v(" /\n                       "), (project.id) ? _c('span', [_vm._v(_vm._s(_vm._f("two_decimal")(project.hours)))]) : _vm._e(), _vm._v(" Horas\n                    ")], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "p-5",
      attrs: {
        "id": "bordered-table"
      }
    }, [_c('div', {
      staticClass: "preview"
    }, [_c('div', {
      staticClass: "overflow-x-auto"
    }, [_c('table', {
      staticClass: "table"
    }, [_vm._m(0, true), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredTasks), function(task) {
      return (task.project_id == project.id) ? _c('tr', {
        class: {
          'tr-green': task.state_id == 4
        }
      }, [_c('td', {
        staticClass: "border"
      }, [_vm._v(_vm._s(task.name))]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [(task.user_id) ? _c('span', [_vm._v(_vm._s(task.user_name))]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [_vm._v(_vm._s(task.hours))]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [_c('button', {
        staticClass: "button button--sm w-24 text-white",
        class: _vm.dateClass(task)
      }, [_vm._v(_vm._s(task.date))])]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [_vm._v(_vm._s(task.state_name))])]) : _vm._e()
    }), 0)])])])])]) : _vm._e()
  })], 2) : _c('div', {
    staticClass: "col-span-12"
  }, [_c('div', {
    staticClass: "intro-y box p-2 mt-4"
  }, _vm._l((_vm.user.accounts), function(account) {
    return _c('div', {
      key: account.id
    }, _vm._l((_vm.sumHoursByAccount), function(sum) {
      return (sum.account_id == account.id) ? _c('span', _vm._l((_vm.filteredHours), function(hour) {
        return (hour.account_id == account.id) ? _c('span', [(hour.hours - sum.total < 0) ? _c('div', {
          staticClass: "flex bg-red-200 rounded-lg p-4 mb-2 text-sm text-red-700",
          attrs: {
            "role": "alert"
          }
        }, [_c('svg', {
          staticClass: "w-5 h-5 inline mr-3",
          attrs: {
            "fill": "currentColor",
            "viewBox": "0 0 20 20",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
            "clip-rule": "evenodd"
          }
        })]), _vm._v(" "), _c('div', [_c('span', {
          staticClass: "font-medium"
        }, [_vm._v(_vm._s(account.name) + " - " + _vm._s(account.country.prefix))]), _vm._v(" excedió el número de horas asignadas.\n                    ")])]) : _vm._e()]) : _vm._e()
      }), 0) : _vm._e()
    }), 0)
  }), 0), _vm._v(" "), _vm._l((_vm.user.accounts), function(account) {
    return (account.id == _vm.account_session || _vm.account_session == null) ? _c('div', {
      staticClass: "intro-y box mt-1"
    }, [_c('div', {
      staticClass: "flex flex-col sm:flex-row items-center p-5 mt-8 border-b border-gray-200"
    }, [_c('h2', {
      staticClass: "font-medium text-base mr-auto"
    }, [_vm._v("\n                  " + _vm._s(account.name) + " - " + _vm._s(account.country.prefix) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "w-full sm:w-auto flex items-center sm:ml-auto mt-3 sm:mt-0"
    }, [_c('button', {
      staticClass: "button button--sm mr-1 mb-2 mt-2 border dark:border-dark-5 dark:text-gray-300 courser-not"
    }, [_vm._l((_vm.sumHoursByAccount), function(sum) {
      return (sum.account_id == account.id) ? _c('span', _vm._l((_vm.filteredHours), function(hour) {
        return (hour.account_id == account.id) ? _c('span', [_vm._v(_vm._s(_vm._f("two_decimal")(hour.hours - sum.total)))]) : _vm._e()
      }), 0) : _vm._e()
    }), _vm._v("\n                     Horas Disponibles\n                  ")], 2), _vm._v(" "), _c('button', {
      staticClass: "button button--sm mr-1 mb-2 mt-2 border border-theme-1 border-theme-10 text-theme-10 courser-not"
    }, [_vm._l((_vm.sumHoursByAccount), function(sum) {
      return (sum.account_id == account.id) ? _c('span', [_vm._v(_vm._s(_vm._f("two_decimal")(sum.total)))]) : _vm._e()
    }), _vm._v(" /\n                     "), _vm._l((_vm.filteredHours), function(hour) {
      return (hour.account_id == account.id) ? _c('span', [_vm._v(_vm._s(_vm._f("two_decimal")(hour.hours)))]) : _vm._e()
    }), _vm._v(" Horas\n                  ")], 2), _vm._v(" "), _c('button', {
      staticClass: "button button--sm mr-1 mb-2 mt-2 border dark:border-dark-5 dark:text-gray-300 courser-not"
    }, [_vm._l((_vm.filteredHours), function(hour) {
      return (hour.account_id == account.id) ? _c('span', [_vm._v(_vm._s(_vm._f("two_decimal")((hour.hours) / 5)))]) : _vm._e()
    }), _vm._v(" Diarias\n                  ")], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "p-5",
      attrs: {
        "id": "bordered-table"
      }
    }, [_c('div', {
      staticClass: "preview"
    }, [_c('div', {
      staticClass: "overflow-x-auto"
    }, [_c('table', {
      staticClass: "table"
    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredTasks), function(task) {
      return (task.campaign_attribute.project_account_id == account.id) ? _c('tr', {
        class: {
          'tr-green': task.state_id == 4
        }
      }, [_c('td', {
        staticClass: "border"
      }, [_vm._v(_vm._s(_vm._f("limit")(task.name)))]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [_vm._v("\n                                      " + _vm._s(task.state_name) + " "), _c('br'), _vm._v(" "), (task.user_id) ? _c('span', [_vm._v(_vm._s(task.user_name))]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [_vm._v(_vm._s(task.hours))]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [_c('button', {
        staticClass: "button button--sm w-24 text-white",
        class: _vm.dateClass(task)
      }, [_vm._v(_vm._s(task.date))])]), _vm._v(" "), _c('td', {
        staticClass: "border"
      }, [(task.state_id != 4) ? _c('a', {
        staticClass: "cursor-pointer flex items-center mr-3",
        on: {
          "click": function($event) {
            return _vm.viewAccountTask(task)
          }
        }
      }, [_c('app-icon', {
        attrs: {
          "name": "edit",
          "classname": "w-4 h-4 mr-2"
        }
      }), _vm._v(" Editar\n                                      ")], 1) : _vm._e()])]) : _vm._e()
    }), 0)])])])])]) : _vm._e()
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Asignada a")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("No. Horas")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Fecha Entrega")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Estado")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Estado")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("No. Horas")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Fecha Entrega")]), _vm._v(" "), _c('th', {
    staticClass: "border border-b-2 dark:border-dark-5 whitespace-nowrap"
  }, [_vm._v("Acciones")])])])
}]}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [(_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateUser.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.user.name
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('name', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Correo:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": _vm.user.email
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('email', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 sm:col-span-2"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.user.active
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('active', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Activo")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-4 sm:col-span-4"
  }, [_c('label', [_vm._v("Contraseña (opcional):")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.user.password
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('password', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Perfil")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.user.profile_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('profile_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.filteredProfiles), function(profile) {
    return _c('option', {
      key: profile.id
    }, [_vm._v("\n                " + _vm._s(profile.name) + "\n              ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.user.roles[0].id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('role', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el role")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Lider")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Trabajador")])])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditUser()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "update"
    }
  }, [_vm._v("\n            Modificar\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("Mi Equipo")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-5"
  }, _vm._l((_vm.filteredUsers), function(user) {
    return _c('div', {
      key: user.id,
      staticClass: "intro-y col-span-12 md:col-span-6"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "w-24 h-24 lg:w-12 lg:h-12 image-fit lg:mr-1"
    }, [(user.avatar) ? _c('img', {
      staticClass: "rounded-full",
      attrs: {
        "alt": "Profile",
        "src": user.avatar
      }
    }) : _c('img', {
      staticClass: "rounded-full",
      attrs: {
        "alt": "Profile",
        "src": "/static/images/profile.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "lg:ml-2 lg:mr-auto text-center lg:text-left mt-3 lg:mt-0"
    }, [_c('a', {
      staticClass: "font-medium",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(user.name) + " (" + _vm._s(user.roles[0].name) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v("\n                " + _vm._s(user.team ? user.team.name : '-') + " :\n                " + _vm._s(user.profile ? user.profile.name : '-') + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v("\n                " + _vm._s(user.accounts.length) + " Cuentas Asociadas\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "flex -ml-2 lg:ml-0 lg:justify-end mt-3 lg:mt-0"
    }, [(user.active === 0) ? _c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      attrs: {
        "title": "Estado"
      },
      on: {
        "click": function($event) {
          return _vm.editUser(user)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'alert-triangle',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      attrs: {
        "to": '/admin/calendar/' + user.slug
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'calendar',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      on: {
        "click": function($event) {
          return _vm.editUser(user)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1), _vm._v(" "), _c('a', {
      staticClass: "pl-2 w-8 h-8 rounded-full flex items-center justify-center border ml-2 text-gray-500 zoom-in",
      on: {
        "click": function($event) {
          return _vm.removeUser(user)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'trash',
        "classname": 'w-4 h-4 mr-2'
      }
    })], 1)], 1)])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "user"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--md"
  }, [_vm._m(2), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createUser.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Contraseña:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Correo:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Perfil")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.profile_id),
      expression: "user.profile_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "profile_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el perfil")]), _vm._v(" "), _vm._l((_vm.filteredProfiles), function(profile) {
    return _c('option', {
      key: profile.id,
      domProps: {
        "value": profile.id
      }
    }, [_vm._v("\n                  " + _vm._s(profile.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Role")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role),
      expression: "user.role"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el role")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "leader"
    }
  }, [_vm._v("Lider")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "employee"
    }
  }, [_vm._v("Trabajador")])])])]), _vm._v(" "), _vm._m(3)])])])]) : _c('div', [_c('app-loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Editar Usuario")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#user",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Usuario")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Usuario")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              Cancelar\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n              Crear\n            ")])])
}]}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-8"
  }, [_vm._v("\n          Equipos (" + _vm._s(_vm.teams.length) + ")\n        ")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.boxedit) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateTeam.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.team.name
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('name', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.team.status
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('status', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Activo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeEditTeam()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Modificar")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-3 sm:gap-6 mt-5"
  }, _vm._l((_vm.teams), function(team) {
    return _c('div', {
      staticClass: "intro-y col-span-6 sm:col-span-4 md:col-span-3 xxl:col-span-2"
    }, [_c('div', {
      staticClass: "file box rounded-md px-5 pt-8 pb-5 px-3 sm:px-5 relative zoom-in"
    }, [_vm._m(2, true), _vm._v(" "), _c('a', {
      staticClass: "block font-medium mt-4 text-center truncate",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(team.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 text-xs text-center"
    }, [_vm._v(_vm._s(team.status === 0 ? 'Inactivo' : 'Activo'))]), _vm._v(" "), _c('div', {
      staticClass: "absolute top-0 right-0 mr-2 mt-2 dropdown ml-auto"
    }, [_c('a', {
      staticClass: "dropdown-toggle w-5 h-5 block",
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'more-vertical',
        "classname": 'w-5 h-5 text-gray-500'
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "dropdown-box mt-5 absolute w-40 top-0 right-0 z-10"
    }, [_c('div', {
      staticClass: "dropdown-box__content box p-2"
    }, [_c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.editTeam(team)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'edit',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v(" Editar\n                          ")], 1), _vm._v(" "), _c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.removeTeam(team)
        }
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'trash',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v(" Eliminar\n                          ")], 1), _vm._v(" "), _c('router-link', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      attrs: {
        "to": '/admin/users?team=' + team.id
      }
    }, [_c('app-icon', {
      attrs: {
        "name": 'users',
        "classname": 'w-4 h-4 mr-2'
      }
    }), _vm._v(" Miembros\n                          ")], 1)], 1)])])])])
  }), 0)]) : _c('div', [_c('app-loading')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "team"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--sm"
  }, [_vm._m(3), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createTeam.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.team.name),
      expression: "team.name"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.team.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.team, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(4)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('a', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "data-target": "#team",
      "data-toggle": "modal"
    }
  }, [_vm._v("Crear Equipo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Editar Equipo\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "w-3/5 file__icon file__icon--directory mx-auto",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "file__icon__file-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            Crear Equipo\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("Crear")])])
}]}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse mt-3 sm:flex-row items-center"
  }, [_c('h2', {
    staticClass: "intro-y text-lg font-medium mr-auto mt-2"
  }, [_vm._v("\n        Presupuestos (" + _vm._s(_vm.pagination.total) + ")\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }, [_c('app-icon', {
    attrs: {
      "name": 'search',
      "classname": 'w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700'
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.slug),
      expression: "filter.slug"
    }],
    staticClass: "input w-full sm:w-64 box px-10 text-gray-700",
    attrs: {
      "type": "text",
      "placeholder": "Buscar por código"
    },
    domProps: {
      "value": (_vm.filter.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "slug", $event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
  }, [_c('app-icon', {
    attrs: {
      "name": "chevron-down",
      "classname": "dropdown-toggle w-4 h-4 cursor-pointer text-gray-700"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inbox-filter__dropdown-box dropdown-box mt-10 absolute top-0 left-0 z-20"
  }, [_c('div', {
    staticClass: "dropdown-box__content box p-5"
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.account),
      expression: "filter.account"
    }],
    staticClass: "input w-full border mt-2 flex-13",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "account", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione una opción")]), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _c('option', {
      key: account.id,
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                      " + _vm._s(account.name) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Cliente")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.client),
      expression: "filter.client"
    }],
    staticClass: "input w-full border mt-2 flex-13",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "client", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione una opción")]), _vm._v(" "), _vm._l((_vm.clients), function(client) {
    return _c('option', {
      key: client.id,
      domProps: {
        "value": client.id
      }
    }, [_vm._v("\n                      " + _vm._s(client.social_reason) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Mes")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.month),
      expression: "filter.month"
    }],
    staticClass: "input w-full border mt-2 flex-13",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "month", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione una opción")]), _vm._v(" "), _vm._l((_vm.months), function(month) {
    return _c('option', {
      key: month.id,
      domProps: {
        "value": month.id
      }
    }, [_vm._v("\n                      " + _vm._s(month.name) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button mt-28 text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        _vm.filter = _vm.clearFilter()
      }
    }
  }, [_vm._v("\n                      Borrar Filtro\n                    ")])])])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "to": "/admin/business/budgets/create"
    }
  }, [_vm._v("\n          Crear Presupuesto\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "intro-y flex overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredBudgets), function(budget) {
    return _c('tr', {
      key: ("budget-" + (budget.id)),
      staticClass: "intro-x"
    }, [_c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(budget.slug) + " - " + _vm._s(budget.version_count) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(_vm._f("limit")(budget.reference)) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(budget.type) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                $ " + _vm._s(_vm.formatPrice(budget.latest_version.subtotal)) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                $ " + _vm._s(_vm.formatPrice(budget.latest_version.total)) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "table-report__action w-56"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('router-link', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      attrs: {
        "to": ("/admin/business/budgets/show/" + (budget.id))
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Detalle\n                ")], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      attrs: {
        "href": ("/v1/api/budget/download/" + (budget.id)),
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Ver PDF\n                ")], 1)]), _vm._v(" "), _c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('a', {
      staticClass: "flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      attrs: {
        "href": ("/v1/api/budget/download-complete/" + (budget.id)),
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('app-icon', {
      attrs: {
        "name": "folder",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("PDF\n                  Completo\n                ")], 1)])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "intro-y flex flex-wrap sm:flex-row sm:flex-no-wrap items-center mt-3"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', [_c('a', {
    staticClass: "pagination__link text-theme-1",
    class: {
      'pagination__link--disabled': _vm.pagination.currentPage <= 1
    },
    on: {
      "click": function($event) {
        return _vm.changePage(1)
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "chevrons-left",
      "classname": "w-4 h-4"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "pagination__link text-theme-1",
    class: {
      'pagination__link--disabled': _vm.pagination.currentPage <= 1
    },
    on: {
      "click": function($event) {
        return _vm.changePage(_vm.pagination.currentPage - 1)
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "chevron-left",
      "classname": "w-4 h-4"
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.paginationPages), function(page) {
    return _c('li', {
      key: 'page-' + page
    }, [_c('a', {
      staticClass: "pagination__link text-theme-1",
      class: {
        'pagination__link--active': page === _vm.pagination.currentPage
      },
      on: {
        "click": function($event) {
          return _vm.changePage(page)
        }
      }
    }, [_vm._v("\n            " + _vm._s(page) + "\n          ")])])
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "pagination__link text-theme-1",
    class: {
      'pagination__link--disabled': _vm.pagination.currentPage >= _vm.pagination.lastPage
    },
    on: {
      "click": function($event) {
        return _vm.changePage(_vm.pagination.currentPage + 1)
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "chevron-right",
      "classname": "w-4 h-4"
    }
  })], 1)]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "pagination__link text-theme-1",
    class: {
      'pagination__link--disabled': _vm.pagination.currentPage >= _vm.pagination.lastPage
    },
    on: {
      "click": function($event) {
        return _vm.changePage(_vm.pagination.lastPage)
      }
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "chevrons-right",
      "classname": "w-4 h-4"
    }
  })], 1)])], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.pagination.perPage),
      expression: "pagination.perPage",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input box mt-3 sm:mt-0 w-20",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.pagination, "perPage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changePage(1)
      }]
    }
  }, [_c('option', [_vm._v("10")]), _vm._v(" "), _c('option', [_vm._v("15")]), _vm._v(" "), _c('option', [_vm._v("25")]), _vm._v(" "), _c('option', [_vm._v("50")])])])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("CÓDIGO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("REFERENCIA")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("TIPO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("SUBTOTAL")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])])
}]}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Enviar Mensaje Inxapp"
    },
    on: {
      "close": _vm.emitClose
    }
  }, [_c('form', {
    staticClass: "p-5 grid grid-cols-12",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendMessage.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-span-12"
  }, [_c('label', [_vm._v("Titulo:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 mt-2"
  }, [_c('label', [_vm._v("Mensaje:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.emitClose
    }
  }, [_vm._v("\n        Cancelar\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "edit"
    }
  }, [_vm._v("\n        Enviar\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal",
    attrs: {
      "id": "passwordModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal__content modal__content--MD",
    attrs: {
      "id": "passwordModalContent"
    }
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "form-task",
    attrs: {
      "enctype": "multipart/form-data"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updatePassword.apply(null, arguments)
      }
    }
  }, [_vm._l((_vm.errors), function(error) {
    return _c('div', {
      key: error
    }, [_c('p', {
      staticClass: "px-5 py-2 grid text-red-700 font-extrabold"
    }, [_vm._v(_vm._s(error))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("CONTRASEÑA")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("REPETIR CONTRASEÑA")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password_confirmation),
      expression: "form.password_confirmation"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password_confirmation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(1)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n            ACTUALIZAR CONTRASEÑA "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Actualizar")])])
}]}

/***/ })
],[223]);


// WEBPACK FOOTER //
// static/js/app.58033caad96aee76aaaa.js